// 缅甸

export default {

loading:"တင်နေသည်",
quantity:"အရေအတွက်",
name:"အမည်",
all:"အားလုံး",
yes:"ဟုတ်",
no:"မဟုတ်",
or:"သို့မဟုတ်",
and:"နှင့်",
in_all:"စုစုပေါင်း",
Query:"မေးမြန်းချက်",
creation:"ဖန်တီး",
Batchquery:"အစုလိုက်မေးမြန်းချက်",
delete:"ဖျက်",
checkAll:"အားလုံးကိုရွေးချယ်",
Save_export_condition:"ထုတ်ပို့မှုအခြေအနေများ သိမ်းဆည်း",
Total_print:"စုစုပေါင်းပုံနှိပ်",
successfully_delete:"ဖျက်ခြင်းအောင်မြင်ပါပြီ!",
error_Message:"အမှားဖြစ်ပေါ်သည့် သတင်းစကား",
edit:"တည်းဖြတ်",
editUser:"အသုံးပြုသူကို တည်းဖြတ်",
confirm:"အတည်ပြု",
print:"ပုံနှိပ်",
today:"ယနေ့",
yesterday:"မနေ့",
enterprise:"ကုမ္ပဏီ",
personage:"ပုဂ္ဂိုလ်",
Before_yesterday:"မနေ့တုန်းက",
printLog:"မှတ်တမ်းပုံနှိပ်",
check:"ကြည့်",
Button:"ခလုတ်",
notice:"မှတ်ချက်",
revocation:"ပြန်ဖျက်",
Query_content:"မေးမြန်းချက်အကြောင်းအရာ",
Scanning_successful:"စကင်အောင်မြင်ပါပြီ",
successful_operation:"လုပ်ငန်းစဉ်အောင်မြင်ပါပြီ!",
Please_select_orders_to_operate:"ဆောင်ရွက်မည့် အော်ဒါကို ရွေးချယ်ပါ",
Please_select_same_platform_orders:"လုပ်ငန်းဆောင်ရွက်ရန် တူညီသော ပလက်ဖောင်းမှ အော်ဒါများကို ရွေးချယ်ပါ။",
The_query_is_successful:"မေးမြန်းမှု အောင်မြင်ပါပြီ။",
Delete_success:"ဖျက်ခြင်း အောင်မြင်ပါပြီ။",
operation_failed:"လုပ်ငန်း မအောင်မြင်ပါ!",
more:"ပိုမို",
click_to_download:"ဒေါင်းလုဒ်လုပ်ရန် နှိပ်ပါ။",
More_operations:"အခြား လုပ်ငန်းများ",
More_Conditions:"အခြား စည်းကမ်းများ",
Displaystatus:"အခြေအနေ ပြသ",
According:"ပြသ",
Total_declared_value:"စုစုပေါင်း ကြေညာထားသော တန်ဖိုး",
NoAccording:"မပြသပါနှင့်",
Download_via_QR_code:"QR ကုဒ်ဖြင့် ဒေါင်းလုဒ်လုပ်ပါ",
Please_select_display_status:"ပြသအခြေအနေကို ရွေးချယ်ပါ။",
Path_is_None_Check_whether_the_address_is_correct:"လိပ်စာ ဗလာနေပါသည်။ လိပ်စာ ထည့်သွင်းမှုကို အတည်ပြုပါ။!",
Is_this_a_piece_of_content_sure_to_delete:"ဤအကြောင်းအရာကို ဖျက်ရန် အတည်ပြုပါသလား။",
phone_number:"မိုဘိုင်းနံပါတ်",
Payment_order_number:"ငွေပေးချေမှု အော်ဒါနံပါတ်",
Please_enter_a_phone_number:"မိုဘိုင်းနံပါတ် ထည့်ပါ။",
SystemSettings:"စနစ်ဆက်တင်များ",
please_enter:"ထည့်ပါ။",
old_password:"ဟောင်း စကားဝှက်",
Please_enter_your_old_password:"ဟောင်းစကားဝှက် ထည့်ပါ",
new_password:"အသစ်စကားဝှက်",
Please_enter_basket_length_width_and_height:"အိတ်ဆောင်အရွယ်အစား (အရှည် x အနံ x အမြင့်) ထည့်ပါ",
Please_enter_the_order_number:"အော်ဒါနံပါတ် ထည့်ပါ",
Please_enter_the_search_criteria:"မေးမြန်းချက် စံနှုန်းများ ထည့်ပါ",
uploading:"တင်ပါ",
next_step:"နောက်တစ်ခု",
last_step:"ရှေ့တစ်ခု",
change_password:"စကားဝှက်ပြောင်းပါ",
Mission_center:"တာဝန်စင်တာ",
TaskCenter:"တာဝန်စင်တာ",
TaskCenterRegulates:"တာဝန်စင်တာ စီမံခန့်ခွဲမှု",
TaskCenterList:"တာဝန်စင်တာ",
Drag_and_drop_upload:"ဆွဲ၍ ထည့်ခြင်း",
Successfully_copied_to_clipboard:"ကလစ်ဘုတ်သို့ အောင်မြင်စွာ မိတ္တူကူးထားသည်",
Unable_to_copy_to_clipboard:"ကလစ်ဘုတ်သို့ မိတ္တူကူး၍ မရနိုင်ပါ",
The_form_verification_fails_Please_modify_and_try_again:"ဖောင်စစ်ဆေးမှု မအောင်မြင်ပါ။ ပြင်ဆင်၍ ထပ်မံကြိုးစားပါ",
The_selected_data_is_empty:"ရွေးထားသော ဒေတာ မပါဝင်ပါ",
The_added_data_is_empty:"ထည့်သွင်းထားသော ဒေတာ မပါဝင်ပါ",
systematic_notification:"စနစ် အသိပေးချက်",
open_in_new_window:"ပြတင်းပေါက်အသစ်တွင် ဖွင့်ရန်",
successfully_upload:"အပ်လုဒ် အောင်မြင်ပါပြီ",
Specify_export_order:"တင်ပို့မည့် အော်ဒါများ သတ်မှတ်ပါ",
Specified_export_goods:"တင်ပို့မည့် ပစ္စည်းများ သတ်မှတ်ပါ",
Export_task_Id:"တင်ပို့လုပ်ငန်းတာဝန် ID",
Derived_exception:"တင်ပို့အမှား",
View_Personal_details:"ကိုယ်ရေးအချက်အလက် ကြည့်ရှုရန်",
not_modified:"ပြောင်းလဲမှု မရှိပါ",
save_as_PDF:"PDF အဖြစ် သိမ်းဆည်းရန်",
Download_sheet:"ပို့ဆောင်ရေး တံဆိပ် ဒေါင်းလုဒ်လုပ်ရန်",
ToolDownload:"ကိရိယာ ဒေါင်းလုဒ်",
toolName:"ကိရိယာအမည်",
remote_control_software:"အဝေးမှ ထိန်းချုပ် ဆော့ဖ်ဝဲ",
Print_plug_in:"ပုံနှိပ် ပလပ်ဂင်",
PDABrowser:"PDA ဘရောက်ဇာ",
It_can_be_downloaded_by_clicking_the_button_and_scanning_the_QR_code_by_touching_the_button:"ခလုတ်နှိပ်၍ ဒေါင်းလုဒ်လုပ်ရန် သို့မဟုတ် ထိတွေ့ QR ကုဒ် စကင်၍ ဒေါင်းလုဒ်လုပ်ရန်",
The_user_does_not_have_any_permission_Please_assign_the_permission_to_the_superior_of_the_user:"ဤအသုံးပြုသူတွင် ခွင့်ပြုချက် မရှိပါ။ ၎င်းတို့၏ အထက်တန်းတာဝန်ရှိသူမှ သင့်လျော်သော ခွင့်ပြုချက်များ သတ်မှတ်ပေးပါ။",
To_use_system_printing_you_need_to_download_a_print_plugin:"စနစ်ပုံနှိပ်ရန်အတွက် ပုံနှိပ်ပလပ်ဂင်ကို ဒေါင်းလုဒ်လုပ်ရန် လိုအပ်ပါသည်။",
The_current_user_has_no_permission_Please_set_the_permission_and_log_in_again:"လက်ရှိအသုံးပြုသူတွင် ခွင့်ပြုချက် မရှိပါ။ ထပ်မံဝင်ရောက်ရန် ကြိုးစားမတိုင်မီ ခွင့်ပြုချက်များကို ပြင်ဆင်ပါ။",
Using_the_specified_export_order_data_will_overwrite_the_list_of_selected_order_data:"သတ်မှတ်ထားသော တင်ပို့အော်ဒါဒေတာကို အသုံးပြုခြင်းဖြင့် စာရင်းမှ ရွေးထားသော အော်ဒါဒေတာကို အစားထိုးမည်ဖြစ်သည်။",
This_order_has_not_been_shipped_out_of_the_warehouse_and_cannot_be_reprinted:"ဤအော်ဒါကို မပို့ဆောင်ရသေးပါ။ လမ်းကြောင်းလွှာများကို ထပ်မံပုံနှိပ်၍ မရပါ။",
Interface_communication_failed_Please_refresh_the_page_or_log_in_again_If_the_problem_persists_contact_the_administrator:"အင်တာဖေ့စ် ဆက်သွယ်မှု မအောင်မြင်ပါ။ စာမျက်နှာကို ပြန်လည်အသစ်တင်ပါ သို့မဟုတ် ထပ်မံဝင်ရောက်ပါ။ ပြဿနာ ဆက်လက်ဖြစ်ပေါ်ပါက အုပ်ချုပ်သူထံ ဆက်သွယ်ပါ။",
Enter_the_client:"Client ထည့်ပါ",
query_condition:"မေးမြန်းချက် စည်းကမ်းများ",
Home:"အိမ်",
return:"နောက်ပြန်",
Please_upload:"တင်ပါ",
The_upload_format_is:"တင်ပုံစံမှာ",
The_file_format_was_wrong_last_time:"တင်ထားသော ဖိုင်ပုံစံ မမှန်ပါ",
The_uploaded_file_exceeds_the_specified_size_Procedure:"တင်ထားသော ဖိုင်သည် သတ်မှတ်ထားသော အရွယ်အစား ကျော်လွန်၍ တင်ခြင်း မအောင်မြင်ပါ။",
Shop_status:"ဆိုင် အခြေအနေ",
normal:"ပုံမှန်",
Authorization_expired:"ခွင့်ပြုချက် သက်တမ်းကုန်ဆုံး",
One_click_out_of_storage:"တစ်ချက်နှိပ်ပို့ဆောင်ခြင်း",
can_only_choose_one:"ရွေးချယ်နိုင်သည့် ရွေးစရာ တစ်ခုတည်းသာ ရှိပါသည်",
Go_to_the_service_platform:"ဝန်ဆောင်မှု ပလက်ဖောင်းသို့ ပြန်လည်ညွှန်ပြ",
api_Order:"API အော်ဒါများ",
Notification_form:"Push အော်ဒါများ",
Please_clear_template_format:"နမူနာပုံစံကို ဖျက်ပါ",
announcementsList:"ကြေညာချက်စာရင်း",
successful_operation_exist:"ရှိပြီးသား ဂိုဒေါင် ဖွဲ့စည်းမှု အောင်မြင်ပါပြီ",
new:"အသစ်",
no_blank_remains:"အလွတ်ကြောင်းများ မထည့်နိုင်ပါ",
mass_export:"အစုလိုက် ထုတ်ပို့ခြင်း",
Print_controls:"ပုံနှိပ်ထိန်းချုပ်မှုများ",
test:"စမ်းသပ်ခြင်း",
The_store_backend_address_must_be_exactly_the_same_as_the_shipping_warehouse_address:"ဆိုင်နောက်ခံလိပ်စာသည် ပို့ဆောင်မည့် ဂိုဒေါင်လိပ်စာနှင့် တိတိကျကျ ကိုက်ညီရမည်",
Password:"စကားဝှက်",
Authentication_Code:"အတည်ပြုကုဒ်",
Can_Exchange:"မရှင်းလင်းပါက ကုဒ်အသစ် ရယူရန် နှိပ်ပါ",
Remember_Password:"စကားဝှက် မှတ်ထားရန်",
Login:"ဝင်ရောက်ရန်",
Register_Account:"အကောင့် မှတ်ပုံတင်ရန်",
Confirm_PassWord:"စကားဝှက် အတည်ပြုရန်",
Account_Manager_ID:"အကောင့် မန်နေဂျာ ID",
identity_card:"အထောက်အထားကတ်",
business_license:"စီးပွားရေးလိုင်စင်",
Please_Input_Password:"စကားဝှက် ထည့်ပါ",
The_Passwords_Entered_Do_Not_Match:"ထည့်သွင်းထားသော စကားဝှက်များ မကိုက်ညီပါ။",
Please_Input_Phone_Number:"မိုဘိုင်းနံပါတ် ထည့်ပါ။",
Please_Input_Verification_Code:"အတည်ပြုကုဒ် ထည့်ပါ။",
Too_Many_Requests_Please_Try_Again_Later:"ကြိမ်နှုန်းများစွာ လုပ်ဆောင်မှုတွေ့ရှိရသည်။ နောက်မှ ထပ်မံကြိုးစားပါ။!",
The_SMS_Verification_Code_Has_Been_Sent_Procedure:"SMS အတည်ပြုကုဒ် ပို့ပြီးပါပြီ။",
Obtain_SMS_Verification_Code:"SMS အတည်ပြုကုဒ် ပြန်ယူပါ။",
Sending_The_Verification_Code:"အတည်ပြုကုဒ် ပို့နေပါသည်။",
Email:"အီးမေးလ်",
Phone_Number:"မိုဘိုင်းနံပါတ်",
Message_Authentication_Code:"SMS အတည်ပြုကုဒ်",
Please_Enter_A_Valid_Email:"မှန်ကန်သော အီးမေးလ်လိပ်စာ ထည့်ပါ။",
The_Current_User_Has_Not_Been_Granted_Permissions_Please_Set_The_Permissions_And_Then_Try_Logging_In_Again:"လက်ရှိအသုံးပြုသူတွင် ခွင့်ပြုချက် မရှိပါ။ ဝင်ရန်မတိုင်မီ ခွင့်ပြုချက်များကို ပြင်ဆင်ပါ။",
Too_Many_Errors_Please_Enter_The_Verification_Code_And_Try_Again:"အမှားကန့်သတ်ကျော်လွန်သွားပါပြီ။ အတည်ပြုကုဒ်ကို ထပ်မံထည့်၍ ထပ်မံကြိုးစားပါ။",
Automatic_login_failed_Please_enter_your_account_and_password_manually:"အလိုအလျောက် ဝင်ရောက်ခြင်း မအောင်မြင်ပါ။ အသုံးပြုသူအမည်နှင့် စကားဝှက်ကို ကိုယ်တိုင် ထည့်သွင်းပါ။",
Logging_In_Automatically:"အလိုအလျောက် ဝင်ရောက်နေသည်",
Chinese:"တရုတ်",
English:"အင်္ဂလိပ်",
OMS_System:"OMS Client",
OMS_System_Admin:"OMS Admin",
UserAccount:"အသုံးပြုသူအမည်",
password:"စကားဝှက်",
RememberPassword:"စကားဝှက် မှတ်ထားရန်",
ForgotPassword:"စကားဝှက် မေ့သွားပါသလား",
RegisterAccount:"အကောင့် မှတ်ပုံတင်ရန်",
Register:"မှတ်ပုံတင်ရန်",
login:"ဝင်ရန်",
Please_enter_a_user_account:"အသုံးပြုသူအမည် မထည့်ထားပါ",
Please_enter_the_user_password:"စကားဝှက် မထည့်ထားပါ",
Obtain_SMS_verification_code:"SMS အတည်ပြုကုဒ် ရယူရန်",
SignIn:"ဝင်ရောက်ခြင်း",
LoginSuccessful:"ဝင်ရောက်မှု အောင်မြင်ပါပြီ",
language:"ဘာသာစကား",
LogOut:"ထွက်ခြင်း",
Skip_logistics_system:"ကုန်ပို့ဆောင်ရေးစနစ်သို့ ပြောင်းရွှေ့ခြင်း",
No_need_to_export_content:"ထုတ်ပို့ရန် အကြောင်းအရာ မရှိပါ",
waiting_in_line:"စောင့်ဆိုင်းနေဆဲ",
No_data_yet:"ဒေတာ မရရှိနိုင်ပါ",
Account_manager_ID:"အကောင့်မန်နေဂျာ ID",
message_authentication_code:"SMS အတည်ပြုကုဒ်",
The_SMS_verification_code_has_been_sent_Procedure:"SMS အတည်ပြုကုဒ် ပို့ပြီးပါပြီ",
authentication_code:"အတည်ပြုကုဒ်",
Sending_the_verification_code:"အတည်ပြုကုဒ် ပို့နေဆဲ",
Can_exchange:"မရှင်းလင်းပါက ကုဒ်အသစ်အတွက် နှိပ်ပါ",
Export_successfully:"ထုတ်ပို့မှု အောင်မြင်ပါပြီ!",
Export_task:"ထုတ်ပို့ရေး လုပ်ငန်း",
print_out_task:"ပုံနှိပ်ရေး လုပ်ငန်း",
Derivation_time:"ထုတ်ပို့ချိန်",
Derived_state:"ထုတ်ပို့အခြေအနေ",
exporting:"ထုတ်ပို့နေဆဲ",
Recalculation_successful:"ပြန်တွက်ချက်မှု အောင်မြင်ပါပြီ",
It_is_being_saved_as_a_PDF:"PDF အဖြစ် သိမ်းဆည်းနေဆဲ",
The_PDF_export_was_successful_The_automatic_download_has_started_If_it_does_not_start_automatically_please_refresh_and_try_again:"PDF ထုတ်ပို့မှု အောင်မြင်ပါပြီ၊ အလိုအလျောက် ဒေါင်းလုဒ် စတင်ပါမည်။ အလိုအလျောက် မဖြစ်ပါက စာမျက်နှာ ပြန်လည်အသစ်တင်ပြီး ထပ်မံကြိုးစားပါ။",
Export_task_name:"တာဝန်အမည်",
download:"ဒေါင်းလုဒ်",
download_successfully:"ဒေါင်းလုဒ် အောင်မြင်ပါပြီ",
Too_many_errors_Please_enter_the_verification_code_and_try_again:"အမှားများလွန်လွန်းပါသည်၊ အတည်ပြုကုဒ်ကို ထပ်မံထည့်သွင်း၍ ထပ်မံကြိုးစားပါ။",
fopltal:"လုပ်ငန်းများ မကြာခဏဖြစ်နေပါသည်၊ နောက်မှ ထပ်မံကြိုးစားပါ။",
Frequent_operation_please_try_again_later:"လုပ်ငန်းများ မကြာခဏဖြစ်နေပါသည်၊ နောက်မှ ထပ်မံကြိုးစားပါ။",
Business_license:"စီးပွားရေးလိုင်စင်",
Business_license_File:"စီးပွားရေးလိုင်စင်စာရွက်",
Identity_card:"အထောက်အထားကတ်",
ID_card_document:"အထောက်အထားကတ်စာရွက်",
Identity_card_code:"အထောက်အထားကတ်နံပါတ်",
ID_card_number_of_legal_person:"ဥပဒေအရ ကိုယ်စားလှယ် အထောက်အထားနံပါတ်",
Please_enter_the_ID_card_number_of_the_legal_person:"ဥပဒေရေးရာ ကိုယ်စားလှယ်၏ ID နံပါတ်ကို ထည့်ပါ။",
Please_enter_the_ID_number:"ID နံပါတ်ကို ထည့်ပါ။",
Default_customer:"မူလ ဖောက်သည်",
Do_you_want_to_confirm_the_cancellation:"ဖျက်သိမ်းခြင်းကို အတည်ပြုပါသလား?",
express_sheet:"ပို့ဆောင်လွှာ",
Confirm_activation:"ဖွင့်လှစ်ခြင်းကို အတည်ပြုပါသလား?",
Please_upload_PDF_file:"PDF ဖိုင်ကို တင်ပါ။",
delivered:"ပို့ဆောင်ပြီး",
One_click_export_across_warehouses_is_not_allowed:"ဂိုဒေါင်များကြား တစ်ချက်နှိပ်ပို့ခြင်း ခွင့်မပြုပါ။",
Please_select_the_recipient_country_first_the_receipt_will_be_saved_to_the_server_in_the_corresponding_region:"ပထမဦးစွာ လက်ခံသူနိုင်ငံကို ရွေးချယ်ပါ; ပို့ဆောင်လွှာများကို သက်ဆိုင်ရာ ဒေသဆိုင်ရာ ဆာဗာတွင် သိမ်းဆည်းမည်။",
data_reorganizing:"ဒေတာ လုပ်ဆောင်နေဆဲ",
Please_upload_the_front_and_back_of_your_ID_card:"ID ကတ်၏ နှစ်ဖက်ကို တင်ပါ။",
Menu_authorization:"မီနူး ခွင့်ပြုချက်",
goodsOnline:"အွန်လိုင်း ထုတ်ကုန်များ",
adminGoodsOnline:"အွန်လိုင်း ထုတ်ကုန်များ",
menuID:"မီနူး ID",
authorization:"ခွင့်ပြုချက်",
editRoleInfo:"တာဝန် တည်းဖြတ်",
createRoleInfo:"တာဝန် ဖန်တီး",
Role_ordering:"တာဝန် စီစဉ်",
UserCenter:"ကိုယ်ရေးကိုယ်တာ စင်တာ",
workbench:"အလုပ်ခွင်",
announceList:"ကြေညာချက် စာရင်း",
Processing_Center:"လုပ်ငန်းစဉ် စင်တာ",
Outbound:"ထွက်ပို့",
Order:"အော်ဒါများ",
pendingOrders:"ပို့ဆောင်ရန် စောင့်ဆိုင်းနေသော အော်ဒါများ",
Basic_configuration:"အခြေခံ ဖွဲ့စည်းမှု",
BasicConfiguration:"အခြေခံ ဖွဲ့စည်းမှု",
basketList:"လှည်းစာရင်း",
fixedSkuFee:"သတ်မှတ်ထားသော SKU ကြေး",
consumables:"အသုံးအဆောင် ပစ္စည်း အမျိုးအစား",
log:"မှတ်တမ်း",
logType:"မှတ်တမ်း အမျိုးအစား",
Please_upload_the_national_emblem_and_portrait:"အမျိုးသားအလံဘက်နှင့် မျက်နှာဘက်ကို တင်ပါ။",
oprateLog:"လုပ်ငန်းမှတ်တမ်း",
oprateInfo:"လုပ်ငန်းအချက်အလက်",
Please_enter_a_keyword_to_search:"ရှာဖွေရန် သော့ချက်စာလုံးများ ထည့်ပါ။",
MenuRemark:"မီနူးမှတ်စုများ",
Please_select_whether_to_enable_it:"ဖွင့်ရန် ရွေးချယ်ပါ။",
Please_select_menu_type:"မီနူးအမျိုးအစား ရွေးပါ။",
menu:"မီနူး",
MenuManagement:"မီနူးစီမံခန့်ခွဲမှု",
Please_enter_a_menu_name:"မီနူးအမည် ထည့်ပါ။",
Menu_name:"မီနူးအမည်",
Please_add_the_menu:"မီနူးကို ပထမဦးစွာ ထည့်ပါ။",
The_same_name_menu_is_not_allowed:"မီနူးအမည်များ ထပ်တူမဖြစ်နိုင်ပါ။",
The_data_is_incorrect_adding_failed:"ဒေတာမှားယွင်း၍ ထည့်သွင်းမှု မအောင်မြင်ပါ။",
viewWarehouseEntry:"လက်ခံမှတ်စုများ ကြည့်ရန်",
PDAStatus:"PDA အခြေအနေ",
Task_generation_type:"တာဝန်ဖန်တီးမှု အမျိုးအစား",
Jump_to_old_system:"ဟောင်းစနစ်သို့ ခုန်သွားရန်",
This_operation_will_be_one_click_out_of_the_warehouse_and_can_not_be_undone_be_sure_to_confirm_that_the_order_is_complete_careful_operation:"ဤလုပ်ငန်းစဉ်သည် တစ်ချက်နှိပ်ခြင်းဖြင့် ထွက်ပို့ပစ္စည်းတင်ပို့ခြင်းကို ဆောင်ရွက်မည်ဖြစ်ပြီး ပြန်လည်ဖျက်၍ မရနိုင်ပါ။ ဆက်လက်ဆောင်ရွက်မည့်အခါ မှာယူထားသော ပစ္စည်းများအားလုံး ပြည့်စုံပြီးစီးကြောင်း သေချာစေရန် လိုအပ်ပါသည်။ သတိထားပါ။",
videoPhotoManagement:"ဗီဒီယိုနှင့်ဓာတ်ပုံ စီမံခန့်ခွဲမှု",
storageSpaceServersWarehouse:"ဂိုဒေါင်ဆာဗာ သိုလှောင်နိုင်မှု",
videoPhotographyManagementControl:"ဗီဒီယိုနှင့်ဓာတ်ပုံ စီမံခန့်ခွဲမှု ထိန်းချုပ်မှုများ",
videoPhotoList:"ဗီဒီယိုနှင့်ဓာတ်ပုံ စာရင်း",
returnGoodsRegistrationShelving:"အမြန်ပြန်ပို့ မှတ်ပုံတင်ခြင်း၊ အရည်အသွေး စစ်ဆေးခြင်းနှင့် စင်တင်ခြင်း",
returnInventoryManagement:"ပြန်ပို့ထားသော ကုန်ပစ္စည်း စတော့ စီမံခန့်ခွဲမှု",
returnInventoryList:"ပြန်ပို့ထားသော ကုန်ပစ္စည်း စတော့ စာရင်း",
ShopeeProfitReport:"Shopee အမြတ်အစီရင်ခံစာ",
warehouseLevelReport:"ဂိုဒေါင်အဆင့် ဝင်ငွေ/ထွက်ငွေ ဒေတာအစီရင်ခံစာ",
platformLevelReport:"ပလက်ဖောင်းအဆင့် ဝင်ငွေ/ထွက်ငွေ ဒေတာအစီရင်ခံစာ",
customerLevelReport:"ဖောက်သည်အဆင့် ဝင်ငွေ/ထွက်ငွေ ဒေတာအစီရင်ခံစာ",
storeLevelReport:"ဆိုင်အဆင့် ဝင်ငွေ/ထွက်ငွေ ဒေတာအစီရင်ခံစာ",
orderLevelReport:"အော်ဒါအဆင့် ဝင်ငွေ/ထွက်ငွေ ဒေတာအစီရင်ခံစာ",
shopeeOrderProfitReport:"Shopee အော်ဒါ အမြတ်အစီရင်ခံစာ",
shopeeStoreReport:"Shopee ဆိုင် အမြတ်အစီရင်ခံစာ",
currencyExchangeRate:"ငွေလဲလှယ်နှုန်းများ",
currencyExchangeRateList:"ငွေလဲလှယ်နှုန်းစာရင်း",
returnWarehouseFlowList:"ပြန်ပို့ပုံး ဝင်/ထွက် လုပ်ငန်းစဉ် မှတ်တမ်းစာရင်း",
costRecalculation:"ကြေး ပြန်တွက်ချက်ခြင်း",
chargeGiveSpecial:"ကြေး အထူးခွင့်ပြုချက်",
ShopeeReport:"Shopee အစီရင်ခံစာများ",
TikTokOrderProfitReport:"TikTok အော်ဒါ အမြတ်အစီရင်ခံစာ",
logisticsHandover:"ကုန်ပို့ဆောင်ရေး လွှဲပြောင်းခြင်း",
logisticsHandoverTaskList:"ကုန်ပို့ဆောင်ရေး လွှဲပြောင်းခြင်း လုပ်ငန်းစဉ် စာရင်း",
taskScanningFlowList:"တာဝန် စကင် လုပ်ငန်းစဉ် မှတ်တမ်းစာရင်း",
handoverTaskList:"အပ်နှံရေးတာဝန်များ",
tikTokStoreProfitReport:"TikTok Shop အမြတ်အစီရင်ခံစာ",
lazadaProfitReport:"Lazada အမြတ်အစီရင်ခံစာ",
lazadaOrderProfitReport:"Lazada အော်ဒါအမြတ်အစီရင်ခံစာ",
lazadaStoreProfitReport:"Lazada ဆိုင်အမြတ်အစီရင်ခံစာ",
generateInventoryPlan:"ကုန်ပစ္စည်းသိုလှောင်ရေးအစီအစဉ် ဖန်တီးခြင်း",
inventoryPlanManagement:"ကုန်ပစ္စည်းသိုလှောင်ရေးအော်ဒါ စီမံခန့်ခွဲမှု",
TikTokProfitReport:"TikTok အမြတ်အစီရင်ခံစာ",
viewInventoryPlanManagement:"ကုန်ပစ္စည်းသိုလှောင်ရေးအော်ဒါ စီမံခန့်ခွဲမှု ကြည့်ရှုခြင်း",
taskFlow:"တာဝန် လည်ပတ်မှု မှတ်တမ်း",
systemDeductionControl:"စနစ်ကြေး ဖြတ်တောက်မှု ထိန်းချုပ်မှု",
contractAuthorization:"စာချုပ် အတည်ပြုခွင့်",
contractListCheck:"စာချုပ် ကြည့်ရှုခြင်း",
logisticsHandoverScanningLog:"ကုန်ပို့ရေး လက်လွှဲ စကင် မှတ်တမ်း",
itemTypeRuleSettings:"ထုပ်ပိုးအမျိုးအစား စည်းမျဉ်း ဆက်တင်များ",
addLogisticsChannel:"ကုန်ပို့ရေး ချန်နယ် ဖန်တီးခြင်း",
editLogisticsChannel:"ကုန်ပို့ရေး ချန်နယ် တည်းဖြတ်ခြင်း",
listOfChannelsToBeConfirmed:"အတည်ပြုရန် စောင့်ဆိုင်းနေသော ချန်နယ် စာရင်း",
newlyDevelopedCustomerSetting:"ဖောက်သည်အသစ် တပ်ဆင်ခြင်း",
parent_directory:"မူလ ဖိုလ်ဒါ",
Dictionary_management:"စကားလုံးစာအုပ် စီမံခန့်ခွဲမှု",
explain:"ဖော်ပြချက်",
Please_enter_explain:"ဖော်ပြချက် ထည့်ပါ",
warning:"သတိပေးချက်",
cancel_authorization:"ခွင့်ပြုချက် ဖျက်သိမ်းခြင်း",
Definitive_de_authorization:"ဖျက်သိမ်းခြင်း အတည်ပြုပါသလား?",
apiPushMotificationList:"Push လုပ်ငန်းငွေ မှတ်တမ်း စာရင်း",
platform:"ပလက်ဖောင်း",
shop:"ဆိုင်",
Please_select_CustomerId:"ဖောက်သည် ID ကို ရွေးပါ",
Please_select_shop:"ဆိုင်ကို ရွေးပါ",
Only_a_single_store_can_be_selected:"ဆိုင် တစ်ခုတည်းသာ ရွေးနိုင်ပါသည်",
The_transaction_number_and_order_time_cannot_be_empty_at_the_same_time:"ငွေလွှဲနံပါတ်နှင့် အော်ဒါအချိန်ကို တစ်ပြိုင်နက်လုံး ဗလာမထားနိုင်ပါ။",
warehouse:"ဂိုဒေါင်",
Warehouse_name:"ဂိုဒေါင်အမည်",
Warehouse_code:"ဂိုဒေါင်ကုဒ်",
storage_location:"ကုန်ပစ္စည်းတည်နေရာ",
order_number:"အော်ဒါနံပါတ်",
transaction_number:"Transaction ID",
waybill_number:"Waybill နံပါတ်",
logistics_channel:"လော့ဂျစ်စတစ်ခ်ချန်နယ်",
Logistics_track:"လော့ဂျစ်စတစ်ခ်ထရက်ကာ",
Only_orders_entered_into_the_system_at_the_current_time_15_days_are_processed:"နောက်ဆုံး ၁၅ ရက်အတွင်း ထည့်သွင်းထားသော အော်ဒါများကိုသာ ဆောင်ရွက်ပါ။",
search:"ရှာဖွေခြင်း",
type:"အမျိုးအစား",
state:"အခြေအနေ",
time:"ရက်စွဲ",
country:"နိုင်ငံ",
Please_enter_country:"နိုင်ငံကို ထည့်ပါ။",
oprate:"လုပ်ဆောင်ချက်",
operation_log:"လုပ်ဆောင်ချက်မှတ်တမ်း",
thumbnail:"သေးငယ်သောပုံ",
Bar_code_of_goods:"ထုတ်ကုန်ဘားကုဒ်",
Commodity_bar_code_and_two_dimensional_code:"ထုတ်ကုန်ဘားကုဒ် QR ကုဒ်",
stock_position:"ကုန်ပစ္စည်းတည်နေရာ",
Orders_in_the_fulfillment:"ရွေးယူခြင်း ဆောင်ရွက်နေသော အော်ဒါများ",
Pending_sorting_tasks:"ခွဲခြားခြင်း စောင့်ဆိုင်းနေသော တာဝန်များ",
Sorting_tasks:"ခွဲခြားခြင်း ဆောင်ရွက်နေခြင်း",
Pending_shipment:"ပို့ဆောင်ခြင်း စောင့်ဆိုင်းနေခြင်း",
In_transit:"ပို့ဆောင်ခြင်း ဆောင်ရွက်နေခြင်း",
Irregularity_in_delivery:"ရွေးယူခြင်း မမှန်ကန်မှု",
Abnormal_quantity_of_distribution:"ရွေးယူခြင်း မမှန်ကန်မှု ပမာဏ",
The_sorting_task_is_abnormal:"ခွဲခြားခြင်း တာဝန် မမှန်ကန်မှု",
Shipment_exception:"ပို့ဆောင်ခြင်း မမှန်ကန်မှု",
Abnormal_shipment_quantity:"ပို့ဆောင်ခြင်း မမှန်ကန်မှု ပမာဏ",
log_list:"မှတ်တမ်းစာရင်း",
Document_ID:"စာရွက်စာတမ်း ID",
task_order_number:"တာဝန် အော်ဒါ နံပါတ်",
order_id:"အော်ဒါ ID",
Operation_type:"လုပ်ငန်းအမျိုးအစား",
Operation_Description:"လုပ်ငန်း ဖော်ပြချက်",
Operator:"အော်ပရေတာ",
creation_time:"ဖန်တီးချိန်",
No_delivery_basket:"ရွေးယူရန် ဘင် မရှိပါ",
No_sorting_basket:"ခွဲခြားရန် ဘတ်စကက် မရှိပါ",
time_left:"ကျန်ရှိ",
overdue:"ကျော်လွန်",
days:"ရက်",
hours:"နာရီ",
minutes:"မိနစ်",
copy:"ကူးယူခြင်း",
copu_successful:"ကူးယူအောင်မြင်",
verify_the_time:"အတည်ပြုချိန်",
Transfer_to_oms_time:"OMS သို့ ကူးပြောင်းချိန်",
sorting_time:"ခွဲခြားချိန်",
Please_tick_the_content_first:"အကြောင်းအရာကို ပထမဦးစွာ ရွေးချယ်ပါ။",
start_date:"စတင်ရက်",
end_date:"ပြီးဆုံးရက်",
to:"သို့",
Whether_used:"အသုံးပြုထားခြင်းရှိ/မရှိ",
Last_three_days:"နောက်ဆုံး သုံးရက်",
Last_week:"နောက်ဆုံး တစ်ပတ်",
Last_month:"နောက်ဆုံး လ",
Assign_a_distributor:"တာဝန်ပေးထားသော ညွှန်ကြားသူ",
Please_appoint_a_distributor:"သတ်မှတ်ထားသော ကောက်ယူဝန်ထမ်းကို ရွေးချယ်ပါ။",
positionTransfer:"ကုန်ပစ္စည်း ကူးပြောင်း",
shiftingParkingData:"ဂိုဒေါင် ကူးပြောင်း",
Old_storage_location:"ဟောင်းနေရာ",
New_storage_location:"အသစ်နေရာ",
Transfer_quantity:"ကူးပြောင်းအရေအတွက်",
Add_transfer_library:"ကူးပြောင်းထည့်ရန်",
The_number_of_removable_warehouses:"ကူးပြောင်းနိုင်သည့် အရေအတွက်",
Cannot_scan_the_same_database_location:"တစ်နေရာတည်းရှိ သိုလှောင်မှုနေရာကို စကင်၍ မရပါ။",
This_product_does_not_exist_in_this_repository_Please_scan_other_repositories:"ဤထုတ်ကုန်သည် ဤနေရာတွင် မရှိပါ။ အခြားနေရာကို စကင်ပါ။",
Go_to_OMS1_0:"OMS1.0 သို့ ချက်ချင်းသွားရန်",
The_bar_code_cannot_exceed_100_characters:"ဘားကုဒ်သည် အက္ခရာ ၁၀၀ ကျော်မရပါ။",
The_SKU_cannot_exceed_100_characters:"SKU သည် အက္ခရာ ၁၀၀ ကျော်မရပါ။",
The_name_of_a_Chinese_product_cannot_exceed_300_characters:"တရုတ်ထုတ်ကုန်အမည်သည် အက္ခရာ ၃၀၀ ကျော်မရပါ။",
The_name_of_an_English_product_cannot_exceed_300_characters:"အင်္ဂလိပ်ထုတ်ကုန်အမည်သည် အက္ခရာ ၃၀၀ ကျော်မရပါ။",
Single_product_distribution:"တစ်ခုချင်းစီ ရွေးယူခြင်း",
singleProductDistribution:"တစ်ခုချင်းစီ ရွေးယူခြင်း",
tips:"သတိပေးချက်",
Task_mode:"တာဝန်နည်းလမ်း",
Get_task:"တာဝန်ရယူခြင်း",
Warehouse_partition:"ဂိုဒေါင်ဇုန်",
Distribution_box_scanning_box:"ရွေးယူရန် ဘင် စကင်ဧရိယာ",
Distribution_basket_code:"ရွေးယူခြင်း စကူ ကုဒ်",
Barcode_scanning_box_of_goods:"ထုတ်ကုန် ဘားကုဒ် စကင်ဧရိယာ",
picture:"ပုံ",
Allocated_goods:"ရွေးယူပြီး",
To_be_distributed:"ရွေးယူရန် စောင့်နေ",
stock:"စာရင်း",
view_details:"အသေးစိတ်ကြည့်ရန်",
details:"အသေးစိတ်",
Logistics_channel:"ပို့ဆောင်ရေးလမ်းကြောင်း",
Please_enter_customer_ID:"ဖောက်သည် ID ထည့်ပါ",
conveyor:"ကွန်ဗီးယာဘဲလ်",
please_scan_the_distribution_basket:"ရွေးယူခြင်း စကူကို စကင်ပါ",
The_basket_does_not_exist:"ဤ စကူ မရှိပါ",
Quantity_of_goods_allocated:"ရွေးယူထားသော အရေအတွက်",
When_you_do_not_need_to_pick_and_ship_you_do_not_need_to_carry_the_basket_number_please_scan_the_distribution_basket_code_directly:"ပို့ဆောင်ရန် ခွဲခြားရန် မလိုအပ်ပါက၊ စကိတ်နံပါတ်များကို မသယ်ဆောင်ရ။ တိုက်ရိုက် ပစ်ကင်းစကိတ်ကုဒ်ကို စကင်ပါ။",
When_scanning_the_sorting_basket_the_basket_number_is_missing_please_rescan:"ခွဲခြားထားသော စကိတ်များကို စကင်သည့်အခါ၊ မပါသော စကိတ်နံပါတ်များကို ပြန်လည်စကင်ရန် လိုအပ်သည်။",
Quantity_sorted:"ခွဲခြားပြီး အရေအတွက်",
Quantity_of_goods_to_be_allocated:"စောင့်ဆိုင်းနေသော အရေအတွက်",
distributor:"ပစ်ကင်းသူ",
Distribution_time:"ပစ်ကင်းချိန်",
Total_quantity_to_be_allocated:"စုစုပေါင်း စောင့်ဆိုင်းနေသော အရေအတွက်",
abnormal_quantity:"မမှန်ကန်သော အရေအတွက်",
Distribution_start_time:"ပစ်ကင်းစတင်ချိန်",
Distribution_end_time:"ပစ်ကင်းပြီးဆုံးချိန်",
Bulk_allocation:"အစုလိုက် ခွဲဝေပေးခြင်း",
Sorting_query:"ခွဲခြားခြင်း မေးမြန်းချက်",
Separate_sorting_and_shipping:"တစ်ခုချင်းစီ ခွဲခြားခြင်းနှင့် ပို့ဆောင်ခြင်း",
Total_sorting_quantity:"စုစုပေါင်း ခွဲခြားထားသော အရေအတွက်",
Sorting_stage:"ခွဲခြားခြင်း အဆင့်",
Sorting_end_time:"ခွဲခြားခြင်း ပြီးဆုံးချိန်",
sorter:"ခွဲခြားသူ",
reauthorize:"ပြန်လည် ခွင့်ပြု",
Prepare_a_single_item_distribution_basket_in_the_current_warehouse:"လက်ရှိ ဂိုဒေါင်အတွက် ပစ္စည်း ခွဲဝေပေးရန် ဘတ်စကက် ပြင်ဆင်ပါ",
Scan_the_distribution_basket:"ခွဲဝေပေးသည့် ဘတ်စကက်ကို စကင်ပါ",
Scanning_product_bar_code:"ထုတ်ကုန် ဘားကုဒ်ကို စကင်ပါ",
Click_the_quantity_of_allocated_goods_to_batch_allocate_goods:"အစုလိုက် ခွဲဝေပေးရန် 'ခွဲဝေထားသော အရေအတွက်' ကို နှိပ်ပါ",
Scan_the_corresponding_warehouse_location_for_distribution:"ရွေးယူရန် သက်ဆိုင်ရာ သိုလှောင်ရာနေရာများကို စကင်လုပ်ပါ",
Take_the_goods_that_have_been_allocated_and_scan_the_goods_directly_to_be_shipped:"ရွေးယူထားသော ပစ္စည်းများကို ပို့ဆောင်ရေးဧရိယာသို့ ရွှေ့ပြောင်းပြီး၊ ပို့ဆောင်ရန်အတွက် ပစ္စည်းများကို တိုက်ရိုက် စကင်လုပ်ပါ",
Click_the_shipped_quantity_to_ship_in_bulk:"အစုလိုက်ပို့ဆောင်ရန် 'ပို့ဆောင်ပြီးပမာဏ' ကို နှိပ်ပါ",
Click_on_the_selected_quantity_to_pick_in_bulk:"အစုလိုက်ရွေးယူရန် 'ရွေးယူပြီးပမာဏ' ကို နှိပ်ပါ",
Scan_the_sorting_basket_head:"အမျိုးအစားခွဲသေတ္တာ ခေါင်းစီးကို စကင်လုပ်ပါ",
Scan_all_distribution_baskets:"ရွေးယူထားသော ပစ္စည်းသေတ္တာအားလုံးကို စကင်လုပ်ပါ",
Place_in_the_corresponding_sorting_basket:"ပစ္စည်းများကို သက်ဆိုင်ရာ အမျိုးအစားခွဲသေတ္တာများထဲသို့ ထည့်ပါ",
Scan_the_sorting_basket:"အမျိုးအစားခွဲသေတ္တာကို စကင်လုပ်ပါ",
Scan_all_products:"ပစ္စည်းအားလုံးကို စကင်လုပ်ပါ",
priority_in_delivery:"ဦးစားပေးပို့ဆောင်ခြင်း",
Confirmation_marked_as_priority_shipment:"ဦးစားပေးပို့ဆောင်မှုအခြေအနေကို အတည်ပြုပါ",
Click_on_the_shipped_quantity_to_scan_in_bulk:"ပို့ဆောင်မည့်အရေအတွက်ကို နှိပ်၍ အစုလိုက် စကင်ပါ",
Carry_out_the_corresponding_weighing_photo_operation_to_deliver_the_goods:"ပို့ဆောင်ရန်အတွက် သက်ဆိုင်ရာ အလေးချိန်တိုင်းခြင်းနှင့် ဓာတ်ပုံရိုက်ခြင်း လုပ်ငန်းစဉ်များကို ဆောင်ရွက်ပါ",
multiProductDistribution:"ပစ္စည်းအများကြီးရွေးယူခြင်း",
singleItemDelivery:"တစ်ခုချင်းစီပို့ဆောင်ခြင်း",
Packaging_material:"ထုပ်ပိုးပစ္စည်းများ",
Order_information:"အော်ဒါအသေးစိတ်",
orderInfo:"အော်ဒါအသေးစိတ်",
total:"စုစုပေါင်း",
Shipper:"ရွေးယူသူ",
package_photo:"ပက်ကေ့ဂျ်ဓာတ်ပုံ",
Package_material_information:"ထုပ်ပိုးသတင်းအချက်အလက်",
Waybill_number:"ပို့ဆောင်ရေးနံပါတ်",
Has_been_inspected:"စစ်ဆေးပြီး",
pending_inspection:"စစ်ဆေးရန်ကျန်",
abnormal_delivery:"ပို့ဆောင်မှု အမှား",
Photograph:"ဓာတ်ပုံရိုက်",
Enter_key_to_take_a_photo:"ဓာတ်ပုံရိုက်ရန် Enter နှိပ်ပါ",
Please_weigh_the_order:"အော်ဒါကို အလေးချိန်တိုင်းပါ",
Please_photos_the_order:"အော်ဒါကို ဓာတ်ပုံရိုက်ပါ",
Out_of_stock_successfully:"ထွက်ပို့မှု အောင်မြင်",
The_order_number_cannot_be_empty:"အော်ဒါနံပါတ်ကို ဗလာမထားနိုင်ပါ!",
submit:"တင်သွင်း",
send_back:"ပြန်သွား",
Flag_exception:"အမှားအဖြစ် မှတ်သား",
sensitized:"ဖွင့်လှစ်",
weigh:"အလေးချိန်တိုင်း",
Remaining_shipment_quantity:"ကျန်ရှိသေးသော ပို့ဆောင်မည့် အရေအတွက်",
Quantity_shipped:"ပို့ဆောင်ပြီးသော အရေအတွက်",
Quantity_of_goods_to_be_shipped:"ပို့ဆောင်ရန် စောင့်ဆိုင်းနေသော အရေအတွက်",
The_barcode_does_not_exist:"ဤပစ္စည်းအတွက် ဘားကုဒ် မရှိပါ",
Follow_these_steps_to_fill_in_the_standard_template_and_import_the_data:"စံပုံစံကို ပြီးစီးပြီး အောက်ပါအတိုင်း ဒေတာကို တင်သွင်းပါ:",
Header_Entry_order_information_In_the_template_fill_in_the_data_of_the_table_header_from_order_type_to_remarks_Each_row_represents_an_entry_orderentry_order:"၁။ ဝင်ရောက်/ပို့ဆောင်ရေးစာရွက်စာတမ်းအချက်အလက်များ: ပုံစံတွင် Order Type မှ Remarks အထိ ခေါင်းစဉ်ကော်လံများကို ဖြည့်ပါ။ တစ်ကြောင်းစီသည် ဝင်ရောက်/ပို့ဆောင်ရေးစာရွက်စာတမ်း တစ်စောင်ကို ကိုယ်စားပြုသည်။",
Box_product_information_In_the_template_fill_in_the_table_head_data_from_the_box_number_to_the_weight_KG_box_Each_row_represents_a_box_of_products:"၂။ ကတ်ထုံးထုတ်ကုန်အချက်အလက်များ: ပုံစံတွင် Carton Number မှ Weight (kg/carton) အထိ ခေါင်းစဉ်ကော်လံများကို ဖြည့်ပါ။ တစ်ကြောင်းစီသည် ထုတ်ကုန်ကတ်ထုံး တစ်ထုပ်ကို ကိုယ်စားပြုသည်။",
Please_ensure_that_each_item_is_filled_in_accurately_and_follow_the_example_after_downloading_the_standard_template:"ဒေတာအားလုံးကို တိကျမှန်ကန်စွာ ဖြည့်သွင်းထားကြောင်း သေချာစေပါ။ စံနမူနာဖောင်ကို ဒေါင်းလုဒ်ဆွဲပြီး နမူနာဖော်ပြချက်အတိုင်း လိုက်နာပါ။",
The_weight_must_not_be_less_than_or_equal_to_0:"အလေးချိန်သည် 0 ထက် မနည်း၊ မညီရ",
Exceeds_the_maximum_weight_please_re_enter:"အများဆုံးအလေးချိန်ကျော်လွန်ပါက ပြန်လည်ထည့်သွင်းပါ။",
Unable_to_access_the_camera:"ကင်မရာ ဝင်ရောက်၍ မရနိုင်ပါ။",
Error_uploading_files_to_Alibaba_Cloud_Please_contact_the_administrator:"Alibaba Cloud သို့ ဖိုင်တင်ခြင်း မအောင်မြင်ပါ။ အုပ်ချုပ်သူထံ ဆက်သွယ်ပါ။",
The_number_of_anomalies_entered_is_incorrect:"အရေအတွက် မမှန်ကန်ပါ။",
advanceLoadingSingleItemDelivery:"တစ်ခုချင်းစီ ပို့ဆောင်ခြင်း (ကြိုတင်တင်ခြင်း)",
advanceLoadingMultiProductDelivery:"အများအပြား ပို့ဆောင်ခြင်း (ကြိုတင်တင်ခြင်း)",
advanceLoadingExplosiveDelivery:"အကောင်းဆုံးရောင်းအားရှိ ပစ္စည်းများ ပို့ဆောင်ခြင်း (ကြိုတင်တင်ခြင်း)",
Only_xlsx_format_files_are_supported_for_import_and_the_size_cannot_exceed_15_MB_A_maximum_of_ten_thousand_rows_of_data_can_be_imported:"xlsx ဖော်မတ်ဖိုင်များကိုသာ ထောက်ပံ့ပြီး အများဆုံး အရွယ်အစား 15MB နှင့် အတန်း 10,000 အထိသာ ခွင့်ပြုသည်။",
multiProductSorting:"ပစ္စည်းအများအပြား ခွဲခြားခြင်း",
The_sorting_basket_does_not_exist_or_is_already_occupied_Please_refresh_and_try_again:"ဤ ခွဲခြားရန် ဘင် မရှိပါ သို့မဟုတ် အသုံးပြုနေပါသည်။ ပြန်လည်အသစ်တင်ပြီး ထပ်မံကြိုးစားပါ။",
Basket_state:"ဘင် အခြေအနေ",
Please_Select_Basket_state:"ဘင် အခြေအနေကို ရွေးချယ်ပါ။",
The_distribution_basket_does_not_exist:"ဤ ရွေးယူရန် ဘင် မရှိပါ။",
Sort_the_basket_head:"ခွဲခြားရန် ဘင် ခေါင်းစဉ်",
Task_details:"တာဝန်အသေးစိတ်",
Distribution_basket_not_scanned:"စကင်မထားသေးသော ရွေးယူခြင်းဘားကက်များ",
Remaining_sorting_orders:"ကျန်ရှိသေးသော အမျိုးအစားခွဲခြင်း အမိန့်များ",
Quantity_of_remaining_sorting:"ကျန်ရှိသေးသော အမျိုးအစားခွဲခြင်း ပမာဏ",
Sorting_abnormal_quantity:"အမျိုးအစားခွဲခြင်း မမှန်ကန်မှုများ ရေတွက်ချက်",
Sorting_start_time:"အမျိုးအစားခွဲခြင်း စတင်ချိန်",
The_list_has_been_picked:"ရွေးယူထားသော စာရင်း",
Pick_details:"ရွေးယူခြင်း အသေးစိတ်",
Sorting_number:"အမျိုးအစားခွဲခြင်း ID",
Quantity_picked:"ရွေးယူထားသော ပမာဏ",
Quantity_to_be_picked:"ရွေးယူရန် စောင့်ဆိုင်းနေသော ပမာဏ",
Bulk_pick_quantity:"အစုလိုက်ရွေးယူခြင်း ပမာဏ",
Allotment_quantity:"ခွဲဝေပေးထားသော ပမာဏ",
number_of_pages:"စာမျက်နှာ နံပါတ်",
Select_the_SKU_that_you_want_to_replace:"အစားထိုးရန် လိုအပ်သော SKU များကို ရွေးပါ",
When_entering_transaction_numbers_in_batches_separate_them_with_line_breaks_or:"transaction နံပါတ်များကို အစုလိုက် ထည့်သွင်းသောအခါ လိုင်းခွဲ (line breaks) သို့မဟုတ် ကော်မာ (comma) ဖြင့် ခွဲထားပါ။",
Multi_product_delivery:"ပစ္စည်းအများအပြား ပို့ဆောင်ခြင်း",
multiProductDelivery:"ပစ္စည်းအများအပြား ပို့ဆောင်ခြင်း",
newMultiProductDelivery:"ပစ္စည်းအများအပြား ပို့ဆောင်ခြင်း အသစ်",
IF_Need_to_take_pictures:"ဓာတ်ပုံလိုအပ်ပါသလား?",
IF_Need_to_be_weighed:"အလေးချိန်တိုင်းတာရန် လိုအပ်ပါသလား?",
Priority_Shipping_Orders:"ဦးစားပေး ပို့ဆောင်ရန် အော်ဒါများ",
Scanning_sorting_blue_head:"စကင် စုစည်းခြင်း ဘားကက် ခေါင်းစဉ်",
Number_of_current_product_types:"လက်ရှိ ပစ္စည်းအမျိုးအစားများနှင့် အရေအတွက်များ",
kind:"အမျိုးအစားများ",
indivual:"ပစ္စည်းများ",
dispatcher:"ရွေးယူသူ",
Shipping_Basket:"စုစည်းခြင်း ဘားကက်",
Preview_photo:"ဓာတ်ပုံ ကြိုကြည့်ခြင်း",
reshoot:"ပြန်ရိုက်",
No_photos_yet:"ဓာတ်ပုံမရှိပါ",
determine:"အတည်ပြု",
Sorting_error_No_basket_number:"အမျိုးအစားခွဲခြင်းမှားယွင်း၊ စည်ပင် ID မရှိ",
The_current_task_is_complete:"လက်ရှိတာဝန်ပြီးစီး",
Loading_a_sheet:"ပို့ဆောင်ရေးတံဆိပ်များတင်နေသည်",
Transaction_number_only:"ငွေလုပ်ငန်း ID သာ",
Transaction_number_and_order_weight:"ငွေလုပ်ငန်း ID နှင့် အမှာစာအလေးချိန်",
Waybill_No_only:"ပို့ဆောင်လွှာနံပါတ်သာ",
Shipment_number_and_order_weight_only:"ပို့ဆောင်လွှာနံပါတ်နှင့် အမှာစာအလေးချိန်",
Shipping_format:"ပို့ဆောင်ပုံစံ",
Freight_mode:"ပို့ဆောင်နည်း",
Scan_delivery_information:"ပို့ဆောင်မှုအသေးစိတ်ကို စကင်ခြင်း",
add_basket_head:"စည်ပင်ခေါင်းစဉ်အသစ်ထည့်ပါ",
save:"သိမ်းဆည်း",
Cancel:"ဖျက်ရန်",
sequence:"စီးရီးနံပါတ်",
Please_enter_basket_header:"Basket Header ကို ထည့်ပါ။",
Add_basket:"Basket ထည့်ရန်",
Edit_basket:"Basket တည်းဖြတ်ရန်",
Basket_Type:"Basket အမျိုးအစား",
basket_head:"Basket Header",
basket_name:"Basket အမည်",
Batch_create_baskets:"အစုလိုက် Basket များ ဖန်တီးရန်",
Please_select_a_basket_type:"Basket အမျိုးအစားကို ရွေးပါ။",
Basket_description:"Basket ဖော်ပြချက်",
Please_enter_a_basket_description:"Basket ဖော်ပြချက်ကို ထည့်ပါ။",
sorting_basket:"အမျိုးအစားခွဲ Basket",
Allotment_basket:"ရွေးယူ Basket",
Please_select_a_distribution_basket:"ရွေးယူ Basket ကို ရွေးပါ။",
Sorting_basket_number:"အမျိုးအစားခွဲ Basket နံပါတ်",
Allocation_phase:"ရွေးယူအဆင့်",
Allotment_basket_item:"ရွေးယူ Basket (တစ်ခုတည်း)",
quality_inspection_basket:"အရည်အသွေး စစ်ဆေး Basket",
other_types:"အခြားအမျိုးအစားများ",
Operation_time:"လုပ်ငန်းချိန်",
Can_only_contain_letters_and_numbers:"အက္ခရာများနှင့် ဂဏန်းများသာ ထည့်နိုင်ပါသည်။",
print_basket_number:"ဘတ်စကက်နံပါတ် ပုံနှိပ်ရန်",
starting_number:"စတင်နံပါတ်",
Please_enter_the_starting_number:"စတင်နံပါတ်ကို ထည့်ပါ။",
end_number:"အဆုံးနံပါတ်",
Please_enter_the_end_number:"အဆုံးနံပါတ်ကို ထည့်ပါ။",
The_label_specification:"တံဆိပ် သတ်မှတ်ချက်",
The_starting_number_must_be_less_than_the_ending_number:"အဆုံးနံပါတ်သည် စတင်နံပါတ်ထက် ကြီးရမည်။",
If_you_enter_the_start_number_2_end_number_5_and_basket_prefix_A_the_basket_will_be_generated_A2_A3_A4_A5:"ဥပမာအားဖြင့် စတင်နံပါတ် 2၊ အဆုံးနံပါတ် 5 နှင့် ဘတ်စကက်ခေါင်းစဉ် A ကို ထည့်ပါက ဘတ်စကက်များမှာ A-2၊ A-3၊ A-4၊ A-5 ဖြစ်ပါမည်။",
custom_specification:"တံဆိပ် အထူး သတ်မှတ်ချက်",
operational_context:"လုပ်ငန်း အကြောင်းအရာ",
Basket_number:"ပုံးနံပါတ်",
Please_enter_the_basket_name:"ပုံးနံပါတ်ကို ထည့်ပါ။",
Bulk_allocation_quantity:"အစုခွဲပမာဏ",
available:"ရရှိနိုင်",
occupy:"အသုံးပြုပြီး",
Allocation_task_for_additional_packing_material_delivery:"အစုခွဲတာဝန်အတွက် ထပ်ဆောင်းထုပ်ပိုးပစ္စည်းများ ပို့ဆောင်လိုက်ပါပြီ!",
The_basket_needs_to_be_placed_in_the_special_packing_area_of_the_item:"ဤပုံးကို အထူးပစ္စည်းထုပ်ပိုးရာတွင် ထားရမည်",
The_basket_needs_to_be_placed_in_the_special_packing_area_for_explosive_products:"ဤပုံးကို အရောင်းအကောင်းဆုံးအထူးထုပ်ပိုးရာတွင် ထားရမည်",
Please_place_in_the_nearest_single_item_delivery_area:"အစုခွဲပြီးစီးပါပြီ! အနီးဆုံး ပစ္စည်းပို့ဆောင်ရာဇုန်တွင် ထားပါ။",
Distribution_completed_Please_place_it_in_the_nearest_delivery_area:"ရွေးချယ်မှုပြီးစီးပါပြီ! နီးဆုံး အရောင်းအကောင်းဆုံးပစ္စည်း ပို့ဆောင်ရေးဧရိယာတွင် ထားပါ။",
If_the_inspection_fails_contact_the_administrator:"ပို့ဆောင်ရေးစာရွက် အတည်ပြုခြင်း မအောင်မြင်ပါ။ ဖြေရှင်းရန် အုပ်ချုပ်သူထံ ဆက်သွယ်ပါ။",
Incorrect_ticket_address_Failed_to_read_the_ticket:"ပို့ဆောင်ရေးစာရွက်လိပ်စာ မမှန်ပါ။ ပို့ဆောင်ရေးစာရွက် ဖတ်ရှုခြင်း မအောင်မြင်ပါ။",
Failed_to_parse_the_PDF_content:"ပို့ဆောင်ရေးစာရွက် အကြောင်းအရာ ပျက်စီးနေပါသည်။ PDF ခွဲခြမ်းစိတ်ဖြာခြင်း မအောင်မြင်ပါ။",
Failed_to_convert_PDF_to_JPG:"PDF မှ JPG ပြောင်းလဲခြင်း မအောင်မြင်ပါ။",
Failed_to_parse_the_JPG_content:"JPG အကြောင်းအရာ ခွဲခြမ်းစိတ်ဖြာခြင်း မအောင်မြင်ပါ။",
The_surface_bill_does_not_match_the_waybill:"ပို့ဆောင်ရေးစာရွက်သည် ပစ္စည်းပို့ဆောင်ရေးမှတ်တမ်းနှင့် မကိုက်ညီပါ။",
Enter_product_bar_codes_separated_by_SKU_line_breaks_for_batch_query:"ထုတ်ကုန် ဘားကုဒ်များနှင့် SKU များကို လိုင်းခွဲများဖြင့် ခွဲ၍ ထည့်ပါ၊ ထို့နောက် အစုလိုက် ရှာဖွေရန် batch query ခလုတ်ကို နှိပ်ပါ။",
Getting_data:"ဒေတာ ရှာဖွေနေသည်...",
The_shipping_mark_is_being_rendered:"အမှတ်တံဆိပ်များ ပြသနေသည်...",
Rendering_box_label:"ဘောက်စ် အမှတ်အသားများ ပြသနေသည်...",
Print_function_saved_as_PDF:"ပုံနှိပ်ခြင်း လုပ်ဆောင်ချက်: PDF အဖြစ် သိမ်းဆည်းရန်",
Set_the_default_printer_to:"မူလ ပရင်တာအဖြစ် သတ်မှတ်ရန်",
Microsoft_Print_to_PDF:"Microsoft Print to PDF",
Or_set_it_in_the_print_window_that_pops_up_after_you_click_Print:"Print ကို နှိပ်ပြီးနောက် ပေါ်လာမည့် ပုံနှိပ်ခြင်း စကားပြောဘောက်စ်တွင် ဆက်တင်များကို ချိန်ညှိပါ။",
After_setting_up_the_printer_click_Print_and_click_OK:"ပရင်တာကို သတ်မှတ်ပြီးနောက် Print ကို နှိပ်ပြီး OK ကို နှိပ်ပါ။",
Note_When_the_printer_does_not_have_suitable_paper_A4_paper_can_be_used_using_the_top_zoom_function_to_adjust:"မှတ်ချက်။ ပရင်တာတွင် သင့်လျော်သော စက္ကူမရှိပါက A4 စက္ကူကို အသုံးပြုပြီး ထိပ်ဘက်ရှိ စကေးချိန်ညှိမှု (top scaling) ဖြင့် ချိန်ညှိပါ။",
If_the_number_of_export_boxes_exceeds_300_boxes_it_will_be_divided_into_multiple_files_If_you_do_not_want_to_be_divided_into_multiple_files_please_use_the_print_function:"မှတ်ချက်။ PDF အဖြစ် သိမ်းဆည်းသည့်အခါ ဘောက်စ် ၃၀၀ ကျော်ကို ထုတ်ပို့ပါက ဖိုင်ကို အပိုင်းများစွာ ခွဲထုတ်မည်ဖြစ်သည်။ ခွဲထုတ်ခြင်း မဖြစ်စေရန် ပရင့်လုပ်ခြင်း လုပ်ဆောင်ချက်ကို အသုံးပြုပါ။",
Charge_items:"ကြေးအမျိုးအစား",
Add_currency_information:"ကြေးအချက်အလက် ထည့်သွင်းရန်",
Edit_currency_information:"ကြေးအချက်အလက် တည်းဖြတ်ရန်",
special_price:"အထူးစျေးနှုန်း",
default_price:"မူလစျေးနှုန်း",
discounted_price:"လျှော့စျေး",
Listing_fee:"စာရင်းတင်ကြေး",
order_processing_fee:"အော်ဒါဆောင်ရွက်ခ",
orderProcessingFee:"ကိုင်တွယ်ခ",
Destruction_delisting_fee:"ဖျက်/စာရင်းမှဖယ်ရှားခ",
Return_reshelving_fee:"ပြန်ပို့ထားသောပစ္စည်း ပြန်စာရင်းတင်ခ",
Return_listing_fee:"ပြန်ပို့ထားသောပစ္စည်း စာရင်းတင်ကြေး",
currency:"ငွေကြေး",
currency_Type:"ငွေကြေးအမျိုးအစား",
Please_select_currency_type:"ငွေကြေးအမျိုးအစားကိုရွေးချယ်ပါ။",
Please_enter_SKU:"SKU ကိုထည့်ပါ။",
Please_enter_Stock:"ဂိုဒေါင်ကိုထည့်ပါ။",
Please_enter_a_range_fee:"အကွာအဝေးကြေးကိုထည့်ပါ။",
Please_enter_the_number_of_ranges:"အကွာအဝေးအရေအတွက်ကိုထည့်ပါ။",
Please_select_Charge_items:"ကြေးအမျိုးအစားကိုရွေးချယ်ပါ။",
expense_breakdown:"ကြေးအသေးစိတ်",
Order_Status:"အော်ဒါအခြေအနေ",
Empty_product_details_exist_Please_check_and_try_again:"ထုတ်ကုန်အသေးစိတ် မမှန်ကန်မှုတွေ့ရှိပါသည်။ ပြန်လည်စစ်ဆေးပြီး ထပ်မံကြိုးစားပါ။",
There_are_duplicate_product_details_Please_check_and_try_again:"ထပ်တူထပ်မျှ ထုတ်ကုန်အသေးစိတ်များ ရှိနေပါသည်။ ကျေးဇူးပြု၍ ပြန်လည်စစ်ဆေးပြီး ထပ်မံကြိုးစားပါ။",
Skus_and_bar_codes_can_only_contain_English_numbers_and_symbols_and_Spaces:"SKU များနှင့် ထုတ်ကုန်ဘားကုဒ်များတွင် အင်္ဂလိပ်အက္ခရာများ၊ နံပါတ်များနှင့် အထူးသင်္ကေတများ (- , ., _, အကွာအဝေး) တို့သာ ပါဝင်ရမည်။",
After_activation_all_receiving_and_quality_inspection_information_will_be_cleared_The_stage_of_the_inbound_order_will_be_changed_to_Tail_end_Receiving_in_Progress_Please_complete_the_receiving_and_quality_inspection_operations_again:"ဖွင့်လှစ်ခြင်းသည် လက်ခံမှတ်တမ်းများနှင့် အရည်အသွေးစစ်ဆေးမှတ်တမ်းများအားလုံးကို ဖျက်ပစ်မည်။ ဝင်ရောက်အဆင့်သည် 'နောက်ဆုံးပို့ဆောင်မှုလက်ခံမှတ်တမ်း' သို့ ပြောင်းလဲမည်။ ကျေးဇူးပြု၍ လက်ခံခြင်းနှင့် စစ်ဆေးခြင်းလုပ်ထုံးလုပ်နည်းများကို အသစ်ပြန်လည် ပြီးစီးပါ။",
If_necessary_please_make_sure_to_save_the_relevant_delivery_and_quality_inspection_information_before_activation:"လိုအပ်ပါက၊ စတင်လုပ်ဆောင်မတိုင်မီ လက်ခံရေးနှင့် အရည်အသွေး စစ်ဆေးရေး မှတ်တမ်းများ သက်ဆိုင်ရာကို သိမ်းဆည်းထားပါ။",
SKU:"SKU",
Modified_by:"ပြင်ဆင်သူ",
founder:"ဖန်တီးသူ",
Please_enter_founder:"ဖန်တီးသူကို ထည့်ပါ။",
Please_enter_Modified_by:"ပြင်ဆင်သူကို ထည့်ပါ။",
tip:"မေးခွန်း",
Confirm_before_deleting:"ဤမှတ်တမ်းကို ဖျက်လိုပါသလား? ဖျက်ပြီးပါက ပြန်မရနိုင်ပါ။",
other:"အခြား",
ProductID:"ပစ္စည်းနံပါတ်",
batch_number:"အစုနံပါတ်",
Load_rate:"သိုလှောင်နှုန်း",
Menu_list:"မီနူးစာရင်း",
menuList:"မီနူးစာရင်း",
add_Menu:"မီနူးထည့်ရန်",
Batch_add_menu:"အစုလိုက် မီနူးထည့်ရန်",
Edit_Menu:"မီနူးတည်းဖြတ်ရန်",
Menu_Name:"မီနူး တရုတ်အမည်",
Menu_EnName:"မီနူး အင်္ဂလိပ်အမည်",
Please_enter_the_Menu_Name:"မီနူး တရုတ်အမည်ကို ထည့်ပါ",
Please_enter_the_Menu_EnName:"မီနူး အင်္ဂလိပ်အမည်ကို ထည့်ပါ",
Please_enter_menu_sort:"မီနူး စီစဉ်အဆင့်ကို ထည့်ပါ",
Menu_function:"မီနူး လုပ်ဆောင်ချက်",
Menu_Icon:"အိုင်ကွန်",
catalogue:"ဖိုလ်ဒါ",
Menu_Path:"မီနူးလိပ်စာ",
structure_configuration:"ဖွဲ့စည်းမှု ဖွဲ့စည်းခြင်း",
Please_enter_the_Menu_Path:"ဝင်ရောက်လိပ်စာကို ထည့်ပါ",
Menu_Sort:"မီနူး စီစဉ်အဆင့်",
Menu_Code:"မီနူးကုဒ်",
MenuPlease_enter_the_Menu_Code:"မီနူးကုဒ်ကို ထည့်ပါ",
MenuPlease_enter_the_Menu_address:"မီနူးလိပ်စာကို ထည့်ပါ",
Please_enter_Menu_Sort:"စီစဉ်အဆင့်ကို ထည့်ပါ",
Menu_Name_Not_Null:"မီနူး တရုတ်အမည် မလွတ်နိုင်ပါ",
Menu_EnName_Not_Null:"မီနူး အင်္ဂလိပ်အမည် မလွတ်နိုင်ပါ",
Menu_Code_Not_Null:"Menu Code မလွတ်နိုင်ပါ",
Paren_Menu:"မူလမီနူး",
Son_Menu:"ခွဲမီနူး",
Please_Select_Paren_Menu:"မူလမီနူးကို ရွေးချယ်ပါ",
Please_Select_Son_Menu:"ခွဲမီနူးကို ရွေးချယ်ပါ",
Menu_Level:"မီနူးအဆင့်",
Menu_creator:"မီနူးဖန်တီးသူ",
Menu_modifier:"မီနူးတည်းဖြတ်သူ",
Menu_creation_time:"မီနူးဖန်တီးသည့်နေ့စွဲ",
Menu_change_time:"မီနူးပြင်ဆင်သည့်နေ့စွဲ",
Menu_Type:"မီနူးအမျိုးအစား",
Menu_Stair:"အဆင့် ၁",
Menu_Second:"အဆင့် ၂",
Menu_Three:"အဆင့် ၃",
Visible:"မြင်သာမှု",
Remark:"မှတ်ချက်များ",
RemarkInfo:"မှတ်ချက်အချက်အလက်",
Please_Input_Remark:"မှတ်ချက်များ ထည့်ပါ",
scanWaybillNumber:"Waybill နံပါတ်ကို စကင်ပါ",
initialDistributionFlowLog:"အစပိုင်း ခရီးစဉ် ဖြန့်ဝေမှု မှတ်တမ်း",
logisticsChannelManagement:"ကုန်ပို့ဆောင်ရေးလမ်းကြောင်း စီမံခန့်ခွဲမှု",
logisticsChannelManagementList:"ကုန်ပို့ဆောင်ရေးလမ်းကြောင်း စီမံခန့်ခွဲမှု စာရင်း",
roleInfo:"အခန်းကဏ္ဍအချက်အလက်",
sysRole:"အခန်းကဏ္ဍစာရင်း",
roleList:"အခန်းကဏ္ဍစာရင်း",
Role_CnName:"အခန်းကဏ္ဍ တရုတ်အမည်",
Role_EnName:"အခန်းကဏ္ဍ အင်္ဂလိပ်အမည်",
Role_Code:"အခန်းကဏ္ဍ ထူးခြား ID",
Role_IsStart:"ဖွင့်ထားသည်",
Add_Role:"အခန်းကဏ္ဍ ထည့်ရန်",
Edit_Role:"အခန်းကဏ္ဍ ထည့်ရန်",
Role_Name:"အခန်းကဏ္ဍအမည်",
Please_Input_Role_Name:"အခန်းကဏ္ဍအမည်ကို ထည့်ပါ",
Please_Input_Role_CnName:"အခန်းကဏ္ဍ တရုတ်အမည်ကို ထည့်ပါ",
Please_Input_Role_EnName:"အခန်းကဏ္ဍ တရုတ်အမည်ကို ထည့်ပါ",
Please_Input_Role_Code:"အခန်းကဏ္ဍ ထူးခြား ID ကို ထည့်ပါ",
Reset:"ပြန်လည်စတင်",
ResetQuery:"မေးခွန်း ပြန်လည်စတင်",
reset_data:"ဒေတာ ပြန်လည်စတင်",
Role_Sort:"စီစဉ်",
Role_CnName_Not_Null:"အခန်းကဏ္ဍ တရုတ်အမည် မလွတ်နိုင်ပါ",
Role_EnName_Not_Null:"အခန်းကဏ္ဍ အင်္ဂလိပ်အမည် မလွတ်နိုင်ပါ",
Role_Code_Not_Null:"အခန်းကဏ္ဍ ထူးခြား ID မလွတ်နိုင်ပါ",
Accredit_Menu:"ခွင့်ပြုချက် မီနူး",
Accredit_Stock:"ခွင့်ပြုချက် သိမ်းဆည်းရာ",
More:"ထပ်မံ",
Editing_role:"အခန်းကဏ္ဍ တည်းဖြတ်",
Modifying_Role_Permissions:"အခန်းကဏ္ဍ ခွင့်ပြုချက်များ ပြင်ဆင်",
Role_describe:"အခန်းကဏ္ဍ ဖော်ပြချက်",
blocked_balances:"ခဲယဉ်းငွေ",
Amount_of_gift:"ခွင့်ပြုထားသော ပမာဏ",
Adjustment_type:"ပြင်ဆင်မှု အမျိုးအစား",
Adjustment_blocked_balances:"ခဲယဉ်းငွေ ပြင်ဆင်",
Adjustment_Amount_of_gift:"ခွင့်ပြုထားသော ပမာဏ ပြင်ဆင်",
role_state:"အခန်းကဏ္ဍ အခြေအနေ",
usersList:"အသုံးပြုသူ စာရင်း",
usersInfo:"အသုံးပြုသူ အချက်အလက်",
userManagement:"အသုံးပြုသူ စီမံခန့်ခွဲမှု",
User_Code:"အသုံးပြုသူ အကောင့်",
User_Name:"အသုံးပြုသူ အမည်",
User_CnName:"အခန်းကဏ္ဍ တရုတ်အမည်",
Owning_warehouse:"သိမ်းဆည်းရာ",
Role:"အခန်းကဏ္ဍ",
RoleManagement:"အခန်းကဏ္ဍ စီမံခန့်ခွဲမှု",
user_password:"အသုံးပြုသူ စကားဝှက်",
staff:"ဝန်ထမ်း",
staffManagement:"ဝန်ထမ်း စီမံခန့်ခွဲမှု",
dictionaries:"စကားလုံးစာအုပ်",
region:"ဒေသ",
stateManagement:"နိုင်ငံစီမံခန့်ခွဲမှု",
User_Branch:"ဌာန",
User_Phone:"မိုဘိုင်း",
User_Rank:"ရာထူး",
User_Email:"အီးမေးလ်",
User_EntryDate:"စတင်ရက်စွဲ",
User_Status:"အသုံးပြုသူအခြေအနေ",
commonUser:"စံအသုံးပြုသူ",
service:"ဖောက်သည်ဝန်ဆောင်မှု",
open:"ဖွင့်ထားသည်",
finance:"ဘဏ္ဍာရေး",
salesman:"အရောင်းကိုယ်စားလှယ်",
salesmanager:"အရောင်းမန်နေဂျာ",
superuser:"အထူးအသုံးပြုသူ",
overseasagency:"နိုင်ငံခြားကိုယ်စားလှယ်",
Please_select_User_Status:"အသုံးပြုသူအခြေအနေကို ရွေးချယ်ပါ",
Please_select_User_Role:"အသုံးပြုသူအခန်းကဏ္ဍကို ရွေးချယ်ပါ",
Please_select_User_Type:"အသုံးပြုသူအမျိုးအစားကို ရွေးချယ်ပါ",
Please_select_User_Branch:"ဌာနကို ရွေးချယ်ပါ",
Please_select_User_Sex:"လိင်ကို ရွေးချယ်ပါ",
Please_select_salesman:"အရောင်းကိုယ်စားလှယ်ကို ရွေးချယ်ပါ",
Please_select_service:"ဖောက်သည်ဝန်ဆောင်မှုကို ရွေးချယ်ပါ",
User_Type:"အသုံးပြုသူအမျိုးအစား",
User_Sex:"အသုံးပြုသူလိင်",
man:"ကျား",
woman:"မ",
User_Emergency:"အရေးပေါ်ဆက်သွယ်ရန်နံပါတ်",
User_PassWord:"စကားဝှက်",
User_confirmPassWord:"စကားဝှက်အတည်ပြု",
User_IDNumber:"အိုင်ဒီကတ်",
User_Address:"နေရပ်လိပ်စာ",
User_Unit:"အဖွဲ့အစည်း",
warehouseList:"ဂိုဒေါင်စာရင်း",
transshipmentdepot:"သယ်ယူပို့ဆောင်ရေးဂိုဒေါင်",
Please_Input_User_Name:"အသုံးပြုသူအမည် ထည့်ပါ",
Please_Input_transshipmentdepot:"သယ်ယူပို့ဆောင်ရေးဂိုဒေါင် ထည့်ပါ",
Please_select_transshipmentdepot:"သယ်ယူပို့ဆောင်ရေးဂိုဒေါင် ရွေးပါ",
Please_select_stock:"ဂိုဒေါင် ရွေးပါ",
Please_Input_User_Code:"အသုံးပြုသူကုဒ် ထည့်ပါ",
Please_Input_User_PassWord:"စကားဝှက် ထည့်ပါ",
Please_Input_User_confirmPassWord:"စကားဝှက် အတည်ပြုပါ",
Please_Input_User_Rank:"ရာထူး ထည့်ပါ",
Please_Input_User_IDNumber:"အိုင်ဒီနံပါတ် ထည့်ပါ",
Please_Input_User_Emergency:"အရေးပေါ်ဆက်သွယ်ရန်နံပါတ် ထည့်ပါ",
Please_Input_User_Phone:"မိုဘိုင်းနံပါတ် ထည့်ပါ",
Please_enter_the_correct_mobile_number:"မှန်ကန်သော မိုဘိုင်းနံပါတ် ထည့်ပါ",
Please_Input_User_Address:"နေရပ်လိပ်စာ ထည့်ပါ",
Please_Input_User_Email:"အီးမေးလ်လိပ်စာ ထည့်ပါ",
Please_enter_the_correct_email_address:"မှန်ကန်သော အီးမေးလ်လိပ်စာ ထည့်ပါ",
Please_Input_User_Unit:"အဖွဲ့အစည်း ထည့်ပါ",
Please_Input_User_Status:"အခြေအနေ ရွေးပါ",
Please_Input_User_Role:"တာဝန် ရွေးပါ",
Entered_passwords_differ:"ထည့်သွင်းထားသော စကားဝှက်များ မကိုက်ညီပါ။",
The_password_contains_less_than_characters:"စကားဝှက်အရှည်သည် အနည်းဆုံး ၆ အက္ခရာ ရှိရမည်။",
Tpntbco816dolnos:"စကားဝှက်တွင် အက္ခရာ၊ နံပါတ်နှင့် သင်္ကေတများ ပါဝင်၍ စုစုပေါင်း ၈ မှ ၁၆ အက္ခရာ ရှိရမည်။",
The_password_must_contain_8_to_16_characters:"စကားဝှက်အရှည်ကို ၈ မှ ၁၆ အက္ခရာအထိ သတ်မှတ်ပါ။",
It_is_currently_being_exported:"လက်ရှိ တင်ပို့နေပါသည်။",
When_there_are_many_PDFS_to_be_saved_it_is_recommended_to_export_them_in_batches:"PDF များစွာကို တစ်ပြိုင်နက် တင်ပို့ရာတွင် အစုလိုက်လုပ်ငန်းစဉ်ကို အကြံပြုပါသည်။",
It_is_recommended_when_there_are_a_large_number_of_PDFS_to_be_saved:"PDF များစွာကို တစ်ပြိုင်နက် တင်ပို့ရာတွင် အစုလိုက် တင်ပို့ရန် အကြံပြုပါသည်။",
Export_in_batches:"အစုလိုက် ထုတ်ပို့ခြင်း",
The_left_navigation_allows_you_to_select_the_number_of_boxes_to_printSKU_and_quantity:"ဘယ်ဘက် မီနူးမှ ပုံနှိပ်ဘောက်စ်အရေအတွက်၊ SKU နှင့် အရေအတွက်ကို ရွေးချယ်နိုင်သည်။",
Add_User:"အသုံးပြုသူအသစ် ထည့်ရန်",
Please_Select:"ကျေးဇူးပြု၍ ရွေးချယ်ပါ",
Please_select_the_print_size:"ကျေးဇူးပြု၍ ပုံနှိပ်အရွယ်အစားကို ရွေးချယ်ပါ",
Please_select_a_single_customer:"ကျေးဇူးပြု၍ ဖောက်သည်တစ်ဦးချင်းစီကို ရွေးချယ်ပါ",
Please_select_print_data:"ကျေးဇူးပြု၍ ပုံနှိပ်ဒေတာကို ရွေးချယ်ပါ",
Please_select_a_single_warehouse:"ကျေးဇူးပြု၍ ဂိုဒေါင်တစ်ခုချင်းစီကို ရွေးချယ်ပါ",
Please_select_the_same_order_type_order:"ကျေးဇူးပြု၍ တစ်မျိုးတည်းသော အော်ဒါအမျိုးအစားရှိ အော်ဒါများကို ရွေးချယ်ပါ",
Please_Select_Task_Name:"ကျေးဇူးပြု၍ တာဝန်အမည်ကို ရွေးချယ်ပါ",
Please_Select_Order:"ကျေးဇူးပြု၍ အော်ဒါကို ရွေးချယ်ပါ",
Please_select_the_business_condition:"ကျေးဇူးပြု၍ စီးပွားရေးအခြေအနေကို ရွေးချယ်ပါ",
Please_Select_Date:"ကျေးဇူးပြု၍ အချိန်ကို ရွေးချယ်ပါ",
Please_select_billing_properties:"ကျေးဇူးပြု၍ ငွေတောင်းခံခြင်း အင်္ဂါရပ်ကို ရွေးချယ်ပါ",
Please_select_whether_it_can_be_edited:"ကျေးဇူးပြု၍ တည်းဖြတ်နိုင်ခြင်း ရှိ/မရှိကို ရွေးချယ်ပါ",
Enabled:"ဖွင့်ရန်",
Batch_enabled_goods:"ထုတ်ကုန်များကို အစုလိုက် ဖွင့်ရန်",
Prohibited_goods_in_bulk:"ထုတ်ကုန်များကို အစုလိုက် ပိတ်ရန်",
Close:"ပိတ်ရန်",
all_transshipmentdepot:"သယ်ယူပို့ဆောင်ရေး ဂိုဒေါင်အားလုံး",
all_warehouse:"ဂိုဒေါင်အားလုံး",
Please_select_a_type:"အမျိုးအစားကို ရွေးချယ်ပါ",
Please_select_content:"အကြောင်းအရာကို ရွေးချယ်ပါ",
Cost_information:"ကြေးသတင်းအချက်အလက်",
Please_select_a_contact:"ဆက်သွယ်ရန်ကို ရွေးချယ်ပါ",
The_same_rule_already_exists:"တူညီသော စည်းကမ်းချက် ရှိပြီးသားဖြစ်သည်",
Please_select_the_goods_for_which_the_storage_location_needs_to_be_changed:"သိုလှောင်ရာနေရာ ပြောင်းရန် လိုအပ်သော ထုတ်ကုန်များကို ရွေးချယ်ပါ",
all_partition:"ဇုန်အားလုံး",
enabled_product:"ထုတ်ကုန် ဖွင့်ရန်",
prohibited_product:"ထုတ်ကုန် ပိတ်ရန်",
set_inventory_warning:"ကုန်ပစ္စည်း သတိပေးချက် သတ်မှတ်ရန်",
When_a_single_warehouse_is_selected_either_the_priority_picking_floor_or_the_priority_picking_zone_must_be_filled_in_one_of_the_two:"ဂိုဒေါင်တစ်ခုသာ ရွေးချယ်သောအခါ ဦးစားပေးရွေးယူသည့် ကြမ်းပြင်နှင့် ဦးစားပေးရွေးယူသည့် ဇုန်သည် မဖြစ်မနေဖြည့်ရမည့် ကွက်လပ်များဖြစ်သည် (တစ်ခုသာ ရွေးပါ)",
department:"ဌာန",
Investment_promotion_department:"စီးပွားရေးဖွံ့ဖြိုးတိုးတက်ရေး",
accounting_department:"ဘဏ္ဍာရေး",
customer_service_department:"ဖောက်သည်ဝန်ဆောင်မှု",
management_department:"အုပ်ချုပ်ရေး",
oversea_location:"ပြည်ပဂိုဒေါင်များ",
distribution:"ဖြန့်ဖြူးရေး",
IT:"အိုင်တီ",
Logistics_Department:"လိုဂျစ်စတစ်စ်",
staffList:"ဝန်ထမ်းစာရင်း",
personal_details:"ကိုယ်ရေးအချက်အလက်",
contact_Information:"ဆက်သွယ်ရန်အချက်အလက်",
Owning_Information:"ဆက်စပ်အဖွဲ့အစည်းအချက်အလက်",
account_Information:"အကောင့်အချက်အလက်",
upload_photo_as_avatar:"ပရိုဖိုင်ဓာတ်ပုံ တင်ပါ",
staffInfo:"ဝန်ထမ်းအချက်အလက်",
staff_name:"ဝန်ထမ်းအမည်",
staff_Code:"ဝန်ထမ်းအကောင့်",
staff_Status:"ဝန်ထမ်းအခြေအနေ",
staff_Role:"ဝန်ထမ်းတာဝန်",
staff_gender:"ဝန်ထမ်းလိင်",
staffType:"ဝန်ထမ်းအမျိုးအစား",
staff_password:"ဝန်ထမ်းစကားဝှက်",
Laborial_Staff:"ပုံမှန်ဝန်ထမ်း",
Administrator:"အုပ်ချုပ်သူ",
Please_enter_the_employee_name:"ဝန်ထမ်းအမည် ထည့်ပါ",
Please_enter_your_employee_ID:"ဝန်ထမ်းအကောင့် ထည့်ပါ",
Please_select_member_type:"ဝန်ထမ်းအမျိုးအစားကို ရွေးချယ်ပါ",
createStaff:"ဝန်ထမ်းအသစ်ဖန်တီး",
editStaff:"ဝန်ထမ်းတည်းဖြတ်",
Please_select_member:"ဝန်ထမ်းကို ရွေးချယ်ပါ",
Please_select_an_employee_role:"ဝန်ထမ်းအခန်းကဏ္ဍကို ရွေးချယ်ပါ",
batch_edit_staff_type:"ဝန်ထမ်းအမျိုးအစားအစုလိုက်တည်းဖြတ်",
create_staff:"ဝန်ထမ်းအသစ်ဖန်တီး",
batch_create_staff:"ဝန်ထမ်းများအစုလိုက်ဖန်တီး",
batchCreateStaff:"ဝန်ထမ်းများအစုလိုက်ဖန်တီး",
batch_modify:"အစုလိုက်ပြင်ဆင်",
Import_employees:"ဝန်ထမ်းများတင်သွင်း",
Enter_employee_account:"ဝန်ထမ်းအကောင့်သို့ ဝင်ရောက်",
Prioritize_stock_allocation:"ဦးစားပေးခွဲဝေခြင်း",
Module_Permissions:"မော်ဂျူးခွင့်ပြုချက်များ",
All_Modules:"မော်ဂျူးအားလုံး",
After_selecting_a_module_you_can_view_the_data_of_restricted_modules:"မော်ဂျူးတစ်ခုကို ရွေးချယ်ပြီးနောက် ကန့်သတ်ထားသော မော်ဂျူးများမှ ဒေတာများကို မြင်နိုင်မည်ဖြစ်သည်",
provided_that_the_corresponding_warehouse_or_transit_permissions_are_set:"သက်ဆိုင်ရာ ဂိုဒေါင်/ဖြတ်သန်းဂိုဒေါင် ခွင့်ပြုချက်များ ဖွဲ့စည်းထားပါက",
Add_consumables_type:"အသုံးအဆောင်ပစ္စည်း အမျိုးအစား ထည့်ရန်",
Edit_consumables_type:"အသုံးအဆောင်ပစ္စည်း အမျိုးအစား တည်းဖြတ်ရန်",
Consumable_name:"အသုံးအဆောင်ပစ္စည်း အမည်",
Description_of_consumables:"အသုံးအဆောင်ပစ္စည်း ဖော်ပြချက်",
Please_enter_the_consumable_name:"အသုံးအဆောင်ပစ္စည်း အမည် ထည့်ပါ",
Please_enter_a_description_of_the_consumable:"အသုံးအဆောင်ပစ္စည်း ဖော်ပြချက် ထည့်ပါ",
type_name:"အမျိုးအစား အမည်",
Type_description:"အမျိုးအစား ဖော်ပြချက်",
Change_the_time:"ပြင်ဆင်ချိန်",
Add_consumables:"အသုံးအဆောင်ပစ္စည်း ထည့်ရန်",
Add_consumable_information:"အသုံးအဆောင်ပစ္စည်း အချက်အလက် ထည့်ရန်",
Editing_Supplies_Information:"အသုံးအဆောင်ပစ္စည်း အချက်အလက် တည်းဖြတ်ရန်",
Consumables_Code:"အသုံးအဆောင်ပစ္စည်း ကုဒ်",
Consumable_size:"အသုံးအဆောင်ပစ္စည်း အတိုင်းအတာများ",
Number_of_consumables:"အသုံးအဆောင်ပစ္စည်း အရေအတွက်",
single_standard_price:"ယူနစ် စံဈေးနှုန်း",
long:"အရှည်",
long_cm:"အရှည် (စင်တီမီတာ)",
outer_box_long_cm_one:"အပြင်ဘောက်စ် အရှည် (စင်တီမီတာ/ပစ္စည်း)",
Receiving_outer_box_long_cm_one:"လက်ခံရရှိသော အပြင်ဘောက်စ် အရှည် (စင်တီမီတာ/ယူနစ်)",
please_enter_Receiving_outer_box_long_cm_one:"လက်ခံရရှိသော အပြင်ဘောက်စ် အရှည် (စင်တီမီတာ/ယူနစ်) ကို ထည့်ပါ။",
width:"အကျယ်",
width_cm:"အကျယ် (စင်တီမီတာ)",
outer_box_width_cm_one:"အပြင်ဘောက်စ် အကျယ် (စင်တီမီတာ/ယူနစ်)",
Receiving_outer_box_width_cm_one:"လက်ခံရရှိသော အပြင်ဘောက်စ် အကျယ် (စင်တီမီတာ/ယူနစ်)",
please_enter_Receiving_outer_box_width_cm_one:"လက်ခံရရှိသော အပြင်ဘောက်စ် အကျယ် (စင်တီမီတာ/ယူနစ်) ကို ထည့်ပါ။",
Received_weight_KG_one:"လက်ခံရရှိသော အလေးချိန် (ကီလိုဂရမ်/ယူနစ်)",
Received_weight_KG:"လက်ခံရရှိသော အလေးချိန်",
please_enter_Received_weight_KG_one:"လက်ခံရရှိသော အလေးချိန် (ကီလိုဂရမ်/ယူနစ်) ကို ထည့်ပါ။",
height:"အမြင့်",
height_cm:"အမြင့် (စင်တီမီတာ)",
outer_box_height_cm_one:"အပြင်ဘောက်စ် အမြင့် (စင်တီမီတာ/ပစ္စည်း)",
Receiving_outer_box_height_cm_one:"လက်ခံမည့် အပြင်ဘောက်စ် အမြင့် (စင်တီမီတာ/ပစ္စည်း)",
please_enter_Receiving_outer_box_height_cm_one:"လက်ခံမည့် အပြင်ဘောက်စ် အမြင့် (စင်တီမီတာ/ပစ္စည်း) ကို ထည့်ပါ။",
Please_enter_the_consumable_code:"အသုံးအဆောင်ကုဒ်ကို ထည့်ပါ။",
Please_enter_length_width_and_height:"အရှည်၊ အကျယ်၊ အမြင့် အတိုင်းအတာများကို ထည့်ပါ။",
Please_enter_the_quantity_of_consumables:"အသုံးအဆောင်အရေအတွက်ကို ထည့်ပါ။",
Please_enter_a_single_standard_price:"တစ်ယူနစ် စံဈေးနှုန်းကို ထည့်ပါ။",
Please_select_a_warehouse:"ဂိုဒေါင်ကို ရွေးပါ။",
Please_enter_warehouse:"ဂိုဒေါင်ကို ထည့်ပါ။",
Please_select_a_consumable_type:"အသုံးအဆောင်အမျိုးအစားကို ရွေးပါ။",
Consumable_Type:"အသုံးအဆောင်အမျိုးအစား",
Billing_way:"ငွေချေမှုနည်းလမ်း",
The_priority_billing_method_shall_prevail:"ဦးစားပေးငွေချေမှုနည်းလမ်း သက်ဆိုင်ပါသည်",
Excluding_the_amount:"ထည့်မပါသော ပမာဏ",
Automatically_calculate_the_estimated_inventory_formula:"ကုန်ပစ္စည်းသတိပေးချက် ဖော်မြူလာကို အလိုအလျောက်တွက်ချက်ခြင်း",
All_billing_methods_will_be_calculated_and_the_highest_fee_will_be_taken_as_the_standard:"ငွေတောင်းခံနည်းလမ်းအားလုံးကို တွက်ချက်မည်ဖြစ်ပြီး၊ ကုန်ကျစရိတ်အမြင့်ဆုံးကို ဦးစားပေးမည်",
Billing_attribute:"ငွေတောင်းခံခြင်းဆိုင်ရာ အင်္ဂါရပ်များ",
Stores_operation_accounting_attributes:"ဂိုဒေါင်လုပ်ငန်း ငွေတောင်းခံခြင်းဆိုင်ရာ အင်္ဂါရပ်များ",
Precedence_Billing_way:"ဦးစားပေး ငွေတောင်းခံနည်း",
Please_select_Precedence_Billing_way:"ဦးစားပေး ငွေတောင်းခံနည်းကို ရွေးချယ်ပါ",
The_number_of_the_first_charge:"ပထမဆုံးပစ္စည်း ငွေတောင်းခံအရေအတွက်",
The_number_of_the_first_billing_item_must_not_be_less_than_1:"ပထမဆုံးပစ္စည်း ငွေတောင်းခံအရေအတွက်သည် ၁ ထက် မနည်းရ",
please_enter_The_number_of_the_first_charge:"ပထမဆုံးပစ္စည်း ငွေတောင်းခံအရေအတွက်ကို ထည့်ပါ",
Please_enter_the_number_of_items_for_which_the_charge_will_be_calculated:"နောက်ထပ်ပစ္စည်း ဘီလ်ထုတ်မည့် အရေအတွက်ကို ထည့်ပါ။",
The_continuation_charge_amount_cannot_be_less_than_1:"နောက်ထပ်ပစ္စည်း ဘီလ်ထုတ်မည့် အရေအတွက်သည် ၁ ထက် မနည်းရ။",
Please_select_Billing_way:"ဘီလ်ထုတ်နည်းကို ရွေးပါ။",
Volume_weight_value:"ထုထည်အလေးချိန် တန်ဖိုး",
Please_enter_volume_weight_value:"ထုထည်အလေးချိန် တန်ဖိုးကို ထည့်ပါ။",
Please_enter_the_case_number:"ဘောက်စ်နံပါတ်ကို ထည့်ပါ။",
The_case_number_does_not_exist:"ဤဘောက်စ်နံပါတ် မရှိပါ။",
The_sku_does_not_exist:"ဤကုန်ပစ္စည်းကုဒ် မရှိပါ။",
Save_receipt:"လက်ခံလွှာ သိမ်းဆည်းခြင်း",
Save_receipt_succeed:"လက်ခံလွှာကို အောင်မြင်စွာ သိမ်းဆည်းပြီးပါပြီ။",
Please_stock_the_goods_at_the_specified_distribution_warehouse:"သတ်မှတ်ထားသော ရွေးယူရာနေရာမှ ရွေးယူပါ။",
putaway:"သိုလှောင်ခြင်း",
Inventory_batch_number:"ကုန်ပစ္စည်းအစုအမှတ်",
unfinished:"မပြီးစီးသေး",
completed:"ပြီးစီးပါပြီ",
Export_the_pairing_data:"ကိုက်ညီသည့် ဒေတာ ထုတ်ပို့ခြင်း",
Currently_no_floor_is_added_to_the_warehouse_Please_perform_this_operation_after_adding_a_floor:"လက်ရှိ ဂိုဒေါင်တွင် ထပ်တန်း မထည့်သွင်းထားပါ။ ဤ လုပ်ငန်းစဉ်ကို ဆက်လက်လုပ်ဆောင်ရန် မတိုင်မီ ထပ်တန်း တစ်ခု ထည့်သွင်းပါ။",
If_the_selected_data_exists_the_selected_data_is_processed_preferentially_for_batch_processing:"ရွေးချယ်ထားသော ဒေတာများ ရှိပါက အစုလိုက် လုပ်ငန်းစဉ်အတွက် ရွေးချယ်ထားသော ဒေတာများကို ဦးစားပေး ဆောင်ရွက်ပါ။",
If_the_selected_data_is_not_selected_manually_fill_in_the_box_number_range_for_batch_processing:"ဒေတာ မရွေးချယ်ထားပါက အစုလိုက် လုပ်ငန်းစဉ်အတွက် ဘောက်စ်နံပါတ် အကွာအဝေးကို လက်ဖြင့် ထည့်ပါ။",
If_the_field_value_is_empty_the_field_data_is_not_modified:"ကွက်လပ် တန်ဖိုးသည် ဗလာ သို့မဟုတ် 0.00 ဖြစ်ပါက ကွက်လပ် ဒေတာကို မပြောင်းလဲပါ။",
Momentumfee:"တစ်ခုချင်းစီ ပို့ဆောင်ခ သတ်မှတ်ချက်များ",
export:"ထုတ်ပို့ခြင်း",
Export_the_header_order:"ထွက်ပို့ အော်ဒါများ ထုတ်ပို့ခြင်း",
Export_the_header_list:"ထွက်ပို့ စာရင်းများ ထုတ်ပို့ခြင်း",
Export_the_First_bill:"ထွက်ပို့ ငွေတောင်းခံလွှာများ ထုတ်ပို့ခြင်း",
Export_the_import_and_export_details:"ဝင်/ထွက် အသေးစိတ် အချက်အလက်များ ထုတ်ပို့ခြင်း",
Three_sides_before_weight:"အတိုင်းအတာ ပထမ၊ အလေးချိန် ဒုတိယ",
First_weight_then_three_sides:"အလေးချိန် ပထမ၊ အတိုင်းအတာ ဒုတိယ",
First_cubic_then_weight:"ကုဗစ်မီတာ ပထမ၊ အလေးချိန် ဒုတိယ",
First_weight_then_cube:"အလေးချိန် ပထမ၊ ကုဗစ်မီတာ ဒုတိယ",
First_cube_and_then_three_sides:"ကုဗစ်မီတာ ပထမ၊ အတိုင်းအတာ ဒုတိယ",
Three_sides_before_the_cube:"အတိုင်းအတာ ပထမ၊ ကုဗစ်မီတာ ဒုတိယ",
entryAndExitDetails:"ဝင်/ထွက် အသေးစိတ် အချက်အလက်များ",
add:"ထည့်ရန်",
Batch_add:"အစုလိုက် ထည့်ရန်",
Batch_delete:"အစုလိုက် ဖျက်ရန်",
date:"ရက်စွဲ",
The_longest_edge:"အရှည်ဆုံး အတိုင်းအတာ",
Long_side:"ဒုတိယ အရှည်ဆုံး အတိုင်းအတာ",
The_shortest_edge:"အတိုဆုံး အတိုင်းအတာ",
weight:"အလေးချိန်",
Start_weight:"အစအလေးချိန်",
End_weight:"အဆုံးအလေးချိန်",
weight_KG:"အလေးချိန် (ကီလိုဂရမ်)",
number:"ပစ္စည်းအရေအတွက်",
Add_interval:"အကွာအဝေး ထည့်ရန်",
SumThreeSides:"စုစုပေါင်း အတိုင်းအတာများ",
SumThreeSides_CM:"စုစုပေါင်း အတိုင်းအတာ (စင်တီမီတာ)",
The_sum_of_the_three_sides_cannot_be_negative:"စုစုပေါင်း အတိုင်းအတာများသည် အနုတ်မဖြစ်ရ",
First_packing_material_cost:"အစ ပက်ကေ့ဂျင်းကြေး",
Three_sides_length:"အတိုင်းအတာများ၏ စုစုပေါင်း",
Three_sides:"အတိုင်းအတာများ",
Start_hree_sides_length:"အစ အတိုင်းအတာများ",
End_hree_sides_length:"အဆုံး အတိုင်းအတာများ",
Three_sides_length_CM:"ဘက်သုံးဖက်ပေါင်း (စင်တီမီတာ)",
actual_SumThreeSides:"အမှန်တကယ် ဘက်သုံးဖက်ပေါင်း",
actual_SumThreeSides_CM:"အမှန်တကယ် ဘက်သုံးဖက်ပေါင်း (စင်တီမီတာ)",
Continued_SKU_packaging_costs:"ထပ်မံ SKU ထုပ်ပိုးခ",
The_number_of_continuations_is_charged:"ထပ်မံပစ္စည်းအရေအတွက်",
Please_enter_the_number_of_continuation_charges:"ထပ်မံပစ္စည်းအရေအတွက် ထည့်ပါ",
cost_a:"တစ်ခုလျှင် ကြေး",
Cost_attribute:"ကြေး အင်္ဂါရပ်",
cost_one_day_cube:"ကြေး (တစ်ရက်/တစ်ကုဗ์မီတာလျှင်)",
cube:"ကုဗ์မီတာ",
Start_cube:"စတင်ကုဗ်မီတာ",
End_cube:"အဆုံးကုဗ်မီတာ",
Extra_charge:"ထပ်မံ SKU ကိုင်တွယ်ခ",
One_charge:"အစ SKU ကိုင်တွယ်ခ",
One_Packaging_material:"အစ SKU ထုပ်ပိုးခ",
Extra_Packaging_material:"ထပ်မံ SKU ထုပ်ပိုးခ",
Currency_type:"ငွေကြေး",
Original_Currency_type:"မူရင်းငွေကြေး",
Packaging_material_cost:"ထုပ်ပိုးခ",
packagingMaterialManagement:"ထုပ်ပိုးမှု စီမံခန့်ခွဲမှု",
Please_enter_Currency_type:"ငွေကြေးကို ထည့်ပါ။",
Please_select_Currency_type:"ငွေကြေးကို ရွေးပါ။",
Please_enter_The_longest_edge:"အရှည်ဆုံးဘက်ကို ထည့်ပါ။",
Please_enter_Long_side:"ဒုတိယအရှည်ဆုံးဘက်ကို ထည့်ပါ။",
Please_enter_The_shortest_edge:"အတိုဆုံးဘက်ကို ထည့်ပါ။",
Please_enter_weight:"အလေးချိန်ကို ထည့်ပါ။",
Please_enter_quantity:"အရေအတွက်ကို ထည့်ပါ။",
Please_enter_SumThreeSides:"ဘက်သုံးဘက် စုစုပေါင်း အရှည်ကို ထည့်ပါ။",
Please_enter_cost_a:"ဘက်သုံးဘက် စုစုပေါင်း အရှည်ကို ထည့်ပါ။",
Please_enter_cost:"ကြေးကို ထည့်ပါ။",
Please_enter_Extra_charge:"ထပ်ဆောင်း SKU ကိုင်တွယ်ခကို ထည့်ပါ။",
Please_enter_One_charge:"အစ SKU ကိုင်တွယ်ခကို ထည့်ပါ။",
Please_enter_number:"ပစ္စည်းအရေအတွက်ကို ထည့်ပါ။",
Please_enter_One_Packaging_material:"အစ SKU ထုပ်ပိုးခကို ထည့်ပါ။",
Please_enter_Extra_Packaging_material:"ထပ်ဆောင်း SKU ထုပ်ပိုးခ ထည့်ပါ။",
Cancel_the_editor:"ပြင်ဆင်ခြင်းကို ဖျက်ရန်",
Cancel_the_add:"ထည့်သွင်းခြင်းကို ဖျက်ရန်",
Failed_to_start_the_camera_Please_check_whether_the_camera_is_available_Or_turn_on_the_camera_head:"ကင်မရာဖွင့်ရန် မအောင်မြင်ပါ။ ကင်မရာ လုပ်ဆောင်နိုင်မှုကို စစ်ဆေးပါ။ ဒါမှမဟုတ် ကင်မရာ ဝင်ခွင့် ခွင့်ပြုပါ။",
This_operation_cannot_be_undone_Do_you_want_to_continue:"ဤ လုပ်ဆောင်ချက်ကို ပြန်မလုပ်နိုင်ပါ။ ဆက်လက်ရန်?",
size:"အတိုင်းအတာများ",
Please_select_size:"အတိုင်းအတာများကို ရွေးပါ။",
Please_enter_size:"အတိုင်းအတာများ ထည့်ပါ။",
Three_high:"အရှည် x အကျယ် x အမြင့်",
packaging:"ထုပ်ပိုးနည်း",
The_whole_pack:"အမှာစာတစ်ခုလုံး ထုပ်ပိုးခြင်း",
Pack_by_sku:"SKU အခြေပြု ထုပ်ပိုးခြင်း",
Packing_according_to_the_entire_order_will_pack_all_the_items_in_the_entire_order_together:"အော်ဒါတစ်ခုလုံးအလိုက် ထုပ်ပိုးခြင်းသည် အော်ဒါအတွင်းရှိ ပစ္စည်းအားလုံးကို တစ်စုတည်းအဖြစ် ထုပ်ပိုးပေးမည်",
Package_according_to_SKU_and_pack_together_with_SKU:"SKU အလိုက် ထုပ်ပိုးခြင်းသည် SKU တူညီသော ပစ္စည်းများကို တစ်စုတည်းအဖြစ် ထုပ်ပိုးပေးမည်",
All_items_will_be_packaged_separately:"ပစ္စည်းအားလုံးကို တစ်ခုချင်းစီ သီးခြား ထုပ်ပိုးမည်",
Create_a_warehouse_entry:"လက်ခံမှတ်တမ်း ဖန်တီးရန်",
Separate_product_packaging:"ပစ္စည်းတစ်ခုချင်းစီ ထုပ်ပိုးခြင်း",
editCost:"ကြေးများ ပြင်ဆင်ရန်",
outbound_pictures:"ထွက်ပို့ဓာတ်ပုံ",
photo_list:"ဓာတ်ပုံစာရင်း",
scan_pictures:"စကင်ပြီး ဓာတ်ပုံရိုက်ခြင်း",
scanning_waybill_number:"ပို့ဆောင်ရေးမှတ်ပုံတင်နံပါတ် စကင်ခြင်း",
The_operation_fails_Check_whether_the_input_of_the_waybill_number_is_correct:"လုပ်ငန်းစဉ် မအောင်မြင်ပါ။ ထည့်သွင်းထားသော waybill နံပါတ်ကို ပြန်လည်စစ်ဆေးပါ။",
Review_images:"ဓာတ်ပုံများ ကြည့်ရှုရန်",
Operation_of:"အော်ပရေတာ",
start_time:"စတင်ချိန်",
End_days:"ကြာမြင့်ချိန် (ရက်)",
Please_enter_the_start_time:"စတင်ချိန် ထည့်ပါ။",
Please_enter_the_end_time:"အဆုံးချိန် ထည့်ပါ။",
The_input_start_time_cannot_be_negative:"ထည့်သွင်းထားသော စတင်ချိန်သည် အနုတ်မဖြစ်နိုင်ပါ။",
The_end_time_cannot_be_negative:"ထည့်သွင်းထားသော အဆုံးချိန်သည် အနုတ်မဖြစ်နိုင်ပါ။",
The_start_time_cannot_be_later_than_the_end_time:"စတင်ချိန်သည် အဆုံးချိန်ထက် နောက်မကျနိုင်ပါ။",
The_end_time_cannot_be_later_than_the_start_time:"အဆုံးချိန်သည် စတင်ချိန်ထက် မရှေ့မဖြစ်နိုင်ပါ။",
end_time:"အဆုံးချိန်",
Batch_set_roles:"အုပ်စုတာဝန် ခန့်အပ်ခြင်း",
Bulletin:"ကြေညာချက်များ",
BulletinManagement:"ကြေညာချက် စီမံခန့်ခွဲမှု",
Bulletin_Type:"ကြေညာချက် အမျိုးအစား",
Bulletin_Name:"ကြေညာချက် ခေါင်းစဉ်",
This_window_asks_if_you_want_to_leave:"ဤပြတင်းပေါက်တွင် ထွက်လိုပါသလား မေးနေပါသည်",
The_information_you_enter_may_not_be_saved:"သင်ထည့်သွင်းထားသော အချက်အလက်များ မသိမ်းဆည်းနိုင်ပါ",
New_announcement:"ကြေညာချက် ထည့်ရန်",
announcementState:"ကြေညာချက် အခြေအနေ",
workOrder:"လက်မှတ် စီမံခန့်ခွဲမှု",
workOrderList:"လက်မှတ် စာရင်း",
work_order_ID:"လက်မှတ် ID",
problem_description:"ပြဿနာ ဖော်ပြချက်",
problem_types:"ပြဿနာ အမျိုးအစား",
processed_time:"ဆောင်ရွက်ချိန်",
processor:"ဆောင်ရွက်သူ",
discuss:"မှတ်ချက်များ",
ranking:"အဆင့်သတ်မှတ်ချက်",
turn_off_time:"ပိတ်သိမ်းချိန်",
New_work_order:"လက်မှတ်အသစ်ဖန်တီးရန်",
result_of_handling:"ဖြေရှင်းချက်",
Please_enter_the_work_order_ID:"လက်မှတ် ID ကို ထည့်ပါ။",
Please_provide_the_description_of_the_problem:"ပြဿနာဖော်ပြချက်ကို ထည့်ပါ။",
Please_provide_the_result_of_handling:"ဖြေရှင်းချက်ကို ထည့်ပါ။",
Work_order_information:"လက်မှတ်အချက်အလက်",
Should_this_work_order_be_invalidated:"ဤလက်မှတ်ကို ဖျက်မည်လား?",
to_deal_with:"ဖြေရှင်းရန် ဆက်လက်လုပ်ဆောင်ပါ",
Work_order_processing:"လက်မှတ်ဖြေရှင်းချက်",
reply:"ပြန်ဖြေ",
Please_select_the_type_of_question:"ပြဿနာအမျိုးအစားကို ရွေးပါ။",
Please_select_the_rating_level:"အဆင့်သတ်မှတ်မှုအဆင့်ကို ရွေးပါ။",
Please_enter_your_evaluation:"အကဲဖြတ်ချက်ကို ထည့်ပါ။",
initiator:"စတင်သူ",
Adding_dictionary_Categories:"စာရင်းအဘိဓာန်အမျိုးအစား ထည့်ရန်",
DictionaryList:"စာရင်းအဘိဓာန်စာရင်း",
dictionaryList:"စကားလုံးစာရင်း",
EditDictionary:"စကားလုံး တည်းဖြတ်ခြင်း",
Please_enter_the_dictionary_name:"စကားလုံးအမည် ထည့်ပါ",
Name_of_dictionary:"စကားလုံးအမည်",
Chinese_name:"တရုတ်အမည်",
English_name:"အင်္ဂလိပ်အမည်",
Goods_Chinese_name:"ထုတ်ကုန် တရုတ်အမည်",
Goods_English_name:"ထုတ်ကုန် အင်္ဂလိပ်အမည်",
setpoint:"တန်ဖိုး",
Please_enter_Chinese_name:"တရုတ်အမည် ထည့်ပါ",
Please_enter_English_name:"အင်္ဂလိပ်အမည် ထည့်ပါ",
Please_enter_setpoint:"တန်ဖိုး ထည့်ပါ",
Add_dictionary:"စကားလုံး ထည့်ခြင်း",
Batch_Add_dictionary:"စကားလုံးများ အစုလိုက် ထည့်ခြင်း",
value:"တန်ဖိုး",
Please_add_the_dictionary_first:"အရင်ဆုံး စကားလုံး ထည့်ပါ",
Chinese_name_English_name_does_not_allow_null_value:"တရုတ်အမည်/အင်္ဂလိပ်အမည် မလွတ်ထားနိုင်ပါ",
The_value_cannot_be_modified_after_it_is_set_Please_confirm_and_add_it_after_completion:"တန်ဖိုးများကို သတ်မှတ်ပြီးပါက ပြင်ဆင်၍ မရပါ။ ထည့်သွင်းမတိုင်မီ ပြီးစီးမှုကို အတည်ပြုပါ။",
Batch_Add_Parent_Directory:"မိခင်စာရင်းများ အစုလိုက်ထည့်ခြင်း",
recently:"နောက်ဆုံး",
day:"ရက်",
Warehouse_capacity:"ဂိုဒေါင်စွမ်းရည်",
Warehouse_capacity_data:"ဂိုဒေါင်စွမ်းရည်ဒေတာ",
Service_storage_capacity:"အသုံးပြုပြီးသော စွမ်းရည်",
Storage_capacity_in_transit:"ပို့ဆောင်နေဆဲ စွမ်းရည်",
Residual_storage_capacity:"ကျန်ရှိသော စွမ်းရည်",
Use_of_space:"အသုံးပြုပြီးသော သိုလှောင်ခန်းများ",
Available_space:"ရရှိနိုင်သည့် သိုလှောင်ခန်းများ",
financial_data:"ဘဏ္ဍာရေးဒေတာ",
all_costs:"ကြေးအားလုံး",
storage_charges:"ဂိုဒေါင်ငှားခ",
Removal_fee:"စာရင်းမှ ဖယ်ရှားခြင်းကြေး",
Returnable_shelving_fee:"ပြန်ပို့ထားသော ပစ္စည်း ပြန်စာရင်းတင်ခြင်းကြေး",
other_expenses:"အခြားကြေးများ",
Order_data:"အော်ဒါဒေတာ",
Orderto_be_supplied:"ဖြည့်ဆည်းရန် စောင့်ဆိုင်းနေသော အော်ဒါများ",
Order_In_transit:"ပို့ဆောင်နေဆဲ အော်ဒါများ",
Orderto_shipped:"ပို့ဆောင်ပြီး အော်ဒါများ",
Nearly_a_day:"နောက်ဆုံး ၂၄ နာရီ",
Last_seven_days:"နောက်ဆုံး ၇ ရက်",
The_last_thirty_days:"နောက်ဆုံး ၃၀ ရက်",
Nearly_ninety_days:"နောက်ဆုံး ၉၀ ရက်",
Customer_details:"ဖောက်သည် အသေးစိတ်",
TC_data:"ပထမအဆင့် ဒေတာ",
TC_wait_for_receiving:"ပထမအဆင့် လက်ခံရန် စောင့်ဆိုင်းနေ",
Transfer_Warehouse_Receipt:"ပို့ဆောင်ရေး ဂိုဒေါင် လက်ခံလွှာ",
Transit_warehouse_receiving_time:"ပို့ဆောင်ရေး ဂိုဒေါင် လက်ခံလွှာ အချိန်",
in_transit:"ပို့ဆောင်နေဆဲ",
The_Last_Leg_Received:"နောက်ဆုံးအဆင့် လက်ခံပြီး",
finish:"ပြီးစီး",
Warehouse_entry_data:"လက်ခံလွှာ ဒေတာ",
Transit_warehouse_to_receive_goods:"ပို့ဆောင်ရေး ဂိုဒေါင် လက်ခံရန် စောင့်ဆိုင်းနေ",
The_last_leg_to_be_received:"နောက်ဆုံးအဆင့် လက်ခံရန် စောင့်ဆိုင်းနေ",
To_be_inspected:"အရည်အသွေး စစ်ဆေးရန် စောင့်ဆိုင်းနေ",
To_be_put_on_the_shelf:"စင်တင်ရန် စောင့်ဆိုင်းနေ",
Return_data:"ပြန်ပို့ကုန် ပစ္စည်း ဒေတာ",
Customer_ID:"ဖောက်သည် ID",
ClientManagement:"ဖောက်သည်စီမံခန့်ခွဲမှု",
Customer:"ဖောက်သည်",
spread:"ချဲ့ထွင်",
pack_up:"ပိတ်",
Put_away_the_menu:"ပိတ်မီနူး",
Customer_List:"ဖောက်သည်စာရင်း",
clientList:"ဖောက်သည်စာရင်း",
advanced_query:"တိုးတက်မြှင့်တင်ထားသော ရှာဖွေမှု",
Customer_account_number:"ဖောက်သည်အကောင့်",
Please_enter_account_number:"ဖောက်သည်အကောင့်ကို ထည့်ပါ။",
Customer_account_name:"ဖောက်သည်အမည်",
Please_enter_account_name:"ဖောက်သည်အမည်ကို ထည့်ပါ။",
Customer_account_state:"ဖောက်သည်အခြေအနေ",
Please_enter_account_state:"ဖောက်သည်အခြေအနေကို ထည့်ပါ။",
unverified:"အတည်မပြုထား",
approve:"အတည်ပြုချက်ကျော်လွန်",
Approval_failure:"အတည်ပြုချက်မအောင်မြင်",
Api_Order:"API အော်ဒါများ",
Notification_Form:"ပို့ထားသော အော်ဒါများ",
handbill:"လက်ဖြင့်အော်ဒါများ",
forbidden:"ပိတ်ထား",
audit:"စိစစ်နေဆဲ",
Contract_to_be_signed:"စာချုပ်စောင့်ဆိုင်းနေ",
cell_phone_number:"မိုဘိုင်းနံပါတ်",
Please_enter_cell_phone_number:"မိုဘိုင်းနံပါတ်ကို ထည့်ပါ။",
Please_select_cell_phone_number:"ဖောက်သည်အခြေအနေကို ရွေးပါ။",
Please_select_Customer:"ဖောက်သည်ကို ရွေးပါ။",
company_name:"ကုမ္ပဏီ",
corporate_company:"တရားဝင်အဖွဲ့အစည်းကုမ္ပဏီ",
Please_enter_company_name:"ကုမ္ပဏီအမည်ကို ထည့်ပါ။",
registration_time:"မှတ်ပုံတင်ရက်စွဲ",
clearing_form:"ငွေပေးချေမှုနည်းလမ်း",
Please_select_clearing_form:"ငွေပေးချေမှုနည်းလမ်းကို ရွေးပါ။",
Please_select_whether_to_renew:"သက်တမ်းတိုးမလား မရွေးပါနှင့်",
Starting_amount:"စတင်ငွေပမာဏ",
Closing_amount:"အဆုံးငွေပမာဏ",
prejunction:"ငွေပေးချေမှုမပြုမီ",
monthly_balance:"လစဉ်ငွေပေးချေမှု",
balance_outstanding:"ကျန်ငွေ",
Please_enter_balance_outstanding:"ကျန်ငွေကို ထည့်ပါ။",
Please_enter_contact_information:"ဆက်သွယ်ရန် အသေးစိတ်ကို ထည့်ပါ။",
Please_select_balance_outstanding:"ကျန်ငွေကို ရွေးပါ။",
Please_select_the_shipping_to_transit_bin_method:"သယ်ယူပို့ဆောင်ရေးနည်းလမ်းကို ရွေးပါ။",
have:"ဟုတ်",
without:"မဟုတ်",
Add_customer:"ဖောက်သည်ထည့်ရန်",
Batch_upload:"အစုလိုက်တင်သွင်းရန်",
reset_passwords:"စကားဝှက် ပြန်လည်သတ်မှတ်ရန်",
Limit_adjustment:"ကန့်သတ်ချက် ချိန်ညှိရန်",
allot_salesman:"အရောင်းကိုယ်စားလှယ် ခန့်အပ်ရန်",
allot_service:"ဖောက်သည်ဝန်ဆောင်မှု ခန့်အပ်ရန်",
Customer_Name:"ဖောက်သည်အမည်",
subordinate_companies:"ဆက်စပ်ကုမ္ပဏီ",
contact_information:"ဆက်သွယ်ရန် အချက်အလက်",
account_frozen:"ပိတ်သိမ်းထားသော ငွေပမာဏ",
line_of_credit:"အကြွေးကန့်သတ်",
No_currency_available:"လက်ရှိ ငွေကြေး မရှိ",
Set_currency:"ငွေကြေး သတ်မှတ်",
account_type:"အကောင့်အမျိုးအစား",
account_state:"အကောင့်အခြေအနေ",
Merchant_name:"ကုန်သည်အမည်",
Merchant_Number:"ကုန်သည် ID",
Corporate_name:"ဥပဒေအရ ကိုယ်စားလှယ်အမည်",
Corporate_Identity_Card:"ဥပဒေအရ ကိုယ်စားလှယ်၏ မှတ်ပုံတင်ကတ်",
Corporate_phone_number:"ဥပဒေအရ ကိုယ်စားလှယ်၏ မိုဘိုင်းနံပါတ်",
Business_license_registration_address:"စီးပွားရေးလိုင်စင်မှတ်ပုံတင်လိပ်စာ",
business_address:"ရုံးလိပ်စာ",
Unified_social_credit_code:"ပေါင်းစည်းလူမှုယုံကြည်မှုကုဒ်",
Please_enter_unified_social_credit_code:"ပေါင်းစည်းလူမှုယုံကြည်မှုကုဒ်ကို ထည့်ပါ။",
user_role:"အသုံးပြုသူအခန်းကဏ္ဍ",
service_team:"ဝန်ဆောင်မှုအဖွဲ့",
Distribution_service_team:"ဝန်ဆောင်မှုအဖွဲ့ ခန့်အပ်ခြင်း",
Please_select_a_customer:"ဖောက်သည်တစ်ဦးကို ရွေးပါ။",
available_balance:"အသုံးပြုနိုင်သော ကျန်ငွေ",
Audit_customer:"ဖောက်သည် ပြန်လည်သုံးသပ်ခြင်း",
Confirm_to_audit_the_customer:"ဤဖောက်သည်အား ပြန်လည်သုံးသပ်ခြင်း အတည်ပြုခြင်း",
Please_enter_the_customer_mobile_number:"ဖောက်သည်၏ မိုဘိုင်းနံပါတ်ကို ထည့်ပါ။",
New_account_login_will_overwrite_the_data_of_the_original_account_whether_to_continue:"အကောင့်အသစ်ဖြင့် ဝင်ခြင်းဖြင့် ရှိပြီးသား အကောင့်ဒေတာအား အစားထိုးမည်။ ဆက်လက်ရန်?",
Set_up_warehouse:"ဂိုဒေါင် စတင်တပ်ဆင်ခြင်း",
Set_up_a_transit_warehouse:"သယ်ယူပို့ဆောင်ရေး ဂိုဒေါင် စတင်တပ်ဆင်ခြင်း",
Full_warehouse_or_not:"ဤသည် အဓိက ဂိုဒေါင်လား?",
Whether_all_transfer_warehouse:"ဤသည် သယ်ယူပို့ဆောင်ရေး ဂိုဒေါင်လား?",
Total_balance:"စုစုပေါင်း ကျန်ငွေ",
client_info:"ဖောက်သည်အချက်အလက်",
clientInfo:"ဖောက်သည်အချက်အလက်",
createClient:"ဖောက်သည်အသစ်ဖန်တီးရန်",
editClient:"ဖောက်သည်တည်းဖြတ်ရန်",
basic_information:"အခြေခံအချက်အလက်",
address_message:"လိပ်စာအချက်အလက်",
QQ_WeChat:"QQ/WeChat",
QQ_WeChat_ID_Not_Nickname:"QQ/WeChat ID (နာမည်မဟုတ်)",
oblast_province:"ပြည်နယ်/တိုင်းဒေသကြီး",
province:"တိုင်းဒေသကြီး",
district:"ခရိုင်",
Please_enter_oblast:"ပြည်နယ်ကို ထည့်ပါ။",
city:"မြို့",
Please_enter_city:"မြို့ကို ထည့်ပါ။",
location:"လိပ်စာ",
shipping_address:"ပို့ဆောင်ရန်လိပ်စာ",
Alternate_delivery_address:"အခြားပို့ဆောင်ရန်လိပ်စာ",
Please_enter_location:"လိပ်စာကို ထည့်ပါ။",
financial_information:"ဘဏ္ဍာရေးဆိုင်ရာအချက်အလက်",
customer_code:"ဖောက်သည်ကုဒ်",
Customer_mailbox:"ဖောက်သည်အီးမေးလ်",
Customer_mobile_phone_number:"ဖောက်သည်မိုဘိုင်းနံပါတ်",
customer_company:"ဖောက်သည်ကုမ္ပဏီ",
Superior_account:"မိဘအကောင့်",
service_conditions:"စီးပွားရေးအခြေအနေ",
underway:"ဆက်လက်ဆောင်ရွက်နေဆဲ",
Terminated:"ပယ်ဖျက်ထားသည်",
delivery_method:"ပို့ဆောင်နည်း",
assigner:"တာဝန်ပေးထားသူ",
operating_log:"လုပ်ငန်းမှတ်တမ်း",
auditor:"ပြန်လည်သုံးသပ်သူ",
audit_time:"ပြန်လည်သုံးသပ်ချိန်",
Identifying_people:"အတည်ပြုသူ",
acknowledging_time:"အတည်ပြုချိန်",
Whether_to_send_back_ERP:"ERP သို့ ပြန်ပို့",
Return_time:"ပြန်ပို့ချိန်",
Return_result:"ပြန်ပို့ရလဒ်",
Account_top_up_details:"အကောင့်ငွေဖြည့်ခြင်းအသေးစိတ်",
accountTopUpDetails:"အကောင့်ငွေဖြည့်ခြင်းအသေးစိတ်",
Recharge_method:"ငွေဖြည့်နည်း",
Storage_query:"ကုန်ပစ္စည်းစုံစမ်းမေးမြန်းခြင်း",
storageQuery:"ကုန်ပစ္စည်းစုံစမ်းမေးမြန်းခြင်း",
account_recharge:"အကောင့်ငွေဖြည့်ခြင်း",
accountRecharge:"အကောင့်ငွေဖြည့်ခြင်း",
online_trading:"အွန်လိုင်းငွေလွှဲ",
Online_payment:"အွန်လိုင်းငွေပေးချေမှု",
money:"ပမာဏ",
Please_enter_the_money:"ပမာဏ ထည့်ပါ",
Recharge_type:"ငွေဖြည့်အမျိုးအစား",
The_page_you_visited_does_not_exist_Please_check_whether_the_network_connection_is_normal_or_check_whether_the_address_input_is_correct:"သင် ဝင်ရောက်ကြည့်ရှုလိုသော စာမျက်နှာ မရှိပါ။ သင့်ကွန်ယက်ချိတ်ဆက်မှုကို စစ်ဆေးပါ သို့မဟုတ် လိပ်စာကို မှန်ကန်စွာ ထည့်သွင်းထားကြောင်း သေချာစေပါ။",
The_orders_that_have_been_shipped_and_failed_to_be_shipped_can_be_scanned_and_reprinted_here_Orders_that_have_been_shipped_can_be_reprinted_here_Note_The_order_must_be_the_order_placed_in_your_task_list:"ပို့ဆောင်မှု စကင်ပြီးသော်လည်း ပို့ဆောင်မှု မအောင်မြင်သေးသော အော်ဒါများအတွက် ဒီမှာ ထပ်မံပုံနှိပ်နိုင်ပါသည်။ ပို့ဆောင်ပြီးသား အော်ဒါများအတွက် ဒီမှာ ပို့ဆောင်ရေး တံဆိပ်ကို ထပ်မံပုံနှိပ်နိုင်ပါသည်။ (မှတ်ချက်: အော်ဒါများသည် သင့်တာဝန်စာရင်းအောက်တွင် ရှိရမည်။)",
Confirm_the_mark_is_abnormal:"မမှန်ကန်မှုအဖြစ် မှတ်သားရန် အတည်ပြုပါသလား?",
operation_procedure:"လုပ်ငန်းစဉ်",
Operating_Instructions:"လုပ်ငန်းညွှန်ကြားချက်များ",
general:"အထွေထွေ",
system_wide:"စနစ်တစ်ခုလုံး",
clientSide:"ဖောက်သည်",
Management:"အုပ်ချုပ်သူ",
Announcement_title:"ကြေညာချက်ခေါင်းစဉ်",
Announcement_content:"ကြေညာချက်အကြောင်းအရာ",
Announcement_Number:"ကြေညာချက် ID",
Please_enter_Announcement_title:"ကြေညာချက်ခေါင်းစဉ်ကို ထည့်ပါ။",
Please_enter_Announcement_Number:"ကြေညာချက် ID ကို ထည့်ပါ။",
Please_enter_Announcement_content:"ကြေညာချက်အကြောင်းအရာကို ထည့်ပါ။",
Please_select_Bulletin_Type:"ကြေညာချက်အမျိုးအစားကို ရွေးပါ။",
title:"ခေါင်းစဉ်",
method:"တောင်းဆိုနည်း",
requestMethod:"တောင်းဆိုပုံ",
operUrl:"လုပ်ဆောင်ချက် URL",
operIp:"လုပ်ဆောင်ချက် IP လိပ်စာ",
operLocation:"လုပ်ဆောင်ရာနေရာ",
operParam:"လုပ်ဆောင်ချက် ပါရာမီတာများ",
status:"အခြေအနေ",
errorMsg:"အမှားစာတို",
operTime:"လုပ်ဆောင်ချိန်",
Success:"အောင်မြင်",
Failure:"မအောင်မြင်",
Inventory_order_list:"ဂိုဒေါင်မှာယူစာရင်း",
inventoryOrderList:"ဂိုဒေါင်မှာယူစာရင်း",
inventoryAllOrderList:"မှာယူမှုအားလုံး",
abnormalTransportationList:"ပို့ဆောင်မှုဆိုင်ရာ မမှန်ကန်မှုများ",
warehouse_order_management:"ဂိုဒေါင်မှာယူမှု စီမံခန့်ခွဲမှု",
logistics:"လော့ဂျစ်စတစ်စ်",
logistics_status:"လော့ဂျစ်စတစ်စ် အခြေအနေ",
Please_select_Logistics_channel:"လော့ဂျစ်စတစ်စ် ချန်နယ် ရွေးချယ်ပါ",
Platform_state:"ပလက်ဖောင်း အခြေအနေ",
Please_select_Platform_state:"ပလက်ဖောင်း အခြေအနေ ရွေးချယ်ပါ",
Please_enter_order_number:"မှာယူမှုနံပါတ် ထည့်ပါ",
Please_enter_waybill_number:"ကုန်ပို့လွှာနံပါတ် ထည့်ပါ",
Please_enter_transaction_number:"ငွေလွှဲနံပါတ် ထည့်ပါ",
Priority_delivery:"ဦးစားပေးပို့ဆောင်မှု",
Priority_delivery_order:"ဦးစားပေးမှာယူမှုများ",
Non_priority_delivery_orders:"ဦးစားမပေးသောမှာယူမှုများ",
Platform_setting_priority_delivery:"ပလက်ဖောင်း ဦးစားပေးပို့ဆောင်မှု ဆက်တင်များ",
Manually_set_priority_delivery:"လက်ဖြင့် ဦးစားပေးပို့ဆောင်မှု ဆက်တင်များ",
Please_select_Priority_delivery:"ဦးစားပေးပို့ဆောင်မှု ရွေးချယ်စရာ ရွေးပါ",
shipping_method:"ပို့ဆောင်နည်း",
Please_select_shipping_method:"ပို့ဆောင်နည်းကို ရွေးချယ်ပါ",
Please_select_logistics_status:"လော့ဂျစ်စတစ်အခြေအနေကို ရွေးချယ်ပါ",
Please_select_platform:"ပလက်ဖောင်းကို ရွေးချယ်ပါ",
time_of_payment:"ငွေပေးချေချိန်",
Please_select_time_of_payment:"ငွေပေးချေချိန်ကို ရွေးချယ်ပါ",
Please_select_Recharge_method:"ငွေဖြည့်နည်းကို ရွေးချယ်ပါ",
To_be_reviewed:"အတည်ပြုရန် စောင့်ဆိုင်းနေ",
drop_shipping:"ပို့ဆောင်ရန် စောင့်ဆိုင်းနေ",
Being_distributed:"အော်ဒါ ဖြည့်ဆည်းနေ",
shipped:"ပို့ဆောင်ပြီးစီး",
have_been_voided:"ဖျက်သိမ်းထား",
have_been_reject:"ငြင်းပယ်ထား",
Get_the_tracking_number:"ဝေဘီလ်နံပါတ် ရှာဖွေ",
Set_up_order_package_materials:"အော်ဒါ ထုပ်ပိုးပစ္စည်းများ သတ်မှတ်",
Forward_delivery:"ပို့ဆောင်ရန် စောင့်ဆိုင်းနေသို့ ပြောင်းရွှေ့",
cancellation:"ဖျက်ရန်",
Cancelled_order:"အော်ဒါ ဖျက်ရန်",
activate:"ဖွင့်ရန်",
Get_order:"အော်ဒါ ရှာဖွေ",
Get_order_time:"အော်ဒါထုတ်ယူချိန်",
Upload_sheet:"လမ်းကြောင်းလွှာတင်ခြင်း",
processing_batch:"အစုလိုက်လုပ်ဆောင်ခြင်း",
Return_for_review:"ပြန်လည်သုံးသပ်ရန် စောင့်ဆိုင်းနေသည်",
Print_sheet:"လမ်းကြောင်းလွှာပုံနှိပ်ခြင်း",
Preview_the_waybill:"လမ်းကြောင်းလွှာကြိုကြည့်ခြင်း",
Printing_sheet:"လမ်းကြောင်းလွှာပုံနှိပ်နေသည်...",
Preview_failed_orders:"ကြိုကြည့်ရန် မအောင်မြင်သော အော်ဒါများ",
create_order:"အော်ဒါဖန်တီးခြင်း",
createOrder:"အော်ဒါဖန်တီးခြင်း",
Batch_create_order:"အစုလိုက် အော်ဒါဖန်တီးခြင်း",
stores_expired:"ဆိုင်ခွင့်ပြုချက် သက်တမ်းကုန်ဆုံးသည်",
Push_or_not:"Push အသိပေးချက်",
Please_select_whether_to_push:"Push လုပ်မလား မရွေးချယ်ရသေးပါ",
Please_select_order_status:"အော်ဒါအခြေအနေကို ရွေးချယ်ပါ",
Platform_logistics_channel:"ပလက်ဖောင်း သယ်ယူပို့ဆောင်ရေး ချန်နယ်",
master_bill_number:"မဟာလမ်းကြောင်းလွှာနံပါတ်",
WMS_status:"WMS အခြေအနေ",
destination_country:"ရောက်မည့် နိုင်ငံ",
Platform_remarks:"ပလက်ဖောင်း မှတ်ချက်များ",
Warehouse_presence_remarks:"ဂိုဒေါင်မှတ်ချက်များ ရှိသည်",
No_warehouse_remarks_exist:"ဂိုဒေါင်မှတ်ချက်များ မရှိသည်",
Warehouse_note:"ဂိုဒေါင်မှတ်ချက်များ",
Delivery_of_abnormal_information:"ပို့ဆောင်မှုပုံမှန်မဟုတ်မှု သတင်းအချက်အလက်",
Remaining_delivery_time:"ကျန်ရှိသေးသော ပို့ဆောင်ချိန်",
order_amount:"အော်ဒါပမာဏ",
primitive_money:"မူလငွေကြေး",
Order_profit:"အော်ဒါအမြတ်",
profit_margin:"အမြတ်နှုန်း",
delivery_time:"ထွက်ခွာချိန်",
Deduct_time:"လျော့ချချိန်",
Save_the_current_search_conditions:"လက်ရှိ ရှာဖွေမှု စည်းမျဉ်းများကို သိမ်းဆည်းပါ",
No_data_is_selected:"ဒေတာ မရွေးထားပါ!",
No_customer_has_been_selected:"ဖောက်သည် မရွေးထားပါ!",
The_order_was_cancelled_successfully:"အော်ဒါကို အောင်မြင်စွာ ဖျက်သိမ်းပြီးပါပြီ!",
Order_activation_success:"အော်ဒါကို အောင်မြင်စွာ ဖွင့်လှစ်ပြီးပါပြီ!",
Orders_have_been_prioritized_for_delivery:"အော်ဒါကို ဦးစားပေးပို့ဆောင်ရန် သတ်မှတ်ပြီးပါပြီ!",
OrderInfo:"အော်ဒါအသေးစိတ်",
Modify_remarks:"မှတ်ချက်များ တည်းဖြတ်ရန်",
Quick_query_condition:"အမြန် ရှာဖွေမှု စည်းမျဉ်းများ",
Marked_delivery:"ပို့ဆောင်ပြီးဟု အမှတ်ပြုရန်",
Please_select_a_piece_of_data:"မှတ်တမ်းတစ်ခု ရွေးပါ",
Marked_delivery_Succeed:"ပို့ဆောင်ပြီး အောင်မြင်ကြောင်း အမှတ်ပြုပါသည်",
Marked_delivery_lose:"ပို့ဆောင်ပြီးအမှတ်ပြုခြင်း မအောင်မြင်ပါ",
Systematic_item_list:"စနစ် ထုတ်ကုန်အသေးစိတ်",
not_available:"လက်ရှိ မရှိပါ",
multiattribute:"အင်္ဂါရပ်များစွာ",
multiattributeID:"အင်္ဂါရပ်များစွာ ID",
Please_select_an_order_from_the_same_warehouse:"ကျေးဇူးပြု၍ တစ်ခုတည်းသော ဂိုဒေါင်မှ အော်ဒါများကို ရွေးချယ်ပါ",
Batch_replacement_of_SKUs:"အစုလိုက် SKU အစားထိုးခြင်း",
replace_SKU:"SKU အစားထိုးခြင်း",
delete_SKU:"SKU ဖျက်ခြင်း",
add_sku:"SKU ထည့်ခြင်း",
Only_one_SKU_can_be_replaced:"တစ်ခုတည်းသော SKU အစားထိုးခြင်းကိုသာ ထောက်ပံ့သည်",
Select_the_sku_that_you_want_to_replace:"အစားထိုးရန် SKU ကို ရွေးချယ်ပါ",
Select_the_new_SKU:"အသစ် SKU ကို ရွေးချယ်ပါ",
Whether_the_product_has_a_barcode:"ထုတ်ကုန်တွင် ဘားကုဒ် တံဆိပ်ရှိပါသလား?",
Duplicate_SKUs_appear:"SKU ထပ်တူတွေ့ရှိပါသည်",
Printing:"ပုံနှိပ်နေဆဲ...",
Please_select_a_type_of_basket:"ကျေးဇူးပြု၍ စျေးဝယ်ခြင်းအမျိုးအစားကို ရွေးချယ်ပါ",
printPreview:"ပုံနှိပ်ကြိုကြည့်ခြင်း",
designPrinting:"ပုံနှိပ်ဒီဇိုင်း",
Delete_an_order:"အော်ဒါ ဖျက်ခြင်း",
Pairing_or_not:"တွဲထားပါသလား?",
type_of_merchandize:"ထုတ်ကုန် အမျိုးအစား",
Print_type:"ပုံနှိပ် အမျိုးအစား",
The_uploaded_file_format_is_incorrect:"တင်သွင်းထားသော ဖိုင် ဖော်မတ်မှားနေသည်",
Currently_only_single_order_upload_is_supported:"လက်ရှိတွင် တစ်ခုချင်းစီ အော်ဒါ တင်သွင်းခြင်းကိုသာ ထောက်ပံ့ပါသည်",
Save_as_PDF:"PDF အဖြစ် သိမ်းဆည်းရန်",
downloading:"ဒေါင်းလုဒ် ဆွဲနေသည်...",
Direct_printing:"တိုက်ရိုက် ပုံနှိပ်ခြင်း",
Confirm_submission:"တင်သွင်းရန် အတည်ပြုပါသလား?",
quantity_of_order:"အော်ဒါ အရေအတွက်",
hour:"အချိန်",
The_task_can_be_obtained_directly:"တာဝန်ကို တိုက်ရိုက် ပြန်လည် ရယူနိုင်သည်",
You_need_to_scan_the_distribution_basket_to_get_the_task:"တာဝန်ကို ပြန်လည် ရယူရန် ပစ္စည်းထည့်လှည်းကို စကင်ရန် လိုအပ်သည်",
When_the_task_type_is_multi_product_you_can_choose_whether_to_allocate_goods_by_floor:"တာဝန် အမျိုးအစားကို Multi-Item အဖြစ် ရွေးချယ်သောအခါ ကြမ်းပြင်အလိုက် ရွေးချယ်၍ ယူနိုင်ပါသည်",
Whether_to_scan_the_warehouse_location_when_distributing_goods:"ရွေးယူစဉ် သိုလှောင်ရာနေရာများကို စကင်ရန် လိုအပ်ပါသလား?",
When_the_task_type_is_multi_product_the_matching_and_sending_function_cannot_be_enabled:"အရာဝတ္ထုများစွာပါသော တာဝန်အမျိုးအစားကို ရွေးချယ်သောအခါ တပြိုင်နက် ရွေးယူခြင်းနှင့် ပို့ဆောင်ခြင်းကို ဖွင့်မရနိုင်ပါ။",
presell:"အရောင်းမတိုင်မီ",
stockoutOrder:"ကုန်သွားသော အော်ဒါများ",
No_out_of_stock_orders:"ကုန်မသွားသော အော်ဒါများ",
Online_product_Pictures:"အွန်လိုင်းထုတ်ကုန်ဓာတ်ပုံများ",
After_the_warehouse_is_selected_the_corresponding_inventory_will_be_returned:"ထွက်ပို့ရန် ဂိုဒေါင်ကို ရွေးပြီးနောက် သက်ဆိုင်ရာ ပစ္စည်းစာရင်း ပြန်လည်ပြသမည်။",
Transfer_the_tracking_number_to_obtain:"Waybill နံပါတ် ရယူခြင်းသို့ ပြောင်းရွှေ့ခြင်း",
Transfer_the_tracking_number_to_obtain_or_pending_shipment:"ပို့ဆောင်ရေးနံပါတ် ရယူခြင်း / ပို့ဆောင်ရန် စောင့်ဆိုင်းနေဆဲ",
Orders_with_a_tracking_number_will_automatically_be_moved_to_awaiting_shipment_while_orders_without_a_tracking_number_will_enter_tracking_number_retrieval:"ပို့ဆောင်ရေးနံပါတ်ပါ အော်ဒါများသည် အလိုအလျောက် ပို့ဆောင်ရန် စောင့်ဆိုင်းနေဆဲ အခြေအနေသို့ ပြောင်းရွှေ့သွားမည်။ ပို့ဆောင်ရေးနံပါတ်မပါသော အော်ဒါများသည် ပို့ဆောင်ရေးနံပါတ် ရယူခြင်း အခြေအနေသို့ ဝင်ရောက်မည်။",
The_tracking_number_exists:"ပို့ဆောင်ရေးနံပါတ် ရှိသည်",
No_waybill_number_exists:"ပို့ဆောင်ရေးနံပါတ် မရှိသည်",
has_waybill_number:"ပို့ဆောင်ရေးနံပါတ် ရှိသည်",
no_waybill_number:"ပို့ဆောင်ရေးနံပါတ် မရှိသည်",
Whether_out_of_stock:"ကုန်ပစ္စည်းကုန်ဆုံး အခြေအနေ",
stockout:"ကုန်ပစ္စည်းကုန်ဆုံး",
stockout_short:"ကုန်ပစ္စည်းကုန်ဆုံး",
Platform_and_Shop:"ပလက်ဖောင်း/ဆိုင်",
Whether_the_waybill_number_exists:"ပို့ဆောင်ရေးနံပါတ် ရှိသည်",
Presence_platform_remarks:"ပလက်ဖောင်းမှတ်ချက် ရှိသည်",
No_platform_remarks:"ပလက်ဖောင်းမှတ်ချက် မရှိသည်",
has_platform_remark:"ပလက်ဖောင်းမှတ်စုများ ရှိသည်",
no_platform_remark:"ပလက်ဖောင်းမှတ်စုများ မရှိသည်",
Presence_remark:"မှတ်စုများ ရှိသည်",
No_remarks_exist:"မှတ်စုများ မရှိသည်",
has_remark:"မှတ်စုများ ရှိသည်",
no_remark:"မှတ်စုများ မရှိသည်",
Split_order:"ခွဲထားသော အော်ဒါ",
Unsplit_order:"မခွဲထားသော အော်ဒါ",
Advance_order:"ကြိုရောင်းအော်ဒါ",
Non_advance_order:"ကြိုရောင်းမဟုတ်သော အော်ဒါ",
Matching_order:"ကိုက်ညီသော အော်ဒါ",
Already_paired_Order:"ကိုက်ညီသော အော်ဒါ",
unpaired_Order:"မကိုက်ညီသော အော်ဒါ",
Traffic_anomaly:"ပို့ဆောင်မှုဆိုင်ရာ ထူးခြားချက်",
A_traffic_exception_exists_Procedure:"ပို့ဆောင်မှုဆိုင်ရာ ထူးခြားချက် ရှိသည်",
No_traffic_exception_exists:"ပို့ဆောင်မှုဆိုင်ရာ ထူးခြားချက် မရှိသည်",
has_transportation_abnormal:"ပို့ဆောင်မှုဆိုင်ရာ ထူးခြားချက် ရှိသည်",
no_transportation_abnormal:"ပို့ဆောင်မှုဆိုင်ရာ ထူးခြားချက် မရှိသည်",
allTask:"တာဝန်အားလုံး",
todayTask:"ယနေ့လုပ်ဆောင်ရန်အလုပ်များ",
todayTask17:"ယနေ့လုပ်ဆောင်ရန်အလုပ် ၁၇",
todayTask14:"ယနေ့လုပ်ဆောင်ရန်အလုပ် ၁၄",
yesterdayTask:"မနေ့ကလုပ်ဆောင်ရန်အလုပ်များ",
New_quick_query:"အမြန်မေးမြန်းချက်အသစ်",
Order_status_inquiry:"အော်ဒါအခြေအနေမေးမြန်းချက်",
The_tracking_number_is_being_obtained:"လမ်းကြောင်းနံပါတ် ရှာဖွေနေသည်...",
Submit_the_order_task:"တင်သွင်းထားသော အော်ဒါအလုပ်များ",
Mixed_shipment_or_not:"ပို့ဆောင်မှုရွေးချယ်စရာများ",
Order_task_submitted_today_00_00_00_18_00_00:"ယနေ့ တင်သွင်းထားသော အော်ဒါအလုပ်များ ၀၀:၀၀:၀၀-၁၈:၀၀:၀၀",
Order_task_submitted_yesterday_00_00_00_23_59_59:"မနေ့က တင်သွင်းထားသော အော်ဒါတာဝန်များ 00:00:00-23:59:59",
This_operation_will_permanently_delete_the_query_condition_Do_you_want_to_continue:"ဤ လုပ်ဆောင်ချက်သည် ဤ မေးမြန်းချက် စည်းမျဉ်းများကို အမြဲတမ်း ဖျက်ပစ်မည်။ ဆက်လက်လုပ်ဆောင်မလား?",
After_obtaining_the_tracking_number_it_will_be_automatically_transferred_to_the_agent_for_delivery:"လိုက်နာမှုနံပါတ် ရရှိပြီးပါက အော်ဒါကို အလိုအလျောက် 'ပို့ဆောင်ရန် စောင့်ဆိုင်းနေ' သို့ ပြောင်းရွှေ့မည်။",
The_input_format_is_incorrect_English_is_not_allowed_only_three_decimal_places:"ထည့်သွင်းပုံ မမှန်ပါ။ အင်္ဂလိပ်စာများ မခွင့်ပြုပါ; ဒဿမ ၃ နေရာသာ ခွင့်ပြုသည်။",
Once_the_QR_code_scanning_is_initiated_it_will_be_invalid_Repeated_scanning_will_fail_the_verification_and_the_transaction_needs_to_be_re_initiated:"အွန်လိုင်း ထပ်ဖြည့် QR ကုဒ်သည် တစ်ကြိမ် စကင်ပြီးနောက် သက်တမ်းကုန်သွားမည်။ ထပ်မံ စကင်ပါက အတည်ပြုခြင်း မအောင်မြင်တော့ဘဲ၊ လုပ်ငန်းအသစ် တစ်ခု စတင်ရမည်။",
Confirm_the_transfer_pending:"စောင့်ဆိုင်းနေသော လုပ်ငန်းသို့ ပြောင်းရွှေ့ခြင်း အတည်ပြုပါ",
transfer_pending:"စောင့်ဆိုင်းနေသော လုပ်ငန်းသို့ ပြောင်းရွှေ့ပါ",
When_the_task_type_is_multi_product_if_delivery_inspection_is_disabled_there_is_no_need_to_scan_all_SKUs_of_the_corresponding_order_scanning_one_SKU_will_allow_the_corresponding_order_to_be_shipped_If_enabled_all_SKUs_of_the_order_need_to_be_scanned:"အလုပ်အမျိုးအစားမှာ အများပစ္စည်း (multi-item) ဖြစ်ပါက၊ ပို့ဆောင်မှု အတည်ပြုခြင်းကို ပိတ်ထားပါက တစ်ခုချင်းစီ SKU ကို စကင်လိုက်တာနဲ့ သက်ဆိုင်ရာ အော်ဒါကို ပို့ဆောင်ရန် ဖြုတ်ပေးမည်။ ဖွင့်ထားပါက အော်ဒါထဲရှိ SKU အားလုံးကို စကင်ရမည်။",
When_the_task_type_is_single_product_and_the_match_and_send_function_is_enabled_There_is_no_need_to_wait_for_the_allocation_task_to_be_completely_finished_Once_some_SKUs_are_allocated_you_can_operate_the_orders_of_the_corresponding_allocated_SKUs_for_shipping:"အလုပ်အမျိုးအစားသည် တစ်ခုတည်းသော ပစ္စည်းဖြစ်ပြီး ရွေးယူသည့်အတိုင်း ပို့ဆောင်မည် ကို ဖွင့်ထားပါက၊ ရွေးယူမှု အလုပ်အားလုံး ပြီးစီးရန် မစောင့်ဘဲ ရွေးယူပြီးသား SKU များအတွက် အော်ဒါပို့ဆောင်မှုကို ဆက်လက်လုပ်ဆောင်နိုင်ပါသည်။",
Enable_this_function_and_single_product_orders_can_be_obtained_in_multi_product_allocation:"ဤအင်္ဂါရပ်ကို ဖွင့်ခြင်းဖြင့် တစ်ခုတည်းသော ပစ္စည်းအော်ဒါများကို အများပစ္စည်းရွေးယူစဉ်တွင် ထုတ်ယူနိုင်ပါသည်။",
Expired_stores:"ကုန်ဆုံးသွားသော ဆိုင်",
The_transportation_of_goods_in_the_past_seven_days_has_been_abnormal:"ပြီးခဲ့သည့် ၇ ရက်အတွင်း ပို့ဆောင်မှုဆိုင်ရာ မမှန်ကန်မှုများ",
Whether_to_exclude_submission_rules:"တင်သွင်းမှု စည်းမျဉ်းများကို ထုတ်ပယ်မည်လား?",
Not_excluded_submission_rules:"တင်သွင်းစည်းမျဉ်းများ မဖယ်ရှားထားပါ",
Excluded_submission_rules:"တင်သွင်းစည်းမျဉ်းများ ဖယ်ရှားထားပါ",
Whether_to_exclude_automatic_packaging_rules:"အလိုအလျောက်ထုပ်ပိုးစည်းမျဉ်းများ မဖယ်ရှားထားပါ",
Not_excluded_automatic_packaging_rules:"အလိုအလျောက်ထုပ်ပိုးစည်းမျဉ်းများ ဖယ်ရှားထားပါ",
Excluded_automatic_packaging_rules:"အလိုအလျောက်ထုပ်ပိုးစည်းမျဉ်းများ ဖယ်ရှားထားပါ",
Cancel_excluded_submission_rules:"တင်သွင်းစည်းမျဉ်း ဖျက်ခြင်း မဖယ်ရှားထားပါ",
Cancel_excluded_automatic_packaging_rules:"အလိုအလျောက်ထုပ်ပိုးစည်းမျဉ်း ဖျက်ခြင်း မဖယ်ရှားထားပါ",
Excluded_all_rules:"စည်းမျဉ်းအားလုံး ဖယ်ရှား",
Cancel_excluded_all_rules:"စည်းမျဉ်းအားလုံး ဖယ်ရှားခြင်း ဖျက်ခြင်း",
Refresh_platform_status:"ပလက်ဖောင်းအခြေအနေ ပြန်လည်အသစ်တင်ခြင်း",
Only_supports_operations_for_API_orders_with_a_delivery_deadline_within_12_hours_and_push_orders_created_later_than_12_hours:"၁၂ နာရီအတွင်း ပို့ဆောင်ရမည့် အချိန်ကန့်သတ်ထားသော API အော်ဒါများနှင့် ၁၂ နာရီကျော်က ဖန်တီးထားသော push အော်ဒါများကိုသာ ထောက်ပံ့ပါသည်",
shipping_label:"လမ်းကြောင်းလွှာ",
shipping_label_exists:"လမ်းကြောင်းလွှာ ရှိသည်",
no_shipping_label_exists:"လမ်းကြောင်းလွှာ မရှိပါ",
has_label:"လမ်းကြောင်းလွှာ ရှိသည်",
no_label:"လမ်းကြောင်းလွှာ မရှိပါ",
out_of_stock_orders:"ကုန်ပစ္စည်းမလုံလောက်သော အော်ဒါ",
No_waybill_number:"လမ်းကြောင်းလွှာနံပါတ် မရှိပါ",
// has_platform_remark:"ပလက်ဖောင်းမှတ်ချက်များ ရှိသည်",
has_warehouse_remark:"ဂိုဒေါင်မှတ်ချက်များ ရှိသည်",
no_warehouse_remark:"ဂိုဒေါင်မှတ်ချက် မရှိပါ",
is_split_orders:"အော်ဒါခွဲ",
is_presell_orders:"ကြိုရောင်းအော်ဒါ",
Unpaired:"မကိုက်ညီ",
Get_the_logistics_track:"ပို့ဆောင်ရေးလမ်းကြောင်းလိုက်လံခြင်း",
Latest_updates:"နောက်ဆုံးအပ်ဒိတ်",
Logistics_information_is_being_pulled:"ပို့ဆောင်ရေးအချက်အလက် ဆွဲယူနေသည်",
package_information:"ထုပ်ပိုးမှုအသေးစိတ်",
Chinese_product_name:"တရုတ်ထုတ်ကုန်အမည်",
English_product_name:"အင်္ဂလိပ်ထုတ်ကုန်အမည်",
Obtaining_tracking_number:"လမ်းကြောင်းလွှာနံပါတ် ရှာဖွေနေသည်",
No_abnormalities:"ထူးခြားချက် မရှိပါ",
Submission_rules_are_not_excluded:"တင်သွင်းမှုစည်းမျဉ်းများ မဖယ်ရှားထားပါ",
The_submission_rule_is_excluded:"တင်သွင်းမှုစည်းမျဉ်းများ ဖယ်ရှားထားသည်",
Automatic_packaging_material_rules_not_excluded:"အလိုအလျောက်ထုပ်ပိုးစည်းကမ်းများ မထုတ်ပယ်ထားပါ",
The_automatic_packaging_rules_have_been_excluded:"အလိုအလျောက်ထုပ်ပိုးစည်းကမ်းများ ထုတ်ပယ်ထားပါ",
The_number_of_selected_orders_cannot_exceed_100:"ရွေးထားသော အော်ဒါအရေအတွက်သည် ၁၀၀ ကျော်၍ မရပါ",
Reship:"ပို့ဆောင်မှုကို ထပ်မံတင်သွင်းရန်",
Transfer_cancellation_exception:"ဖျက်သိမ်းခြင်းထူးခြားချက်သို့ ပြောင်းရွှေ့ရန်",
Returned_without_generation:"ပြန်ပို့ရန် မဖန်တီးထားပါ",
The_currently_selected_order_has_no_delivery_exceptions_and_requires_no_action:"လက်ရှိရွေးထားသော အော်ဒါများအတွက် ပို့ဆောင်မှုထူးခြားချက် မရှိပါ၊ ဆောင်ရွက်ရန် မလိုအပ်ပါ",
If_you_need_to_check_the_inventory_information_of_the_products_please_select_the_option_on_the_right:"ကုန်ပစ္စည်းစာရင်းအသေးစိတ် ကြည့်ရန် ညာဘက်ရှိ ခလုတ်ကို နှိပ်ပါ",
Add_Warehouse_Product_Inventory_Details:"ဂိုဒေါင်ကုန်ပစ္စည်းစာရင်းအသေးစိတ် ထည့်ရန်",
editOrder:"အော်ဒါ တည်းဖြတ်ရန်",
bulk_edit:"အစုလိုက် တည်းဖြတ်ရန်",
empty:"ရှင်းရန်",
consigner:"ပို့သူ",
shipper:"ကုန်ပို့သူ",
Order_deduction:"အော်ဒါ ကုန်ကျစရိတ်များ",
Select_sender:"ပို့သူကို ရွေးချယ်ရန်",
Please_enter_consigner:"ပို့သူအသေးစိတ်ကို ထည့်ပါ။",
Sender_information:"ပို့သူ အချက်အလက်",
consigner_address:"ပို့သူ လိပ်စာ",
Please_enter_consigner_address:"ပို့သူ လိပ်စာကို ထည့်ပါ။",
consignee_information:"လက်ခံသူ အချက်အလက်",
recipients:"လက်ခံသူ",
recipientsList:"လက်ခံသူ စာရင်း",
Save_as_a_regular_recipient:"အကြိုက်ဆုံး လက်ခံသူ အဖြစ် သိမ်းဆည်းရန်",
Select_recipients:"လက်ခံသူကို ရွေးချယ်ရန်",
Please_enter_recipients:"လက်ခံသူအသေးစိတ်ကို ထည့်ပါ။",
Only_one_recipient_can_be_selected:"တစ်ဦးတည်းသာ ရွေးချယ်နိုင်သည်",
Please_enter_the_recipient_name_for_query:"ရှာဖွေရန် လက်ခံသူအမည်ကို ထည့်ပါ။",
postcode:"ပို့စ်ကုဒ်",
Please_enter_postcode:"ပို့စ်ကုဒ်ကို ထည့်ပါ။",
recipients_country:"လက်ခံသူနိုင်ငံ",
Please_enter_recipients_country:"လက်ခံသူနိုင်ငံကို ထည့်ပါ။",
Please_select_recipients_country:"လက်ခံသူနိုင်ငံကို ရွေးပါ။",
Please_select_recipients:"လက်ခံသူကို ရွေးပါ။",
type_of_shipping:"ပို့ဆောင်နည်း",
Please_enter_type_of_shipping:"ပို့ဆောင်နည်းကို ထည့်ပါ။",
Please_select_type_of_shipping:"ပို့ဆောင်နည်းကို ရွေးပါ။",
Alternate_recipient_address:"အခြားလက်ခံသူလိပ်စာ",
Please_enter_Alternate_recipient_address:"အခြားလက်ခံသူလိပ်စာကို ထည့်ပါ။",
commodity_information:"ထုတ်ကုန်အချက်အလက်",
Select_product:"ထုတ်ကုန်ရွေးပါ",
Save_until_reviewed:"စစ်ဆေးရန် စောင့်ဆိုင်းနေသော အမှာစာများသို့ သိမ်းဆည်းရန်",
Submit_to_consignment:"ပို့ဆောင်ရန် စောင့်ဆိုင်းနေသော အမှာစာများသို့ တင်သွင်းရန်",
Batch_set_package_materials:"ထုပ်ပိုးပစ္စည်းများ အစုလိုက် သတ်မှတ်ရန်",
Please_add_packing_material:"ထုပ်ပိုးပစ္စည်းများ ထည့်ပါ။",
under:"အောက်တွင်",
Please_enter_the_tracking_number_information:"Huolala လိုက်လံစစ်ဆေးနံပါတ် အချက်အလက်ကို ထည့်ပါ။",
Please_select_the_estimated_time_of_arrival:"ဂိုဒေါင်သို့ ခန့်မှန်းရောက်ရှိမည့် အချိန်ကို ရွေးပါ။",
Only_a_single_recipient_can_be_selected:"လက်ခံသူ တစ်ဦးတည်းသာ ရွေးနိုင်ပါသည်။",
Please_enter_a_combination_SKU:"ပေါင်းစပ် SKU ကို ထည့်ပါ။",
The_number_of_empty_combination_SKUs_exists_Check_and_try_again:"ပေါင်းစပ် SKU အရေအတွက်များတွင် အလွတ်များ ရှိနေပါသည်။ စစ်ဆေးပြီး ထပ်မံကြိုးစားပါ။",
Please_enter_the_combination_SKU_name:"ပေါင်းစပ် SKU အမည်ကို ထည့်ပါ။",
Click_to_select_the_row_data_doubleclick_to_select_the_row_data_and_confirm_the_current_selection_data:"ဒီဒေတာတန်းကို ရွေးရန် နှိပ်ပါ။ ဒေတာတန်းကို နှစ်ချက်နှိပ်၍ လက်ရှိရွေးချယ်မှုကို အတည်ပြုပါ။",
tagged:"အမှတ်တံဆိပ်တပ်ထားသည်",
No_mark:"အမှတ်တံဆိပ်မတပ်ထားသည်",
Import_recipients:"တင်သွင်းသူများ",
agree:"သဘောတူသည်",
reject:"ငြင်းပယ်သည်",
cancellationOrder:"မှာယူမှု ဖျက်သိမ်းသည်",
reason_for_refusal:"ငြင်းပယ်ခြင်း အကြောင်းရင်း",
Please_enter_reason_for_refusal:"ငြင်းပယ်ခြင်း အကြောင်းရင်းကို ရွေးချယ်ပါ",
Application_for_cancellation_of_time:"ဖျက်သိမ်းရန် တောင်းဆိုချိန်",
expiration_time:"သက်တမ်းကုန်ဆုံးချိန်",
reason_of_cancellation:"ဖျက်သိမ်းခြင်း အကြောင်းရင်း",
Please_Select_Warehouse_First:"အရင်ဆုံး ဂိုဒေါင်ကို ရွေးချယ်ပါ",
Please_Select_Packaging_Method_First:"အရင်ဆုံး ထုပ်ပိုးနည်းကို ရွေးချယ်ပါ",
Number_Of_Loops:"ပတ်အရေအတွက်",
Please_Select_Packaging_Material:"ထုပ်ပိုးပစ္စည်းကို ရွေးချယ်ပါ",
Please_Select_Packaging_Method:"ထုပ်ပိုးနည်းကို ရွေးချယ်ပါ",
Please_Enter_Number_Of_Loops:"ပတ်အရေအတွက်ကို ထည့်ပါ",
Order_Packaging:"မှာယူမှု ထုပ်ပိုးခြင်း",
Packaging_Method:"ထုပ်ပိုးနည်း",
Packaging_Material_Type:"ထုပ်ပိုးအမျိုးအစား",
Whole_Order_Packaging:"မှာယူမှုတစ်ခုလုံး ထုပ်ပိုးခြင်း",
Packaging_By_SKU:"SKU အလိုက် ထုပ်ပိုးခြင်း",
Individual_Product_Packaging:"တစ်ခုချင်းစီ ထုပ်ပိုးခြင်း",
Volume:"အရွယ်အစား",
Unit_Price:"တစ်ခုချင်းစျေးနှုန်း",
Please_Enter_Quantity:"အရေအတွက် ထည့်ပါ",
Packaging_Material_Type_And_Packaging_Method_Must_Be_Filled_In_Simultaneously:"ထုပ်ပိုးပုံစံ နှင့် ထုပ်ပိုးနည်း နှစ်ခုလုံး ဖြည့်ရမည်",
first_leg:"ထွက်ပို့",
Head_process_management:"ထွက်ပို့ စီမံခန့်ခွဲမှု",
FirstLegOrderManagement:"ထွက်ပို့ အော်ဒါ စီမံခန့်ခွဲမှု",
firstLegOrderList:"ထွက်ပို့ အော်ဒါ စာရင်း",
firstBillingList:"ထွက်ပို့ ငွေတောင်းခံလွှာ စာရင်း",
First_billing_list:"ထွက်ပို့ ငွေတောင်းခံလွှာ စာရင်း",
FirstLegOrderStatus:"ထွက်ပို့ အော်ဒါ အခြေအနေ",
FirstLegOrderNumber:"ထွက်ပို့ အော်ဒါ နံပါတ်",
Headway_tracking_number_Order_number_Grabway_information:"အစပိုင်းအဆင့် လိုက်လံစစ်ဆေးနံပါတ်/လိုက်လံစစ်ဆေးနံပါတ်/ဟူဝါအချက်အလက်",
First_order_stage:"အစပိုင်းအဆင့် အော်ဒါအဆင့်",
Please_enter_FirstLegOrderNumber:"အစပိုင်းအဆင့် လိုက်လံစစ်ဆေးနံပါတ်ကို ထည့်ပါ။",
warehouse_entry_number:"ဝင်လာမည့် အော်ဒါနံပါတ်",
Please_enter_warehouse_entry_number:"ဝင်လာမည့် အော်ဒါနံပါတ်ကို ထည့်ပါ။",
createoriginReceivingInboundOrder:"အစပိုင်းအဆင့် ဝင်လာမည့် အော်ဒါ ဖန်တီးခြင်း",
editOriginReceivingInboundOrder:"အစပိုင်းအဆင့် ဝင်လာမည့် အော်ဒါ တည်းဖြတ်ခြင်း",
editHeaderList:"အစပိုင်းအဆင့် အော်ဒါ တည်းဖြတ်ခြင်း",
firstLegOrderId:"အစပိုင်းအဆင့် ID",
draft:"မူကြမ်း",
audited:"အတည်ပြု",
abnormal:"မမှန်ကန်",
Self_delivery_warehouse:"ဂိုဒေါင်သို့ ကိုယ်တိုင်ပို့ဆောင်ခြင်း",
The_customer_sends_it_to_the_transit_warehouse:"ဖောက်သည်မှ သယ်ယူပို့ဆောင်ရေးဂိုဒေါင်သို့ ပို့ဆောင်ခြင်း",
Door_to_door_collection:"တံခါးရှေ့မှ ကောက်ယူခြင်း",
Transfer_warehouse_contact_logistics_to_customer_designated_address_collection:"သယ်ယူပို့ဆောင်ရေးဂိုဒေါင်သည် ဖောက်သည် သတ်မှတ်ထားသည့် လိပ်စာမှ ကုန်ပစ္စည်းများကို စုဆောင်းရန် လိုဂျစ်စတစ် ပံ့ပိုးသူထံ ဆက်သွယ်သည်။",
Warehouse_entry_stage:"ဝင်ရောက်အော်ဒါအဆင့်",
Warehouse_entry_description:"ဝင်ရောက်အော်ဒါ ဖော်ပြချက်",
Batch_number_issued_by_three_warehouses:"တတိယပါတီ ဂိုဒေါင် အစုအဖွဲ့နံပါတ်",
Three_party_warehouse_PO_number:"တတိယပါတီ ဂိုဒေါင် ဝယ်ယူမှုအမှာစာနံပါတ်",
Storage_single_status:"ဝင်ရောက်အော်ဒါ အခြေအနေ",
destination:"ရောက်ရှိမည့်နေရာ",
Other_destinations:"အခြားရွေးချယ်စရာ ရောက်ရှိမည့်နေရာ",
Other_address:"အခြားရွေးချယ်စရာ လိပ်စာ",
Other_address_contacts:"အခြားရွေးချယ်စရာ လိပ်စာဆက်သွယ်သူ",
Other_address_Contact_number:"အခြားရွေးချယ်စရာ လိပ်စာဆက်သွယ်သူနံပါတ်",
Estimated_time_of_arrival:"ခန့်မှန်းရောက်ရှိချိန်",
Channel_type:"ချန်နယ်အမျိုးအစား",
Please_select_a_destination:"ရောက်ရှိမည့်နေရာကို ရွေးချယ်ပါ။",
Please_select_Channel_type:"ချန်နယ်အမျိုးအစားကို ရွေးချယ်ပါ။",
Self_delivered:"ကိုယ်တိုင်ပို့ဆောင်ခြင်း",
Take_in:"စုဆောင်းခြင်း",
total_quantity:"စုစုပေါင်းအရေအတွက်",
odd:"လိုက်လံစစ်ဆေးနံပါတ်",
push:"ပို့ဆောင်ခြင်း",
Do_not_push:"မပို့ပါနှင့်",
Edit_cabinet_number:"ကွန်တိန်နာနံပါတ် တည်းဖြတ်ရန်",
Cargo_pull_information:"Huolala အချက်အလက်",
odd_Cargo_pull_information:"လိုက်လံစစ်ဆေးနံပါတ်/Huolala အသေးစိတ်",
First_billing_stage:"ပထမအဆင့် ငွေတောင်းခံလွှာ အဆင့်",
First_pass_single_stage:"ပထမအဆင့် အဆင့်",
Delivery_to_transit_warehouse:"သယ်ယူပို့ဆောင်ရေး ဂိုဒေါင်သို့ ပို့ဆောင်နည်း",
Reserved_gross_weight:"အစီအစဉ်ထားသော စုစုပေါင်း အလေးချိန်",
Total_number_of_reservations:"အစီအစဉ်ထားသော စုစုပေါင်း အရွယ်အစား",
Total_number_of_quantity:"အစီအစဉ်ထားသော စုစုပေါင်း အရေအတွက်",
Total_number_of_packages_arrived:"တကယ့် စုစုပေါင်း အပိုင်းရေ",
Actual_gross_weight:"တကယ့် စုစုပေါင်း အလေးချိန်",
Actual_total_number_of_squares:"တကယ့် စုစုပေါင်း အရွယ်အစား",
Total_number_of_appointments:"အစီအစဉ်ထားသော စုစုပေါင်း အပိုင်းရေ",
Total_number_of_boxes_booked:"အစီအစဉ်ထားသော စုစုပေါင်း ဘောက်စ်ရေ",
Cost_per_cubic_meter_KG:"တစ် ကုဗစ်မီတာ/ကီလိုဂရမ်လျှင် ကုန်ကျစရိတ်",
expense_per_cubic_meter_KG:"တစ် ကုဗစ်မီတာ/ကီလိုဂရမ်လျှင် ကုန်ကျစရိတ်",
Total_number_of_billed_squares:"ငွေတောင်းခံထားသော စုစုပေါင်း အရွယ်အစား",
Gross_chargeable_weight:"စုစုပေါင်း ငွေတောင်းခံနိုင်သည့် အလေးချိန်",
Additional_charge_per_cubic_meter_KG:"တစ် ကုဗစ်မီတာ/ကီလိုဂရမ်လျှင် ထပ်ဆောင်းကြေး",
Surcharge_cost_per_cubic_meter_KG:"တစ် ကုဗစ်မီတာ/ကီလိုဂရမ်လျှင် ထပ်ဆောင်းကြေးကုန်ကျစရိတ်",
container_number:"ကွန်တိန်နာနံပါတ်",
Please_enter_container_number:"ကွန်တိန်နာနံပါတ် ထည့်ပါ။",
Please_select_a_stuffing_time:"ကွန်တိန်နာတင်ချိန် ထည့်ပါ။",
Customer_remarks:"ဖောက်သည်မှတ်ချက်များ",
Customer_service_remarks:"ဖောက်သည်ဝန်ဆောင်မှုမှတ်ချက်များ",
Financial_remarks:"ဘဏ္ဍာရေးမှတ်ချက်များ",
Abnormal_remarks:"မမှန်ကန်သောမှတ်ချက်များ",
please_enter_Abnormal_remarks:"မမှန်ကန်သောမှတ်ချက်များ ထည့်ပါ။",
receiving_time:"လက်ခံချိန်",
consignee:"ပစ္စည်းလက်ခံသူ",
Delivery_time:"သယ်ယူပို့ဆောင်ရေးလက်ခံချိန်",
Estimated_time_to_transit_warehouse:"ခန့်မှန်းထားသည့် သယ်ယူပို့ဆောင်ရေးဂိုဒေါင် ရောက်ရှိချိန်",
Destination_arrival_time:"ရောက်ရှိမည့်နေရာ ရောက်ရှိချိန်",
submission_time:"တင်သွင်းချိန်",
Create_a_Customer_ID:"ဖောက်သည် ID ဖန်တီးပါ",
The_operation_failed_because_an_empty_box_exists_Please_modify_the_box_and_try_again:"လုပ်ငန်းဆောင်တာ မအောင်မြင်ပါ၊ ဗူးလွတ်များ တွေ့ရှိပါသည်။ ပြင်ဆင်၍ ထပ်မံကြိုးစားပါ။",
The_operation_failed_because_there_is_an_empty_amount_of_incoming_storage_Please_modify_it_and_try_again:"လုပ်ငန်းဆောင်တာ မအောင်မြင်ပါ၊ ဝင်လာမည့် ပမာဏများတွင် ဗူးလွတ်များ တွေ့ရှိပါသည်။ ပြင်ဆင်၍ ထပ်မံကြိုးစားပါ။",
viewOriginReceivingInboundOrder:"ဝင်လာမည့် အော်ဒါ အသေးစိတ် ကြည့်ရန်",
firstReceiptGoods:"ဝင်လာမှု လက်ခံမှတ်တမ်း",
goods_receiving_information:"လက်ခံမှတ်တမ်း အချက်အလက်",
consignment_sheet:"လက်ခံမှတ်တမ်း စာရင်း",
firstBillingDetails:"ဝင်လာမည့် ငွေတောင်းခံလွှာ အသေးစိတ်",
billing_details:"ငွေတောင်းခံလွှာ အသေးစိတ်",
billingDetails:"ငွေတောင်းခံလွှာ အသေးစိတ်",
Inventory_SKU_List:"ကုန်ပစ္စည်း SKU စာရင်း",
inventorySKUIist:"ကုန်ပစ္စည်း SKU စာရင်း",
First_order_number:"ဝင်လာမည့် အော်ဒါ နံပါတ်",
Entry_number:"ဝင်ရောက်အော်ဒါနံပါတ်",
Financial_verification_time:"ဘဏ္ဍာရေးအတည်ပြုချိန်",
Verify_collection_time:"အတည်ပြုလက်ခံချိန်",
Total_freight:"ကုန်ပို့ခစုစုပေါင်း",
freight_amount:"ကုန်ပို့ခပမာဏ",
Total_freight_cost:"ကုန်ပို့ခကုန်ကျစရိတ်စုစုပေါင်း",
gross_profit:"အမြတ်စုစုပေါင်း",
Gross_surcharge:"အပိုကြေးစုစုပေါင်း",
Basic_query:"အခြေခံမေးမြန်းချက်",
Logistics_inquiry:"လိုဂျစ်စတစ်မေးမြန်းချက်",
logisticsInquiry:"လိုဂျစ်စတစ်မေးမြန်းချက်",
Logistics_batch:"လိုဂျစ်စတစ်အုပ်စု",
Number_of_scans:"စကင်ထားသောအရေအတွက်",
Successful_quantity:"အောင်မြင်သောအရေအတွက်",
Number_of_failures:"မအောင်မြင်သောအရေအတွက်",
Remark_query:"မှတ်ချက်မေးမြန်းချက်",
Time_query:"အချိန်မေးမြန်းချက်",
Amount_inquiry:"ပမာဏမေးမြန်းချက်",
settlement_date:"ငွေပေးချေချိန်",
Statement_number:"ငွေပေးချေရေးနံပါတ်",
Supplier_settlement:"ပံ့ပိုးသူငွေပေးချေမှု",
viewFirstBillingDetails:"ဝင်ရောက်ဘီလ်အသေးစိတ်ကြည့်ရှုခြင်း",
stuffing_time:"ကွန်တိန်နာတင်ချိန်",
Changing_Customer_ID:"ဖောက်သည် ID ပြင်ဆင်ခြင်း",
Submit_initial_billing:"ထွက်ငွေတောင်းခံလွှာ တင်သွင်းခြင်း",
Return_the_initial_bill:"ဝင်ငွေတောင်းခံလွှာ ပြန်လည်တင်သွင်းခြင်း",
freight_inquiry:"ကုန်ပစ္စည်းစုံစမ်းမေးမြန်းခြင်း",
Starting_weight:"အစပိုင်းအလေးချိန်",
Initial_number:"အစပိုင်းထုထည်မီတာ",
End_square:"နောက်ဆုံးထုထည်မီတာ",
Starting_number_of_packages:"အစပိုင်းထုပ်ပိုးအရေအတွက်",
End_number_of_packages:"နောက်ဆုံးထုပ်ပိုးအရေအတွက်",
Initial_quantity:"အစပိုင်းအရေအတွက်",
End_quantity:"နောက်ဆုံးအရေအတွက်",
Actual_quantity_arrived:"လက်ခံရရှိသော တကယ့်အရေအတွက်",
Reservation_quantity:"စာရင်းသွင်းထားသော အရေအတွက်",
The_number_of_received_boxes_is_inconsistent_with_the_number_of_reserved_boxes_whether_to_continue_to_submit:"လက်ခံရရှိသော ဘောက်စ်ရေသည် အစီအစဉ်အရ ရေတွက်ချက်နှင့် မကိုက်ညီပါ - တင်သွင်းမည်လား?",
First_leg_deduction_fee:"ပထမအဆင့် ဖြတ်ချခြင်း",
Advance_payment:"ပထမအဆင့် ငွေပေးချေမှု",
Transfer_warehouse_to_collect:"သယ်ယူပို့ဆောင်ရေး ဂိုဒေါင်မှ စုဆောင်းခြင်း",
Shipping_to_overseas_warehouse:"နိုင်ငံခြား ဂိုဒေါင်သို့ ပို့ဆောင်ခြင်း",
Overseas_warehouse_delivery:"နိုင်ငံခြား ဂိုဒေါင်မှ ပို့ဆောင်ခြင်း",
There_are_mandatory_fields_in_the_received_information:"ပို့ဆောင်ရေးအချက်အလက်တွင် မဖြည့်သွင်းရသေးသော မဖြစ်မနေရသော ကွက်လပ်များ ပါဝင်သည်။",
There_are_mandatory_fields_in_the_channel_information:"သယ်ယူပို့ဆောင်ရေးအသေးစိတ်တွင် မဖြည့်ထားသေးသော မဖြစ်မနေရသော အကွက်များ ပါဝင်နေသည်။",
There_are_no_required_fields_in_the_delivery_information:"ဂိုဒေါင်ရောက်ရှိမှုအသေးစိတ်တွင် မဖြည့်ထားသေးသော မဖြစ်မနေရသော အကွက်များ ပါဝင်နေသည်။",
Please_select_a_delivery_type:"ပို့ဆောင်မှုအမျိုးအစားကို ရွေးချယ်ပါ။",
warehousing:"ဂိုဒေါင်ထည့်သွင်းခြင်း",
pick_up_in_a_store:"ကိုယ်တိုင်လာယူခြင်း",
delivery:"ပို့ဆောင်ပေးခြင်း",
delivery_address:"ပို့ဆောင်ရန်လိပ်စာ",
Store_goods_directly_in_overseas_warehouses:"နိုင်ငံခြားဂိုဒေါင်တွင် ကုန်ပစ္စည်းများကို တိုက်ရိုက်သိုလှောင်ခြင်း",
The_customer_will_receive_the_goods_from_the_overseas_warehouse_by_himself:"ဖောက်သည်သည် နိုင်ငံခြားဂိုဒေါင်မှ ကုန်ပစ္စည်းများကို တိုက်ရိုက်လာယူသည်။",
By_overseas_warehouse_contact_logistics_delivery_to_the_customer_designated_location:"နိုင်ငံခြားဂိုဒေါင်လိုဂျစ်စတစ်မှတဆင့် ဖောက်သည် သတ်မှတ်ထားသော နေရာသို့ ပို့ဆောင်ရန် စီစဉ်ပါ",
Upload_credentials:"ငွေပေးချေမှု သက်သေ တင်ပါ",
credentials:"ငွေပေးချေမှု သက်သေ",
Please_select_the_same_channel_type:"ကျေးဇူးပြု၍ တူညီသော ချန်နယ်အမျိုးအစားကို ရွေးပါ",
replacement_expense:"ကြေးများ ပြန်လည်သတ်မှတ်ပါ",
Set_the_replacement_charge_according_to_the_head_charge:"အစပိုင်း ခရီးစရိတ်များအပေါ် အခြေခံ၍ ကြေးများ ပြန်လည်သတ်မှတ်ပါ",
Reset_the_current_order_cost_by_the_actual_number_of_square_feet:"လက်ရှိ အော်ဒါကြေးများကို တကယ့် ကူဘစ်မီတာအရ ပြန်လည်သတ်မှတ်ပါ",
Reset_the_current_order_charge_according_to_the_actual_order:"လက်ရှိ အော်ဒါကြေးများကို တကယ့် အော်ဒါနည်းလမ်းအရ ပြန်လည်သတ်မှတ်ပါ",
Order_different_goods_attributes_warehouse_transit_warehouse_billing_method_currency_customer_will_use_the_current_cost_Settings_to_calculate_the_cost:"အော်ဒါအတွင်းရှိ ကုန်ပစ္စည်းအင်္ဂါရပ်များ၊ ဂိုဒေါင်များ၊ သယ်ယူပို့ဆောင်ရေးဂိုဒေါင်များ၊ ငွေတောင်းခံနည်းများ၊ ငွေကြေးများနှင့် ဖောက်သည်များအားလုံးသည် လက်ရှိကြေးဆက်တင်များကို တွက်ချက်ရာတွင် အသုံးပြုမည်။",
Freight_cost_surcharge_cost_default_value_is_set_for_the_current_order_cost_corresponding_to_the_maximum_amount_cubic_KG:"ကုန်ပို့ခ၊ အပိုကြေး၊ မူလတန်ဖိုးသည် လက်ရှိအော်ဒါကြေးများအတွက် သတ်မှတ်ထားသော အများဆုံးပမာဏ (ကော်ဘစ်မီတာ/ကီလိုဂရမ်) နှင့် ကိုက်ညီသည်။",
Freight_cubic_meter_KG:"ကုန်ပို့ခ (ကော်ဘစ်မီတာ/ကီလိုဂရမ်)",
Additional_charge_cubic_meter_KG:"အပိုကြေး (ကော်ဘစ်မီတာ/ကီလိုဂရမ်)",
freight_cost_cubic_meter_KG:"ကုန်ပို့ခ (ကော်ဘစ်မီတာ/ကီလိုဂရမ်)",
Surcharge_cost_cubic_meter_KG:"အပိုကြေးကုန်ကျစရိတ် (ကုဗစ်မီတာ/ကီလိုဂရမ်)",
The_content_is_not_filled_in:"ဖြည့်မထားသေးသော အကွက်များ ရှိနေပါသည်",
Please_scan_the_head_track_number:"ပထမဆုံးပို့ဆောင်မှု လိုက်လံစစ်ဆေးနံပါတ်ကို စကင်ပေးပါ",
Please_scan_a_valid_header_tracking_number:"မှန်ကန်သော ပထမဆုံးပို့ဆောင်မှု လိုက်လံစစ်ဆေးနံပါတ်ကို စကင်ပေးပါ",
Attributes_of_goods_received:"လက်ခံရရှိသော ကုန်ပစ္စည်း အင်္ဂါရပ်များ",
Commodity_property:"ထုတ်ကုန် ကုန်ပစ္စည်း အင်္ဂါရပ်များ",
Import_order:"အမှာစာ တင်သွင်းခြင်း",
Click_Upload:"တင်ရန် နှိပ်ပါ",
Click_here_to_download_the_template:"နမူနာ ဖိုင် ဒေါင်းလုဒ်ဆွဲရန် ဤနေရာကို နှိပ်ပါ",
Download_template:"နမူနာ ဖိုင် ဒေါင်းလုဒ်ဆွဲပါ",
DeliveryTime:"သယ်ယူပို့ဆောင်ရေး အချိန်",
Start_time_of_inspection:"အရည်အသွေး စစ်ဆေးမှု စတင်ချိန်",
End_time_of_inspection:"အရည်အသွေး စစ်ဆေးမှု အဆုံးချိန်",
Shelf_start_time:"စင်တင်ချိန် စတင်ချိန်",
End_shelf_time:"စင်တင်ချိန် အဆုံးချိန်",
Billing_information:"ငွေတောင်းခံခြင်း အချက်အလက်",
evidence_of_payment:"ငွေပေးချေမှု သက်သေ",
Be_generating:"ဖန်တီးနေဆဲ...",
Entering_a_custom_size_will_override_the_selected_print_size:"ကိုယ်တိုင်ထည့်သွင်းသော အတိုင်းအတာများသည် ရွေးထားသော ပုံနှိပ်အတိုင်းအတာများကို ကျော်လွန်မည်",
import_first_receipt_goods:"ပထမဆုံး ပို့ဆောင်မှု လက်ခံလွှာများ တင်သွင်းခြင်း",
View_the_inbound_and_outbound_flows:"ဂိုဒေါင် ဝင်/ထွက် လုပ်ငန်းစဉ် မှတ်တမ်းများ ကြည့်ရှုခြင်း",
tracking_number:"သယ်ယူပို့ဆောင်ရေး လိုက်လံစစ်ဆေးနံပါတ်",
edit_tracking_number:"သယ်ယူပို့ဆောင်ရေး လိုက်လံစစ်ဆေးနံပါတ် တည်းဖြတ်ခြင်း",
transit_time:"သယ်ယူပို့ဆောင်ချိန်",
loading_time:"တင်ပို့ချိန်",
preset_Exception_Remark:"ကြိုတင်သတ်မှတ်ထားသော ထူးခြားချက် မှတ်စုများ",
Batch_Modify_Product_Billing_Attributes:"ထုတ်ကုန် ငွေတောင်းခံခြင်း လက္ခဏာများကို အစုလိုက် ပြင်ဆင်ခြင်း",
Please_Select_Product_Billing_Attributes:"ထုတ်ကုန် ငွေတောင်းခံခြင်း လက္ခဏာများကို ရွေးချယ်ပါ",
Product_Billing_Attributes:"ထုတ်ကုန် ငွေတောင်းခံခြင်း လက္ခဏာများ",
stockManagement:"ဝင်ရောက်စီမံခန့်ခွဲမှု",
Warehouse_entry_list:"ဝင်ရောက်အော်ဒါစာရင်း",
warehouseEntryList:"ဝင်ရောက်အော်ဒါစာရင်း",
warehouseReceiptList:"ဝင်ရောက်လက်ခံစာရင်း",
over_time:"အချိန်ကုန်",
Hit_shelves_on_time:"အချိန်မီတင်ခြင်း",
Number_of_SKUs:"SKU အရေအတွက်",
SKU_total_quantity:"စုစုပေါင်း SKU အရေအတွက်",
qualified_quantity:"အရည်အသွေးပြည့်မီသောအရေအတွက်",
Quantity_of_reserved_storage:"အစီအစဉ်ပြုထားသောဝင်ရောက်အရေအတွက်",
Number_of_reserved_storage_parties:"အစီအစဉ်ပြုထားသောဝင်ရောက် ကုဗစ်မီတာ",
time_efficiency:"ကြာမြင့်ချိန်",
On_shelf_rate:"တင်ခြင်းအချိန်မီနှုန်း",
Whether_it_is_forced_into_transit:"သွားလာနေစဉ်သို့ အတင်းအကျပ်ပို့ခြင်း",
Store_entry_details:"ဝင်ရောက်အော်ဒါအသေးစိတ်",
Damaged_quantity:"ပျက်စီးပမာဏ",
Miss_delivery:"ပျောက်ဆုံးပစ္စည်းများ",
Miss_delivery_quantity:"လျော့နည်းပမာဏ",
wrongly_send:"မှားယွင်းပစ္စည်းများ",
wrongly_send_quantity:"မှားယွင်းပမာဏ",
Warehousing_to_receive_goods:"ကုန်ပစ္စည်းလက်ခံခြင်း",
warehousingReceiveGoods:"ကုန်ပစ္စည်းလက်ခံခြင်း",
inventoryEntryListChecked:"စစ်ဆေးရန်စောင့်ဆိုင်းနေသော လက်ခံစာရင်း",
inventoryEntryList:"တင်ရန်စောင့်ဆိုင်းနေသော လက်ခံစာရင်း",
Inbound_inspection:"ဝင်ရောက်အရည်အသွေးစစ်ဆေးခြင်း",
inboundInspection:"ဝင်ရောက်အရည်အသွေးစစ်ဆေးခြင်း",
Quality_inspection_quantity:"စစ်ဆေးမည့်အရေအတွက်",
quality_testing:"အရည်အသွေးစစ်ဆေးခြင်း",
Batch_quality_inspection:"အစုလိုက်စစ်ဆေးခြင်း",
Obtaining_quality_Inspection_Task:"စစ်ဆေးရေးတာဝန်များ ထုတ်ယူခြင်း",
Generate_a_quality_check_task:"စစ်ဆေးရေးတာဝန်များ ခန့်အပ်ခြင်း",
Setting_priority_inspection:"ဦးစားပေးစစ်ဆေးခြင်း သတ်မှတ်ခြင်း",
The_inspection_quantity_cannot_be_empty:"စစ်ဆေးမည့်အရေအတွက်ကို ဗလာမထားနိုင်ပါ။",
Disabled_Excess_Check_quantity_cannot_be_greater_than_the_scheduled_check_quantity:"အပိုစစ်ဆေးမှုကို ပိတ်ထားသောအခါ၊ စစ်ဆေးမည့်အရေအတွက်သည် စီစဉ်ထားသည့်အရေအတွက်ထက် မကျော်ရ",
Abnormal_quality_inspection_quantity:"စစ်ဆေးမည့်အရေအတွက် မမှန်ကန်ခြင်း",
enter_the_qualified_quantity:"ကိုက်ညီသောပစ္စည်းများ၏ အရေအတွက်ကို ထည့်ပါ။",
enter_the_breakage_quantity:"ပျက်စီးနေသောပစ္စည်းများ၏ အရေအတွက်ကို ထည့်ပါ။",
enter_the_lack_send_quantity:"ပျောက်ဆုံးနေသောပစ္စည်းများ၏ အရေအတွက်ကို ထည့်ပါ။",
enter_the_wrongly_send_quantity:"မှားပို့ထားသောပစ္စည်းများ၏ အရေအတွက်ကို ထည့်ပါ။",
enter_the_actual_weight:"လက်တွေ့အလေးချိန်ကို ထည့်ပါ။",
enter_the_actual_length:"လက်တွေ့အရှည်ကို ထည့်ပါ။",
enter_the_actual_width:"လက်တွေ့အကျယ်ကို ထည့်ပါ။",
enter_the_actual_height:"လက်တွေ့အမြင့်ကို ထည့်ပါ။",
length_CM:"အရှည် (စင်တီမီတာ)",
width_CM:"အကျယ် (စင်တီမီတာ)",
height_CM:"အမြင့် (စင်တီမီတာ)",
widht_MM:"အကျယ် (မီလီမီတာ)",
height_MM:"အမြင့် (မီလီမီတာ)",
There_may_be_print_incompatibilities_when_using_custom_printing:"စိတ်ကြိုက်ပုံနှိပ်ခြင်းအသုံးပြုသောအခါ မကိုက်ညီသော ပုံနှိပ်အကြောင်းအရာများ ဖြစ်ပေါ်နိုင်ပါသည်။",
This_parameter_is_valid_only_when_the_width_and_height_are_greater_than_0:"အကျယ်နှင့် အမြင့် အတိုင်းအတာများ နှစ်ခုစလုံး 0 ထက် ကြီးမှသာ အကျိုးရှိပါမည်။",
Create_mis_sent_SKUs:"မှားပို့ထားသော SKU ဖန်တီးခြင်း",
The_number_of_missent_SKUs_cannot_be_0:"မှားပို့ထားသော SKU အရေအတွက်သည် 0 မဖြစ်ရ။",
Only_a_single_item_can_be_selected:"တစ်ခုချင်းစီသာ ခွင့်ပြုပါသည်။",
Number_of_SKUs_sent_incorrectly:"မှားပို့ထားသော SKU အရေအတွက်",
The_inspection_of_the_sku_has_been_completed_Scan_other_SKUs:"ဤ SKU သည် စစ်ဆေးမှု ပြီးစီးပါပြီ။ အခြား SKU ကို စကင်ပါ။",
The_inspection_Label_quantity_cannot_be_empty:"အမှတ်တံဆိပ်ထိုးထားသော အရေအတွက်ကို ထည့်ပါ။",
The_inspection_Label_quantity_cannot_be_greater_than_the_qualified_quantity:"အရည်အသွေးစစ်ဆေးရေး တံဆိပ်အရေအတွက်သည် အရည်အသွေးပြည့်မီသော အရေအတွက်ထက် မကျော်ရ",
Please_scan_the_receipt_number:"ဂိုဒေါင်လက်ခံလွှာနံပါတ်ကို စကင်ပါ",
Quality_inspector:"အရည်အသွေးစစ်ဆေးသူ",
Quality_inspection_information:"အရည်အသွေးစစ်ဆေးမှု အချက်အလက်",
Product_real_information:"ထုတ်ကုန် အချက်အလက်",
printBoxLabel:"ဘောက်စ်တံဆိပ် ပုံနှိပ်ရန်",
Print_head_entry_slip:"ပထမအဆင့် ဂိုဒေါင်လက်ခံလွှာ ပုံနှိပ်ရန်",
Print_shipping_mark_and_case_label:"ပို့ဆောင်ရေးတံဆိပ် ပုံနှိပ်ရန်",
Print_storage_box_label:"ဂိုဒေါင်လက်ခံလွှာတံဆိပ် ပုံနှိပ်ရန်",
Quantity_labeled:"တံဆိပ်တပ်ပြီးသော အရေအတွက်",
Quantity_inspected:"စစ်ဆေးပြီးသော အရေအတွက်",
Printing_product_bar_code:"ထုတ်ကုန် ဘားကုဒ် ပုံနှိပ်ရန်",
unpackingInspection:"ထုတ်ပစ္စည်း စစ်ဆေးခြင်း",
fastQualityInspectionAndShelf:"အမြန်စစ်ဆေးပြီး စင်တင်ခြင်း",
qualityInspectionTaskList:"အရည်အသွေးစစ်ဆေးရေး တာဝန်စာရင်း",
shelvesTaskList:"စင်တင်ရေး တာဝန်စာရင်း",
Ordinary_quality_inspection:"စံစစ်ဆေးခြင်း",
Rapid_quality_inspection:"အမြန်စစ်ဆေးခြင်း",
Please_enter_SKU_or_product_barcode:"SKU/ထုတ်ကုန် ဘားကုဒ်ကို ထည့်ပါ။",
batch_input:"တစ်ချက်နှိပ်၍ ထည့်သွင်းခြင်း",
Please_enter_the_number_of_boxes:"ဘောက်စ်အရေအတွက်ကို ထည့်ပါ။",
Order_types:"အော်ဒါအမျိုးအစား",
entering_the_warehouse:"ဝင်ရောက်မှု",
FirstLegOrder:"အစပထမ ပို့ဆောင်မှု မှတ်ချက်",
InventoryOrder:"ဝင်ရောက်မှု မှတ်ချက်",
FirstLegOrder_AND_InventoryOrder:"အစပထမ ပို့ဆောင်မှု မှတ်ချက် + ဝင်ရောက်မှု မှတ်ချက်",
InventoryOrderType:"ဝင်ရောက်မှု မှတ်ချက် အမျိုးအစား",
InventoryOrderID:"ဝင်ရောက်မှု မှတ်ချက် ID",
ThirdPartyInventoryOrder:"တတိယပါတီ ဂိုဒေါင် ဝင်ရောက်မှု မှတ်ချက်",
Receive_information:"ယူဆောင်မှု အသေးစိတ်",
Receiving_address:"ယူဆောင်မှု လိပ်စာ",
transport_information:"သယ်ယူပို့ဆောင်ရေး အသေးစိတ်",
Arrival_information:"ဂိုဒေါင် ရောက်ရှိမှု အသေးစိတ်",
delivery_type:"ပို့ဆောင်နည်း",
Push_order:"Push အော်ဒါ",
Push_order_Type:"Push အော်ဒါ အခြေအနေ",
Please_select_delivery_type:"ပို့ဆောင်နည်းကို ရွေးချယ်ပါ",
Please_select_Order_types:"အော်ဒါ အမျိုးအစားကို ရွေးချယ်ပါ",
Please_select_a_task_type:"တာဝန် အမျိုးအစားကို ရွေးချယ်ပါ",
detailed_address:"အသေးစိတ် လိပ်စာ",
Please_enter_detailed_address:"အသေးစိတ် လိပ်စာကို ထည့်ပါ",
Please_enter_phone:"ဆက်သွယ်ရန် နံပါတ်ကို ထည့်ပါ",
Select_a_contact:"ဆက်သွယ်မည့် ပုဂ္ဂိုလ်ကို ရွေးချယ်ပါ",
phone:"ဆက်သွယ်ရန် နံပါတ်",
warehouse_address:"ဂိုဒေါင် လိပ်စာ",
Warehouse_information:"ဂိုဒေါင် အချက်အလက်",
freight_information:"ကုန်ပို့ခ အချက်အလက်",
Please_enter_mode_of_transportation:"သယ်ယူပို့ဆောင်နည်းကို ထည့်ပါ",
Please_enter_warehouse_address:"ဂိုဒေါင် လိပ်စာကို ထည့်ပါ",
Please_select_Estimated_time_to_transit_warehouse:"ခန့်မှန်းထားသော ဂိုဒေါင် ရောက်ရှိချိန်ကို ရွေးချယ်ပါ",
Please_select_an_estimated_time_to_warehouse:"ခန့်မှန်းထားသော ဂိုဒေါင် ရောက်ရှိချိန်ကို ရွေးချယ်ပါ",
Shipping_to_transit_warehouse_method:"Transit ဂိုဒေါင် ပို့ဆောင်နည်း",
Pure_warehouse_receipt_does_not_support_door_to_door_collection:"အဝင်အမှာစာသီးသန့်များတွင် အိမ်တိုင်ပို့ယူခြင်း မထောက်ပံ့ပါ။",
General_container_number:"ထုပ်ပိုးအိတ်စုစုပေါင်း",
cargo_list:"ကုန်ပစ္စည်းစာရင်း",
cargoInfo:"ကုန်ပစ္စည်းအချက်အလက်",
personalized_setting:"စိတ်ကြိုက်ပြင်ဆင်မှုဆက်တင်များ",
Navigation_bar_style:"လမ်းညွှန်ဘားပုံစံ",
window:"ပြတင်းပေါက်",
windowAddress:"ပြတင်းပေါက်လိပ်စာ",
printContent:"ပုံနှိပ်မည့်အကြောင်းအရာ",
printingQuantity:"ပုံနှိပ်မည့်အရေအတွက်",
isShowCnName:"တရုတ်နာမည်ပြသ",
isShowMadeInChina:"Made in China' ပြသ",
isShowTime:"အချိန်ပြသ",
The_cargo_list_is_empty:"ကုန်ပစ္စည်းစာရင်းဗလာနေသည်",
add_cargo_list:"ကုန်ပစ္စည်းစာရင်းထည့်ရန်",
batch_add_cargo_list:"ကုန်ပစ္စည်းစာရင်းအစုလိုက်ထည့်ရန်",
total_value:"စုစုပေါင်းတန်ဖိုး",
outer_box_length:"အပြင်ထုပ်ပိုးအိတ်အရှည်",
Please_enter_outer_box_length:"အပြင်ထုပ်ပိုးအိတ်အရှည်ကို ထည့်ပါ။",
outer_box_width:"အပြင်ထုပ်ပိုးအိတ်အကျယ်",
Please_enter_outer_box_width:"အပြင်ထုပ်ပိုးအိတ်အကျယ်ကို ထည့်ပါ။",
outer_box_height:"အပြင်ဘောက်စ် အမြင့်",
Please_enter_outer_box_height:"အပြင်ဘောက်စ် အမြင့်ကို ထည့်ပါ။",
Receiving_container_length:"လက်ခံမည့် အပြင်ဘောက်စ် အရှည်",
Receiving_container_width:"လက်ခံမည့် အပြင်ဘောက်စ် အကျယ်",
Receiving_container_height:"လက်ခံမည့် အပြင်ဘောက်စ် အမြင့်",
Received_weight:"လက်ခံမည့် အလေးချိန်",
carton_size:"အပြင်ဘောက်စ် အတိုင်းအတာများ",
Please_select_whether_there_is_a_label:"တံဆိပ်တပ်မည့်/မတပ်မည့်ကို ရွေးပါ။",
Please_enter_the_customer_name:"ဖောက်သည်အမည်ကို ထည့်ပါ။",
box:"ဘောက်စ်",
boxNumber:"ဘောက်စ်နံပါတ်",
product_details:"ကုန်ပစ္စည်းအသေးစိတ်",
add_product_details:"ကုန်ပစ္စည်းအသေးစိတ် ထည့်ရန်",
remove:"ဖယ်ရှားရန်",
product_image:"ကုန်ပစ္စည်းပုံ",
Eng_Cn_Name:"တရုတ်ကုန်အမည်",
Please_enter_Eng_Cn_Name:"တရုတ်ကုန်အမည်ကို ထည့်ပါ။",
Eng_En_Name:"အင်္ဂလိပ်ကုန်အမည်",
Please_enter_Eng_En_Name:"အင်္ဂလိပ်ကုန်အမည်ကို ထည့်ပါ။",
unit_price:"တစ်ယူနစ်စျေးနှုန်း",
Please_enter_unit_price:"တစ်ယူနစ်စျေးနှုန်းကို ထည့်ပါ။",
Is_there_a_mark:"တံဆိပ်တပ်မည့်/မတပ်မည့်",
goodsCode:"ကုန်ပစ္စည်း ဘားကုဒ်",
model:"မော်ဒယ်",
Please_enter_model:"မော်ဒယ်ကို ထည့်ပါ။",
material:"ပစ္စည်း",
stage:"အဆင့်",
product_code:"ကုန်ပစ္စည်းကုဒ်",
Please_enter_material:"ပစ္စည်းကို ထည့်ပါ။",
customs_code:"ကုန်သွယ်ခွန်ကုဒ်",
Please_enter_customs_code:"ကုန်သွယ်ခွန်ကုဒ်ကို ထည့်ပါ။",
brand:"အမှတ်တံဆိပ်",
Please_enter_brand:"အမှတ်တံဆိပ်ကို ထည့်ပါ။",
List_of_goods_not_selected_for_addition:"ရွေးမထားသေးသော ကုန်ပစ္စည်းစာရင်း",
There_is_an_empty_container_number_Please_fill_in_the_container_number_and_try_again:"ဘောက်စ်နံပါတ် မမှန်ပါ၊ မှန်ကန်သော ဘောက်စ်နံပါတ် ထည့်၍ ထပ်မံကြိုးစားပါ။",
Property_of_goods:"ကုန်ပစ္စည်း အင်္ဂါရပ်များ",
Please_select_goods_attributes:"ကုန်ပစ္စည်း အင်္ဂါရပ်များကို ရွေးပါ။",
CollectInfo:"စုဆောင်းမှု အချက်အလက်",
Repeated_SKUs_appear:"SKU ထပ်တူတွေ့ရှိပါသည်",
Save_to_draft:"မူကြမ်းသို့ သိမ်းဆည်းရန်",
batch_processing:"အစုလိုက် လုပ်ငန်းစဉ်",
Quantity_in_storage:"ဝင်ရောက်ပမာဏ",
Dimensional_synchronization:"အတိုင်းအတာညှိနှိုင်းခြင်း",
The_batch_list_is_not_selected:"အစုလိုက်လုပ်ငန်းအတွက် ရွေးမထားသေးသော ကုန်ပစ္စည်းစာရင်း",
Total_storage_quantity:"စုစုပေါင်း ဝင်ရောက်ပမာဏ",
Gross_cargo_weight:"စုစုပေါင်း ကုန်ပစ္စည်းအလေးချိန်",
Shipping_Information:"ပို့ဆောင်ရေးအချက်အလက်",
Delivery_type:"ပို့ဆောင်ရေးအမျိုးအစား",
box_quantity:"သေတ္တာအရေအတွက်",
Size_of_the_outer_box_received:"လက်ခံရရှိသော အပြင်ဘက်သေတ္တာ အတိုင်းအတာများ",
not_receive_the_goods:"မလက်ခံရရှိသေး",
received:"လက်ခံရရှိပြီး",
Take_pictures_of_receiving_goods:"လက်ခံလွှာပုံ",
Receive_goods_in_one_box:"တစ်သေတ္တာလက်ခံလွှာ",
Double_receipt:"မိတ္တူလက်ခံလွှာ",
Write_back_time:"ပြန်ရေးချိန်",
Write_back_result:"ပြန်ရေးရလဒ်",
Single_box_Only_one_box_can_be_selected:"တစ်သေတ္တာလက်ခံလွှာဖြင့် တစ်သေတ္တာသာ ရွေးချယ်နိုင်သည်",
The_receiving_list_has_empty_value_and_cannot_be_saved:"လက်ခံစာစာရင်းတွင် အလွတ်တန်ဖိုးများပါရှိပြီး သိမ်းဆည်းခြင်း မအောင်မြင်ပါ။",
No_box_was_selected_to_save_the_receipt:"လက်ခံသိမ်းဆည်းရန် ဘောက်စ်များ မရွေးထားပါ။",
Duplicate_receipt_is_detected_whether_to_duplicate_receipt:"ထပ်တူထပ်မျှ လက်ခံစာများ တွေ့ရှိပါသည်။ ထပ်တူထပ်မျှ လက်ခံစာကို အတည်ပြုမည်လား?",
Whether_excess_inspection:"အရည်အသွေး စစ်ဆေးခွင့် ကုလားထိုင် ကျော်လွန်သွားပါသလား?",
Priority_inspection:"အရည်အသွေး စစ်ဆေးမှုကို ဦးစားပေးမည်လား?",
Only_a_single_entry_ticket_can_be_selected:"တစ်ခုတည်းသော လက်ခံစာ အမှာစာများကိုသာ ခွင့်ပြုထားသည်။",
The_box_number_already_exists:"ဘောက်စ်နံပါတ် မှားနေပါသည်၊ ပြန်ထည့်ပါ။",
Please_enter_the_box_number:"ဘောက်စ်နံပါတ် ထည့်ပါ။",
The_inspection_of_all_the_current_container_numbers_has_been_completed:"လက်ရှိ ဘောက်စ်နံပါတ်အတွက် အရည်အသွေး စစ်ဆေးမှုများအားလုံး ပြီးစီးပါပြီ။",
There_is_no_quality_inspection_data_for_the_current_container_number:"လက်ရှိဘောက်စ်နံပါတ်အတွက် စစ်ဆေးမှုဒေတာ မတွေ့ပါ။ ပြန်လည်စကင်ပါ။",
The_SKU_does_not_exist_in_the_current_container_number:"လက်ရှိဘောက်စ်နံပါတ်အတွက် SKU မရှိပါ။",
inspected:"စစ်ဆေးပြီး",
Not_inspected:"မစစ်ဆေးသေး",
Successful_receipt:"လက်ခံမှု အောင်မြင်ပါပြီ",
Submit_and_print:"တင်သွင်းပြီး ပုံနှိပ်ရန်",
Print_head_list:"ဝေးဘစ်လ် ပုံနှိပ်ရန်",
Header_list:"ဝေးဘစ်လ် စာရင်း",
printHeaderList:"ဝေးဘစ်လ် စာရင်း ပုံနှိပ်ရန်",
printSubMitHeaderList:"တင်သွင်းထားသော ဝေးဘစ်လ် စာရင်း ပုံနှိပ်ရန်",
First_shipping_mark:"ဝေးဘစ်လ် တံဆိပ်",
printFirsShippingMark:"ဝေးဘစ်လ် တံဆိပ် ပုံနှိပ်ရန်",
printSubMitFirsShippingMark:"တင်သွင်းထားသော ဝေးဘစ်လ် တံဆိပ် ပုံနှိပ်ရန်",
First_single_box_label:"ဝေးဘစ်လ် ဘောက်စ် တံဆိပ်",
Warehouse_single_box_label:"ဝင်လာသော အော်ဒါ ဘောက်စ် တံဆိပ်",
printFirstSingleBoxLabelAndWarehouseSingleBoxLabel:"ပထမအဆင့် Waybill ပုံနှိပ်ခြင်း၊ သေတ္တာမှတ်သားခြင်း + လက်ခံစာရင်း သေတ္တာမှတ်သားခြင်း",
printSubMitFirstSingleBoxLabelAndWarehouseSingleBoxLabel:"တင်သွင်းထားသော ပထမအဆင့် Waybill ပုံနှိပ်ခြင်း၊ သေတ္တာမှတ်သားခြင်း + လက်ခံစာရင်း သေတ္တာမှတ်သားခြင်း",
Select_individual_order:"အော်ဒါ တစ်ခုသာ ရွေးပါ။",
total_number_packages:"စုစုပေါင်း အပိုင်းရေ",
total_weight_KG:"စုစုပေါင်း အလေးချိန် (ကီလိုဂရမ်)",
Gross_cube_CBM:"စုစုပေါင်း ကုဗစ်မီတာ (CBM)",
Gross_cube:"စုစုပေါင်း ကုဗစ်မီတာ",
Export_data_priority:"ဒေတာ ထုတ်ပို့ခြင်း ဦးစားပေးမှု",
Specified_exported_data:"ထုတ်ပို့မည့် ဒေတာ သတ်မှတ်ပါ",
List_selection_data:"စာရင်းမှ ဒေတာ ရွေးပါ",
List_filtering_data:"စာရင်းမှ ဒေတာ စစ်ထုတ်ပါ",
distributionManagement:"အော်ဒါဖြည့်ဆည်းမှု စီမံခန့်ခွဲမှု",
printInventoryEntryList:"လက်ခံစာရင်း ပုံနှိပ်ခြင်း",
The_form_verification_failed_Please_check_and_try_again:"ဖောင်အတည်ပြုခြင်း မအောင်မြင်ပါ။ ကျေးဇူးပြု၍ စစ်ဆေးပြီး ထပ်မံကြိုးစားပါ။",
The_product_bar_code_does_not_exist_in_the_current_task_list_or_has_been_put_on_the_shelf:"ဤထုတ်ကုန် ဘားကုဒ်သည် လက်ရှိ လုပ်ငန်းတွင် မတွေ့ရှိပါ သို့မဟုတ် စင်ပေါ်သို့ ရွှေ့ထားပါသည်။ ကျေးဇူးပြု၍ ထပ်မံ စကင်ပါ။",
Inventory_entry_list:"လက်ခံစာရင်း",
Print_the_inventory_entry_list:"လက်ခံစာရင်း ပုံနှိပ်ခြင်း",
One_click_out_and_print_the_pick_list:"တစ်ချက်နှိပ်၍ ပို့ဆောင်ခြင်းနှင့် ရွေးယူလက်မှတ် ပုံနှိပ်ခြင်း",
One_click_out_the_warehouse_and_print_the_invoice:"တစ်ချက်နှိပ်၍ ပို့ဆောင်မှုလက်မှတ် ပုံနှိပ်ခြင်း",
Only_confirmation_time_is_supported:"အတည်ပြုချိန်သာ ထောက်ပံ့ထားသည်",
Please_select_confirmation_time:"ကျေးဇူးပြု၍ အတည်ပြုချိန်ကို ရွေးချယ်ပါ။",
Only_save_the_hour_minute_and_second_of_the_confirmation_time:"အတည်ပြုချိန်၏ နာရီ၊ မိနစ်နှင့် စက္ကန့်များကိုသာ သိမ်းဆည်းပါသည်။ အမြန်စစ်ဆေးမှုများအတွက် ယနေ့ရက်စွဲကို အလိုအလျောက် သတ်မှတ်သည်။",
The_current_operation_cannot_be_undone_Do_you_want_to_continue:"လက်ရှိ လုပ်ဆောင်ချက်ကို ပြန်မလုပ်နိုင်ပါ။ ဆက်လက်လုပ်ဆောင်မည်လား?",
Quantities_that_have_not_passed_quality_inspection_will_be_considered_entirely_unqualified:"စစ်ဆေးမထားသော အရေအတွက်များကို လုံးဝ မလိုက်နာဟု သတ်မှတ်မည်။",
Edit_warehouse_remark:"ဂိုဒေါင်မှတ်စုများ ပြင်ဆင်ရန်",
Submit_to_listed:"သိမ်းဆည်းထားသည့် အခြေအနေသို့ တင်သွင်းရန်",
Has_the_quality_inspection_been_completed:"အရည်အသွေး စစ်ဆေးမှု ပြီးစီးပါသလား?",
Forecast_error_message:"ခန့်မှန်းချက် အမှား သတင်းစကား",
Take_pictures_out_of_the_warehouse:"ထွက်ပို့ဓာတ်ပုံ",
Online_product_details:"အွန်လိုင်း ထုတ်ကုန် အသေးစိတ်",
Product_preview:"ထုတ်ကုန် ကြိုကြည့်ဓာတ်ပုံ",
declared_value:"ကြေညာထားသော တန်ဖိုး",
Weight_KG_piece:"အလေးချိန် (ကီလိုဂရမ်/ယူနစ်)",
Weight_KG_box:"အလေးချိန် (ကီလိုဂရမ်/ဘောက်စ်)",
Declared_value_USD_piece:"ကြေညာထားသော တန်ဖိုး (USD/ယူနစ်)",
Please_enter_Declared_value_USD_piece:"ကြေညာထားသော တန်ဖိုး (USD/ယူနစ်) ကို ထည့်ပါ။",
Please_enter_Weight_KG_piece:"အလေးချိန် (ကီလိုဂရမ်/ယူနစ်) ကို ထည့်ပါ။",
CommodityManagement:"ထုတ်ကုန် စီမံခန့်ခွဲမှု",
commodity:"ထုတ်ကုန်",
commodityName:"ထုတ်ကုန်အမည်",
Online_product_name:"အွန်လိုင်း ထုတ်ကုန်အမည်",
SKUManagement:"SKU စီမံခန့်ခွဲမှု",
inventorySKUManagement:"စာရင်း SKU စီမံခန့်ခွဲမှု",
inventorySKU:"စာရင်း SKU",
EditInventorySKU:"စာရင်း SKU",
inventorySKUName:"စာရင်း SKU အမည်",
inventorySKUList:"စာရင်း SKU စာရင်း",
inventorySKUImage:"Inventory SKU ပုံ",
Click_to_upload_stock_SKU_picture:"Inventory SKU ပုံ တင်ရန် နှိပ်ပါ",
Click_to_upload_combined_SKU_images:"Combination SKU ပုံ တင်ရန် နှိပ်ပါ",
Import_goods:"ထုတ်ကုန်များ ထည့်သွင်းခြင်း",
Batch_create_goods:"ထုတ်ကုန်များ အစုလိုက် ဖန်တီးခြင်း",
Edit_the_combined_SKU:"Combination SKU တည်းဖြတ်ခြင်း",
bar_code:"ဘားကုဒ်",
Commodity_billing_attribute:"ထုတ်ကုန် ငွေတောင်းခံ အင်္ဂါရပ်များ",
Editable_or_not:"တည်းဖြတ်နိုင်သည်",
Combination_quantity:"ပေါင်းစပ်အရေအတွက်",
Add_stock_SKUs:"Inventory SKU ထည့်ခြင်း",
Please_enter_inventorySKU:"Inventory SKU ထည့်ပါ",
Please_enter_bar_code:"ဘားကုဒ် ထည့်ပါ",
product_Cn_name:"ထုတ်ကုန် တရုတ်အမည်",
Please_enter_product_Cn_name:"ထုတ်ကုန် တရုတ်အမည် ထည့်ပါ",
product_En_name:"ထုတ်ကုန် အင်္ဂလိပ်အမည်",
Please_enter_product_En_name:"ထုတ်ကုန် အင်္ဂလိပ်အမည် ထည့်ပါ",
initiate_mode:"ဖွင့်လှစ်ထားသော အခြေအနေ",
Please_select_initiate_mode:"ဖွင့်လှစ်ထားသော အခြေအနေ ရွေးပါ",
inventory_status:"လက်ကျန် အခြေအနေ",
Please_select_inventory_status:"ကုန်ပစ္စည်းစာရင်းအခြေအနေကို ရွေးချယ်ပါ",
Alarm_threshold_status:"သတိပေးအဆင့်အခြေအနေ",
Please_select_Alarm_threshold_status:"သတိပေးအဆင့်အခြေအနေကို ရွေးချယ်ပါ",
Last_two_weeks:"နောက်ဆုံး ၂ ပတ်",
Last_two_month:"နောက်ဆုံး ၂ လ",
Last_three_month:"နောက်ဆုံး ၃ လ",
actual_weight_KG:"အလေးချိန် (ကီလိုဂရမ်)",
Actual_Trilateral_sum_CM:"အတိုင်းအတာသုံးခုပေါင်း (စင်တီမီတာ)",
Actual_size_CM:"အတိုင်းအတာ (စင်တီမီတာ)",
physical_length:"အရှည်",
physical_width:"အကျယ်",
physical_height:"အမြင့်",
size_CM:"အတိုင်းအတာများ (စင်တီမီတာ)",
Actual_size:"အတိုင်းအတာများ",
print_size:"ပုံနှိပ်အတိုင်းအတာများ",
Custom_size:"စိတ်ကြိုက်အတိုင်းအတာများ",
Custom_size_print:"ပုံနှိပ်ရန်အတွက် စိတ်ကြိုက်အတိုင်းအတာများ",
Please_enter_actual_weight:"အလေးချိန်ကို ထည့်ပါ",
Please_enter_actual_Trilateral_sum_CM:"အတိုင်းအတာသုံးခုပေါင်းကို ထည့်ပါ (စင်တီမီတာ)",
Please_enter_actual_weight_KG:"အလေးချိန် (ကီလိုဂရမ်) ကို ထည့်ပါ။",
Please_enter_actual_size:"တကယ့်အတိုင်းအတာများကို ထည့်ပါ။",
inventory_quantity:"စုစုပေါင်းစာရင်း",
Total_occupied_inventory:"အသုံးပြုထားသော စုစုပေါင်းစာရင်း",
Total_cubic_number_of_inventory:"စုစုပေါင်းစာရင်း ကုဗစ်မီတာ",
Total_unshipped_quantity:"ပို့ဆောင်ရန်ကျန်သော စုစုပေါင်းစာရင်း",
Total_available_inventory:"ရရှိနိုင်သော စုစုပေါင်းစာရင်း",
Available_Stock:"ရရှိနိုင်သော စာရင်း",
Total_number_of_cubes_in_transit:"လမ်းပေါ်တွင် သယ်ဆောင်နေသော ကုဗစ်မီတာ စုစုပေါင်း",
Total_number_in_transit:"လမ်းပေါ်တွင် သယ်ဆောင်နေသော စုစုပေါင်းစာရင်း",
Total_unavailable_inventory_quantity:"မရရှိနိုင်သော စုစုပေါင်းစာရင်း",
In_transit_inventory:"လမ်းပေါ်တွင် သယ်ဆောင်နေသော စာရင်း",
Sales_Volume_7_14_30_60_90:"အရောင်းပမာဏ (၇/၁၄/၃၀ ရက်)",
Sales_Volume_60_90:"အရောင်းပမာဏ (၆၀/၉၀ ရက်)",
Sales_Volume_45_60_90:"အရောင်းပမာဏ (၄၅/၆၀/၉၀ ရက်)",
Forecast_30_day_average_daily_sales:"၃၀ ရက်တာ ပျမ်းမျှ နေ့စဉ် အရောင်း ခန့်မှန်းချက်",
Number_of_warnings:"သတိပေးပမာဏ",
Alert_stock:"သတိပေး စတော့",
Whether_to_calculate_alert_inventory_automatically:"သတိပေး စတော့ကို အလိုအလျောက် တွက်ချက်မလား?",
Please_select_Whether_to_calculate_alert_inventory_automatically:"သတိပေး စတော့ကို အလိုအလျောက် တွက်ချက်မလား ရွေးချယ်ပါ",
Automatic_calculation_mode:"အလိုအလျောက် တွက်ချက်နည်း",
purchase_price:"ဝယ်ယူစျေးနှုန်း",
Please_select_SKU:"SKU ရွေးပါ",
portfolioSKUManagement:"SKU ပေါင်းစပ် စီမံခန့်ခွဲမှု",
portfolioSKUList:"ပေါင်းစပ် SKU စာရင်း",
product_barcode:"ထုတ်ကုန် ဘားကုဒ်",
Please_enter_the_product_barcode:"ထုတ်ကုန် ဘားကုဒ် ထည့်ပါ",
Select_all_boxes:"ဘောက်စ်အားလုံးကို ရွေးပါ",
Reset_option:"ရွေးချယ်မှု ပြန်လည်စတင်ပါ",
Modify_the_print_quantity_of_the_selected_item:"ရွေးထားသော အရာများ ပြင်ဆင်ပါ ပမာဏ ပုံနှိပ်ပါ",
Please_enter_the_product_barcode_for_screening:"စစ်ထုတ်ရန် ထုတ်ကုန် ဘားကုဒ် ထည့်ပါ",
Inventory_warning_does_not_allow_duplicate_warehouses:"သိုလှောင်မှု သတိပေးချက်များသည် ထပ်တူသိုလှောင်ခန်းများတွင် မကျယ်ပြန့်ရ",
isReceiveWarningNotice:"သတိပေးချက် အသိပေးချက်များ လက်ခံရန်",
Last_release_date:"နောက်ဆုံး စာရင်းတင်ခဲ့သည့် ရက်စွဲ",
Add_early_warning:"သတိပေး စတော့ထည့်ရန်",
Days_of_existing_warning:"သတိပေးချက် စတင်ခဲ့သည့် ရက်များ",
Please_enter_the_number_of_alerts:"သတိပေး စတော့ ထည့်ပါ",
Please_enter_the_expected_number_of_days:"သတိပေးကာလ ထည့်ပါ",
Please_select_automatic_calculation_mode:"အလိုအလျောက် တွက်ချက်နည်း ရွေးပါ",
Please_select_whether_to_receive_an_alert_notification:"သတိပေးချက် အသိပေးချက်များ လက်ခံမလား ရွေးချယ်ပါ",
Average_daily_sales_for_the_last_7_days:"ပျမ်းမျှ တစ်နေ့တာ အရောင်း (နောက်ဆုံး ၇ ရက်)",
Average_daily_sales_for_the_last_15_days:"ပျမ်းမျှ တစ်နေ့တာ အရောင်း (နောက်ဆုံး ၁၅ ရက်)",
Average_daily_sales_for_the_last_30_days:"ပျမ်းမျှ တစ်နေ့တာ အရောင်း (နောက်ဆုံး ၃၀ ရက်)",
Average_weekly_sales:"ပျမ်းမျှ တစ်ပတ်တာ အရောင်း",
Sales_time_meets_12_months_week:"အရောင်းကာလ ၁၂ (လ/ပတ်) ပြည့်သည်",
Total_sales_in_the_last_12_weeks_month_divided_by_12:"စုစုပေါင်း အရောင်း (နောက်ဆုံး ၁၂ ပတ်/လ) ÷ ၁၂",
Average_monthly_sales:"ပျမ်းမျှ တစ်လတာ အရောင်း",
The_data_was_updated_in_the_early_hours_of_the_next_day:"ဒေတာကို နောက်နေ့ မနက် ၀၀:၀၀ နာရီတွင် အပ်ဒိတ်လုပ်ပါသည်",
The_sales_time_does_not_meet_12_months_week:"အရောင်းကာလ ၁၂ (လ/ပတ်) မပြည့်ပါ",
Total_sales_in_months_weeks_sold_divided_by_the_number_of_months_weeks_sold:"စုစုပေါင်းအရောင်း (လ/ပတ်) ÷ အရောင်းကာလ (လ/ပတ်)",
Set_inventory_warning_in_batches:"ပစ္စည်းအစုလိုက် စတော့အသိပေးချက်များ သတ်မှတ်",
combination_SKU_Chinese_name:"ပေါင်းစပ် SKU တရုတ်အမည်",
combination_SKU_English_name:"ပေါင်းစပ် SKU အင်္ဂလိပ်အမည်",
Add_the_combined_SKU:"ပေါင်းစပ် SKU ထည့်ရန်",
Combine_SKU_images:"ပေါင်းစပ် SKU ပုံ",
combined_SKU:"ပေါင်းစပ် SKU",
Portfolio_inventory:"ပေါင်းစပ် စတော့",
goodsImage:"ထုတ်ကုန်ပုံ",
viewPortfolioSKU:"ပေါင်းစပ် SKU ကြည့်ရန်",
Historical_operation_record:"သမိုင်းဆိုင်ရာ လုပ်ငန်းမှတ်တမ်းများ",
Edit_inventory_SKU_list:"စတော့ SKU စာရင်း တည်းဖြတ်",
editInventorySkuList:"စတော့ SKU စာရင်း တည်းဖြတ်",
viewInventorySkuList:"စတော့ SKU စာရင်း ကြည့်ရန်",
createInventorySkuList:"ကုန်ပစ္စည်းစာရင်း SKU ဖန်တီးခြင်း",
Only_common_products_can_be_selected:"စံနှုန်းထားသော ကုန်ပစ္စည်းများတွင်သာ အများပြားရွေးချယ်နိုင်ပါသည်",
inventory_management:"ကုန်ပစ္စည်း စီမံခန့်ခွဲမှု",
inventoryManagement:"ကုန်ပစ္စည်း စီမံခန့်ခွဲမှု",
Unavailable_inventory:"ရရှိနိုင်မှု အခြေအနေ",
inventoryList:"ကုန်ပစ္စည်းစာရင်း",
product_material:"ကုန်ပစ္စည်း ပစ္စည်း",
Please_select_product_material:"ကုန်ပစ္စည်း ပစ္စည်းကို ရွေးချယ်ပါ",
Product_bar_code:"ကုန်ပစ္စည်း ဘားကုဒ်",
Reference_number:"ကိုးကားနံပါတ်",
update_specified_goods:"သတ်မှတ်ထားသော ကုန်ပစ္စည်းများ အပ်ဒိတ်လုပ်ခြင်း",
pull_specified_goods:"သတ်မှတ်ထားသော ကုန်ပစ္စည်းများ ရှာဖွေခြင်း",
please_select_data:"ဒေတာကို ရွေးချယ်ပါ",
Select_a_single_SKU_for_operation:"လုပ်ဆောင်ရန် တစ်ခုချင်းစီ SKU များကို ရွေးချယ်ပါ",
update_successfully:"အပ်ဒိတ် အောင်မြင်ပါပြီ",
pull_successfully:"ရှာဖွေမှု အောင်မြင်ပါပြီ",
please_enter_link_id:"လင့်ခ် ID ထည့်ပါ",
subordinate_Account:"အောက်အကောင့်",
Authorized_subaccount:"အောက်အကောင့် ခွင့်ပြုခြင်း",
Assign_subaccount:"အောက်အကောင့် ချမှတ်ခြင်း",
Please_select_the_subaccount_that_you_want_to_authorize:"ခွင့်ပြုချက်လိုအပ်သော အောက်အကောင့်ကို ရွေးချယ်ပါ",
Please_select_a_sub_account:"အောက်အကောင့်ကို ရွေးချယ်ပါ",
modifyProductInformationList:"ထုတ်ကုန်အချက်အလက် ပြင်ဆင်မှု လုပ်ငန်းစဉ်စာရင်း",
batchCreateCombinedsku:"ပေါင်းစပ် SKU များကို အစုလိုက် ဖန်တီးပါ",
batch_create_combined_sku:"ပေါင်းစပ် SKU များကို အစုလိုက် ဖန်တီးပါ",
Please_check_the_data_first:"ပထမဦးစွာ ဒေတာကို အမှတ်ပြုပါ",
Import_the_combined_SKU:"ပေါင်းစပ် SKU များကို တင်သွင်းပါ",
batchCreateSubAccount:"အောက်အကောင့်များကို အစုလိုက် ဖန်တီးပါ",
batch_Create_SubAccounts:"အောက်အကောင့်များကို အစုလိုက် ဖန်တီးပါ",
Import_subAccounts:"အောက်အကောင့်များကို တင်သွင်းပါ",
Import_to_modify_the_product_barcode:"ထုတ်ကုန် ဘားကုဒ် ပြင်ဆင်ပါ",
modify_the_product_barcode:"ထုတ်ကုန် ဘားကုဒ် ပြင်ဆင်ပါ",
Set_the_default_allocation_of_the_first_trip_fee:"ပုံမှန်မျှဝေ ပထမဆုံး သယ်ယူပို့ဆောင်ခ စရိတ် သတ်မှတ်ပါ",
Default_allocation_of_first_trip_fee:"ပုံမှန်မျှဝေ ပထမဆုံး သယ်ယူပို့ဆောင်ခ စရိတ်",
Default_first_leg_fee:"ပုံမှန် ပထမဆုံး သယ်ယူပို့ဆောင်ခ စရိတ်",
Default_allocation_of_first_trip_fee_only_used_for_order_profit_report_calculation_statistics:"မျှဝေသုံး ပုံမှန် ပထမဆုံး ပို့ဆောင်ခများသည် အော်ဒါအမြတ်အစီရင်ခံစာများ တွက်ချက်ရန်အတွက်သာ ဖြစ်ပါသည်။",
Includes_the_quantity_to_be_reviewed_and_reviewed_received_in_the_transit_warehouse_and_in_transit_and_in_the_last_leg_and_received_in_the_last_leg_and_in_the_quality_inspection_and_inspected_but_not_yet_listed:"စစ်ဆေးရန် စောင့်နေ၊ စစ်ဆေးပြီး၊ သယ်ယူပို့ဆောင်ရေး ဂိုဒေါင်တွင် လက်ခံရရှိ၊ သယ်ယူပို့ဆောင်နေ၊ နောက်ဆုံးပို့ဆောင်မှု စောင့်နေ၊ နောက်ဆုံးပို့ဆောင်မှု လက်ခံရရှိ၊ အရည်အသွေး စစ်ဆေးနေ၊ စစ်ဆေးပြီးသော်လည်း မတင်ထားသေး သည့် အရေအတွက်များ ပါဝင်သည်။",
This_operation_will_permanently_delete_sku:"ဤ လုပ်ဆောင်ချက်သည် SKU ကို အမြဲတမ်း ဖျက်ပစ်မည်။",
Batch_modification_of_purchase_prices:"စုစုပေါင်း ဝယ်ယူစျေးနှုန်း ပြင်ဆင်ခြင်း",
Batch_modification_of_default_allocation_of_headhaul_fees:"မျှဝေသုံး ပုံမှန် ပထမဆုံး သယ်ယူပို့ဆောင်ခများကို အစုလိုက် ပြင်ဆင်ခြင်း",
Original_purchase_price:"မူလ ဝယ်ယူစျေးနှုန်း",
New_purchase_price:"အသစ် ဝယ်ယူစျေးနှုန်း",
The_original_default_allocation_of_the_origin_leg_cost:"မူလ မျှဝေသုံး ပုံမှန် ပထမဆုံး သယ်ယူပို့ဆောင်ခ",
New_default_allocation_of_origin_charges:"အသစ် မျှဝေသုံး ပုံမှန် ပထမဆုံး သယ်ယူပို့ဆောင်ခ",
Modify_the_purchase_price:"ဝယ်ယူစျေးနှုန်း ပြင်ဆင်ခြင်း",
Form_modification_of_purchase_price:"ဖောင်အခြေပြု ဝယ်ယူစျေးနှုန်း ပြင်ဆင်ခြင်း",
Modify_the_default_allocation_of_origin_charges:"မျှဝေသုံး ပုံမှန် ပထမဆုံး သယ်ယူပို့ဆောင်ခ ပြင်ဆင်ခြင်း",
Modify_the_default_allocation_of_the_initial_transportation_cost_in_the_form:"ဖောင်အခြေပြု မျှဝေသုံး ပုံမှန် ပထမဆုံး သယ်ယူပို့ဆောင်ခ ပြင်ဆင်ခြင်း",
Import_and_modify_the_purchase_price_and_the_default_headway_cost_allocation:"ဝယ်ယူစျေးနှုန်းနှင့် မျှဝေထားသော ပထမဆုံး သယ်ယူပို့ဆောင်ခ စတင်ကုန်ကျစရိတ်ကို ပြင်ဆင်ရန် တင်သွင်းခြင်း",
Greater_than_0_001_and_less_than_9999999:"0.001 ထက် ကြီးပြီး 9999999 ထက် သေးသည်",
Unusable_inventory_quantity:"မရနိုင်သော ပစ္စည်းအရေအတွက်",
createGoods:"ထုတ်ကုန် ဖန်တီးခြင်း",
product_information:"ထုတ်ကုန် အချက်အလက်များ",
Please_enter_product_information:"ထုတ်ကုန် အချက်အလက်များကို ထည့်ပါ။",
product_specification:"ထုတ်ကုန် အသေးစိတ်ဖော်ပြချက်များ",
Product_declaration:"ထုတ်ကုန် ကြေညာချက်",
procurement_price:"ဝယ်ယူစျေးနှုန်း",
Please_enter_cost_price:"ကုန်ကျစရိတ်ကို ထည့်ပါ။",
Please_enter_procurement_price:"ဝယ်ယူစျေးနှုန်းကို ထည့်ပါ။",
volume_cm:"ထုထည် (စင်တီမီတာ³)",
actual_volume:"တကယ့်ထုထည်",
actual_volume_cm:"တကယ့်ထုထည် (စင်တီမီတာ³)",
commercial_specification:"ထုတ်ကုန် အသေးစိတ်ဖော်ပြချက်များ",
Please_enter_commercial_specification:"ထုတ်ကုန်အင်္ဂါရပ်များကို ထည့်သွင်းပါ။",
Product_name_Chinese:"ကြေညာထားသော ထုတ်ကုန်အမည် (တရုတ်)",
Please_enter_Product_name:"ကြေညာထားသော ထုတ်ကုန်အမည်ကို ထည့်သွင်းပါ။",
Product_name_English:"ကြေညာထားသော ထုတ်ကုန်အမည် (အင်္ဂလိပ်)",
country_of_origin:"မူလနိုင်ငံ",
Please_enter_country_of_origin:"မူလနိုင်ငံကို ထည့်သွင်းပါ။",
Days_of_purchase:"ဝယ်ယူရက်များ",
Please_enter_Days_of_purchase:"ဝယ်ယူရက်များကို ထည့်သွင်းပါ။",
product_attribute:"ထုတ်ကုန်အင်္ဂါရပ်များ",
Special_commodity_attribute:"ထူးခြားသော ထုတ်ကုန်အင်္ဂါရပ်များ",
Please_select_product_properties:"ထုတ်ကုန်အင်္ဂါရပ်များကို ရွေးချယ်ပါ။",
inventory_warning:"စာရင်းသတိပေးချက်",
Early_warning_inventory:"သတိပေး စတော့အဆင့်",
Days_of_warning:"သတိပေးရက်များ",
Please_enter_Early_warning_inventory:"သတိပေး စတော့အဆင့်ကို ထည့်သွင်းပါ။",
Please_enter_Days_of_warning:"သတိပေးရက်များကို ထည့်သွင်းပါ။",
Calculating_early_warning_inventory:"သတိပေး စတော့တွက်ချက်နည်း",
Automatic_calculation_of_early_warning_inventory:"သတိပေး စတော့ကို အလိုအလျောက် တွက်ချက်မည်",
Alert_inventory_is_equal_to_alert_days_multiplied_by_daily_sales:"သတိပေးကုန်ပစ္စည်း=သတိပေးရက် × တစ်ရက်တာ ရောင်းအား",
Click_to_upload:"တင်ရန် နှိပ်ပါ",
Only_jpg_or_png_files_with_a_maximum_size_of_2048kb_can_be_uploaded:"jpg သို့မဟုတ် png ဖိုင်များကိုသာ တင်နိုင်ပြီး 2048kb ထက် မကျော်ရ",
Please_upload_product_pictures:"ကုန်ပစ္စည်းဓာတ်ပုံများ တင်ပါ",
Please_enter_dimensions_of_length_width_and_height_greater_than_zero:"အရှည်၊ အကျယ်နှင့် အမြင့် အတိုင်းအတာများကို ထည့်ပါ၊ အားလုံး သုညထက် ကြီးရမည်",
The_operation_failed__Please_check_the_content_and_submit_again:"လုပ်ငန်း မအောင်မြင်ပါ။ သင်ထည့်သွင်းထားသော အချက်အလက်များကို ပြန်လည်စစ်ဆေးပြီး ထပ်မံတင်ပါ။",
editorialGoods:"ကုန်ပစ္စည်း တည်းဖြတ်",
viewGoods:"ကုန်ပစ္စည်း ကြည့်ရှု",
Enter_SKU_and_bar_code_separated_by_commas_comma:"SKU များနှင့် ဘားကုဒ်များကို ကော်မာဖြင့် ခွဲ၍ ထည့်ပါ။",
Please_enter_sku:"SKU ထည့်ပါ",
delete_in_batches_sku:"SKU များ အစုလိုက် ဖျက်ရန်",
Select_the_sku_that_you_want_to_delete:"ဖျက်မည့် SKU များကို ရွေးပါ။",
Select_the_SKUs_that_you_want_to_add:"ထည့်မည့် SKU များကို ရွေးပါ။",
And_enter_the_number_of_SKUs_you_want_to_add:"ထည့်မည့် အရေအတွက် ထည့်ပါ။",
Select_the_SKU_that_you_want_to_modify:"ပြင်ဆင်မည့် SKU များကို ရွေးပါ။",
Enter_the_number_of_SKUs_that_you_want_to_modify:"ပြင်ဆင်မည့် အရေအတွက် ထည့်ပါ။",
Select_the_SKU_for_which_you_want_to_modify_the_repository:"ဂိုဒေါင်ပြင်ဆင်ရန်လိုအပ်သော SKU များကိုရွေးချယ်ပြီး",
And_select_a_new_warehouse:"ဂိုဒေါင်အသစ်ကိုရွေးချယ်ပါ",
Adding_SKUs_in_bulk:"SKU များအစုလိုက်ထည့်သွင်းခြင်း",
Edit_note:"မှတ်စုများပြင်ဆင်ခြင်း",
select_sku:"SKU များရွေးချယ်ခြင်း",
Type_query:"မေးခွန်းရေးခြင်း",
Export_goods:"ထုတ်ကုန်များထုတ်ပို့ခြင်း",
Export_incoming_and_outgoing_records:"ဝင်/ထွက်မှတ်တမ်းများထုတ်ပို့ခြင်း",
product_list:"ထုတ်ကုန်စာရင်း",
product_list_sub_warehouse:"ထုတ်ကုန်စာရင်း (ဂိုဒေါင်အလိုက်)",
serial_Number:"နံပါတ်",
Create_distribution_control:"ခွဲဝေပေးမှုထိန်းချုပ်မှုဖန်တီးခြင်း",
Number_of_generated_tasks:"တာဝန်အရေအတွက်ထုတ်လုပ်ခြင်း",
create_task:"တာဝန်ထုတ်လုပ်ခြင်း",
Delivery_process_2_cannot_use_border_variation:"ပို့ဆောင်ရေးလုပ်ငန်းစဉ် 2 တွင် ခွဲဝေပေးမှုအခြေပြု ခွဲထွက်ခြင်း မအသုံးပြုနိုင်ပါ",
If_a_check_order_exists_during_task_generation_the_check_order_task_is_preferentially_generated:"တာဝန်များ ဖန်တီးသည့်အခါ၊ ရွေးထားသော အော်ဒါများ ရှိပါက၊ ရွေးထားသော အော်ဒါများအတွက် တာဝန်များကို ဦးစားပေးမည်။",
warehouse_management:"ဂိုဒေါင်စီမံခန့်ခွဲမှု",
warehouseOperation:"ဂိုဒေါင်လုပ်ငန်းများ",
warehouse_Number:"ဂိုဒေါင် ID",
Please_enter_warehouse_Number:"ဂိုဒေါင် ID ကို ထည့်ပါ။",
Please_enter_warehouse_partition:"ဂိုဒေါင်ဇုန်ကို ထည့်ပါ။",
goods_shelf:"စင်တန်းများ",
goods_shelf_info:"စင်တန်းအချက်အလက်",
Shelf_type:"စင်တန်းအမျိုးအစား",
Please_enter_Shelf_type:"စင်တန်းအမျိုးအစားကို ထည့်ပါ။",
Shelf_layer:"စင်တန်းအဆင့်",
Please_enter_Shelf_layer:"စင်တန်းအဆင့်ကို ထည့်ပါ။",
Storage_rack:"စင်တန်းတန်း",
Please_enter_Storage_rack:"စင်တန်းတန်းကို ထည့်ပါ။",
Shelf_size_length_width_and_height:"စင်တန်းအတိုင်းအတာများ (အရှည်*အကျယ်*အမြင့်)",
Shelf_cube:"စင် ကုဗစ်မီတာ/m³",
Please_enter_Shelf_cube:"စင် ကုဗစ်မီတာကို ထည့်ပါ။",
Library_location_information:"သိုလှောင်ခန်း အချက်အလက်",
Storage_location_type:"သိုလှောင်ခန်း အမျိုးအစား",
Please_enter_Storage_location_type:"သိုလှောင်ခန်း အမျိုးအစားကို ထည့်ပါ။",
SKU_storage_type:"SKU သိုလှောင်မှု အမျိုးအစား",
Please_enter_goods_shelf:"စင်ကို ထည့်ပါ။",
Please_enter_Residual_storage_capacity:"ကျန်ရှိသေးသော သိုလှောင်နိုင်စွမ်းကို ထည့်ပါ။",
Please_enter_Storage_capacity_in_transit:"သယ်ယူပို့ဆောင်နေစဉ် သိုလှောင်နိုင်စွမ်းကို ထည့်ပါ။",
Please_enter_Service_storage_capacity:"အသုံးပြုပြီးသော သိုလှောင်နိုင်စွမ်းကို ထည့်ပါ။",
Please_select_the_currency_of_charge:"ငွေချေမှု ငွေကြေးကို ရွေးပါ။",
Storage_location_SKU:"သိုလှောင်ခန်း SKU",
Please_enter_Storage_location_SKU:"သိုလှောင်ခန်း SKU ကို ထည့်ပါ။",
Initial_storage:"သိုလှောင်နိုင်စွမ်း စတင်",
End_storage:"သိုလှောင်နိုင်စွမ်း အဆုံး",
Add_partition:"အပိုင်း ထည့်ရန်",
Edit_partition:"အပိုင်း တည်းဖြတ်ရန်",
partition_number:"အပိုင်း နံပါတ်",
Please_enter_partition:"အပိုင်း နံပါတ်ကို ထည့်ပါ။",
Please_enter_partition_number:"ခွဲခန်းနံပါတ် ထည့်ပါ",
Please_select_floor:"ထပ်ချပ်ကို ရွေးပါ",
partition:"ခွဲခန်း",
floor:"ထပ်ချပ်",
Batch_pairing:"အစုလိုက်တွဲခြင်း",
storey:"ထပ်ချပ်",
Single_SKU:"တစ်ခုတည်း SKU",
Multiple_SKU:"အများ SKU များ",
Add_warehouse:"ဂိုဒေါင်ထည့်ပါ",
Edit_warehouse:"ဂိုဒေါင်ပြင်ဆင်ပါ",
Add_storage_location:"သိုလှောင်ရာနေရာထည့်ပါ",
contacts:"ဆက်သွယ်ရန်ပုဂ္ဂိုလ်",
Please_enter_contacts:"ဆက်သွယ်ရန်ပုဂ္ဂိုလ်ကို ထည့်ပါ",
Warehouse_zip_code:"ဂိုဒေါင်ပို့စ်ကုဒ်",
Please_enter_Warehouse_zip_code:"ဂိုဒေါင်ပို့စ်ကုဒ် ထည့်ပါ",
Toll_currency:"ငွေပေးချေမှုငွေကြေး",
Please_enter_Toll_currency:"ငွေပေးချေမှုငွေကြေး ထည့်ပါ",
Warehouse_recipient:"ဂိုဒေါင်လက်ခံသူ",
Recipient_phone_number:"လက်ခံသူ ဖုန်းနံပါတ်",
Warehouse_capacity_m:"ဂိုဒေါင်စွမ်းရည်/m³",
Service_storage_capacity_m:"အသုံးပြုထားသော စွမ်းရည်/m³",
Storage_capacity_in_transit_m:"သယ်ယူပို့ဆောင်နေစဉ် စွမ်းရည်/m³",
Residual_storage_capacity_m:"ကျန်ရှိသေးသော စွမ်းရည်/m³",
Zoned_storage_m:"ဇုန် စွမ်းရည်/m³",
Storage_location_Storage_capacity_m:"ဘင် စွမ်းရည်/m³",
Storage_capacity_SKU:"စွမ်းရည် SKU",
Bind_the_library_location_SKU:"ဘင်ချိတ်ဆက် SKU",
Pick_the_warehouse_location:"ရွေးယူဘင်",
Shelf_coding:"ရက်ကုဒ်",
Please_enter_Shelf_coding:"ရက်ကုဒ်ကို ထည့်ပါ။",
Shelf_name:"ရက်အမည်",
Please_enter_Shelf_name:"ရက်အမည်ကို ထည့်ပါ။",
Shelf_length:"ရက်အရှည်",
Please_enter_Shelf_length:"ရက်အရှည်ကို ထည့်ပါ။",
Shelf_weight:"ရက်အကျယ်",
Please_enter_Shelf_weight:"ရက်အကျယ်ကို ထည့်ပါ။",
Shelf_height:"ရက်အမြင့်",
Please_enter_Shelf_height:"ရက်အမြင့်ကို ထည့်ပါ။",
single_face:"တစ်ဖက်တည်း",
two_sided:"နှစ်ဖက်တည်း",
Warehouse_location_number:"စတော့ဘင်နံပါတ်",
Location_number:"ဘင်နံပါတ်",
Edit_library_location:"ဘင် တည်းဖြတ်",
Only_one_table_can_be_imported_simultaneously:"တစ်ကြိမ်လျှင် တစ်ဇယားသာ တင်သွင်းနိုင်ပါသည်",
Only_tables_can_be_imported:"ဇယားများသာ တင်သွင်းနိုင်ပါသည်",
Only_select_tables_are_allowed:"ဇယားများသာ ရွေးချယ်နိုင်ပါသည်",
Import_a_single_table_first:"အရင်ဆုံး တစ်ဇယားတင်သွင်းခြင်း ပြုလုပ်ပါ",
Unselected_formula:"ဖော်မြူလာ မရွေးထားပါ",
Selection_result_table:"ရလဒ်ဇယား ရွေးပါ",
Please_select_table:"ဇယားတစ်ခု ရွေးပါ",
Only_one_table_can_be_selected:"တစ်ဇယားသာ ရွေးနိုင်ပါသည်",
Manually_insert_data:"ဒေတာကို လက်ဖြင့် ထည့်သွင်း",
The_current_table_is:"လက်ရှိဇယားမှာ",
Trigger_name:"Trigger အမည်",
Please_enter_Trigger_name:"Trigger အမည် ထည့်ပါ",
libraryLocationList:"ဘင်စာရင်း",
Back_libraryLocationList:"ဘင်စာရင်းသို့ ပြန်သွား",
have_been_used:"အသုံးပြုပြီး",
unused:"အသုံးမပြု",
print_Library_location_number:"သိုလှောင်နေရာနံပါတ် ပုံနှိပ်",
quantity_in_stock:"ကုန်ပစ္စည်းအရေအတွက်",
Inventory_occupancy:"အသုံးပြုထားသော ကုန်ပစ္စည်းအရေအတွက်",
Inventory_warning_quantity:"ကုန်ပစ္စည်း သတိပေး အရေအတွက်",
deposit_type:"သိုလှောင်မှုအမျိုးအစား",
The_location_type:"သိုလှောင်နေရာအမျိုးအစား",
sectionList:"ဇုန်စာရင်း",
shelvesList:"စင်စာရင်း",
Batch_delete_shelves:"စင်များ အစုလိုက် ဖျက်ရန်",
Modify_the_partition_number:"ဇုန်နံပါတ် ပြင်ဆင်",
Modify_the_shelf_number:"စင်နံပါတ် ပြင်ဆင်",
Modify_the_storage_location_number:"သိုလှောင်နေရာနံပါတ် ပြင်ဆင်",
Please_enter_the_shelf_number:"စင်နံပါတ် ထည့်ပါ",
Import_modified_partition_codes:"ဇုန်ကုဒ် တင်သွင်း/ပြင်ဆင်",
Import_and_modify_the_shelf_number:"စင်နံပါတ် တင်သွင်း/ပြင်ဆင်",
Import_and_modify_the_storage_location_numbers:"သိုလှောင်နေရာနံပါတ် တင်သွင်း/ပြင်ဆင်",
Please_select_the_shelves_you_want_to_delete:"ဖျက်မည့် စင်များကို ရွေးပါ",
Confirm_to_delete_the_shelfs:"စင် ဖျက်ခြင်း အတည်ပြု",
goods_shelf_number:"စင်နံပါတ်",
regional_management:"ဒေသ စီမံခန့်ခွဲမှု",
countriesList:"နိုင်ငံ စာရင်း",
Added_country:"နိုင်ငံ ထည့်ရန်",
Bulk_add_countries:"နိုင်ငံများ အစုလိုက် ထည့်ရန်",
Please_select_country:"နိုင်ငံ ရွေးပါ",
Please_select_Destination_warehouse:"ရောက်မည့် ဂိုဒေါင် ရွေးပါ",
Destination_warehouse:"ရောက်မည့် ဂိုဒေါင်",
recipientManagement:"လက်ခံသူ စီမံခန့်ခွဲမှု",
Please_enter_the_recipient_name:"လက်ခံသူ အမည် ထည့်ပါ",
Please_enter_the_recipient_phone_number:"လက်ခံသူ ဖုန်း ထည့်ပါ",
Recipient_name:"လက်ခံသူ အမည်",
Receiver_Address:"လက်ခံသူ လိပ်စာ",
Add_recipient:"လက်ခံသူ ထည့်ရန်",
Edit_recipient:"လက်ခံသူ တည်းဖြတ်ရန်",
Recipient_email_address:"လက်ခံသူ အီးမေးလ်",
Please_select_the_full_region:"ဒေသ အပြည့်အစုံ ရွေးပါ",
Please_select_a_region:"ဒေသ ရွေးပါ",
financialManagement:"ဘဏ္ဍာရေး စီမံခန့်ခွဲမှု",
financialReports:"ဘဏ္ဍာရေး အစီရင်ခံစာများ",
cost:"ကုန်ကျစရိတ်များ",
costmanagement:"ကုန်ကျစရိတ် စီမံခန့်ခွဲမှု",
costType:"ကုန်ကျစရိတ် အခြေအနေ",
costSetting:"ကုန်ကျစရိတ် ဆက်တင်များ",
Client_editing:"ဖောက်သည် တည်းဖြတ်ခြင်း",
AmazonBaiyiUS:"Amazon Baiyikexun USA",
amazonBaiyiUS:"Amazon Baiyikexun USA",
month:"လ",
turnover:"ပတ်လည်ငွေကြေး",
The_amount_of_the_platform_should_be_lent:"ထုတ်ပေးရန် ကျသင့်သော ပလက်ဖောင်းငွေပမာဏ",
The_wrong_amount_should_be_lent:"မှားယွင်းထုတ်ပေးရန် ကျသင့်သော ပမာဏ",
have_already_settled:"ဖြေရှင်းပြီး",
consolidate_orders:"ပေါင်းစည်းထားသော အော်ဒါများ",
refund:"ပြန်အမ်းငွေများ",
rebates:"အပိုင်းဆိုင်ရာ ပြန်အမ်းငွေများ",
Refund_and_compensation:"ပြန်အမ်းငွေ အစားထိုးငွေ",
compensate:"အစားထိုးငွေ",
Unlent_amount:"ထုတ်မထုတ်သေးသောငွေပမာဏ",
deleteTable:"ဇယား ဖျက်ရန်",
Confirm_deletion_table:"ဖျက်ခြင်း အတည်ပြုရန်",
Recharge_time:"ထပ်ဖြည့်ချိန်",
Please_select_a_Recharge_time:"ထပ်ဖြည့်ချိန်ကို ရွေးချယ်ပါ",
Add_top_up:"ထပ်ဖြည့်ရန်",
exchange_rate:"လဲလှယ်နှုန်း",
Amount_actually_paid:"အမှန်တကယ် ပေးချေငွေပမာဏ",
Please_enter_the_Amount_actually_paid:"အမှန်တကယ် ပေးချေငွေပမာဏကို ထည့်ပါ",
Currency_of_payment:"ပေးချေမည့်ငွေကြေး",
Please_enter_the_Currency_of_payment:"ပေးချေမည့်ငွေကြေးကို ထည့်ပါ",
The_currency_of_the_deposit:"ထပ်ဖြည့်ငွေကြေး",
Please_enter_the_The_currency_of_the_deposit:"ထပ်ဖြည့်ငွေကြေးကို ထည့်ပါ",
service_charge:"ကိုင်တွယ်ခ",
accounting_date:"ရောက်ရှိချိန်",
Please_select_a_accounting_date:"ရောက်ရှိချိန်ကို ရွေးချယ်ပါ",
note:"မှတ်ချက်များ",
Top_up_number:"ထပ်ဖြည့်နံပါတ်",
recharge_amount:"ထပ်ဖြည့်ငွေပမာဏ",
Balance_before_recharge:"ထပ်ဖြည့်မတိုင်မီ ကျန်ငွေ",
Balance_after_recharge:"ထပ်ဖြည့်ပြီးနောက် ကျန်ငွေ",
The_charge_shall_not_be_greater_than_the_amount_of_the_deposit:"ကိုင်တွယ်ခသည် ထပ်ဖြည့်ငွေပမာဏထက် မကျော်ရ",
Recharge_information:"ထပ်ဖြည့်ခြင်းအသေးစိတ်",
Please_select_a_billing_time:"ငွေချေချိန်ကို ရွေးချယ်ပါ",
Please_enter_the_statement_number:"ငွေချေငွေတောင်းခံလွှာနံပါတ်ကို ထည့်ပါ",
Please_select_a_recharge_type:"ထပ်ဖြည့်ခြင်းအမျိုးအစားကို ရွေးချယ်ပါ",
About_to_jump_to_the_recharge_page:"ယခု ထပ်ဖြည့်ခြင်း စာမျက်နှာသို့ ပြောင်းရွှေ့မည်",
state_of_payment:"ငွေချေမှုအခြေအနေ",
Continue_to_pay:"ငွေချေမှု ဆက်လက်လုပ်ဆောင်ရန်",
during_the_payment:"ငွေချေမှု ဆောင်ရွက်နေဆဲ",
payment_failure:"ငွေချေမှု မအောင်မြင်",
have_expired:"သက်တမ်းကုန်ဆုံး",
canceled:"ဖျက်သိမ်း",
Completed_transaction:"ငွေလွှဲမှု ပြီးစီး",
Uncompleted_transaction:"ငွေလွှဲမှု မပြီးစီး",
failure_of_transaction:"ငွေလွှဲမှု မအောင်မြင်",
Only_a_single_task_can_be_selected:"တစ်ခုတည်းသာ ရွေးချယ်နိုင်ပါသည်",
Please_select_a_basket:"အိတ်ဆောင်ကို ရွေးချယ်ပါ",
Sheet_address:"ပို့ဆောင်ရေးလိပ်စာ",
Recommended_storage_location:"အကြံပြုသိုလှောင်ရာနေရာ",
The_product_is_finished:"ဤပစ္စည်းပြီးစီးပါပြီ",
initial_workpiece:"ပထမပစ္စည်း",
follow_up_workpiece:"နောက်ထပ်ပစ္စည်းများ",
aggregate_amount:"စုစုပေါင်းငွေပမာဏ",
Daily_order_volume:"နေ့စဉ်အော်ဒါအရေအတွက်",
Total_order_processing_fee:"စုစုပေါင်းအော်ဒါလုပ်ငန်းစဉ်ကြေး",
Average_unit_price_per_order:"တစ်အော်ဒါလျှင်ပျမ်းမျှဈေးနှုန်း",
Total_number_of_SKUs_for_shipment:"စုစုပေါင်းပို့ဆောင်မည့် SKU အရေအတွက်",
Average_unit_price_per_SKU:"တစ် SKU လျှင်ပျမ်းမျှဈေးနှုန်း",
orderProcessingFeeSet:"အော်ဒါလုပ်ငန်းစဉ်ကြေး",
Additional_cost:"ကြေးထည့်ရန်",
Additional_Max_cost:"အများဆုံးကြေးထည့်ရန်",
Add_order_processing_fee:"အော်ဒါလုပ်ငန်းစဉ်ကြေးထည့်ရန်",
Additional_charge:"ထပ်ဆောင်းကြေး",
Rate_number:"ကြေးစံနံပါတ်",
type_of_cost:"ကြေးအမျိုးအစား",
Please_select_type_of_cost:"ကြေးအမျိုးအစားကိုရွေးချယ်ပါ",
Please_enter_Additional_charge:"ထပ်ဆောင်းကြေးထည့်ပါ",
Please_enter_Rate_number:"ကြေးကုဒ် ထည့်ပါ",
Out_of_range_first_SKU_operating_fee:"အရွယ်အစားကြီးသော ပစ္စည်းများအတွက် ပထမဆုံး SKU ကိုင်တွယ်ခ",
Please_enter_Out_of_range_first_SKU_operating_fee:"အရွယ်အစားကြီးသော ပစ္စည်းများအတွက် ပထမဆုံး SKU ကိုင်တွယ်ခ ထည့်ပါ",
Continued_SKU_operating_fee_out_of_range:"အရွယ်အစားကြီးသော ပစ္စည်းများအတွက် ထပ်ဆောင်း SKU ကိုင်တွယ်ခ",
Please_enter_Continued_SKU_operating_fee_out_of_range:"အရွယ်အစားကြီးသော ပစ္စည်းများအတွက် ထပ်ဆောင်း SKU ကိုင်တွယ်ခ ထည့်ပါ",
Cost_of_first_packing_material_out_of_range:"အရွယ်အစားကြီးသော ပစ္စည်းများအတွက် ပထမဆုံး ထုပ်ပိုးပစ္စည်းကြေး",
Please_enter_Cost_of_first_packing_material_out_of_range:"ကန့်သတ်ကျော်လွန် ပထမဆုံး ထုပ်ပိုးခကို ထည့်ပါ။",
SKU_packaging_costs_are_exceeded:"ကန့်သတ်ကျော်လွန် နောက်ထပ် SKU ထုပ်ပိုးခ",
Please_enter_SKU_packaging_costs_are_exceeded:"ကန့်သတ်ကျော်လွန် နောက်ထပ် SKU ထုပ်ပိုးခကို ထည့်ပါ။",
The_number_of_out_of_range_continuums_is_charged:"ကန့်သတ်ကျော်လွန် နောက်ထပ် ပစ္စည်း ငွေတောင်းခံရေတွက်ချက်",
Please_enter_The_number_of_out_of_range_continuums_is_charged:"ကန့်သတ်ကျော်လွန် နောက်ထပ် ပစ္စည်း ငွေတောင်းခံရေတွက်ချက်ကို ထည့်ပါ။",
The_input_add_fee_has_no_value_Please_check_and_try_again:"ထည့်သွင်းထားသော ကြေးတွင် အလွတ်တန်ဖိုးများ ပါဝင်နေပါသည်။ စစ်ဆေးပြီး ထပ်မံကြိုးစားပါ။",
Please_add_the_charges:"ကြေး ထည့်ပါ။",
The_charge_standard_number_cannot_be_repeated:"ကြေးကုဒ်ကို ထပ်မံ မသုံးနိုင်ပါ။",
Out_of_range_listing_fees:"အကွာအဝေးကျော် စာရင်းတင်ခ",
Out_of_range_Destruction_delisting_fee:"အကွာအဝေးကျော် ဖျက်ဆီး/စာရင်းမှဖယ်ရှားခ",
Out_of_range_Return_listing_fee:"အကွာအဝေးကျော် ပြန်လည်စာရင်းတင်ခ",
Three_sides_are_preferred:"နှစ်သက်ရာ ဘက်သုံးဖက် အရှည်",
Preferred_weight:"နှစ်သက်ရာ အလေးချိန်",
packagingMaterialCost:"ထုပ်ပိုးခ",
Package_material_coding:"ထုပ်ပိုးကုဒ်",
Please_enter_Package_material_coding:"ထုပ်ပိုးကုဒ်ကို ထည့်ပါ။",
Packing_material_name:"ထုပ်ပိုးအမည်",
Please_enter_Packing_material_name:"ထုပ်ပိုးအမည်ကို ထည့်ပါ။",
Packing_material_length:"ထုပ်ပိုးအရှည်",
Please_enter_Package_material_length:"ထုပ်ပိုးအရှည်ကို ထည့်ပါ။",
Packing_material_width:"ထုပ်ပိုးအကျယ်",
Please_enter_Package_material_width:"ထုပ်ပိုးအကျယ်ကို ထည့်ပါ။",
Packing_material_height:"ထုပ်ပိုးအမြင့်",
Packing_material_Weight:"ထုပ်ပိုးအလေးချိန်",
Please_enter_Packing_material_height:"ထုပ်ပိုးအမြင့်ကို ထည့်ပါ။",
Packing_material_quantity:"ထုပ်ပိုးအရေအတွက်",
Please_enter_Packing_material_quantity:"ထုပ်ပိုးအရေအတွက် ထည့်ပါ",
Packing_material_type:"ထုပ်ပိုးအမျိုးအစား",
Please_enter_Packing_material_type:"ထုပ်ပိုးအမျိုးအစား ထည့်ပါ",
add_Packing_material:"ထုပ်ပိုးထည့်ခြင်း",
edit_Packing_material:"ထုပ်ပိုးတည်းဖြတ်ခြင်း",
Batch_add_Packing_material:"ထုပ်ပိုးစုထည့်ခြင်း",
quantity_of_commodity:"ကုန်ပစ္စည်းအရေအတွက်",
The_box_number_does_not_exist:"ဒီဘောက်စ်နံပါတ် မရှိပါ",
Packaging_material_picture:"ထုပ်ပိုးပုံ",
createCost:"ဖန်တီးခ",
Please_upload_picture_of_package_material:"ထုပ်ပိုးပုံ တင်ပါ",
expenseDeduction:"ခကြေးချိန်ညှိခြင်း",
Add_a_premium_deduction:"ခကြေးချိန်ညှိခြင်း ထည့်ပါ",
Expense_reimbursement_type:"ခကြေးချိန်ညှိခြင်း အမျိုးအစား",
Please_select_the_type_of_reimbursement:"ခကြေးချိန်ညှိခြင်း အမျိုးအစား ရွေးပါ",
Please_select_packing_material:"ထုပ်ပိုးရွေးပါ",
Please_select_a_packaging_method:"ထုပ်ပိုးနည်း ရွေးပါ",
Set_the_packaging_mode_in_batches:"ထုပ်ပိုးနည်း စုစည်းသတ်မှတ်ခြင်း",
Please_enter_barcode_SKU_Chinese_product_name_English_product_name:"SKU၊ ထုတ်ကုန်ဘားကုဒ်၊ တရုတ်ထုတ်ကုန်အမည်၊ အင်္ဂလိပ်ထုတ်ကုန်အမည် တို့ကို ထည့်ပြီး ရှာဖွေရန် ခလုတ်ကို နှိပ်ပါ။",
Please_enter_barcode_SKU:"SKU၊ ထုတ်ကုန်ဘားကုဒ် တို့ကို ထည့်ပြီး ရှာဖွေရန် ခလုတ်ကို နှိပ်ပါ။",
Please_enter_the_order_number_separated_by_line_breaks_or_commas:"အော်ဒါနံပါတ်များကို လိုင်းချိုး (line break) သို့မဟုတ် ကော်မာ (comma) ဖြင့် ခွဲ၍ ထည့်ပါ။",
Packing_material_billing_type:"ထုပ်ပိုးငွေတောင်းခံပုံ",
Minimum_charge_amount:"အနည်းဆုံး ငွေတောင်းခံပမာဏ",
Number_of_warnings_must_not_exceed_the_quantity_in_stock:"သတိပေးချက်။ ပမာဏသည် လက်ကျန်ပမာဏထက် မကျော်ရ။",
default_packaging_material:"မူလထုပ်ပိုးမှု",
packingMaterialDetail:"ထုပ်ပိုးအသေးစိတ်",
packing_material_info:"ထုပ်ပိုးအချက်အလက်",
import_order_processing_fee:"တင်သွင်းအော်ဒါ လုပ်ငန်းကြေး",
import_storage_charges:"တင်သွင်း ဂိုဒေါင်ငှားခ",
import_fixed_sku_fees:"တင်သွင်း SKU တည်ငြိမ်ကြေး",
import_first_pass_cost:"တင်သွင်း ပထမဆုံး သယ်ယူပို့ဆောင်ခ",
setFeesByTemplate:"နမူနာဖြင့် ကြေး သတ်မှတ်ခြင်း",
The_amount_of_the_deduction:"ကြေး ချိန်ညှိပမာဏ",
viewFixedSKUFee:"တည်ငြိမ် SKU ကြေး ကြည့်ရှုခြင်း",
SpecialAprovalNumber:"အထူးအတည်ပြုနံပါတ်",
Special_Customer_ID:"အထူးအတည်ပြု ဖောက်သည် ID",
Addition_special_fees:"ကြေး အထူးအတည်ပြု ဖန်တီးခြင်း",
Special_approval_for_import_fees:"တင်သွင်း ကြေး အထူးအတည်ပြုခြင်း",
The_current_approver:"လက်ရှိ အတည်ပြုသူ",
Whether_to_be_anonymous_or_not:"အမည်မဖော်ထားသော အခြေအနေ",
Work_order_source:"အလုပ်အော်ဒါ ရင်းမြစ်",
Notes_should_not_exceed_1000_characters:"မှတ်ချက်များသည် 1000 အက္ခရာထက် မပိုရ",
Pending_approval_currently:"လက်ရှိ အတည်ပြုသူ",
Currently_awaiting_review:"လက်ရှိ ပြန်လည်သုံးသပ်ရန် စောင့်ဆိုင်းနေသည်",
firstPassCostSetting:"ပထမအဆင့်ကြေး ဖွဲ့စည်းမှု",
firstPassCost:"ပထမအဆင့်ကြေး",
freight_cost_cube_KG:"ကုန်ပို့ဆောင်ခ (ကုဗစ်မီတာ/ကီလိုဂရမ်)",
freight_cost:"ကုန်ပို့ဆောင်ခ",
fixed_cost:"ကုန်ကျစရိတ်",
profit:"အမြတ်",
Please_enter_the_shipping_cost:"ကုန်ပို့ဆောင်ခ ထည့်ပါ",
Surcharge_cost_cube_KG:"အပိုကြေး ကုန်ကျစရိတ် (ကုဗစ်မီတာ/ကီလိုဂရမ်)",
Surcharge_cost:"အပိုကြေး ကုန်ကျစရိတ်",
Please_enter_the_Surcharge_cost:"အပိုကြေး ကုန်ကျစရိတ် ထည့်ပါ",
Out_of_range_freight_cube_KG:"အကွာအဝေးကျော် ကုန်ပို့ဆောင်ခ (ကုဗစ်မီတာ/ကီလိုဂရမ်)",
Out_of_range_freight:"အကွာအဝေးကျော် ကုန်ပို့ဆောင်ခ",
Please_enter_Out_of_range_freight:"အကွာအဝေးကျော် ကုန်ပို့ဆောင်ခ ထည့်ပါ",
Overreach_surcharge_cube_KG:"အကွာအဝေးကျော် အပိုကြေး (ကုဗစ်မီတာ/ကီလိုဂရမ်)",
Overreach_surcharge:"အကွာအဝေးကျော် အပိုကြေး",
Please_enter_Overreach_surcharge_cube_KG:"အပိုအကွာအဝေး အပိုကြေး ထည့်ပါ",
Minimum_number_of_charging_parties:"အနည်းဆုံး ငွေတောင်းခံ အရွယ်အစား",
Please_enter_Minimum_number_of_charging_parties:"အနည်းဆုံး ငွေတောင်းခံ အရွယ်အစား ထည့်ပါ",
Start_greater_than:"စတင် (>)",
cutoff:"အဆုံး (<=)",
additional_charge_cube_KG:"အပိုကြေး (ကုဗစ်မီတာ/ကီလိုဂရမ်)",
additional_charge:"အပိုကြေး",
Minimum_chargeable_weight:"အနည်းဆုံး ငွေတောင်းခံ အလေးချိန်",
Please_enter_Minimum_chargeable_weight:"အနည်းဆုံး ငွေတောင်းခံ အလေးချိန် ထည့်ပါ",
The_added_fee_is_empty:"ထပ်ဆောင်းကြေးများ ဗလာနေသည်",
The_added_cost_has_a_null_value_The_creation_failed_Please_modify_the_cost_and_try_again:"ထပ်ဆောင်းကြေးများတွင် ဗလာတန်ဖိုးများ ပါဝင်နေသည်။ ဖန်တီးမှု မအောင်မြင်ပါ။ ပြင်ဆင်၍ ထပ်မံကြိုးစားပါ။",
The_start_of_the_added_fee_is_not_equal_to_the_end_Please_modify_it_and_try_again:"ထည့်ထားသော ကြေး စတင်တန်ဖိုးနှင့် အဆုံးတန်ဖိုး မတူညီပါ။ ပြင်ဆင်၍ ထပ်မံကြိုးစားပါ။",
Volume_weight_calculation_method_cubic_divide_volume_weight_is_worth_the_result_compare_the_weight_which_big_which:"ထုထည်အလေးချိန် တွက်ချက်နည်း: ထုထည်/ထည်ထည်အလေးချိန် တန်ဖိုးကို တွက်ချက်ပြီး အလေးချိန်များကို နှိုင်းယှဉ်၍ ပိုကြီးသော တန်ဖိုးကို ယူပါ။",
Length_cm_X_width_cm_X_height_cm_volume_weight_value:"ထုထည်: (အရှည်(စင်တီမီတာ) * အကျယ်(စင်တီမီတာ) * အမြင့်(စင်တီမီတာ) / ထုထည်အလေးချိန် တန်ဖိုး) / 1000000",
There_are_no_packing_materials_for_the_warehouse:"ဤသိုလှောင်ခန်းတွင် ထုပ်ပိုးပစ္စည်း မရှိပါ။",
Printing_control:"ပုံနှိပ်လုပ်ငန်း အမှတ်",
Several_tasks:"...",
code:"ကုဒ်",
await:"စောင့်ဆိုင်းနေသော",
second:"စက္ကန့်",
request_timeout:"တောင်းဆိုမှု အချိန်ကုန်ဆုံးသွားသည်",
Stop_query:"မေးမြန်းချက် ရပ်ဆိုင်းခြင်း",
Edit_the_entry_slip:"ဂိုဒေါင်လက်မှတ် တည်းဖြတ်ခြင်း",
Deduction_amount:"ထပ်မံ ဖြတ်ချခြင်း ပမာဏ",
Deduction_personnel:"ဖြတ်ချခြင်း တာဝန်ရှိသူ",
Deduction_time:"ဖြတ်ချခြင်း အချိန်",
fixedSkuFees:"သတ်မှတ် SKU ကြေး",
Added_fixed_SKU_fee:"သတ်မှတ် SKU ကြေး ထည့်ခြင်း",
edit_fixed_SKU_fee:"သတ်မှတ် SKU ကြေး တည်းဖြတ်ခြင်း",
Select_Add_SKUs:"ထည့်ရန် SKU ရွေးချယ်ပါ",
storageCharges:"ဂိုဒေါင်ငှားခ",
List_of_warehouse_rental_charges:"ဂိုဒေါင်ငှားခ စာရင်း",
listWarehouseRentalCharges:"ဂိုဒေါင်ငှားခ စာရင်း",
Start_days:"စတင်ရက်",
time_Info:"အချိန်ဆိုင်ရာ အချက်အလက်",
Warehousing_charge:"ဂိုဒေါင်ငှားခ",
Days_in_storage:"ဂိုဒေါင်ထဲရှိ ရက်များ",
warehousing_time:"ဂိုဒေါင်ဝင်ချိန်",
edit_cost:"ကြေး တည်းဖြတ်ရန်",
please_enter_SKU:"SKU ထည့်ပါ",
Operator_query:"အော်ပရေတာ မေးမြန်းချက်",
Minimum_length_of_three_sides:"အနည်းဆုံး သုံးဖက် အရှည်",
Maximum_length_of_three_sides:"အများဆုံး သုံးဖက် အရှည်",
The_input_fee_cannot_be_negative:"ကြေး မနုတ်ဖြစ်နိုင်ပါ",
Storage_rental_days_are_calculated_at_the_beginning_of_each_SKU_incoming_batch:"ဂိုဒေါင်ငှားရက်များကို SKU တစ်ခုချင်းစီ၏ ဝင်လာသည့် အစုစတင်ရက်မှ တွက်ချက်သည်။",
labellingCharge:"တံဆိပ်တပ်ခ",
Label_quantity:"တပ်ဆင်ထားသော တံဆိပ်များ အရေအတွက်",
Label_or_not:"တံဆိပ်တပ်ရန် လိုအပ်သည်",
special_CostId:"အထူးအတည်ပြုနံပါတ်",
special_CustomerId:"အထူးအတည်ပြု ဖောက်သည် ID",
finish_time:"အဆုံးသတ်ချိန်",
additionSpecialFees:"အထူးကြေး အတည်ပြုချက် ဖန်တီးခြင်း",
additionSpecialFeesEdit:"အထူးကြေး အတည်ပြုချက် တည်းဖြတ်ခြင်း",
viewSpecialApprovalExpenses:"အထူးကြေး အတည်ပြုချက် ကြည့်ရှုခြင်း",
comeupReview:"ပြန်လည်သုံးသပ်ရန် တင်သွင်းခြင်း",
Special_approval_information:"အထူးအတည်ပြုချက် အသေးစိတ်",
Whether_to_invalidate_this_special_approval_for_expenses:"ဤအထူးကြေး အတည်ပြုချက်ကို ဖျက်ရန်ဖြစ်မဖြစ်",
After_approval_the_original_fee_settings_will_be_overwritten_Please_carefully_check_if_the_settings_are_correct:"အတည်ပြုချက်သည် မူရင်းကြေး သတ်မှတ်ချက်များကို ကျော်လွန်သွားမည်ဖြစ်သည်။ မှန်ကန်မှုကို ဂရုစိုက်၍ စစ်ဆေးပါ။",
Please_select_the_same_type_of_special_order:"တူညီသော အမျိုးအစားရှိ အထူးအတည်ပြု အမှာစာတစ်ခုကို ရွေးချယ်ပါ။",
Financial_statement:"ဘဏ္ဍာရေးထုတ်ပြန်ချက်များ",
financialStatement:"ဘဏ္ဍာရေးထုတ်ပြန်ချက်များ",
tableConfigurationList:"ဇယားဖွဲ့စည်းမှု စာရင်း",
Add_configuration_table:"ဖွဲ့စည်းမှုဇယား ထည့်ရန်",
table_name:"ဇယားအမည်",
table_ID:"ဇယား ID",
table_name_data_type:"ဇယားအမည် ဒေတာအမျိုးအစား",
tier:"အဆင့်လိုက်",
Required_or_not:"လိုအပ်သော ကွက်လပ်",
Enable_or_not:"ဖွင့်ထားသည်",
Add_field:"ကွက်လပ် ထည့်ရန်",
field_name:"ကွက်လပ်အမည်",
field_ID:"ကွက်လပ် ID",
Field_data_type:"ကွက်လပ် ဒေတာအမျိုးအစား",
to_lead:"တင်သွင်း",
Multiple_table_import:"အများဇယား တင်သွင်းခြင်း",
Serial_number_multi_table_import:"စီးရီးယယ်နံပါတ် အများဇယား တင်သွင်းခြင်း",
inportSuccess:"တင်သွင်းမှု အောင်မြင်သည်",
Drag_the_file_here:"ဖိုင်များကို ဤနေရာသို့ ဆွဲထည့်ပါ",
Only_xls_xlsx_csv__files_can_be_uploaded_and_the_size_does_not_exceed_100_MB:"xls/xlsx/csv ဖိုင်များကိုသာ တင်နိုင်ပြီး 100MB ထက် မကျော်ရ",
formulaConfiguration:"ဖော်မြူလာ ဖွဲ့စည်းမှု",
Add_a_single_table_formula:"တစ်ဇယားတည်း ဖော်မြူလာ ထည့်ရန်",
Edit_a_single_table_formula:"တစ်ဇယားတည်း ဖော်မြူလာ တည်းဖြတ်ရန်",
Add_a_multi_table_formula:"အများဇယား ဖော်မြူလာ ထည့်ရန်",
Edit_table_formula:"ဇယား ဖော်မြူလာ တည်းဖြတ်ရန်",
List:"ဇယား",
data_processing_type:"ဒေတာ ပြုလုပ်ပုံ အမျိုးအစား",
operator_symbol:"Operator",
summation:"စုပေါင်း",
Specified_data:"သတ်မှတ်ထားသော ဒေတာ",
Marker_text:"မှတ်သား စာသား",
de_weight:"ထပ်တူများကို ဖယ်ရှားရန်",
equation:"ဖော်မြူလာ",
equation_Name:"ဖော်မြူလာ အမည်",
Sign_Color:"မှတ်သား အရောင်",
Result_field:"ရလဒ် ကွက်လပ်",
Selection_formula:"ဖော်မြူလာ ရွေးရန်",
Selection_result_List:"ရလဒ် ဇယား ရွေးရန်",
Please_select_the_result_table:"ရလဒ် ဇယားကို ရွေးပါ",
Only_one_result_table_can_be_selected:"ရလဒ် ဇယား တစ်ခုတည်းသာ ရွေးနိုင်သည်",
resultList:"ရလဒ်ဇယား",
serial_number:"စီးရီးနံပါတ်",
Serial_number:"ငွေလွှဲနံပါတ်",
Please_enter_the_serial_number:"ငွေလွှဲနံပါတ် ထည့်ပါ",
Please_upload_the_certificate:"အတည်ပြုလက်မှတ် ဖိုင် တင်ပါ",
include:"ပါဝင်စေရန်",
delete_batch:"အုပ်စု ဖျက်ရန်",
Specified_number_of_rows:"တန်းများ သတ်မှတ်ရန်",
Batch_process_field_data_types:"အုပ်စု လုပ်ငန်းဆောင်ရွက်မှု ကွက်လပ် ဒေတာအမျိုးအစား",
Please_enter_the_serial_number_of_the_batch_you_want_to_delete:"ဖျက်မည့် အုပ်စုအတွက် စီးရီးနံပါတ် ထည့်ပါ",
editFinancialStatement:"ဘဏ္ဍာရေးထောက်ပြချက်များ တည်းဖြတ်ရန်",
Add_trigger:"လှုံ့ဆော်ချက် ထည့်ရန်",
Collection_management:"ရရှိရန်ငွေ စီမံခန့်ခွဲမှု",
Please_enter_the_tracking_number_separated_by_commas_or_newlines:"waybill နံပါတ်များကို ကော်မာ သို့မဟုတ် လိုင်းခွဲဖြင့် ခွဲ၍ ထည့်ပါ",
Please_enter_the_transaction_number_separated_by_commas_or_line_breaks:"transaction အမှတ်များကို ကော်မာ (,) သို့မဟုတ် လိုင်းချိုး (line break) ဖြင့် ခွဲ၍ ထည့်ပါ။",
Please_enter_the_head_order_number_separated_by_a_comma_or_a_newline:"initial order အမှတ်များကို ကော်မာ (,) သို့မဟုတ် လိုင်းချိုး (line break) ဖြင့် ခွဲ၍ ထည့်ပါ။",
Please_enter_the_receipt_number_separated_by_a_comma_or_a_newline:"ကုန်ပစ္စည်းလက်ခံရရှိမှု အမှတ်များကို ကော်မာ (,) သို့မဟုတ် လိုင်းချိုး (line break) ဖြင့် ခွဲ၍ ထည့်ပါ။",
registerReturnOrder:"ပြန်လည်လက်ခံရရှိမှု လက်မှတ်",
returnOrderGrounding:"ပြန်လည်လက်ခံရရှိပြီး ပြန်တင်ခြင်း",
Number_of_remaining_shelves:"ကျန်ရှိသေးသော ပြန်တင်ပမာဏ",
please_enter_Number_of_shelves:"ပြန်တင်ပမာဏကို ထည့်ပါ။",
Batch_registration_basket:"အုပ်စုမှတ်တမ်း စုစုပေါင်း",
registration_basket:"မှတ်တမ်း စုစုပေါင်း",
Today_is_total_revenue:"ယနေ့ စုစုပေါင်း ဝင်ငွေ",
Today_is_total_expenditure:"ယနေ့ စုစုပေါင်း ထွက်ငွေ",
Today_is_balance:"ယနေ့ ကျန်ငွေ",
Yesterday_is_balance:"မနေ့ ကျန်ငွေ",
ConsolidationOfSimilar:"ဆင်တူ ကုန်ကျစရိတ်များ ပေါင်းစည်းခြင်း",
sales_return:"ပြန်ပို့ကုန်များ",
return_management:"ပြန်ပို့ကုန် စီမံခန့်ခွဲမှု",
returnManagement:"ပြန်ပို့ကုန် စီမံခန့်ခွဲမှု",
returnList:"ပြန်ပို့ကုန် စာရင်း",
Claim_status:"တောင်းခံမှု အခြေအနေ",
date_issued:"ပြန်သိုလှောင်ချိန်",
valid_time:"အသက်တာ ကာလ",
Create_a_return_form:"ပြန်ပို့ကုန် စလစ် ဖန်တီးရန်",
Edit_a_return_form:"ပြန်ပို့ကုန် စလစ် တည်းဖြတ်ရန်",
Receiving_warehouse:"လက်ခံ ဂိုဒေါင်",
logistics_provider:"ကုန်ပို့ဆောင်ရေး ပံ့ပိုးသူ",
Return_note:"ပြန်ပို့ မှတ်ချက်များ",
processing_scheme:"လုပ်ငန်းစဉ် ဖြေရှင်းချက်",
Product_picture:"ထုတ်ကုန် ပုံများ",
Select_add_item:"ကုန်ပစ္စည်း ထည့်ရန် ရွေးချယ်",
Claim_time:"တောင်းခံချိန်",
Temporary_storage_number:"ယာယီ သိုလှောင်မှု နံပါတ်",
viewReturnNote:"ပြန်ပို့အော်ဒါ ကြည့်ရန်",
Claimed:"တောင်းခံထားသည်",
unclaimed:"မတောင်းခံထားသည်",
Parcel_information:"ပက်ကေ့ဂျ် အချက်အလက်",
Package_picture:"ပက်ကေ့ဂျ် ပုံ",
Package_details:"ပက်ကေ့ဂျ် အသေးစိတ်",
Number_of_shelves:"စာရင်းတင်အရေအတွက်",
unqualified_quantity:"မလိုက်နာသော အရေအတွက်",
Quantity_of_abandonment:"ပယ်ဖျက်ထားသော အရေအတွက်",
// Return_Basket:"ပြန်ပို့ခြင်း စုစည်းမှု၊",
Image:"ပုံ",
Return_StockUnit:"ပြန်ပို့ခြင်း ဘင် တည်နေရာ",
// Actual_Weight:"တကယ့်အလေးချိန်၊",
// Actual_Lenth:"တကယ့်အရှည်၊",
// Actual_Width:"တကယ့်အကျယ်၊",
// Actual_Height:"တကယ့်အမြင့်၊",
Receiving_Warehouse:"လက်ခံဂိုဒေါင်",
Claim_ReturnOrderMsagess:"လက်ရှိ ပက်ကေ့ဂျ် မှတ်ပုံတင်ထားခြင်း မရှိပါ။ အသေးစိတ်များကို ဆက်လက်ဖြည့်ပြီး Claim Area တွင် မှတ်ပုံတင်ရန် Save ကို နှိပ်ပါ။",
Please_enter_the_tracking_number:"Waybill နံပါတ် ထည့်ပါ။",
Please_enter_the_warehouse:"လက်ခံမည့် ဂိုဒေါင် ရွေးပါ။",
Please_enter_the_logistics_provider:"ကုန်ပို့ဆောင်ရေး ပံ့ပိုးသူ ထည့်ပါ။",
Please_enter_the_temporary_number:"ယာယီသိုလှောင်မှု နံပါတ် ထည့်ပါ။",
Please_enter_the_sku:"SKU ရွေးပါ။",
Package_picture_isNotNull:"ပက်ကေ့ဂျ်ဓာတ်ပုံ မလွတ်နိုင်ပါ။",
ReturnOrder_ItemProduct_IsNotSkuQuantityNull:"ပြန်ပို့ထားသော ပစ္စည်း SKU အရေအတွက် မလွတ်နိုင်ပါ။",
ReturnOrder_ItemProduct_IsNotQuantityNull:"ပြန်ပို့ထားသော ပစ္စည်း အရေအတွက် မလွတ်နိုင်ပါ။",
Please_add_the_return_order_item:"ပြန်ပို့ထားသော ပစ္စည်းများ ထည့်ပါ။",
Reject:"ငြင်းပယ်",
Abandon:"ပယ်ဖျက်",
Ground_Quantity:"စင်ပေါ်ထားရှိသော အရေအတွက်",
Stay_Ground_Quantity:"စင်ပေါ်ထားရန် စောင့်ဆိုင်းနေသော အရေအတွက်",
Please_select_the_basket:"ပြန်ပို့ခြင်း စုဆောင်းပုံးကို စကင်ပါ။",
Handle_Remark:"လုပ်ငန်းစဉ် မှတ်ချက်များ",
Please_add_the_commodity:"ထုတ်ကုန်ထည့်ပါ",
Please_fill_in_the_required_information:"အသေးစိတ်အချက်အလက်များအတွက် တကယ့်အတိုင်းအတာများကို ထည့်ပါ",
Please_enter_the_unqualified_quantity:"ချို့ယွင်းပမာဏကို ထည့်ပါ",
The_unqualified_quantity_cannot_be_greater_than_the_product_quantity:"ချို့ယွင်းပမာဏသည် စုစုပေါင်းပမာဏထက် မကျော်နိုင်ပါ",
Generate_shelf_task:"စာရင်းတင်တာဝန် သတ်မှတ်ပါ",
Please_enter_the_solution:"လုပ်ဆောင်ချက် ဖြေရှင်းချက် ထည့်ပါ",
Please_upload_pictures:"ဓာတ်ပုံ တင်ပါ",
//quality_testing:"quality_testing: 'အရည်အသွေး စစ်ဆေးခြင်း',",
Return_StockUnits:"ပြန်ပို့ထားသော စတော့",
Actual_Weight:"တကယ့်အလေးချိန် (ကီလိုဂရမ်/ယူနစ်)",
Actual_Lenth:"တကယ့်အရှည်",
Actual_Width:"တကယ့်အကျယ်",
Actual_Height:"တကယ့်အမြင့်",
Actual_Lenth_unit:"တကယ့်အရှည် (စင်တီမီတာ)",
Actual_Width_unit:"တကယ့်အကျယ် (စင်တီမီတာ)",
Actual_Height_unit:"တကယ့်အမြင့် (စင်တီမီတာ) (စင်တီမီတာ)",
Actual_Size:"အမှန်တကယ် အရှည် x အကျယ် x အမြင့် (စင်တီမီတာ)",
Return_Basket:"ပြန်ပို့မည့် ကုန်ပစ္စည်းများ ထည့်သွင်းရန်",
ThirdParty_Warehousing:"တတိယပါတီ ဂိုဒေါင်",
Determine_whether_to_reject:"ငြင်းပယ်ခြင်း အတည်ပြုပါသလား?",
Determine_whether_to_abandon:"ဖျက်သိမ်းခြင်း အတည်ပြုပါသလား?",
returnOrderStayGrounding:"စင်တင်ရန် စောင့်ဆိုင်းနေသော ပြန်ပို့မည့် စာရင်း",
Please_select_a_product_that_belongs_to_this_customer:"ဖောက်သည်နှင့် ဆက်စပ်သော ပစ္စည်းများ ရွေးချယ်ပါ",
Viewing_Delivery_logs:"ပို့ဆောင်မှု မှတ်တမ်း ကြည့်ရှုရန်",
Reprint_face_sheet:"ပို့ဆောင်ရေး တံဆိပ် ပြန်ပုံနှိပ်ရန်",
By_default_the_quantity_of_reserved_storage_is_regarded_as_the_qualified_quantity_during_batch_inspection:"အစုလိုက် အရည်အသွေး စစ်ဆေးမှုအတွင်း၊ စီစဉ်ထားသော ဝင်ရောက်မည့် ပမာဏကို အရည်အသွေးပြည့်မီသော ပမာဏအဖြစ် အလိုအလျောက် သတ်မှတ်မည်။ ထုတ်ကုန်များတွင် တံဆိပ်တပ်ထားသည်ဟု ယူဆမည်။ ဆက်လက်ရန်?",
When_the_return_form_of_the_claim_area_is_unclaimed_for_more_than_30_days_it_will_automatically_enter_the_destruction_area:"တောင်းခံမှုဧရိယာတွင် ၃၀ ရက်ကျော် တောင်းခံမခံရသေးသော ပြန်ပို့ကုန်များသည် အလိုအလျောက် ဖျက်ဆီးဧရိယာသို့ ဝင်သွားမည်။",
Failure_to_claim_within_30_days_automatically_enters_the_destruction_zone:"တောင်းခံမခံရသေးသော ၃၀ ရက်ကျော်ပြီးနောက် အလိုအလျောက် ဖျက်ဆီးဧရိယာသို့ ဝင်သွားမည်။",
claim:"တောင်းခံမှု",
Please_enter_separated_by_commas_or_newlines:"ကော်မာ (,) သို့မဟုတ် လိုင်းခွဲ (line break) ဖြင့် ခွဲ၍ ထည့်ပါ။",
Import_returns:"တင်သွင်း ပြန်ပို့ကုန်များ",
attribution:"တာဝန်ခံ",
unfinishedReturnTaskList:"မပြီးစီးသေးသော ပြန်ပို့တာဝန်စာရင်း",
finishedReturnTaskList:"ပြီးစီးပြီးသော ပြန်ပို့တာဝန်စာရင်း",
Viewing_print_logs:"ပုံနှိပ်မှတ်တမ်း ကြည့်ရှုရန်",
batch_abandon:"အစုလိုက် ဖျက်ဆီးခြင်း",
The_minimum_value_is:"အနည်းဆုံး တန်ဖိုးမှာ",
The_original_product_cannot_be_deleted_if_there_is_a_shortage_or_defective_product_please_fill_in_the_unqualified_quantity:"မူရင်းပစ္စည်းများကို ဖျက်၍ မရပါ။ ပစ္စည်းများ မရရှိနိုင်ခြင်း သို့မဟုတ် ချို့ယွင်းချက်ရှိပါက မလိုက်နာသော အရေအတွက်ကို ထည့်ပါ။",
Confirm_return_pending_review:"ပြန်လည်သုံးသပ်ရန် ပြန်ပို့ခြင်း အတည်ပြုပါ",
Confirm_abandon:"ပယ်ဖျက်ခြင်း အတည်ပြုပါ",
Cofirm_modify_warehouse:"ဂိုဒေါင်ပြင်ဆင်မှု အတည်ပြုပါ",
Verify_tracking_number:"ပို့ဆောင်မှုနံပါတ် အတည်ပြုပါ",
publish:"စာရင်းတင်ခြင်း",
publishLazada:"Lazada တိုက်ရိုက်ထုတ်ကုန်များ",
publishShopee:"Shopee တိုက်ရိုက်ထုတ်ကုန်များ",
publishTikTok:"TikTok တိုက်ရိုက်ထုတ်ကုန်များ",
tiktokGoodsOnline:"TikTok တိုက်ရိုက်ထုတ်ကုန်များ",
lazadaGoodsOnline:"Lazada တိုက်ရိုက်ထုတ်ကုန်များ",
shopeeGoodsOnline:"Shopee တိုက်ရိုက်ထုတ်ကုန်များ",
lazadaTrusteeshipGoodsOnline:"Lazada စီမံခန့်ခွဲထားသော တိုက်ရိုက်ထုတ်ကုန်များ",
Goods_to_be_released:"ထုတ်လွှင့်ရန် စောင့်ဆိုင်းနေသော ကုန်ပစ္စည်းများ",
CNSC_Goods_to_be_released:"CNSC ထုတ်လွှင့်ရန် စောင့်ဆိုင်းနေသော ကုန်ပစ္စည်းများ",
Global_commodity:"ကမ္ဘာလုံးဆိုင်ရာ ကုန်ပစ္စည်းများ",
Site_goods:"ဆိုက်ပေါ် ကုန်ပစ္စည်းများ",
Link_ID:"လင့်ခ် ID",
Link_Name:"လင့်ခ် အမည်",
Link_SKU:"လင့်ခ် SKU",
Variant_ID:"ဗားရှင်း ID",
master_map:"အဓိက ပုံ",
onLineSKU:"အွန်လိုင်း SKU",
pair:"ကိုက်ညီမှု",
Paired_inventory_SKUs:"ကိုက်ညီမှု",
pairLog:"ကိုက်ညီမှု မှတ်တမ်း",
unpair:"မကိုက်ညီမှု",
Modified_pairing:"ကိုက်ညီမှု ပြင်ဆင်ခြင်း",
PlatformAuthorization:"ပလက်ဖောင်း ခွင့်ပြုချက်",
store_management:"ဆိုင် စီမံခန့်ခွဲမှု",
ShopAuthorization:"ဆိုင် ခွင့်ပြုချက်",
shopAuthorization:"ဆိုင် ခွင့်ပြုချက်",
Add_authorization:"ခွင့်ပြုချက် ထည့်ခြင်း",
name_of_shop:"ဆိုင်အမည်",
store_name:"ဆိုင်အမည်",
korach:"ထုတ်ယူနိုင်ပါသည်",
Being_drawn:"ထုတ်ယူနေသည်",
Please_enter_the_name_of_the_shop:"ဆိုင်အမည် ထည့်ပါ",
Platform_store_name:"ပလက်ဖောင်း ဆိုင်အမည်",
authorization_status:"ခွင့်ပြုချက် အခြေအနေ",
be_authorized:"ခွင့်ပြုထားသည်",
Authorization_successful:"ခွင့်ပြုချက် အောင်မြင်သည်",
unauthorized:"ခွင့်မပြုထားသည်",
privileged_time:"ခွင့်ပြုချိန်",
Expiration_time_of_authorization:"ခွင့်ပြုချိန် သက်တမ်းကုန်",
Is_the_address_consistent:"လိပ်စာ ကိုက်ညီမှု",
Manually_synchronize_the_repository:"လက်ဖြင့် ဂိုဒေါင် ညှိနှိုင်းခြင်း",
After_authorization_automatically_pull_orders_within_half_a_month_automatically_pull_returns_within_half_a_month_and_online_product_information_within_half_a_year:"အတည်ပြုပြီးနောက်၊ နောက်ဆုံး နှစ်ပတ်အတွင်းရှိ အော်ဒါများ၊ ယခင်နှစ်ပတ်အတွင်း ပြန်လည်ပို့ထားသော ပစ္စည်းများနှင့် နောက်ဆုံး ခြောက်လအတွင်း အွန်လိုင်းထုတ်ကုန် အချက်အလက်များကို အလိုအလျောက် ရယူပါသည်။",
After_authorization_automatically_pull_online_products_that_have_been_updated_within_half_a_year:"အတည်ပြုပြီးနောက်၊ နောက်ဆုံး ခြောက်လအတွင်း အပ်ဒိတ်ဖြစ်ထားသော အွန်လိုင်းထုတ်ကုန်များကို အလိုအလျောက် ရယူပါသည်။",
Platform_SKUs_have_changed_please_pay_attention_to_re_pairing_otherwise_the_original_platform_SKUs_and_stock_SKUs_are_still_paired:"Platform SKU များ ပြောင်းလဲသွားပါသည်။ ပြန်လည်တွဲဖက်ရန် လိုအပ်ပါသည်၊ မဟုတ်ပါက မူလ platform SKU နှင့် inventory SKU တွဲဖက်မှုသာ ဆက်လက်ရှိနေပါမည်။",
Replace_the_pairing_the_goods_information_of_the_previous_order_will_not_be_replaced_with_the_newly_paired_goods_please_go_to_the_order_list_to_modify_the_goods:"တွဲဖက်မှုပြောင်းလဲသည့်အခါ ယခင်အော်ဒါရှိ ထုတ်ကုန်အချက်အလက်များကို အသစ်တွဲထားသော ပစ္စည်းများဖြင့် မအပ်ဒိတ်ဖြစ်ပါ။ အော်ဒါစာရင်းရှိ ထုတ်ကုန်များကို ပြင်ဆင်ပါ။",
After_the_dissolution_of_the_relationship_the_product_information_of_the_previous_order_will_not_be_unpaired_After_the_manual_pairing_the_new_pairing_logic_will_not_be_executed_for_the_previously_paired_order_Please_go_to_the_order_list_to_modify_the_product:"တွဲဖက်မှုဖျက်ပြီးနောက် ယခင်အော်ဒါရှိ ထုတ်ကုန်အချက်အလက်များကို အသစ်တွဲထားသည့်အတိုင်း မအပ်ဒိတ်ဖြစ်ပါ။ လက်ဖြင့် ပြန်တွဲပြီးနောက် ယခင်တွဲထားသော အော်ဒါများသည် အသစ်တွဲထားသည့် စည်းမျဉ်းအသစ်ကို မလိုက်နာပါ။ အော်ဒါစာရင်းရှိ ထုတ်ကုန်များကို ပြင်ဆင်ပါ။",
Pull_goods:"ထုတ်ကုန်များ ဆွဲယူခြင်း",
Recent_pull_time:"နောက်ဆုံး ဆွဲယူချိန်",
Store_pull_status:"ဆိုင် ဆွဲယူမှု အခြေအနေ",
Store_pull_exception:"ဆိုင် ဆွဲယူမှု ချို့ယွင်းချက်",
Store_Pull_time:"ဆိုင် ဆွဲယူချိန်",
Last_7_days:"ပြီးခဲ့သည့် ၇ ရက်",
Last_30_days:"ပြီးခဲ့သည့် ၃၀ ရက်",
Last_90_days:"ပြီးခဲ့သည့် ၉၀ ရက်",
Last_180_days:"ပြီးခဲ့သည့် ၁၈၀ ရက်",
Stores_that_have_not_shipped_within_2_months_will_be_automatically_invalidated:"၂ လကြာ ပို့ဆောင်မှုမရှိသော ဆိုင်များကို အလိုအလျောက် ပိတ်သိမ်းမည်",
Latest_shipping_time:"နောက်ဆုံး ပို့ဆောင်သည့် ရက်စွဲ",
Last_3_months:"ပြီးခဲ့သည့် ၃ လ",
Beginning_to_pull_the_time:"ယူဆောင်ရန် စတင်ချိန်",
Ending_pull_time:"ယူဆောင်ရန် အဆုံးသတ်ချိန်",
WMSmissionContro:"WMS တာဝန် ထိန်းချုပ်မှု",
Configuration_task_type:"တာဝန်အမျိုးအစား ဖွဲ့စည်းခြင်း",
please_select_Configuration_task_type:"တာဝန်အမျိုးအစား ဖွဲ့စည်းမှုကို ရွေးချယ်ပါ",
Distribution_task_generation_control_type:"ယူဆောင်ရန် တာဝန် ဖန်တီးမှု ထိန်းချုပ်မှု အမျိုးအစား",
please_select_Distribution_task_generation_control_type:"အော်ဒါဖြည့်ဆည်းရေးတာဝန်ထုတ်လုပ်မှုထိန်းချုပ်မှုအမျိုးအစားကို ရွေးချယ်ပါ။",
Task_order_quantity:"တာဝန် အော်ဒါ အရေအတွက်",
Please_enter_the_Task_order_quantity:"တာဝန် အော်ဒါ အရေအတွက်ကို ထည့်ပါ။",
Maximum_order_number:"အများဆုံး အော်ဒါ အရေအတွက်",
Please_enter_the_Maximum_order_number:"အများဆုံး အော်ဒါ အရေအတွက်ကို ထည့်ပါ။",
Allocation_inquiry:"ဖြည့်ဆည်းရေးမေးမြန်းချက်",
Whether_to_allocate_goods_by_floor:"ထပ်ခွဲအခြေပြု ဖြည့်ဆည်းရေး",
please_select_Whether_to_allocate_goods_by_floor:"ထပ်ခွဲအလိုက် ဖြည့်ဆည်းမလား မရွေးချယ်ပါနှင့်",
Whether_the_storage_space_can_be_allocated:"သိုလှောင်ဘင်များ ဖြည့်ဆည်းရန် အသင့်ရှိမရှိ",
please_select_Whether_the_storage_space_can_be_allocated:"သိုလှောင်ဘင်များ ဖြည့်ဆည်းရန် အသင့်ရှိမရှိကို ရွေးချယ်ပါ။",
Order_allocation_timeout_time:"အော်ဒါဖြည့်ဆည်းရေး အချိန်ကုန်သတ်မှတ်ချက်",
Please_enter_the_Order_allocation_timeout_time:"အော်ဒါဖြည့်ဆည်းရေး အချိန်ကုန်သတ်မှတ်ချက်ကို ထည့်ပါ။",
Generate_timeout_order_tasks_first:"ကျော်လွန်အော်ဒါတာဝန်များ ဖန်တီးရာတွင် ဦးစားပေးခြင်း",
please_select_Generate_timeout_order_tasks_first:"ကျော်လွန်အော်ဒါတာဝန်များ ဖန်တီးရာတွင် ဦးစားပေးမလား ရွေးချယ်ပါ။",
Match_and_send:"ရွေးယူစဉ် ပို့ဆောင်ခြင်း",
please_select_Match_and_send:"ရွေးယူစဉ် ပို့ဆောင်မလား ရွေးချယ်ပါ။",
Delivery_weighing:"ပို့ဆောင်စဉ် အလေးချိန်တိုင်းတာခြင်း",
please_select_Delivery_weighing:"ပို့ဆောင်စဉ် အလေးချိန်တိုင်းတာမလား ရွေးချယ်ပါ။",
Do_you_want_to_take_photos:"ပို့ဆောင်စဉ် ဓာတ်ပုံရိုက်ခြင်း",
Is_the_shipment_recorded:"ပို့ဆောင်စဉ် ဗီဒီယိုမှတ်တမ်းတင်ခြင်း",
please_select_Do_you_want_to_take_photos:"ပို့ဆောင်စဉ် ဓာတ်ပုံရိုက်မလား ရွေးချယ်ပါ။",
Check_whether_the_goods_are_delivered:"ပို့ဆောင်စဉ် စစ်ဆေးခြင်း",
please_select_Check_whether_the_goods_are_delivered:"ပို့ဆောင်စဉ် စစ်ဆေးမလား ရွေးချယ်ပါ။",
Whether_the_whole_sorting_task_is_shipped:"စိစစ်ရေးတာဝန်အားလုံး ပို့ဆောင်ခြင်း",
please_select_Whether_the_whole_sorting_task_is_shipped:"ခွဲခြားရေးတာဝန်များအားလုံးကို ပို့ဆောင်မလား ရွေးချယ်ပါ။",
Delivery_inquiry:"ပို့ဆောင်မှုစုံစမ်းမေးမြန်းခြင်း",
New_task_control:"တာဝန်အသစ် ထိန်းချုပ်မှု",
Edit_task_control:"တာဝန် ထိန်းချုပ်မှု တည်းဖြတ်ခြင်း",
Allocation_information:"ရွေးယူခြင်း အချက်အလက်",
shipping_information:"ပို့ဆောင်မှု အချက်အလက်",
Multi_floor_combination_distribution:"အဆင့်စုံ ပေါင်းစပ်ရွေးယူခြင်း",
Distribute_goods_while_shipping:"တစ်ပြိုင်နက် ရွေးယူ၍ ပို့ဆောင်ခြင်း",
Total_allocation_quantity:"ရွေးယူသည့် စုစုပေါင်းအရေအတွက်",
Total_shipment_quantity:"ပို့ဆောင်သည့် စုစုပေါင်းအရေအတွက်",
Delivery_phase:"ပို့ဆောင်မှုအဆင့်",
Delivery_start_time:"ပို့ဆောင်မှု စတင်ချိန်",
Delivery_end_time:"ပို့ဆောင်မှု အဆုံးချိန်",
Abnormal_query:"ထူးခြားချက် စုံစမ်းမေးမြန်းခြင်း",
need:"လိုအပ်သည်",
do_without:"မလိုအပ်ပါ",
Please_enter_basket_remarks:"အမှာစာမှတ်ချက်များ ထည့်ပါ",
Failed_to_print_sheet_please_rescan:"တံဆိပ်ပုံနှိပ်ခြင်း မအောင်မြင်ပါ၊ ထပ်မံ စကင်ပါ",
Single_print_success:"တံဆိပ်ပုံနှိပ်ခြင်း အောင်မြင်ပါသည်",
batch_delivery:"အစုလိုက် ပို့ဆောင်ခြင်း",
Bulk_shipment_quantity:"အစုလိုက် ပို့ဆောင်မည့် အရေအတွက်",
Whether_to_scan_the_database:"သိုလှောင်ရာနေရာ စကင်မလား",
Please_confirm_that_the_goods_have_been_returned_to_the_original_warehouse:"ကုန်ပစ္စည်းများကို မူလသိုလှောင်ရာနေရာသို့ ပြန်ပို့ထားကြောင်း အတည်ပြုပါ",
Return_the_order_to_ungenerated:"အမှာစာကို 'မထုတ်ပေးသေး' အခြေအနေသို့ ပြန်သွားစေ",
Return_the_order_to_a_draft:"အမှာစာကို 'မူကြမ်း' အခြေအနေသို့ ပြန်သွားစေ",
Return_the_order_to_the_pending_review_status:"အမှာစာကို 'စစ်ဆေးရန် စောင့်ဆိုင်းနေ' အခြေအနေသို့ ပြန်သွားစေ",
Item_task_list:"တစ်ခုချင်းစီ တာဝန်စာရင်း",
itemTaskList:"တစ်ခုချင်းစီ တာဝန်စာရင်း",
Multi_task_list:"ပစ္စည်းအများအပြား တာဝန်စာရင်း",
multiTaskList:"ပစ္စည်းအများအပြား တာဝန်စာရင်း",
Packing_material_condition:"ထုပ်ပိုးပစ္စည်း အခြေအနေ",
Basket_quantity:"ဘတ်စကက် အရေအတွက်",
viewWarehouseEntryList:"ဝင်လာမည့်စာရင်း ကြည့်ရှုရန်",
No_combo_SKU_images_uploaded:"ပေါင်းစပ် SKU ပုံများ တင်ပေးပါ",
Whether_sorting_and_delivery_is_required:"ပို့ဆောင်ရန် အမျိုးအစားခွဲရန် လိုအပ်ပါသလား?",
delivery_process:"ပို့ဆောင်ခြင်း လုပ်ငန်းစဉ်",
delivery_process_one:"ပို့ဆောင်ခြင်း လုပ်ငန်းစဉ် ၁",
delivery_process_two:"ပို့ဆောင်ခြင်း လုပ်ငန်းစဉ် ၂",
Delivery_flow_2_does_not_allow_the_use_of_border_variations:"လုပ်ငန်းစဉ် ၂ သည် တပြိုင်နက် တစ်ပြိုင်တည်း ရွေးယူခြင်းနှင့် အမျိုးအစားခွဲခြင်းကို တားမြစ်သည်",
Delivery_process_2_Multi_floor_distribution_is_not_allowed:"လုပ်ငန်းစဉ် ၂ သည် အဆင့်ဆင့် ရွေးယူခြင်းကို တားမြစ်သည်",
Default_delivery_process_scanning_the_corresponding_basket_for_goods_sorting_and_delivery:"မူလ ပို့ဆောင်ရေးလုပ်ငန်းစဉ်: ကုန်ပစ္စည်း ခွဲခြားပို့ဆောင်ရန် သက်ဆိုင်ရာ ကန်များအား စကင်ခြင်း",
Goods_are_sorted_and_no_baskets_are_needed_for_delivery:"ကုန်ပစ္စည်းများ ခွဲခြားပြီးပါက ပို့ဆောင်ရန် ကန်များ မလိုအပ်တော့ပါ။",
Multiple_products_and_edge_matching_edge_division_unusable_volume:"ပစ္စည်းအများအပြားနှင့် တပြိုင်နက် ခွဲခြား/ရွေးချယ်ခြင်းတွင် အရေအတွက်အခြေပြု ခွဲဝေပေးခြင်း တားမြစ်ထားသည်။",
Use_the_delivery_flow_for_multi_product_tasks_2_The_border_variation_is_not_allowed:"ပို့ဆောင်ရေးလုပ်ငန်းစဉ် ၂ ကို အသုံးပြုသည့် ပစ္စည်းအများအပြား တာဝန်များတွင် တပြိုင်နက် ခွဲခြား/ရွေးချယ်ခြင်း မပြုနိုင်ပါ။",
surfTheInternet:"အွန်လိုင်း အခြေအနေ",
surfExternalOrder:"ပြင်ပမှာယူခွင့်",
Please_choose_surfTheInternet:"အွန်လိုင်း အခြေအနေကို ရွေးချယ်ပါ။",
Please_choose_surfExternalOrder:"ပြင်ပမှာယူခွင့်ကို ရွေးချယ်ပါ။",
Whether_to_go_online_refers_to_whether_the_platform_api_interface_is_called_to_verify_whether_the_logistics_trajectory_has_been_collected:"အွန်လိုင်းအခြေအနေ ဆိုသည်မှာ ပလက်ဖောင်း API အင်တာဖေ့စ်ကို အသုံးပြု၍ သယ်ယူပို့ဆောင်ရေး လိုက်လံစစ်ဆေးခြင်းနှင့် ကောက်ခံမှု အခြေအနေများကို အတည်ပြုခြင်း ရှိ/မရှိကို ဆိုလိုသည်။",
Preview_sheet:"လမ်းကြောင်းလွှာ ကြိုကြည့်ခြင်း",
If_the_bill_is_abnormal_contact_the_administrator:"လမ်းကြောင်းလွှာတွင် မမှန်ကန်မှုများရှိပါက ဖြေရှင်းရန် စီမံခန့်ခွဲသူထံ ဆက်သွယ်ပါ။",
Exit_Printing:"ပုံနှိပ်ခြင်းမှ ထွက်ရန်",
single_product:"တစ်ခုတည်းသော ပစ္စည်း",
paperTask:"စာရွက်အလုပ်",
multiProductPaperDistribution:"ပစ္စည်းများစွာအတွက် စာရွက်ရွေးယူခြင်း",
singleProductPaperDistribution:"တစ်ခုတည်းသော ပစ္စည်းအတွက် စာရွက်ရွေးယူခြင်း",
obtainPaperDistributionOfSingleProduct:"တစ်ခုတည်းသော ပစ္စည်းစာရွက်ရွေးယူခြင်းကို ပြန်လည်ရယူခြင်း",
completeThePaperDistributionOfTheSingleProduct:"တစ်ခုချင်းစာရွက်ရွေးချယ်မှု ပြီးစီး",
obtainMultiProductPaperDistribution:"အများစာရွက်ရွေးချယ်မှု ပြန်ယူ",
completeMultiProductPaperDistribution:"အများစာရွက်ရွေးချယ်မှု ပြီးစီး",
Paper_tracking_number:"စာရွက်လမ်းကြောင်းနံပါတ်",
basket:"လှည်း",
basket_Info:"လှည်းအသေးစိတ်",
specified_Quantity:"သတ်မှတ်အရေအတွက်",
Individual_product_operation:"တစ်ခုချင်း လုပ်ငန်းစဉ်များ",
Multiple_product_operation:"အများလုပ်ငန်းစဉ်များ",
multipleProductOperation:"အများလုပ်ငန်းစဉ်များ",
multiple_products:"အများစာရင်း",
order_quantity:"အော်ဒါအရေအတွက်",
volume:"ထုထည်",
describe:"ဖော်ပြချက်",
taskList:"တာဝန်စာရင်း",
Extra_packing_material:"ထပ်ထည့်ထုပ်ပိုးပစ္စည်းများ",
Additional_packing_material_exists:"ထပ်ထည့်ထုပ်ပိုးပစ္စည်းများ ရှိသည်",
listOrdersShipped:"ပို့ဆောင်ရန် စောင့်ဆိုင်းနေသော အော်ဒါစာရင်း",
listAbnormalShipment:"ပို့ဆောင်ရန် စောင့်ဆိုင်းနေသော အမှားစာရင်း",
Order_phase:"အော်ဒါအဆင့်",
order_source:"အော်ဒါရင်းမြစ်",
Quantity_occupied:"ခွဲဝေထားသော အရေအတွက်",
The_address_of_the_bill_is_empty_Contact_the_administrator:"ပို့ဆောင်လွှာလိပ်စာတွင် အချက်အလက် မပါရှိပါ။ အကူအညီအတွက် စီမံခန့်ခွဲသူထံ ဆက်သွယ်ပါ။",
The_address_of_the_bill_is_empty:"ပို့ဆောင်လွှာလိပ်စာတွင် အချက်အလက် မပါရှိပါ။",
There_are_orders_with_empty_waybill_numbers_in_the_selected_orders_so_the_waybill_cannot_be_previewed:"ရွေးချယ်ထားသော အော်ဒါအချို့တွင် ပို့ဆောင်လွှာနံပါတ်များ မပါရှိပါ။ ပို့ဆောင်လွှာများကို ကြိုကြည့်၍ မရပါ။",
Please_scan:"စကင်ပါ။",
Please_scan_the_barcode:"ထုတ်ကုန် ဘားကုဒ်ကို စကင်ပါ။",
Modify_the_number_of_SKUs:"SKU ပမာဏ ပြင်ဆင်ပါ။",
Modified_warehouse:"ဂိုဒေါင် ပြင်ဆင်ပါ။",
Submitted_to_be_reviewed:"ပြန်လည်သုံးသပ်ရန် တင်ပါ။",
Commit_back_not_generated:"မဆောင်ရွက်သေးသောသို့ တင်သွင်းရန်",
Back_to_not_generated:"မဆောင်ရွက်သေးသောသို့ ပြန်သွားရန်",
Back_to_draft:"မူကြမ်းသို့ ပြန်သွားရန်",
Return_to_pending_review:"ပြန်လည်သုံးသပ်ရန် စောင့်ဆိုင်းနေသည့်သို့ ပြန်သွားရန်",
priority:"ဦးစားပေးမှု",
secondary:"ဒုတိယ",
order_inquiry:"အော်ဒါ စုံစမ်းမေးမြန်းခြင်း",
info_query:"အချက်အလက် စုံစမ်းမေးမြန်းခြင်း",
Print_basket_number:"ပုံနှိပ်ခြင်း စုစည်းမှု နံပါတ်",
Back_to_basket_list:"စုစည်းမှု စာရင်းသို့ ပြန်သွားရန်",
Sorting_starts_numbering:"စီစဉ်ခြင်း စတင်နံပါတ်",
Sorting_end_number:"စီစဉ်ခြင်း အဆုံးနံပါတ်",
Tripartite_warehouse_information:"တတိယပါတီ ဂိုဒေါင် အချက်အလက်",
Threeway_warehouse_OP_number:"တတိယပါတီ ဂိုဒေါင် OP နံပါတ်",
Batch_sorting:"အစုလိုက် စီစဉ်ခြင်း",
The_sorting_number_of_the_current_scan_is:"လက်ရှိ စကင်ထားသော စီစဉ်နံပါတ်မှာ",
Print_the_sorting_basket_head:"ပုံနှိပ် စီစဉ်ခြင်း စုစည်းမှု ခေါင်းစဉ်",
List_of_shipped_orders:"ပို့ဆောင်ပြီးသော အော်ဒါများ စာရင်း",
listShippedOrders:"ပို့ဆောင်ပြီးသော အော်ဒါများ စာရင်း",
taskID:"တာစ်ခ် ID",
Please_enter_taskID:"တာစ်ခ် ID ကို ထည့်ပါ။",
There_are_no_tasks_in_the_basket:"ဤ စကူထဲတွင် လက်ရှိ တာစ်ခ် မရှိပါ။",
bulk_print:"အစုလိုက် ပုံနှိပ်ခြင်း",
to_do_list_ID:"အော်ဒါ တာစ်ခ် ID",
task_type:"တာစ်ခ် အမျိုးအစား",
List_of_tasks_in_allocation:"ရွေးယူခြင်းတွင် ရှိသော တာစ်ခ်များ စာရင်း",
listTasksAllocation:"ရွေးယူခြင်းတွင် ရှိသော တာစ်ခ်များ စာရင်း",
Sorting_task_list:"ခွဲခြားခြင်းတွင် ရှိသော တာစ်ခ်များ စာရင်း",
sortingTaskList:"ခွဲခြားခြင်းတွင် ရှိသော တာစ်ခ်များ စာရင်း",
List_of_tasks_being_shipped:"ပို့ဆောင်ခြင်းတွင် ရှိသော တာစ်ခ်များ စာရင်း",
listTasksBeingShipped:"ပို့ဆောင်ခြင်းတွင် ရှိသော တာစ်ခ်များ စာရင်း",
Printing_successfully_Stopped_printing:"ပုံနှိပ်ခြင်း အောင်မြင်ပါသည်၊ ပုံနှိပ်ခြင်း ရပ်ပါ။",
List_of_shipped_tasks:"ပို့ဆောင်ပြီးသော တာစ်ခ်များ စာရင်း",
listShippedTasks:"ပို့ဆောင်ပြီးသော တာစ်ခ်များ စာရင်း",
explosiveOperation:"အကောင်းဆုံး ရောင်းအားရှိသော ကုန်ပစ္စည်း လုပ်ငန်းစဉ်များ",
explosiveDistribution:"အကောင်းဆုံးရောင်းအားရှိ ပစ္စည်းရွေးယူခြင်း",
explosiveDelivery:"အကောင်းဆုံးရောင်းအားရှိ ပစ္စည်းပို့ဆောင်ခြင်း",
explosiveList:"အကောင်းဆုံးရောင်းအားရှိ ပစ္စည်းစာရင်း",
Order_origin_currency:"အော်ဒါ မူရင်းငွေကြေး",
Out_of_storage:"လုပ်ဆောင်ဆဲ",
Print_failed_Please_check_and_try_again:"ပုံနှိပ်ခြင်း မအောင်မြင်ပါ! ကျေးဇူးပြု၍ စစ်ဆေးပြီး ထပ်မံကြိုးစားပါ။",
One_click_out_completed:"တစ်ချက်နှိပ်ပြီး ပို့ဆောင်မှု ပြီးစီး",
not_finished:"မပြီးစီးသေး",
have_not_started:"မစတင်သေး",
If_the_printing_is_not_successful_for_more_than_5_seconds_the_printing_ends:"အောင်မြင်မှုမရှိဘဲ ၅ စက္ကန့်အပြီး ပုံနှိပ်ခြင်း သက်တမ်းကုန်၍ ရပ်သွားသည်",
Whether_it_is_a_paper_task:"ဤတာဝန်သည် စက္ကူအလုပ်တစ်ခုလား?",
Checking_the_sheet:"လမ်းကြောင်းလွှာ စစ်ဆေးနေသည်",
A_sheet_is_being_printed:"လမ်းကြောင်းလွှာ ပုံနှိပ်နေသည်",
System_deduction:"စနစ် လျော့ချခြင်း",
Get_the_distribution_task:"ပစ္စည်းရွေးယူတာဝန် ပြန်ယူပါ",
Reprint_the_distribution_sheet:"ပစ္စည်းရွေးယူလက်မှတ် ထပ်မံပုံနှိပ်ပါ",
invoice:"ငွေတောင်းခံလွှာ",
HOT:"အကောင်းဆုံးရောင်းအားရှိသော ကုန်ပစ္စည်းများ",
print_TaskId:"ပုံနှိပ်လုပ်ငန်း ID",
Generating_task:"လုပ်ငန်း ဖန်တီးနေဆဲ",
distributionControl:"ခွဲဝေပေးမှု ထိန်းချုပ်မှု",
Order_distribution_time_zone:"အော်ဒါ ခွဲဝေပေးမှု အချိန်ဇုန်",
Order_distribution_sorting_field:"ခွဲဝေပေးမှု စီစဉ်ရန် ကွက်လပ်",
automatic_printing:"အလိုအလျောက် ပုံနှိပ်ခြင်း",
Non_automatic_printing:"အလိုအလျောက် မပုံနှိပ်ရန်",
Automatic_printing_of_distribution_slips:"ခွဲဝေပေးမှု စာရွက်ကို အလိုအလျောက် ပုံနှိပ်ခြင်း",
Automatically_prints_the_task_ID:"လုပ်ငန်း ID ကို အလိုအလျောက် ပုံနှိပ်ခြင်း",
The_time_zone_already_exists:"ဤအချိန်ဇုန်သည် ရှိပြီးသားဖြစ်သည်",
Add_Time_zone:"အချိန်ဇုန် ထည့်သွင်းခြင်း",
example:"ဥပမာ",
Ungenerated_task:"လုပ်ငန်း မဖန်တီးရသေးပါ",
completed_distribution:"ခွဲဝေပေးမှု ပြီးစီးပါပြီ",
Order_submission_time:"အော်ဒါ တင်သွင်းချိန်",
Please_select_automatic_printing:"အလိုအလျောက် ပုံနှိပ်ရန် ရွေးချယ်ပါ",
Please_select_order_distribution_sorting_field:"ခွဲဝေပေးမှု စီစဉ်ရန် ကွက်လပ်ကို ရွေးချယ်ပါ",
The_entered_time_zone_must_be_longer_than_one_hour_from_the_existing_time_zone:"ထည့်သွင်းထားသော အချိန်ဇုန်သည် လက်ရှိ အချိန်ဇုန်နှင့် အနည်းဆုံး တစ်နာရီကွာခြားရမည်",
The_time_zone_must_be_between_0100_and_2300:"ထည့်သွင်းထားသော အချိန်သည် 01:00 မှ 23:00 အတွင်း ဖြစ်ရမည်",
Support_input_time_zone_return_to_add_the_input_time_zone_needs_to_exist_in_the_selection_value:"သင်သည် အချိန်ကို တိုက်ရိုက် ရွေးချယ်နိုင်ပါသည်၊ သို့မဟုတ် အချိန်ဇုန်ကို ထည့်သွင်းပြီး Enter ကို နှိပ်၍ ထည့်သွင်းနိုင်ပါသည်။ မှတ်ချက်။ ထည့်သွင်းထားသော အချိန်ဇုန်သည် ရွေးချယ်စရာစာရင်းတွင် ရှိပြီးသား ဖြစ်ရမည်",
Sort_by_order_submission_time_from_morning_to_night:"အမှာစာ တင်သွင်းချိန် အရ အစောဆုံးမှ နောက်ဆုံးအထိ စီပါ။",
The_order_is_sorted_by_the_repository_number_and_the_next_repository_order_task_will_be_performed_only_after_processing_the_current_repository_order_task:"သိုလှောင်ရာနေရာနံပါတ်အလိုက် စီပါ။ လက်ရှိနေရာအတွက် အော်ဒါများကို ပြီးစီးမှသာ နောက်နေရာအတွက် အော်ဒါများကို ဆက်လက်ဆောင်ရွက်ပါမည်။",
Sort_by_sku_the_current_sku_is_completed_before_proceeding_to_the_next_sku:"SKU အလိုက် စီပါ။ လက်ရှိ SKU အတွက် အော်ဒါများကို ပြီးစီးမှသာ နောက် SKU ကို ဆက်လက်ဆောင်ရွက်ပါမည်။",
Generate_earlier_time_zone_tasks_first:"အချိန်ဇုန်ရှေးရှားသော အော်ဒါများကို ဦးစားပေးထုတ်လုပ်ပါ။",
If_the_order_distribution_time_zone_is_not_set_it_will_not_be_divided_by_time_Only_the_order_distribution_sorting_field_will_be_sorted_to_generate_the_order:"အော်ဒါခွဲဝေမှု အချိန်ဇုန် မသတ်မှတ်ထားပါက အချိန်အခြေပြု ခွဲခြားမှု မဖြစ်ပါ။ အော်ဒါများကို အော်ဒါခွဲဝေမှု စီစဉ်ရေးကွက်အပေါ် အခြေခံ၍သာ ထုတ်လုပ်ပါမည်။",
Pre_0_yesterday_orders_are_preferentially_generated:"မနေ့ည ၁၂ နာရီမတိုင်ခင်မှာယူထားသော အော်ဒါများကို ဦးစားပေးထုတ်လုပ်ပါ။",
Generate_orders_from_0000_to_1200:"၀၀:၀၀ မှ ၁၂:၀၀ အတွင်းမှာယူထားသော အော်ဒါများကို ထုတ်လုပ်ပါ။",
Generate_orders_after_1200_to_before_2400:"၁၂:၀၀ ပြီး ၂၄:၀၀ မတိုင်ခင်မှာယူထားသော အော်ဒါများကို ထုတ်လုပ်ပါ။",
Please_enter_the_number_of_tasks:"အလုပ်တာဝန်အရေအတွက်ကို ထည့်ပါ။",
Please_select_a_single_order_type:"အော်ဒါအမျိုးအစား တစ်ခုကို ရွေးပါ။",
Please_scan_task_ID:"အလုပ်တာဝန် ID ကို စကင်ပါ။",
Whether_to_limit_the_sorting_and_delivery_to_the_same_person:"စီစဉ်ခြင်းနှင့် ပို့ဆောင်ခြင်းကို တစ်ဦးတည်းကပဲ လုပ်ဆောင်ခွင့် ကန့်သတ်မလား?",
Mixed_shipments_are_possible_for_orders_of_different_task_types:"တာဝန်အမျိုးအစားကွဲပြားသော အော်ဒါများကို တစ်ပြိုင်နက်တည်း ပို့ဆောင်နိုင်ပါသည်",
task_bound_person:"တာဝန်ပေးသူ",
remaining_products:"စင်ပေါ်တွင် ထားရှိရန် ကျန်ရှိသေးသော ထုတ်ကုန်အမျိုးအစားများ",
Please_perform_wms_task_control_first:"ပထမဦးစွာ WMS တာဝန်ထိန်းချုပ်မှုကို ဆောင်ရွက်ပါ",
The_current_warehouse_has_not_performed_wms_task_control:"လက်ရှိ ဂိုဒေါင်တွင် WMS တာဝန်ထိန်းချုပ်မှု မဆောင်ရွက်သေးပါ။",
whether_batch_ship:"အစုလိုက်ပို့ဆောင်မှု ဖွင့်ထားပါသလား?",
hot_item_whether_batch_ship:"အရောင်းအကောင်းဆုံး ထုတ်ကုန်များအတွက် အစုလိုက်ပို့ဆောင်မှု ဖွင့်ထားပါသလား?",
manualEntryAndExitList:"လက်ဖြင့် စတော့ရှယ်ယာ လှုပ်ရှားမှု စာရင်း",
Manual_Entry_and_exit_slip_number:"လက်ဖြင့် စတော့ရှယ်ယာ လှုပ်ရှားမှု အော်ဒါနံပါတ်",
Manual_Entry_and_exit_slip_type:"လက်ဖြင့် စတော့ရှယ်ယာ လှုပ်ရှားမှု အမျိုးအစား",
Manual_Entry_and_exit_slip_status:"လက်ဖြင့် စတော့ရှယ်ယာ လှုပ်ရှားမှု အခြေအနေ",
accomplish_Time:"ပြီးဆုံးချိန်",
audits:"အတည်ပြုချက်",
Create_ManualEntryAndExit:"လက်ဖြင့် စတော့ရှယ်ယာ လှုပ်ရှားမှု အော်ဒါ ဖန်တီးရန်",
Please_fill_in_the_audit_remarks:"အတည်ပြုချက် မှတ်ချက်များ ထည့်ပါ",
audit_remarks:"အတည်ပြုချက် မှတ်ချက်များ",
pass_the_audit:"အတည်ပြုချက် ခွင့်ပြုပြီး",
The_inventory_will_be_changed_after_clicking:"အတည်ပြုပြီးနောက် စတော့ရှယ်ယာစာရင်း ပြောင်းလဲမည်",
Clicking_OK_will_flag_the_exception:"အတည်ပြုပြီးနောက် ပုံမှန်မဟုတ်ဟု အမှတ်အသားပြုမည်",
Click_OK_and_it_will_be_rejected:"အတည်ပြုပြီးနောက် ငြင်းပယ်မည်",
Number_of_shelvesd:"စင်ပေါ်ရှိ အရေအတွက်",
Type_of_outgoing_and_incoming_accounts:"စာရင်းကိုင် အမျိုးအစား",
If_a_recommended_repository_exists_the_recommended_repository_is_selected_by_default:"အကြံပြုထားသော သိုလှောင်ရန်နေရာများ ရှိပါက၊ အလိုအလျောက် ရွေးချယ်ထားမည်",
If_a_recommended_repository_exists_the_recommended_repository_is_entered_by_default:"အကြံပြုထားသော သိုလှောင်ရန်နေရာများ ရှိပါက၊ အလိုအလျောက် ထည့်သွင်းထားမည်",
Consolidation_of_similar_expenses:"ဆင်တူကြေးများကို ပေါင်းစည်းမည်",
Add_Consolidation_of_similar_expenses:"ကြေးပေါင်းစည်းမှု အသစ် ထည့်မည်",
Monthly_Expense_List:"လစဉ်အသုံးစရိတ်စာရင်း",
Name_of_the_expense_item:"ကြေးပစ္စည်းအမည်",
Accounting_in:"အကြွေးစာရင်းထည့်သွင်းခြင်း",
Accounting_out:"ငွေထုတ်စာရင်းထည့်သွင်းခြင်း",
in_out_account:"ငွေလွှဲပြောင်းမှု",
Sku_and_quantity:"ကုန်ပစ္စည်း SKU နှင့် အရေအတွက်",
Billing_weight:"ငွေတောင်းခံအလေးချိန်",
Charge_quantity:"ကြေးသတ်မှတ်ချက်: ငွေတောင်းခံယူနစ်များ",
Charge_weight:"ကြေးသတ်မှတ်ချက်: အလေးချိန်",
Cost_setting_Cube:"ကြေးသတ်မှတ်ချက်: ကုဗစ်မီတာ",
cost_setting_Three_sides_length_CM:"ကြေးသတ်မှတ်ချက်: သုံးဖက်စုစုပေါင်း",
Cost_set_three_sides_long:"ကြေးသတ်မှတ်ချက်: သုံးဖက်အရှည်",
goods_cobe:"ကုန်ပစ္စည်း ကုဗစ်မီတာ",
goods_Three_sides_length_CM:"ကုန်ပစ္စည်း သုံးဖက်အရှည်",
goods_weight:"ကုန်ပစ္စည်း အလေးချိန်",
type_of_fee:"ကြေးအမျိုးအစား",
Item_code:"ကုန်ကုဒ်",
Fill_in_the_positive_balance_of_recharge_and_fill_in_the_negative_balance_of_deduction:"ထပ်ဖြည့်ငွေများအတွက် အပေါင်းတန်ဖိုးများ ထည့်ပါ၊ ဖြုတ်ပစ်ငွေများအတွက် အနုတ်တန်ဖိုးများ ထည့်ပါ",
stock_in_and_stock_out_record:"ပစ္စည်းလှုပ်ရှားမှတ်တမ်းများ",
storage_location_number:"ပစ္စည်းတည်နေရာနံပါတ်",
Entry_quantity:"ပစ္စည်းလှုပ်ရှားအရေအတွက်",
total_inventory_quantity:"စုစုပေါင်းပစ္စည်းအရေအတွက်",
Current_batch_inventory_quantity:"လက်ရှိအုပ်စုပစ္စည်းအရေအတွက်",
Batch_stock_quantity:"တည်နေရာစုစုပေါင်းပစ္စည်းအရေအတွက်",
Batch_occupied_inventory_quantity:"အုပ်စုမှယူထားသောပစ္စည်းအရေအတွက်",
life:"ပစ္စည်းသက်တမ်း",
Has_stock:"ပစ္စည်းရှိသည်",
No_stock:"ပစ္စည်းမရှိသည်",
Has_No_stock:"ပစ္စည်းဝင်/ထွက်",
stock_type:"ပစ္စည်းအမျိုးအစား",
Entry_time:"လက်ခံရရှိသည့်ရက်စွဲ",
Tripartite_storage:"တတိယပါတီဂိုဒေါင်ပစ္စည်း",
General_stock:"ပုံမှန်ပစ္စည်း",
Unusable_inventory:"မရနိုင်သောပစ္စည်း",
Entry_and_exit_records:"ပစ္စည်းအသေးစိတ်ကြည့်ရန်",
grounding:"ကုန်ပစ္စည်း တပ်ဆင်ခြင်း",
Shelf_in_bulk:"အုပ်စု တပ်ဆင်ခြင်း",
Number_of_shelvesds:"တပ်ဆင်ထားသော အရေအတွက်",
Unshelved:"မတပ်ဆင်ထား",
Already_listed:"တပ်ဆင်ထား",
Multiple_quantity:"ပိုပို့ထားသော အရေအတွက်",
Shelf_batch:"တပ်ဆင်ထားသော အုပ်စု",
Check_the_storage_details:"ဝင်/ထွက် အသေးစိတ် ကြည့်ရန်",
operate_successfully:"လုပ်ငန်း အောင်မြင်ပါပြီ",
Print_the_default_size_paper_distribution:"စံအရွယ်အစား စက္ကူ Picking Slip ပုံနှိပ်ရန်",
Print_A4_size_distribution:"A4 အရွယ်အစား စက္ကူ Picking Slip ပုံနှိပ်ရန်",
Print_100_150_size_distribution:"100*150 အရွယ်အစား စက္ကူ Picking Slip ပုံနှိပ်ရန်",
The_customer_password_will_be_reset_to_ESTP_mobile_number:"ဖောက်သည် စကားဝှက်ကို ပြန်လည် သတ်မှတ်မည် - ESTP+မိုဘိုင်းနံပါတ်",
Get_a_shelf_task:"တပ်ဆင်ခြင်း တာဝန် ပြန်ယူရန်",
Please_select_some_user:"စာရင်းတင်အေးဂျင့်",
Prioritize_shelving:"ဦးစားပေးစာရင်း သတ်မှတ်",
Please_select_the_type_of_manual_entry_ticket:"လက်ဖြင့် ဝင်/ထွက် ပစ္စည်းရွက်စာတမ်း အမျိုးအစားကို ရွေးချယ်ပါ",
Please_select_warehouse:"ဂိုဒေါင်ကို ရွေးချယ်ပါ",
Please_select_the_warehouse_location:"သိုလှောင်ရာနေရာကို ရွေးချယ်ပါ",
Please_scan_the_database_location:"သိုလှောင်ရာနေရာကို စကင်ပါ",
Select_date_time:"ရက်စွဲနှင့် အချိန်ကို ရွေးချယ်ပါ",
please_select_stockId:"ဂိုဒေါင်ကို ရွေးချယ်ပါ",
please_select_stockzone:"ဇုန်ကို ရွေးချယ်ပါ",
please_select_shelf:"စင်ကို ရွေးချယ်ပါ",
Please_scan_sku:"SKU ကို စကင်ပါ",
please_select_auditUser:"သုံးသပ်သူကို ရွေးချယ်ပါ",
Storage_type:"ဝင်/ထွက် ပစ္စည်းအမျိုးအစား",
Billing_quantity:"စာရင်းသွင်းအရေအတွက်",
Cost_type:"ကြေးအမျိုးအစား",
frozenBillingDetails:"ငွေတောင်းခံမှုအသေးစိတ်ကို ရပ်ဆိုင်း",
storage_location_capacity:"သိုလှောင်ရာနေရာ စွမ်းရည်",
product_capacity:"ထုတ်ကုန်အသုံးပြုနိုင်မှု စွမ်းရည်",
recommendstorage_location_type:"အကြံပြုသိုလှောင်ရာနေရာ အမျိုးအစား",
Operational_query:"လုပ်ငန်းစဉ်မေးမြန်းချက်",
Please_scan_the_basket:"ဘတ်စကက်ကုဒ်ကို စကင်ပါ!",
The_number_of_shelves_cannot_be_greater_than_the_qualified_number:"သိုလှောင်အရေအတွက်သည် အတည်ပြုထားသောအရေအတွက်ထက် မကျော်ရ",
Whether_batch_shelves:"အစုလိုက်သိုလှောင်ခြင်း ဖွင့်ထားပါသလား?",
Please_select_the_same_warehouse_entry_form_to_submit:"တင်သွင်းရန်အတွက် တူညီသော ဂိုဒေါင်မှ လက်ခံမှတ်တမ်းကို ရွေးချယ်ပါ!",
The_database_bit_number_does_not_exist:"ဤသိုလှောင်ရာနေရာနံပါတ် မရှိပါ",
replacement_cost:"ကုန်ကျစရိတ် ပြန်လည်သတ်မှတ်",
Create_a_breakout_task:"အကောင်းဆုံးရောင်းအားရှိသော ထုတ်ကုန်တာဝန် ဖန်တီး",
Match_and_divide:"တစ်ပြိုင်နက်တွင် ခွဲဝေ ဖြန့်ချိ",
matchAndDivide:"တစ်ပြိုင်နက်တွင် ခွဲဝေ ဖြန့်ချိ",
Online_SKU_images:"အွန်လိုင်း SKU ပုံ",
Seller_SKU:"ရောင်းသူ SKU",
AbnormalRemarks:"မမှန်ကန်မှု မှတ်တမ်း",
Store_SKU:"ဆိုင် SKU",
Authorization_assignment:"ခွင့်ပြုချက် တာဝန်ပေးခြင်း",
Please_enter_the_AccessToken:"AccessToken ကို ထည့်ပါ",
Please_enter_the_RefreshToken:"RefreshToken ကို ထည့်ပါ",
APITokenInformation:"API token အချက်အလက်များ",
authorization_management:"ခွင့်ပြုချက် စီမံခန့်ခွဲမှု",
authorization_message:"ခွင့်ပြုချက် အသေးစိတ်",
companyName:"ကုမ္ပဏီအမည်",
Print_a_paper_distribution:"စာရွက်ပုံနှိပ် ကုန်ထုတ်စာရင်း",
Select_case_number:"ဘင်နံပါတ် ရွေးချယ်ပါ",
Starting_box_number:"စတင် ဘင်နံပါတ်",
End_box_number:"အဆုံး ဘင်နံပါတ်",
picker:"ကုန်ထုတ်သူ",
Pick_date:"ကုန်ထုတ်ရက်",
print_time:"ပုံနှိပ်ချိန်",
sku_quantity:"SKU အရေအတွက်",
Refill_slip_number:"ငွေပြန်အမ်း ဖြတ်တောက် အော်ဒါနံပါတ်",
Whether_to_cancel_supplementary_deduction:"ငွေပြန်အမ်း ဖြတ်တောက် ဖျက်သိမ်းမှု အတည်ပြုပါသလား?",
irredeemable:"ဖျက်သိမ်းမှုကို ထပ်မံ မပြုနိုင်ပါ။",
This_item_is_out_of_stock:"ဤပစ္စည်းအတွက် ပစ္စည်းမရှိပါ။",
The_repository_does_not_exist:"ဤဘင် တည်နေရာ မရှိပါ။",
flowingWaterInAndOutOfStorage:"ဝင်/ထွက် လုပ်ငန်းမှတ်တမ်း",
Generation_task_type:"တာဝန်အမျိုးအစား ဖန်တီးပါ",
View_the_default_log_of_the_initial_shipping_fee_for_modifying_the_purchase_price:"ဝယ်ယူစျေးနှုန်း မူလ သယ်ယူပို့ဆောင်ရေး မှတ်တမ်း ကြည့်ရှု/ပြင်ဆင်",
warehouseEntryControl:"လက်ခံ/ပြန်ပို့ ထိန်းချုပ်မှု",
Add_the_entry_ticket_control:"စနစ် ထိန်းချုပ်မှု ထည့်သွင်း",
Edit_entry_slip_control:"စနစ် ထိန်းချုပ်မှု တည်းဖြတ်",
Whether_to_open_excess_inspection:"အပို စစ်ဆေးမှု ဖွင့်မလား?",
Control_the_number_of_boxes_generated_during_inspection_tasks:"စစ်ဆေးရေး တာဝန် Bin ဖန်တီးမှု ထိန်းချုပ်",
Control_the_number_of_SKUs_generated_by_the_mount_task:"စင်တင် တာဝန် SKU မျိုးစုံ ဖန်တီးမှု ထိန်းချုပ်",
Create_entry_ticket_control:"စနစ် ထိန်းချုပ်မှု ဖန်တီး",
Enter_0_for_the_entire_build_task:"အမှာစာ အပြည့်အစုံ တာဝန် ဖန်တီးရန် 0 ထည့်ပါ",
Whether_To_return_the_package_to_take_photos:"ပြန်ပို့ပုံး ဓာတ်ပုံ ရိုက်ရန် လိုအပ်ပါသလား?",
Control_The_number_of_boxes_generated_for_a_quality_inspection_task_indicates_the_number_of_boxes_generated_when_a_worker_obtains_a_quality_inspection_task_Set_0_to_the_entire_generation_task:"အရည်အသွေးစစ်ဆေးရေးတာဝန်ထုတ်လုပ်မည့်အရေအတွက်ကို ထိန်းချုပ်ခြင်း။ အလုပ်သမားများသည် အရည်အသွေးစစ်ဆေးရေးတာဝန်များကို ထုတ်ယူသည့်အခါ ထုတ်လုပ်မည့် ဘောက်စ်အရေအတွက်။ အမှာစာတစ်ခုလုံးအတွက် တာဝန်များထုတ်လုပ်ရန် 0 ထည့်ပါ။",
Control_the_number_of_SKU_types_generated_for_the_shelf_task_to_the_number_of_SKU_types_generated_when_obtaining_the_shelf_task_Fill_in_0_for_the_entire_single_generation_task:"စင်တင်တာဝန် SKU ထုတ်လုပ်မည့်မျိုးစုံကို ထိန်းချုပ်ခြင်း။ အလုပ်သမားများသည် စင်တင်တာဝန်များကို ထုတ်ယူသည့်အခါ ထုတ်လုပ်မည့် SKU မျိုးစုံအရေအတွက်။ အမှာစာတစ်ခုလုံးအတွက် တာဝန်များထုတ်လုပ်ရန် 0 ထည့်ပါ။",
Whether_to_take_a_picture_of_the_return_is_whether_to_take_a_picture_of_the_package_when_the_return_receipt_is_received:"ပြန်ပို့ပုံးဓာတ်ပုံရိုက်ရန်လိုအပ်ခြင်း။ ပြန်ပို့အမှာစာများ လက်ခံသည့်အခါ ပုံးများဓာတ်ပုံရိုက်မလား မရိုက်မလား သတ်မှတ်ခြင်း။",
There_are_mandatory_fields_that_are_not_filled_in_Please_fill_them_in_and_try_again:"လိုအပ်သော ကွက်လပ်များ မပြည့်စုံပါ။ ကျေးဇူးပြု၍ ဖြည့်စွက်ပြီး ထပ်မံကြိုးစားပါ။",
inbound_and_return_control:"ဝင်ရောက်/ပြန်ပို့ ထိန်းချုပ်မှု",
Subaccount_management:"အကောင့်ခွဲ စီမံခန့်ခွဲမှု",
subaccountList:"အကောင့်ခွဲ စာရင်း",
Subaccount_number:"အကောင့်ခွဲ ID",
subaccount_name:"အကောင့်ခွဲ အမည်",
Please_enter_a_subaccount_name:"အကောင့်ခွဲအမည်ကို ထည့်ပါ။",
Add_a_subaccount:"အကောင့်ခွဲ ထည့်ရန်",
subAccountRoleInfo:"အကောင့်ခွဲ အချက်အလက်များ",
payment_type:"ငွေပေးချေမှု နည်းလမ်း",
Whether_to_terminate_services:"စီးပွားရေး ရပ်ဆိုင်းရန်",
Subaccount_role:"အကောင့်ခွဲ တာဝန်",
Please_add_product:"ထုတ်ကုန်များ ထည့်ပါ။",
An_empty_container_number_exists_Please_check_and_try_again:"မမှန်ကန်သော ဘောက်စ်နံပါတ်များ တွေ့ရှိရပါသည်။ ကျေးဇူးပြု၍ စစ်ဆေးပြီး ထပ်မံကြိုးစားပါ။",
An_empty_number_exists_Please_check_and_try_again:"အရေအတွက် မမှန်ပါ၊ ကျေးဇူးပြု၍ စစ်ဆေးပြီး ထပ်မံကြိုးစားပါ။",
Submit_success:"တင်သွင်းမှု အောင်မြင်ပါပြီ!",
cancellation_of_order:"အော်ဒါ ဖျက်ခြင်း",
Cancel_a_task:"တာဝန် ဖျက်ခြင်း",
Confirm_cancellation_of_order:"အော်ဒါ ဖျက်ခြင်း အတည်ပြုရန်",
Confirm_cancel_task:"တာဝန် ဖျက်ခြင်း အတည်ပြုရန်",
Order_operation:"အော်ဒါ လုပ်ငန်းစဉ်များ",
Cancel_an_order:"အော်ဒါ ဖျက်ခြင်း",
Undo_to_exception:"မမှန်ကန်သော အခြေအနေသို့ ဖျက်ခြင်း",
Undo_to_ungenerated:"မထုတ်လုပ်သေးသော အခြေအနေသို့ ဖျက်ခြင်း",
cancelOrder:"အော်ဒါ ဖျက်ခြင်း",
Please_enter_the_waybill_number_Only_100_waybills_are_supported_at_a_time_separated_by_line_breaks:"waybill နံပါတ်များကို တစ်ခါ တင်သွင်းလျှင် ၁၀၀ အထိသာ ခွင့်ပြုပါသည်။ တစ်ခုချင်းစီကို လိုင်းချိုး (line break) ဖြင့် ခွဲ၍ ထည့်ပါ။",
Order_cancellation_Pick_stock_please_return_the_stock_to_the_original_shelf_order_cancellation_directly_to_the_confirmation:"ရွေးယူခြင်း စတင်ပြီးသော အော်ဒါများအတွက် ရွေးယူထားသော ပစ္စည်းများကို ဖျက်ပါ။ ပစ္စည်းများကို မူလ စင်များသို့ ပြန်ထားပါ။ အော်ဒါများကို 'အတည်ပြုထားသည်' အခြေအနေသို့ တိုက်ရိုက် ဖျက်မည်။",
automaticProcessingRule:"အလိုအလျောက် ဆောင်ရွက်ခြင်း စည်းမျဉ်းများ",
Rule_name:"စည်းမျဉ်းအမည်",
Rule_type:"စည်းမျဉ်းအမျိုးအစား",
priority_level:"ဦးစားပေးမှု",
Rule_description:"စည်းမျဉ်းဖော်ပြချက်",
Rule_subitem:"စည်းမျဉ်း အပိုဒ်များ",
Modification_time:"ပြင်ဆင်ချိန်",
Modified_successfully:"ပြင်ဆင်မှု အောင်မြင်သည်",
content:"အကြောင်းအရာ",
Please_add_at_least_one_rule:"အနည်းဆုံး စည်းမျဉ်း တစ်ခု ထည့်ပါ။",
Please_select_the_rule_type_first:"ပထမဦးစွာ စည်းမျဉ်းအမျိုးအစားကို ရွေးပါ။",
Rule_detail:"စည်းကမ်းအသေးစိတ်",
sku_matching_mode:"SKU ကိုက်ညီစစ်ဆေးနည်း",
packing_type:"ထုပ်ပိုးပုံအမျိုးအစား",
Please_select_at_least_one_rule:"စည်းကမ်းအနည်းဆုံး တစ်ခု ရွေးချယ်ပါ",
Only_process_the_orders_that_have_been_pending_review_for_15_days_from_the_current_system_time_and_the_inventory_sufficient:"လက်ရှိစနစ်အချိန်မှ နောက်ဆုံး ၁၅ ရက်အတွင်း ထည့်သွင်းထားပြီး ပစ္စည်းလုံလောက်သော စစ်ဆေးရန် စောင့်ဆိုင်းနေသည့် အော်ဒါများကိုသာ ဆောင်ရွက်ပါ",
Customer_inquiry_Please_enter_only_numbers:"ဖောက်သည်မေးမြန်းချက်များအတွက် သန့်ရှင်းသော ဂဏန်းတန်ဖိုးများကိုသာ ထည့်သွင်းပါ",
listWarehouseRentalChargesDetail:"ဂိုဒေါင်ငှားခ ငွေတောင်းခံလွှာ အသေးစိတ်",
warehouseRentalBillSKUDetails:"ဂိုဒေါင်ငှားခ ငွေတောင်းခံလွှာ SKU အသေးစိတ်",
list_warehouse_rental_charges_detail:"ဂိုဒေါင်ငှားခ ငွေတောင်းခံလွှာ အသေးစိတ်",
Inventory_batch:"ပစ္စည်းအသေးစိတ်",
Upload_file_error_Upload_acsv_XLS_XLSX_file:"တင်သွင်းထားသော ဖိုင်တွင် အမှားရှိပါသည်! .CSV, .XLS, သို့မဟုတ် .XLSX ဖော်မတ်ဖြင့်သာ ဖိုင်များ တင်သွင်းပါ။",
There_are_unfinished:"မပြီးစီးသေးသော",
task:"အလုပ်များ",
Whether_to_process:"ဆက်လက်ဆောင်ရွက်မည်?",
chart_type:"ဇယားအမျိုးအစား",
Excluding_today:"ယနေ့ကို ထည့်တွက်မည်မဟုတ်",
rop_shipping_product_ranking_list:"ပို့ဆောင်ရန် စောင့်ဆိုင်းနေသော ထိပ်တန်းပစ္စည်းများ",
single_Product_Single_Order:"တစ်ပစ္စည်း တစ်အရေအတွက်",
single_Product_Multi_Order:"တစ်ပစ္စည်း အများအရေအတွက်",
singleProductMultiOrder:"တစ်ပစ္စည်း အများအရေအတွက်",
multi_Product_Multi_Order:"ပစ္စည်းအများ အများအရေအတွက်",
multiProductMultiOrder:"ပစ္စည်းအများ အများအရေအတွက်",
single_product_single_order_drop_shipping_product_quantity_ranking_list:"တစ်ခုချင်းစီ ပစ္စည်း ပို့ဆောင်ရန် စောင့်ဆိုင်းမှု အဆင့်သတ်မှတ်ခြင်း",
single_Product_Multi_Order_drop_shipping_product_quantity_ranking_list:"တစ်ခုချင်းစီ အများအပြား ပစ္စည်း ပို့ဆောင်ရန် စောင့်ဆိုင်းမှု အဆင့်သတ်မှတ်ခြင်း",
multi_product_Multi_order_drop_shipping_product_quantity_ranking_list:"အများအပြား ပစ္စည်းများ ပို့ဆောင်ရန် စောင့်ဆိုင်းမှု အဆင့်သတ်မှတ်ခြင်း",
to_do_task:"စောင့်ဆိုင်းနေသော တာဝန်များ",
value_added_services:"တန်ဖိုးတိုးပိုင်း ဝန်ဆောင်မှုများ",
The_timeout_is_set_to_a_certain_time:"အချိန်ကုန်ဆုံးချိန် သတ်မှတ်ချက်",
Recent_announcements:"နောက်ဆုံး ကြေညာချက်များ",
See_more:"ပိုမို ကြည့်ရှုရန်",
next:"နောက်တစ်ခု",
warehouseHolidayList:"ဂိုဒေါင် အများပြည်သူအားလပ်ရက်စာရင်း",
holidayDate:"အများပြည်သူအားလပ်ရက်ရက်စွဲများ",
overdueSetting:"ကျော်လွန်ချိန်ဆက်တင်များ",
overdueTime:"ကျော်လွန်ချိန်ကြာမြင့်မှု",
Import_warehouse_holidays:"ဂိုဒေါင် အများပြည်သူအားလပ်ရက်များ ထည့်သွင်းခြင်း",
overdue_Duration:"ကျော်လွန်ချိန်ကြာမြင့်မှု",
Warehouse_during_holidays:"ဂိုဒေါင် အများပြည်သူအားလပ်ရက်များ",
product_item_type:"ထုတ်ကုန် ပစ္စည်းအမျိုးအစား",
Update_the_product_diversion_number:"ထုတ်ကုန် စီစဉ်ခြင်း ID ကို အပ်ဒိတ်လုပ်ပါ",
Do_you_need_to_update_the_product_diversion_number:"ထုတ်ကုန် စီစဉ်ခြင်း ID ကို အပ်ဒိတ်လုပ်ပါ",
Priority_calculation_method:"နှစ်သက်ရာ တွက်ချက်နည်း",
formula_mode:"တွက်ချက်နည်း",
Add_range:"အကွာအဝေး ထည့်ပါ",
Add_the_maximum_range:"အများဆုံး အကွာအဝေး ထည့်ပါ",
The_input_range_for_addition_contains_null_values_Please_check_and_try_again:"ထည့်သွင်းထားသော အကွာအကွင်းတွင် null တန်ဖိုးများ ပါဝင်နေပါသည်။ ကျေးဇူးပြု၍ စစ်ဆေးပြီး ထပ်မံကြိုးစားပါ။",
Imported_part_type_rule_setting:"ပက်ကေ့ဂျ်အမျိုးအစား စည်းကမ်းချက်များ တင်သွင်းခြင်း",
set_type:"ဆက်တင်အမျိုးအစား",
calculation_type:"တွက်ချက်မှုအမျိုးအစား",
calculate_the_time_type:"တွက်ချက်မှုအချိန်အမျိုးအစား",
calculated_value:"တွက်ချက်မှုတန်ဖိုး",
overseas_warehouse_fees:"နိုင်ငံခြားဂိုဒေါင်ကြေးများ",
First_leg_fees:"အစပိုင်း ခရီးစရိတ်",
Days:"ရက်များ",
Month:"လများ",
Add_newly_developed_customers:"ဖောက်သည်အသစ် ဖွံ့ဖြိုးတိုးတက်ရေး ထည့်ရန်",
Delete_newly_developed_customers:"ဖောက်သည်အသစ် ဖွံ့ဖြိုးတိုးတက်ရေး ဖျက်ရန်",
Please_select_set_type:"ဆက်တင်အမျိုးအစားကို ရွေးချယ်ပါ။",
Please_select_calculation_type:"တွက်ချက်မှုအမျိုးအစားကို ရွေးချယ်ပါ။",
Please_select_calculate_the_time_type:"တွက်ချက်မှုအချိန်အမျိုးအစားကို ရွေးချယ်ပါ။",
Whether_to_use_the_strategy_of_new_order_volume_for_the_entire_month:"လတစ်လတာ အော်ဒါအသစ် ပမာဏ မဟာဗျူဟာကို အသုံးပြုပါ",
Please_enter_the_calculated_value:"တွက်ချက်မှု တန်ဖိုးကို ထည့်ပါ။",
The_calculated_value_must_be_greater_than_zero:"တွက်ချက်မှု တန်ဖိုးသည် 0 ထက် ကြီးရမည်",
When_the_time_type_is_month_the_value_cannot_exceed_twelve:"တွက်ချက်ချိန် အမျိုးအစားမှာ လ ဖြစ်သောအခါ၊ ဤတန်ဖိုးသည် 12 ထက် မကျော်နိုင်ပါ။",
The_month_corresponding_to_the_starting_time_obtained_from_the_calculation_type:"တွက်ချက်မှု အမျိုးအစားမှ ရရှိသော စတင်ရက်နှင့် ကိုက်ညီသည့် လအတွက်၊",
For_new_customers_this_will_no_longer_be_counted_after_this_month:"၎င်းကို ဖွံ့ဖြိုးလာသော ဖောက်သည်အသစ်အဖြစ် သတ်မှတ်မည်; ထိုလပြီးနောက်တွင် မတွက်တော့ပါ။",
The_time_type_is_month:"တွက်ချက်ချိန် အမျိုးအစားမှာ လ ဖြစ်ပါသည်:",
Using_the_strategy_of_total_monthly_new_orders_If_the_data_generation_time_is_the_1st_day:"လတစ်လတာ အသစ်အော်ဒါအရေအတွက် မဟာဗျူဟာ အသုံးပြုခြင်း: ဒေတာကို ၁ ရက်နေ့တွင် ထုတ်ယူပါက၊",
Even_if_the_entire_current_month_has_a_high_volume_of_new_customer_orders_if_this_is_the_case_for_any_other_days:"လက်ရှိလတစ်လလုံးကို အသစ်ဖောက်သည်အော်ဒါအရေအတွက်အဖြစ် တွက်ချက်မည်။ အခြားရက်များအတွက်၊",
The_number_of_new_development_customer_orders_will_be_available_from_the_start_date_until_the_end_of_next_month:"စတင်ရက်မှ နောက်လကုန်အထိကာလကို အသစ်ဖောက်သည်အော်ဒါအရေအတွက်အဖြစ် တွက်ချက်မည်။",
Unutilized_monthly_new_order_volume_strategy_For_the_month_for_which_the_starting_time_was_determined_based_on_the_calculation_type:"လတစ်လတာ အော်ဒါအသစ်အရေအတွက် မူဝါဒမပါဘဲ: တွက်ချက်မှုအမျိုးအစားမှ ရရှိသော စတင်ချိန်နှင့် ကိုက်ညီသည့် လအတွက်၊",
For_the_volume_of_new_customer_orders:"၎င်းကို ဖောက်သည်အသစ်အော်ဒါအရေအတွက်အဖြစ် တွက်ချက်သည်။",
The_time_type_for_calculation_is_in_days:"တွက်ချက်ချိန်အမျိုးအစားမှာ ရက်များဖြစ်သည်:",
The_start_and_end_times_are_calculated_by_adding_the_first_occurrence_time_of_the_corresponding_type_to_the_corresponding_calculated_value_in_days_months:"စတင်ချိန်နှင့် အဆုံးချိန်ကို သက်ဆိုင်ရာ အမျိုးအစား၏ ပထမဆုံးဖြစ်ပွားချိန်သို့ သက်ဆိုင်ရာ တွက်ချက်တန်ဖိုး (ရက်/လ) ကို ထည့်ပေါင်းခြင်းဖြင့် ရရှိသည်။",
For_example_The_calculation_type_is:"ဥပမာအားဖြင့်: တွက်ချက်မှုအမျိုးအစားသည်:",
Enter_into_inventory_set_the_time_type_to_days_and_the_calculation_value_to_15:"ဝင်လာသည့်အမှာစာများအတွက်၊ တွက်ချက်ချိန်အမျိုးအစားမှာ ရက် (Days) ဖြစ်ပြီး တွက်ချက်တန်ဖိုးမှာ ၁၅ ဖြစ်သည်",
Assuming_the_initial_listing_date_is_2025_11_01_then_the_number_of_new_customer_orders_would_be_2025_11_01_to_2025_11_15:"ပထမဆုံးစာရင်းတင်သည့်နေ့ကို ၂၀၂၅-၁၁-၀၁ ဟု ယူဆပါက၊ အသစ်ရောက်ရှိလာသော ဖောက်သည်အမှာစာအရေအတွက်အတွက် စတင်နှင့် အဆုံးသတ်ရက်များမှာ ၂၀၂၅-၁၁-၀၁ မှ ၂၀၂၅-၁၁-၁၅ အထိ ဖြစ်မည်။",
During_this_period_the_orders_that_were_dispatched_are_all_counted_as_the_sales_volume_for_new_customers:"ဤကာလအတွင်း ပို့ဆောင်သည့် အော်ဒါအားလုံးကို ဖောက်သည်အသစ်အော်ဒါအရေအတွက်တွင် တွက်ချက်ပါမည်။",
count_method:"တွက်ချက်နည်း",
Whether_to_automatically_generate_count_tasks:"တွက်ချက်လုပ်ငန်းတာဝန်များကို အလိုအလျောက် ဖန်တီးရန်",
Whether_to_freeze_inventory:"တွက်ချက်စဉ် ကုန်ပစ္စည်းကို ရပ်ဆိုင်းရန်",
whether_Difference_count:"ကွာခြားချက်တွက်ချက်မှု ပြုလုပ်ရန်",
count_setting:"တွက်ချက်ဆက်တင်များ",
When_there_is_an_count_surplus_or_count_deficit_the_next_round_of_count_tasks_will_be_generated_after_the_end_of_the_count_until_the_final_count:"ကုန်ပစ္စည်းပိုလွန်ခြင်း သို့မဟုတ် လျော့နည်းခြင်း ဖြစ်ပေါ်ပါက၊ နောက်ထပ်တွက်ချက်လုပ်ငန်းတာဝန်များကို တွက်ချက်ပြီးစီးသည်အထိ တွက်ချက်ပြီးနောက် ဖန်တီးမည်။",
Indicates_how_many_rounds_of_count_are_required_If_only_one_round_of_count_is_required_the_value_is_one_If_you_need_to_count_two_rounds_it_is_two_and_so_on:"လိုအပ်သည့် ပစ္စည်းရေတွက်အကြိမ်အရေအတွက်ကို ဖော်ပြသည်။ တစ်ကြိမ်တည်းအတွက် 1 ထည့်ပါ၊ နှစ်ကြိမ်အတွက် 2 ထည့်ပါ၊ စသည်ဖြင့်။",
Count_round:"ပစ္စည်းရေတွက်အကြိမ်များ",
max_count_round:"အများဆုံး ပစ္စည်းရေတွက်အကြိမ်များ",
The_types_of_count_tasks_are_divided_into_light_count_and_dark_count:"ပစ္စည်းရေတွက်တာဝန်အမျိုးအစားများကို ဖွင့်ထား (Open) သို့မဟုတ် မမြင်ဘဲ (Blind) ဟု ခွဲခြားထားသည်။",
If_the_light_count_is_selected_the_specific_number_of_SKU_inventory_to_be_counted_will_be_displayed_If_dark_count_is_selected_the_specific_number_of_SKU_inventory_to_be_counted_is_not_displayed:"Open Count ကိုရွေးချယ်ပါက၊ တွက်ချက်ရန်လိုအပ်သည့် SKU များ၏ တိကျသောအရေအတွက်များကို ပြသမည်; Blind Count ကိုရွေးချယ်ပါက၊ တွက်ချက်ရန်လိုအပ်သည့် SKU များ၏ တိကျသောအရေအတွက်များကို မပြသမည်။",
Whether_multiple_rounds_of_count_can_be_the_same_person:"တစ်ဦးတည်းသောပုဂ္ဂိုလ်သည် တွက်ချက်ခြင်းအကြိမ်အများကြီး ဆောင်ရွက်နိုင်မလား",
If_the_automatic_generation_of_count_tasks_is_not_enabled_the_task_to_be_counted_is_not_automatically_generated:"တွက်ချက်ရေးတာဝန်များကို အလိုအလျောက်ဖန်တီးခြင်းကို ပိတ်ထားပါက၊ စောင့်ဆိုင်းနေသော တွက်ချက်ရေးတာဝန်များကို အလိုအလျောက် မဖန်တီးပါ။",
If_you_need_to_restart_the_automatic_generation_of_the_count_task_the_time_of_the_automatic_generation_of_the_count_task_will_start_in_the_morning_of_the_next_day:"အလိုအလျောက် တာဝန်ဖန်တီးခြင်းကို ပြန်လည်ဖွင့်ပါက တာဝန်ဖန်တီးရန် ရေတွက်ချိန်သည် နောက်နေ့ ညနေ ၁၂ နာရီမှ စတင်မည်။",
count_methods_are_divided_into_SKU_count_and_count_by_warehouse_location:"စာရင်းစစ်နည်းများကို SKU အခြေပြုခြင်းနှင့် တည်နေရာအခြေပြုခြင်း ဟု ခွဲခြားထားသည်။",
According_to_the_SKU_count_all_the_storage_locations_that_have_this_SKU_stock_will_be_counted_and_only_the_time_of_the_last_SKU_count_will_be_updated:"SKU အခြေပြုခြင်းဖြင့် ထို SKU အတွက် စတော့ရှိသည့် တည်နေရာအားလုံးကို စစ်ဆေးကာ SKU ၏ နောက်ဆုံးရေတွက်ချိန်ကိုသာ အပ်ဒိတ်လုပ်မည်။",
If_the_count_is_taken_by_warehouse_location_all_SKUs_with_inventory_in_the_warehouse_location_will_be_counted_and_only_the_last_count_time_of_the_warehouse_location_will_be_updated:"တည်နေရာအခြေပြု စတော့စာရင်းပြုလုပ်သည့်အခါ၊ ထိုတည်နေရာတွင် စတော့ရှိသည့် SKU အားလုံးကို တွက်ချက်မည်ဖြစ်ပြီး၊ ထိုတည်နေရာအတွက် နောက်ဆုံးမှတ်တမ်းတင်ထားသည့် စတော့စာရင်းချိန်ကိုသာ အပ်ဒိတ်လုပ်မည်ဖြစ်သည်။",
Subtract_the_last_SKU_or_warehouse_count_time_according_to_the_current_days_find_the_qualified_data_and_generate_the_count_task:"လိုအပ်ချက်များနှင့် ကိုက်ညီသည့် ဒေတာကို SKU/တည်နေရာအတွက် နောက်ဆုံးမှတ်တမ်းတင်ထားသည့် စတော့စာရင်းချိန်ကို လက်ရှိ ရက်အရေအတွက်မှ ဖြုတ်၍ ရှာဖွေပြီး၊ ထိုအရ စတော့စာရင်းလုပ်ငန်းတာဝန်များကို ဖန်တီးမည်ဖြစ်သည်။",
The_cycle_of_the_count_task_is_automatically_generated:"အလိုအလျောက် စတော့စာရင်းလုပ်ငန်းတာဝန် ဖန်တီးခြင်း စက်ဝိုင်း",
Indicates_how_many_count_details_exist_in_an_automatic_count_task:"အလိုအလျောက် စတော့စာရင်းလုပ်ငန်းစဉ်တစ်ခုအတွင်း ပါဝင်သည့် စတော့အသေးစိတ်အရေအတွက်ကို ဖော်ပြသည်။",
For_example_if_the_task_method_is_SKUs_and_the_number_of_automatically_generated_tasks_for_library_locations_and_SKUs_is_ten_the_count_details_contain_10_different_SKUs:"ဥပမာ: စတော့နည်းလမ်းအဖြစ် SKU ကို အသုံးပြုပြီး အလိုအလျောက် ဖန်တီးထားသော လုပ်ငန်းစဉ်အရေအတွက် (တည်နေရာ/SKU) သည် 10 ဖြစ်ပါက၊ စတော့အသေးစိတ်တွင် ထူးခြားသည့် SKU 10 ခု ပါဝင်မည်။",
Automatic_generation_task:"အလိုအလျောက် ဖန်တီးထားသော လုပ်ငန်းစဉ်များ",
check_log:"မှတ်တမ်းကြည့်ရန်",
Not_less_than_two:"2 ထက် မနည်းရ",
Quantity_of_need_to_counted:"လိုအပ်သည့် ရေတွက်အရေအတွက်",
Quantity_of_actually_count:"လက်တွေ့ ရေတွက်အရေအတွက်",
Quantity_of_wait_to_count:"စောင့်ဆိုင်းနေသည့် ရေတွက်အရေအတွက်",
Quantity_of_count_loss:"လျော့နည်းအရေအတွက်",
Quantity_of_count_profit:"ပိုလျံအရေအတွက်",
task_number:"လုပ်ငန်း ID",
finally:"နောက်ဆုံး",
execution_time_of_count:"စာရင်းစစ်ဆောင်ရွက်ချိန်",
executor_of_count:"စာရင်းစစ်ဆောင်ရွက်သူများ",
execute_count:"စာရင်းစစ်ဆောင်ရွက်ခြင်း",
check_count_details:"စာရင်းစစ်အသေးစိတ်ကြည့်ရှုခြင်း",
The_total:"စုစုပေါင်း",
Need_to_count_rounds:"လိုအပ်သော စစ်ဆေးပတ်များ",
current_count_rounds:"လက်ရှိ စစ်ဆေးပတ်",
counter:"စာရင်းစစ်ကိရိယာ",
quantity_of_occupy_stock:"သိမ်းဆည်းထားသော ပစ္စည်းအရေအတွက်",
quantity_of_disabled_stock:"မရရှိနိုင်သော ပစ္စည်းအရေအတွက်",
storage_location_final_count_time:"တည်နေရာအတွက် နောက်ဆုံးစာရင်းစစ်ချိန်",
product_final_count_time:"ပစ္စည်းအတွက် နောက်ဆုံးစာရင်းစစ်ချိန်",
Manually_generate_count_task:"စာရင်းစစ်တာဝန်ကို လက်ဖြင့် ဖန်တီးခြင်း",
Designated_counter:"စာရင်းစစ်ကိရိယာ သတ်မှတ်ခြင်း",
Data_from_different_warehouses_exists_Ensure_that_the_selected_data_belongs_to_the_same_warehouse:"ဂိုဒေါင်အမျိုးမျိုးမှ ဒေတာများ ရှိနေပါသည်။ ရွေးထားသော ဒေတာသည် တစ်ခုတည်းသော ဂိုဒေါင်မှ ဖြစ်ကြောင်း အတည်ပြုပါ။",
The_warehouse_is_not_set_for_count_please_set_for_count_first:"ဤဂိုဒေါင်အတွက် ပစ္စည်းစာရင်းဆက်တင်များ မပြင်ဆင်ထားပါ။ ပထမဦးစွာ ပစ္စည်းစာရင်းဆက်တင်များကို ပြင်ဆင်ပါ။",
please_add_data_first:"ပထမဦးစွာ ဒေတာ ထည့်ပါ။",
count_task_number:"ပစ္စည်းစာရင်း လုပ်ငန်းတာဝန် ID",
stock_batch:"ပစ္စည်းစာရင်း အစု",
stock_batch_ID:"ပစ္စည်းစာရင်း အစု ID",
stock_batch_Num:"ပစ္စည်းစာရင်း အစု အရေအတွက်",
Number_of_quarantined_shelves:"သီးခြားထားသော စင်ပေါ်ထားရှိမှု အရေအတွက်",
Original_batch_shelf_time:"မူရင်း အစု စင်ပေါ်ထားရှိချိန်",
Isolated_storage_location:"သီးခြားထားသော တည်နေရာ",
Whether_the_inventory_is_out_of_storage_location:"တည်နေရာမပါသော ပစ္စည်းစာရင်း",
Isolation_shelf_time:"သီးခြားထားသော စင်တင်ချိန်",
Quarantine_inventory_shelving_task_number:"သီးခြားထားသော စင်လုပ်ငန်းတာဝန် ID",
Mission_start_shelf_time:"လုပ်ငန်းတာဝန် စတင် စင်တင်ချိန်",
Mission_completed_shelf_time:"လုပ်ငန်းတာဝန် ပြီးဆုံး စင်တင်ချိန်",
Task_remarks:"လုပ်ငန်းတာဝန် မှတ်ချက်များ",
Original_storage_location:"မူလ တည်နေရာ",
Isolation_shelf_space:"သီးခြားထားသော စင် တည်နေရာ",
Complete_the_task:"လုပ်ငန်းတာဝန် ပြီးဆုံး",
Fetch_task:"လုပ်ငန်းတာဝန် ပြန်ယူ",
Complete_this_round_of_tasks:"လက်ရှိ ပတ်လည် ပြီးဆုံး",
Current_total_stock:"လက်ရှိ စုစုပေါင်း ပစ္စည်းအရေအတွက်",
Real_time:"အချိန်နှင့်တပြေးညီ",
Task_rotation:"လုပ်ငန်းတာဝန် ပတ်လည်",
Add_non_existing_stock_in_storage_location:"မရှိသေးသော တည်နေရာ ပစ္စည်း ထည့်သွင်း",
count_loss_reason:"ပစ္စည်း လျော့နည်းခြင်း အကြောင်းရင်း",
count_loss_remark:"ပစ္စည်း လျော့နည်းခြင်း မှတ်ချက်များ",
count_loss_type:"ပစ္စည်း လျော့နည်းခြင်း အမျိုးအစား",
Defective_product:"စံမပြည့်",
lack:"ပျောက်ဆုံး",
Current_stock:"လက်ရှိစာရင်း",
Inventory_quantity_at_the_end_of_the_last_round:"ယခင်အကြိမ်အဆုံးစာရင်းအရေအတွက်",
Quantity_of_actually_count_of_last_round_count:"ယခင်အကြိမ်မှ တကယ့်ရေတွက်အရေအတွက်",
Quantity_of_count_profit_of_last_round_count:"ယခင်အကြိမ်မှ ကျန်ရှိအရေအတွက်",
Quantity_of_count_loss_of_last_round_count:"ယခင်အကြိမ်မှ လျော့နည်းအရေအတွက်",
End_time_of_last_round_count:"ယခင်အကြိမ်ရေတွက်ပြီးဆုံးချိန်",
count_checked_and_no_problem_stock:"စာရင်းမှန်ကန်ကြောင်းအတည်ပြု",
Missing_or_damaged_quantity:"ပျောက်ဆုံး/ပျက်စီးအရေအတွက်",
The_amount_that_exceeds_the_real_time_current_inventory:"လက်ရှိစာရင်းထက် ကျော်လွန်နေသောအရေအတွက် (တကယ့်အချိန်)",
Whether_the_real_time_current_inventory_is_different_from_the_Inventory_quantity_at_the_end_of_the_last_round:"လက်ရှိစာရင်း (တကယ့်အချိန်) သည် ယခင်အကြိမ်အဆုံးစာရင်းနှင့် ကွာခြားပါသလား",
Please_complete_the_current_task_first:"လက်ရှိလုပ်ဆောင်ချက်ကို အရင်ဆုံး ပြီးမြောက်ပါ။",
The_storage_location_does_not_exist_or_has_been_completed:"ဤသိုလှောင်ရာနေရာ မရှိပါ သို့မဟုတ် ပြီးစီးသွားပါပြီ",
The_bar_code_does_not_exist_or_has_been_completed:"ဤထုတ်ကုန် ဘားကုဒ် မရှိပါ သို့မဟုတ် ပြီးစီးသွားပါပြီ",
Please_scan_the_storage_location_and_scan_the_product_bar_code_and_enter_the_quantity_of_actually_count:"အရင်ဆုံး သိုလှောင်ရာနေရာနှင့် ထုတ်ကုန် ဘားကုဒ်ကို စကင်ပြီးနောက် တကယ့်ရေတွက်အရေအတွက်ကို ထည့်ပါ။",
Cancel_count_task:"စာရင်းလုပ်ငန်းတာဝန်ကို ဖျက်ရန်",
count_details:"စာရင်းအသေးစိတ်",
count_log:"စာရင်းမှတ်တမ်း",
Confirm_whether_to_cancel_the_count_task:"စာရင်းလုပ်ငန်းတာဝန် ဖျက်သိမ်းမှု အတည်ပြုရန်",
countSetting:"စာရင်းဆက်တင်များ",
stockStorageLocationList:"ကုန်ပစ္စည်းထားရှိရာနေရာစာရင်း",
countTaskList:"စာရင်းလုပ်ငန်းတာဝန်စာရင်း",
countTask:"စာရင်းလုပ်ငန်းတာဝန်",
IsolatedStorageLocationList:"သီးကွပ်ထားသောနေရာစာရင်း",
isolatedShelfTaskList:"သီးကွပ်ထားသော စင်လုပ်ငန်းတာဝန်စာရင်း",
isolatedShelfTask:"သီးကွပ်ထားသော စင်လုပ်ငန်းတာဝန်",
pendingClaimList:"ပြန်လည်ထုတ်ပေးရန် စောင့်ဆိုင်းနေသည်",
countDetails:"စာရင်းအသေးစိတ်",
Please_scan_the_storage_location:"အရင်ဆုံး နေရာကို စကင်ပေးပါ",
please_confirm_exist_storage_location_data_first:"နေရာဒေတာ ရှိကြောင်း အတည်ပြုပါ",
Isolated_storage_location_listing_task_number:"သီးကွပ်ထားသောနေရာ စင်လုပ်ငန်းတာဝန် ID",
task_start_time:"လုပ်ငန်းတာဝန် စတင်ချိန်",
task_end_time:"လုပ်ငန်းတာဝန် ပြီးဆုံးချိန်",
Whether_the_inventory_is_not_in_the_original_storage_location:"ဤသည် မူရင်းမဟုတ်သော တည်နေရာရှိ ပစ္စည်းလား?",
The_actual_number_of_products_on_shelves:"တကယ်တမ်း စင်ပေါ်ထားရှိသော ပစ္စည်းအရေအတွက်",
the_time_that_product_listing_to_the_isolated_storage_location:"ထုတ်ကုန်ကို သီးခြားထားသော တည်နေရာသို့ ထားရှိခဲ့သည့် အချိန်",
Please_scan_the_Original_storage_location:"မူရင်းတည်နေရာကို အရင်ဆုံး စကင်ပါ",
please_confirm_exist_Original_storage_location_data_first:"မူရင်းတည်နေရာ ဒေတာ ရှိကြောင်း အတည်ပြုပါ",
this_task_is_completed:"ဤတာဝန်သည် ပြီးစီးပြီး အခြေအနေတွင် ရှိပါသည်",
the_storage_location_do_not_exist_or_is_not_isolated_storage_location:"ဤတည်နေရာ မရှိပါ သို့မဟုတ် သီးခြားထားသော တည်နေရာ မဟုတ်ပါ",
Whether_to_force_the_task_to_complete:"တာဝန်ကို အတင်းအကျပ် ပြီးစီးစေမလား?",
The_inventory_has_been_counted_to_the_last_product_and_the_count_task_is_to_be_finished_Is_it_confirmed_that_it_is_completed:"နောက်ဆုံးပစ္စည်းကို ရေတွက်ပြီးပါပြီ၊ ပစ္စည်းစာရင်းတာဝန် ပြီးစီးတော့မည်။ ပြီးစီးကြောင်း အတည်ပြုမည်လား?",
unoccupied_quantity:"ခွဲဝေမထားသေးသော ပမာဏ",
occupied_quantity:"ခွဲဝေထားသော ပမာဏ",
return_order:"ပြန်ပို့မှတ်တမ်း",
manual_entry_and_exit:"လက်ဖြင့် ထည့်/ထုတ်",
Shifting_storage_location:"ဘင် ပြောင်းရွှေ့",
Shifting_warehouse:"ဂိုဒေါင် ပြောင်းရွှေ့",
can_no_be_zero:"သုည မဖြစ်နိုင်",
When_this_feature_is_enabled_customers_will_not_be_able_to_use_this_inventory_to_submit_orders_during_the_count:"ပစ္စည်းစာရင်း စစ်ဆေးနေစဉ် ဖောက်သည်များမှ ဤပစ္စည်းကို အော်ဒါတင်ရန် မအသုံးပြုနိုင်စေရန် ဤလုပ်ဆောင်ချက်ကို ဖွင့်ပါ။",
Will_not_be_able_to_operate_this_inventory:"ဤပစ္စည်းကို လုပ်ငန်းဆောင်တာများအတွက် အသုံးမပြုနိုင်တော့ပါ။",
If_the_whether_Difference_count_is_equal_yes_the_count_rounds_default_is_two_and_it_cannot_be_less_than_two:"ကွာဟချက်ရေတွက်မှုသည် စတော့စာရင်းစက်ဝိုင်းရေတွက်မှုနှင့် တူညီပါက၊ မူလတန်ဖိုးသည် 2 ဖြစ်ပြီး 2 ထက်နည်း၍ မရနိုင်ပါ။",
It_is_used_to_control_the_maximum_count_rounds_when_there_is_a_difference_in_count_quantity:"ကွာဟချက်များဖြစ်ပေါ်သောအခါ အများဆုံး စတော့စာရင်းစက်ဝိုင်းရေတွက်မှုကို ထိန်းချုပ်ရန် အသုံးပြုသည်",
modifiable:"ပြင်ဆင်နိုင်သည်",
When_there_is_no_difference_it_is_the_final_count_round:"ကွာဟချက်များ မဖြစ်ပေါ်ပါက၊ ဤသည်မှာ နောက်ဆုံး စတော့စာရင်းစက်ဝိုင်းရေတွက်မှု ဖြစ်သည်",
whether_the_profit_is_isolated_from_the_warehouse_on_the_shelf:"ကျန်ရှိသော စတော့များကို သီးခြားထားသော နေရာများတွင် ထားရှိမလား",
uncounted:"မရေတွက်ပါ",
Have_counted:"ရေတွက်ပါ",
whether_Difference:"ကွာဟချက်များ ရှိမရှိ",
inventory_position_has_not_been_counted_in_recent_N_days:"နောက်ဆုံး N ရက်အတွင်း မတွက်သွင်းသော ပစ္စည်းတည်နေရာများ",
goods_have_not_been_counted_in_recent_N_days:"နောက်ဆုံး N ရက်အတွင်း မတွက်သွင်းသော ပစ္စည်းများ",
Total_quantity_of_goods_in_warehouse:"ဂိုဒေါင်ရှိ ပစ္စည်းစုစုပေါင်း အရေအတွက်",
goods_type_quantity:"ပစ္စည်းအမျိုးအစား အရေအတွက်",
Whether_the_inventory_loss_is_not_available_for_storage:"ပစ္စည်းမလုံလောက်မှုများကို မရနိုင်သော တည်နေရာများတွင် ထားရှိမလား",
Unavailable_library_positions:"မရနိုင်သော တည်နေရာများ",
When_the_unavailable_storage_location_is_selected_for_shelving_the_inventory_of_goods_that_are_in_short_supply_during_the_inventory_check_will_be_automatically_shelved_to_the_unavailable_storage_location:"မရနိုင်သော တည်နေရာများတွင် ထားရန်' ကို ရွေးချယ်ထားပါက၊ ပစ္စည်းစာရင်းတွက်စဉ်ကာလအတွင်း မလုံလောက်သော ပစ္စည်းများကို အလိုအလျောက် မရနိုင်သော တည်နေရာများတွင် ထားရှိမည်။",
When_the_inventory_counting_settings_select_this_item_as_yes_executing_the_final_inventory_counting_if_there_is_a_profit_will_generate_an_isolated_shelving_task_and_move_the_profit_goods_to_the_isolated_library_position:"စာရင်းသွင်းဆက်တင်များတွင် ဤဆက်တင်ကို ဟုတ် ဟု ရွေးချယ်ထားပါက၊ နောက်ဆုံးစာရင်းတွက်ချက်မှုပြီးနောက် ကျော်လွန်ပစ္စည်းတွေ့ရှိပါက၊ ကျော်လွန်ပစ္စည်းများကို သီးခြားသိုလှောင်ရာနေရာသို့ ရွှေ့ရန် သီးခြားသိုလှောင်ခြင်းတာဝန်တစ်ခု ဖန်တီးမည်။",
When_the_inventory_counting_settings_select_this_item_as_no_executing_the_final_inventory_counting_if_there_is_a_profit_will_directly_correct_the_real_time_inventory_and_move_the_profit_goods_to_the_normal_inventory:"စာရင်းသွင်းဆက်တင်များတွင် ဤဆက်တင်ကို မဟုတ် ဟု ရွေးချယ်ထားပါက၊ နောက်ဆုံးစာရင်းတွက်ချက်မှုပြီးနောက် ကျော်လွန်ပစ္စည်းတွေ့ရှိပါက၊ လက်ရှိစာရင်းကို တိုက်ရိုက်ပြင်ဆင်မည်ဖြစ်ပြီး၊ ကျော်လွန်ပစ္စည်းများကို ပုံမှန်စာရင်းသို့ ချိန်ညှိမည်။",
There_are_no_unavailable_locations_in_the_current_warehouse_so_if_you_need_to_set_them_go_to_Add_them_first:"ဤသိုလှောင်ခန်းတွင် လက်ရှိတွင် မရောက်နိုင်သော သိုလှောင်ရာနေရာများ မရှိပါ။ ဖွဲ့စည်းရန်၊ အောက်ပါအရာများကို ထည့်ပါ။",
isolated_storage_location_down:"သီးကွပ်သိုလှောင်ရာနေရာ ဖယ်ရှားခြင်း",
isolated_storage_unit_no:"သီးကွပ်သိုလှောင်ရာနေရာ ID",
isolated_storage_unit_quantity:"သီးကွပ်သိုလှောင်ရာနေရာ ပမာဏ",
no_such_storage_unit_in_warehouse:"ဤသိုလှောင်ရာနေရာ ID သည် ဤသိုလှောင်ခန်းတွင် မရှိပါ။",
cannot_exceed_isolated_quantity:"သီးကွပ်သိုလှောင်ရာနေရာ ပမာဏကို မကျော်လွန်နိုင်ပါ။",
Inventory_cannot_be_removed_from_the_shelves:"မရောက်နိုင်သော ပစ္စည်းစာရင်း ဖယ်ရှားခြင်း",
The_quantity_cannot_be_empty_and_must_be_a_number:"ပမာဏသည် ဗလာမဖြစ်နိုင်ဘဲ ဂဏန်းဖြစ်ရမည်။",
Can_only_be_a_positive_integer:"အပေါင်းဂဏန်းတစ်ခုသာ ဖြစ်ရမည်။",
Confirm_recount:"ပြန်လည်တွက်ချက်မှု အတည်ပြုရန်",
Take_stock_again:"ပြန်လည်တွက်ချက်ခြင်း",
At_the_end_of_the_final_inventory_round_the_quantity_of_stock_exceeded_expectations:"နောက်ဆုံးရေတွက်စက်လည်ပတ်မှုပြီးဆုံးချိန်တွင် စတော့အရေအတွက်သည် ခန့်မှန်းချက်ထက် ကျော်လွန်နေခြင်း",
At_the_end_of_the_final_inventory_round_the_quantity_of_missing_or_defective_stock:"နောက်ဆုံးရေတွက်စက်လည်ပတ်မှုပြီးဆုံးချိန်တွင် စတော့အရေအတွက် လျော့နည်းနေခြင်း သို့မဟုတ် အရည်အသွေးမပြည့်မီအဖြစ် သတ်မှတ်ခံရခြင်း",
Actual_inventory_quantity_at_the_end_of_the_final_counting_round:"နောက်ဆုံးရေတွက်စက်လည်ပတ်မှုပြီးဆုံးချိန်တွင် တကယ့် စတော့အရေအတွက်",
Round_Start_Time:"စက်လည်ပတ်မှု စတင်ချိန်",
Round_End_Time:"စက်လည်ပတ်မှု ပြီးဆုံးချိန်",
Whether_to_independently_choose_the_inventory_execution_method:"စတော့ရေတွက်ဆောင်ရွက်နည်းကို အလိုအလျောက် ရွေးချယ်မလား",
Select_inventory_execution_method:"စတော့ရေတွက်ဆောင်ရွက်နည်းကို ရွေးချယ်ပါ",
Directly_deduct_from_inventory:"စတော့ကို တိုက်ရိုက် လျော့ချခြင်း",
Place_on_unavailable_storage_location:"မရနိုင်သောနေရာ ပြန်ဖြည့်ခြင်း",
When_the_inventory_setting_is_selected_as_Yes_during_inventory_execution_if_there_is_a_loss_in_quantity_you_can_choose_whether_to_directly_deduct_from_inventory_or_shelve_in_unavailable_locations:"ဤဆက်တင်ကို ဟုတ် ဟု ရွေးချယ်ထားပါက၊ ပစ္စည်းစာရင်းစစ်ဆေးမှု ဆောင်ရွက်စဉ်တွင် ပစ္စည်းမလုံလောက်မှုများ ဖြစ်ပေါ်ပါက၊ သင်သည် ပစ္စည်းကို တိုက်ရိုက် လျော့ချခြင်း သို့မဟုတ် အသုံးမပြုနိုင်သော စင်များပေါ်တွင် ထားခြင်း ဟူ၍ ကိုယ်တိုင် ရွေးချယ်နိုင်ပါသည်။",
viewOrderProcessingFee:"အော်ဒါ လုပ်ငန်းစဉ်ကြေးများ ကြည့်ရှုခြင်း",
goods_ranking_list:"ထုတ်ကုန် အဆင့်သတ်မှတ်ချက်များ",
Bar_chart:"ဘားဇယား",
weeks:"အပတ်စဉ်",
hot:"အကောင်းဆုံး ရောင်းအားရှိသော",
unsalable:"ရောင်းအားနည်းသော",
Line_chart:"လိုင်းဇယား",
Total_account_balance:"စုစုပေါင်း အကောင့်ငွေလက်ကျန်",
Account_balance:"အကောင့်ငွေလက်ကျန်",
Number_of_authorized_stores:"ခွင့်ပြုထားသော ဆိုင်အရေအတွက်",
Number_of_authorized_expired_stores:"ခွင့်ပြုချက် သက်တမ်းကုန်ဆုံးထားသော ဆိုင်အရေအတွက်",
Time_period:"ကာလ",
Sales_volume:"ထုတ်ကုန်ရောင်းအား",
Commodity_inventory:"ထုတ်ကုန်လက်ကျန်",
Commodity_inventory_storage_location:"ထုတ်ကုန်လက်ကျန် (တည်နေရာအလိုက်)",
You_have_an_expired_license_store_to_deal_with:"သက်တမ်းကုန်ဆုံးထားသေးပြီး ဆက်လက်ဆောင်ရွက်ရန် စောင့်ဆိုင်းနေသော ဆိုင်များ ရှိပါသည်",
years:"နှစ်",
Historical_announcemen:"သမိုင်းကြောင်း ကြေညာချက်များ",
This_year:"ဒီနှစ်",
Number_of_squares:"စတုရန်းမီတာ",
shipment:"ပို့ဆောင်မှုများ",
Release_time:"ထုတ်လွှင့်ရက်",
Frozen_balance:"ခဲယဉ်းငွေလက်ကျန်",
Frozen:"ခဲယဉ်း",
Store_shipment:"ဆိုင်ပို့ဆောင်မှုများ",
is_total_orders_click_on_the_detailed_data_to_view_the_order_list:"စုစုပေါင်း အော်ဒါအရေအတွက်။ အသေးစိတ်ဒေတာကို နှိပ်၍ အော်ဒါစာရင်း ကြည့်ရှုနိုင်ပါသည်။",
Real_time_total_orders_of_the_day_click_on_the_detailed_data_to_view_the_storage_order_list:"ယနေ့အတွက် အချိန်နှင့်တပြေးညီ စုစုပေါင်း အော်ဒါအရေအတွက်။ အသေးစိတ်ဒေတာကို နှိပ်၍ ဂိုဒေါင်အော်ဒါစာရင်းကို ကြည့်ရှုနိုင်ပါသည်။",
Created_nearly_seven_days_ago:"နောက်ဆုံး ၇ ရက်အတွင်း ဖန်တီးထားသည်။",
Warehouse_order:"ဂိုဒေါင်အော်ဒါများ",
Does_not_include_today_is_sales:"ယနေ့ရောင်းအား မပါဝင်ပါ။",
Pie_chart:"ပိုင်ချတ်",
This_week:"ဒီအပတ်",
Current_month:"ဒီလ",
Unread_announcement:"မဖတ်သေးသော ကြေညာချက်များ",
months:"လ",
main_account:"အဓိကအကောင့်",
head_entry:"ဝင်လာမည့် ပို့ဆောင်မှု လက်ခံရရှိမှု",
First_Leg_Order:"ဝင်လာမည့် ပို့ဆောင်မှုများ",
exception_First_Leg_Order:"မမှန်ကန်သော ဝင်လာမည့် ပို့ဆောင်မှုများ",
In_the_stock_shelves:"လက်ခံခြင်းနှင့် စင်တင်ခြင်း ဆောင်ရွက်နေဆဲ",
Hello_welcome_to_use_estp_oms:"မင်္ဂလာပါ၊ Yisufei OMS သို့ ကြိုဆိုပါသည်။",
Hello_welcome_to_use_Hyperdimensional_OMS:"မင်္ဂလာပါ၊ Chaowei IoT OMS သို့ ကြိုဆိုပါသည်။",
customer_number:"ဖောက်သည် ID",
Top_up_immediately:"ယခုငွေဖြည့်ရန်",
Sales_Volume:"အရောင်းပမာဏ",
Data_last_updated:"ဒေတာနောက်ဆုံးအပ်ဒိတ်လုပ်သည့်အချိန်",
Beijing_time:"ဘေဂျင်းအချိန်",
obligation_first_leg_order:"ငွေပေးချေမှုစောင့်ဆိုင်းနေသည့် ထွက်ပို့အော်ဒါများ",
Total_square_inventory:"စုစုပေါင်းကုန်ပစ္စည်းထုထည် (ကော်ဘစ်မီတာ)",
go:"ဆက်လက်ရန်",
Temporarily_unavailable_please_contact_the_administrator:"ယာယီမရနိုင်ပါ။ သင့်အုပ်ချုပ်သူထံဆက်သွယ်ပါ။",
The_operation_succeeds_and_The_data_is_refreshed_successfully:"လုပ်ငန်းစဉ်အောင်မြင်ပါပြီ။ ဒေတာကိုအောင်မြင်စွာ ပြန်လည်အသစ်ပြုလုပ်ထားပါပြီ။",
number_of_SKU:"SKU မျိုးစုံအရေအတွက်",
Exclusive_Investment_Promotion:"အထူး စီးပွားရေးဖွံ့ဖြိုးတိုးတက်ရေး",
Exclusive_customer_service:"အထူး ဖောက်သည်ထောက်ပံ့ရေး",
inventory_all_quantity:"စုစုပေါင်းကုန်ပစ္စည်းအရေအတွက်",
Total_number_inventory_in_transit:"သယ်ယူပို့ဆောင်နေသည့် စုစုပေါင်းကုန်ပစ္စည်း",
Order_out_today:"ယနေ့အော်ဒါပမာဏ",
Order_out_today_yesterday:"မနေ့ကအော်ဒါပမာဏ",
Timeout_failed_to_complete_the_task:"ကာလကျော်ပြီး တာဝန်များ",
Overdue_order:"ကျော်လွန်နေသော အော်ဒါများ",
Warehousing_order:"လက်ခံရရှိထားသော အော်ဒါများ",
Quantity_of_goods_in_stock_today:"ယနေ့ လက်ခံရရှိပြီး စင်ပေါ်ထားသော အော်ဒါများ",
Number_of_SKUs_in_storage_today:"ယနေ့ လက်ခံရရှိပြီး စင်ပေါ်ထားသော SKU များ",
Return_order:"ပြန်ပို့ထားသော အော်ဒါများ",
Order_quantity_of_return_today:"ယနေ့ ပြန်ပို့ပြီး စင်ပေါ်ထားသော အော်ဒါများ",
Number_of_SKUs_returned_today:"ယနေ့ ပြန်ပို့ပြီး စင်ပေါ်ထားသော SKU များ",
First_billing:"ပထမအဆင့် ငွေတောင်းခံလွှာများ",
unaudited_customer_number:"ဖောက်သည်အတည်ပြုရန် စောင့်ဆိုင်းနေခြင်း",
toBePaidOrderList:"ငွေပေးချေရန် စောင့်ဆိုင်းနေသော အော်ဒါများ",
toBePaid:"ငွေပေးချေရန် စောင့်ဆိုင်းနေခြင်း",
Whether_the_product_is_sold_or_not_will_be_calculated_every_day_if_not_the_number_of_unsalable_days_will_be_added_by_one_and_if_there_is_the_number_of_unsalable_days_will_be_reset_to_zero:"ထုတ်ကုန်ရောင်းအားအခြေအနေကို နေ့စဉ်တွက်ချက်ခြင်း: မရောင်းချပျင်းလျှင် ရပ်တန့်နေသော ပစ္စည်းအရေအတွက်ကို တစ်ရက်ထပ်ထည့်မည်; ရောင်းချပြီးလျှင် ရပ်တန့်နေသော ပစ္စည်းအရေအတွက်ကို သုညသို့ ပြန်လည်သတ်မှတ်မည်",
The_sum_of_pending_shipment_distribution_and_shipment:"ပို့ဆောင်ရန် စောင့်ဆိုင်းနေသော၊ အော်ဒါ ဖြည့်ဆည်းနေသော၊ ပို့ဆောင်ဆဲ စုစုပေါင်း",
The_number_to_be_reviewed:"စစ်ဆေးရန် စောင့်ဆိုင်းနေသော အရေအတွက်",
The_sum_of_the_delivery_exceptions_in_the_pending_review_and_waybill_number_acquisition:"စစ်ဆေးရန် စောင့်ဆိုင်းနေသော၊ Waybill နံပါတ် ရှာဖွေနေသေးသော၊ ပို့ဆောင်မှုဆိုင်ရာ ထူးခြားချက်များ စုစုပေါင်း",
You_do_not_have_permission_to_access_this_page:"ဤစာမျက်နှာကို ဝင်ရောက်ကြည့်ရှုခွင့် မရှိပါ။",
salesReportForSKU:"SKU အရောင်းအစီရင်ခံစာ",
salesReportForWarehouse:"ဂိုဒေါင်အရောင်းအစီရင်ခံစာ",
salesReportForPlatform:"ပလက်ဖောင်းအရောင်းအစီရင်ခံစာ",
salesReportForCountry:"နိုင်ငံအရောင်းအစီရင်ခံစာ",
salesReportForStore:"ဆိုင်အရောင်းအစီရင်ခံစာ",
product_quantity_sold:"ထုတ်ကုန်ရောင်းချအရေအတွက်",
Average_daily_sales:"ပျမ်းမျှနေ့စဉ်ရောင်းအား",
Product_name_in_Chinese_and_English:"ထုတ်ကုန်အမည်များ (တရုတ်နှင့် အင်္ဂလိပ်)",
unsalableGoodsReport:"ရောင်းအားနည်းသော ပစ္စည်းစာရင်း",
unsalable_days:"ကုန်ပစ္စည်းကျန်ရှိသည့် ရက်များ",
overdueList:"ကျော်လွန်စာရင်း",
overdueDetailList:"ကျော်လွန်အသေးစိတ်စာရင်း",
customerDailyConsumptionFlow:"ဖောက်သည်၏ နေ့စဉ်ငွေလှုပ်ရှားမှတ်တမ်း",
customerMonthlyConsumptionFlow:"ဖောက်သည်၏ လစဉ်ငွေလှုပ်ရှားမှတ်တမ်း",
commodityItemNumberReport:"ထုတ်ကုန် SKU စာရင်း",
financialOperations:"ဘဏ္ဍာရေး လုပ်ငန်းစဉ်အစီရင်ခံစာ",
dailyBalance:"ဖောက်သည်၏ နေ့စဉ်ကျန်ငွေ",
shipmentReport:"ပို့ဆောင်မှုပမာဏအစီရင်ခံစာ",
warehouseShipmentReport:"ဂိုဒေါင်ပို့ဆောင်မှုပမာဏအစီရင်ခံစာ",
platformShipmentReport:"ပလက်ဖောင်းပို့ဆောင်မှုပမာဏအစီရင်ခံစာ",
countryShipmentReport:"နိုင်ငံပို့ဆောင်မှုပမာဏအစီရင်ခံစာ",
storeShipmentReport:"ဆိုင်ပို့ဆောင်မှုပမာဏအစီရင်ခံစာ",
Trend_chart:"လမ်းကြောင်းဇယား",
system_setting_overdue_time:"စနစ်သတ်မှတ်ထားသော အကြွေးကျန်ကာလ",
overdue_order_number:"အကြွေးကျန်အော်ဒါအရေအတွက်",
overdue_data:"အကြွေးကျန်ရက်များ",
order_overdue_delivery_time:"အော်ဒါပို့ဆောင်ချိန်ကျော်လွန်သည့် အချိန်များ",
order_delivery_time:"အော်ဒါပို့ဆောင်ချိန်များ",
Daily_cost_trend_chart:"နေ့စဉ်အသုံးစရိတ် လမ်းကြောင်းဇယား",
total_Daily_cost_trend_chart:"နေ့စဉ် စုစုပေါင်းအသုံးစရိတ် လမ်းကြောင်းဇယား",
Total_cost:"စုစုပေါင်းအသုံးစရိတ်များ",
clientShipmentReport:"ဖောက်သည်ပို့ဆောင်မှု ပမာဏအစီရင်ခံစာ",
warehouseDailyReport:"ဂိုဒေါင် နေ့စဉ်အစီရင်ခံစာ",
dailyOrderAllocationReport:"နေ့စဉ် အော်ဒါရွေးချယ်ခြင်းအစီရင်ခံစာ",
monthlyOrderAllocationReport:"လစဉ် အော်ဒါရွေးချယ်ခြင်းအစီရင်ခံစာ",
dailyOrderSortReport:"နေ့စဉ် အော်ဒါခွဲခြားခြင်းအစီရင်ခံစာ",
monthlyOrderSortReport:"လစဉ် အော်ဒါခွဲခြားခြင်းအစီရင်ခံစာ",
dailyOrderDeliverReport:"နေ့စဉ် အော်ဒါ ပို့ဆောင်မှု အစီရင်ခံစာ",
monthlyOrderDeliverReport:"လစဉ် အော်ဒါ ပို့ဆောင်မှု အစီရင်ခံစာ",
task_finish_number:"ပြီးစီးပြီးသော တာဝန်အရေအတွက်",
order_product_number:"အော်ဒါ ပစ္စည်းအရေအတွက်",
total_time_spent:"စုစုပေါင်း ကြာမြင့်ချိန်",
order_count:"အော်ဒါ ပမာဏ",
dailyLogisticsReturnReceiptReport:"နေ့စဉ် လိုဂျစ်စတစ် ပြန်လည်လက်ခံမှု အစီရင်ခံစာ",
dailyCustomerLogisticsReturnReceiptReport:"နေ့စဉ် ဖောက်သည် လိုဂျစ်စတစ် ပြန်လည်လက်ခံမှု အစီရင်ခံစာ",
dailyCustomeReturnGoodsReceiptReport:"နေ့စဉ် ဖောက်သည် ပြန်ပို့လာသော ကုန်ပစ္စည်း လက်ခံမှု အစီရင်ခံစာ",
orderToBeReviewedOutOfStockReport:"အတည်ပြုချက် စောင့်ဆိုင်းနေသော အော်ဒါ မရှိတော့သော ပစ္စည်းများ အစီရင်ခံစာ",
monthlyCustomeReturnGoodsReceiptReport:"လစဉ် ဖောက်သည် ပြန်ပို့လာသော ကုန်ပစ္စည်း လက်ခံမှု အစီရင်ခံစာ",
customerShippedQuantityByWarehouse:"ဖောက်သည် ပို့ဆောင်မှု ပမာဏ (ဂိုဒေါင်)",
goodsSalesVolumeByTotalSku:"ထုတ်ကုန် ရောင်းအား ပမာဏ (SKU စုစုပေါင်း)",
goodsSalesVolumeByWarehouse:"ထုတ်ကုန် ရောင်းအား ပမာဏ (ဂိုဒေါင်)",
The_create_time_is_about_N_days:"N ရက်အတွင်း ဖန်တီးသည့် ရက်စွဲ",
Quantity_out_of_stock:"ကုန်ပစ္စည်း မလုံလောက်မှု အရေအတွက်",
this_day:"ယနေ့",
goodsOutOfStockReport:"ကုန်ပစ္စည်း မလုံလောက်မှု အစီရင်ခံစာ",
out_of_stock_days:"မလုံလောက်သည့် ကာလ (ရက်)",
out_of_stock_date:"မလုံလောက်သည့် ရက်စွဲ",
dailyConsumptionFlow:"နေ့စဉ် ငွေလွှဲ လှုပ်ရှားမှု",
monthlyConsumptionFlow:"လစဉ် ငွေလွှဲ လှုပ်ရှားမှု",
warehouse_hourly_uncleared_orders:"တစ်နာရီလျှင် မဆောင်ရွက်သေးသော အော်ဒါများ (ဂိုဒေါင်)",
responsible_person:"တာဝန်ယူသူ",
total_unshipped_quantity:"မပို့ဆောင်သေးသော စုစုပေါင်း ပမာဏ",
total_shipped_quantity:"ပို့ဆောင်ပြီး စုစုပေါင်း ပမာဏ",
ratio:"အချိုးအစား",
warehouse_hourly_shipping:"တစ်နာရီလျှင် ပို့ဆောင်မှုများ (ဂိုဒေါင်)",
total_order_quantity:"စုစုပေါင်း အော်ဒါ ပမာဏ",
outbound_count:"ထွက်ပစ္စည်း ပမာဏ",
orderTimelinessMonitoringTable:"အော်ဒါ အချိန်မီမှု စောင့်ကြည့်ဇယား",
hourlyShippingReport:"တစ်နာရီလျှင် ပို့ဆောင်မှု အစီရင်ခံစာ",
Packing_timeliness_rate:"ထုပ်ပိုးထိရောက်မှု",
monthlyOrderVolumeInvestmentPromotionOfficerReport:"လစဉ် အော်ဒါ ပမာဏ အစီရင်ခံစာ (စီးပွားရေး ဖွံ့ဖြိုးတိုးတက်ရေး)",
monthlyOrderVolumeInvestmentPromotionDepartmentReport:"စီးပွားရေးဖွံ့ဖြိုးရေးဌာနအတွက် လစဉ်အော်ဒါအရေအတွက်အစီရင်ခံစာ",
monthlyOrderVolumeCustomerReport:"ဖောက်သည်များအတွက် လစဉ်အော်ဒါအရေအတွက်အစီရင်ခံစာ",
monthlyOrderVolumeCountryReport:"နိုင်ငံအလိုက် လစဉ်အော်ဒါအရေအတွက်အစီရင်ခံစာ",
monthlyOrderVolumeWarehouseReport:"သိုလှောင်ခန်းအလိုက် လစဉ်အော်ဒါအရေအတွက်အစီရင်ခံစာ",
monthlyOrderVolumePlatformrReport:"ပလက်ဖောင်းအလိုက် လစဉ်အော်ဒါအရေအတွက်အစီရင်ခံစာ",
investment_Promotion_Officer:"စီးပွားရေးဖွံ့ဖြိုးရေးကိုယ်စားလှယ်",
investment_Promotion_Department:"စီးပွားရေးဖွံ့ဖြိုးရေးဌာန",
average_daily_order_volume:"ပျမ်းမျှနေ့စဉ်အော်ဒါအရေအတွက်",
average_daily_proportion:"ပျမ်းမျှနေ့စဉ်အော်ဒါနှုန်း",
total_order_volume:"စုစုပေါင်းအော်ဒါအရေအတွက်",
total_order_volume_proportion:"စုစုပေါင်းအော်ဒါနှုန်း",
number_of_newly_developed_customers:"အသစ်ရရှိသော ဖောက်သည်အရေအတွက်",
the_total_order_volume_of_newly_developed_customers:"အသစ်ရရှိသော ဖောက်သည်များမှ အော်ဒါအရေအတွက်",
the_proportion_of_new_customer_orders:"အသစ်ရရှိသော ဖောက်သည်များ၏ အော်ဒါနှုန်း",
only_100_order_numbers_are_supported_at_a_time:"တစ်စုလျှင် အော်ဒါနံပါတ် ၁၀၀ ထောက်ပံ့နိုင်သည်",
separated_by_newlines:"လိုင်းခွဲများဖြင့် ခွဲထားသည်",
get_label:"တံဆိပ်များ ပြန်လည်ရယူခြင်း",
get_success:"အောင်မြင်စွာ ရယူနိုင်ခဲ့သည်",
printLabel:"တံဆိပ်ပုံနှိပ်ခြင်း",
dailyInventory:"နေ့စဉ် ပစ္စည်းစာရင်း",
record_date:"မှတ်တမ်းရက်စွဲ",
inventory_grounding_time:"ပစ္စည်းထားရှိချိန်",
daily_inventory_list:"နေ့စဉ် ပစ္စည်းစာရင်း",
deliveryTime:"ထွက်ချိန်",
lastUpdateTime:"အပ်ဒိတ်ချိန်",
completeTime:"ပြီးဆုံးချိန်",
settleAccountsTime:"ငွေပေးချေချိန်",
stockId:"ဂိုဒေါင်",
orderType:"အမျိုးအစား",
orderId:"အော်ဒါနံပါတ်",
trackingNo:"ပို့ဆောင်ရေးနံပါတ်",
referenceNo:"ရည်ညွှန်းနံပါတ်",
skuNum:"SKU*အရေအတွက်",
fileUrl:"ဗီဒီယို မှတ်တမ်းတင်လိပ်စာ",
video_storage_address:"ဗီဒီယို သိမ်းဆည်းလိပ်စာ",
filePhotoUrl:"ထွက်ပို့ snapshot",
createUserId:"ထွက်ပို့ ကိုင်တွယ်သူ",
starCreateTime:"ထွက်ပို့ စတင်ချိန်",
endCreateTime:"ထွက်ပို့ အဆုံးချိန်",
totalStorageSpace:"စုစုပေါင်း သိမ်းဆည်းနိုင်မှု",
usedStorageSpace:"အသုံးပြုထားသော သိမ်းဆည်းမှု",
remainingStorageSpace:"ကျန်ရှိသော သိမ်းဆည်းမှု",
serverIP:"ဆာဗာ IP",
serverName:"ဆာဗာ အမည်",
warehouseServerPort:"Port",
storageFilePath:"သိမ်းဆည်းဖိုင် လမ်းကြောင်း",
addStorageSpaceServersWarehouse:"ဂိုဒေါင် ဆာဗာ သိမ်းဆည်းနိုင်မှု ထည့်ရန်",
editStorageSpaceServersWarehouse:"ဂိုဒေါင် ဆာဗာ သိမ်းဆည်းနိုင်မှု ပြင်ဆင်ရန်",
please_select_warehouse:"ဂိုဒေါင်ကို ရွေးချယ်ပါ",
please_select_serverIP:"ဆာဗာ IP ကို ရွေးချယ်ပါ",
please_select_serverName:"ဆာဗာအမည်ကို ထည့်ပါ။",
please_select_serverPort:"ဆာဗာပေါ့တ်ကို ထည့်ပါ။",
video_snapshot_information:"ဗီဒီယို Snapshot အချက်အလက်",
platformAuthorization:"ပလက်ဖောင်း ခွင့်ပြုချက်",
authorizedStoreList:"ခွင့်ပြုထားသော ဆိုင်များ",
this_data_has_no_outbound_time:"ဤမှတ်တမ်းတွင် ပို့ဆောင်ချိန် မပါပါ။",
please_choose_again:"ပြန်ရွေးပါ။",
total_cloud_server_storage_video_access_path:"မဟာဘုတ် Cloud ဆာဗာ ဗီဒီယိုသိုလှောင်မှု ဝင်ရောက်လမ်းကြောင်း",
total_cloud_server_storage_image_access_path:"မဟာဘုတ် Cloud ဆာဗာ ပုံရိပ်သိုလှောင်မှု ဝင်ရောက်လမ်းကြောင်း",
total_cloud_server_storage_outbound_snapshot:"မဟာဘုတ် Cloud ဆာဗာ ပို့ဆောင် Snapshot သိုလှောင်မှု",
total_cloud_server_storage_video_address:"မဟာဘုတ် Cloud ဆာဗာ ဗီဒီယိုမှတ်တမ်းသိုလှောင်ရန် လိပ်စာ",
unpackRegisterReturnPackage:"တောင်းခံရန် မှတ်ပုံတင်ခြင်း",
registerInClaimArea:"ထုတ်ကြည့်ပြီး ပြန်ပို့ရန် မှတ်ပုံတင်ခြင်း",
Please_select_the_quick_registration_type:"အမြန်ပြန်ပို့ မှတ်ပုံတင်ခြင်း အမျိုးအစားကို ရွေးချယ်ပါ",
Change_storage_location:"သိုလှောင်ရာနေရာ ပြောင်းရန်",
productId:"ထုတ်ကုန် ID",
Please_select_the_product_details_first:"အရင်ဆုံး ထုတ်ကုန်အသေးစိတ်ကို ရွေးချယ်ပါ",
basket_listing:"အိတ်ထဲထည့်ရန်",
Please_enter_the_basket_for_listing:"အိတ် ID ကို ထည့်ပါ",
locationId:"သိုလှောင်ရာနေရာ ID",
automatic_return_listing:"ပြန်ပို့ရာတွင် အလိုအလျောက် ထားရန်",
not_automatically_listed:"အလိုအလျောက် မထားရန်",
shelf_return_warehouse_location:"ပြန်ပို့ရန် သိုလှောင်ရာနေရာတွင် ထားရန်",
registerList:"မှတ်ပုံတင်ပြီး ထားရန်",
Is_the_qualified_quantity_0_saved_to_the_rejection_stage:"ကိုက်ညီသောအရေအတွက်မှာ 0 ဖြစ်သည်။ ငြင်းပယ်ခြင်းအဆင့်သို့ သိမ်းမည်လား?",
Is_the_qualified_quantity_0_saved:"ကိုက်ညီသောအရေအတွက်မှာ 0 ဖြစ်သည်။ သိမ်းမည်လား?",
Please_upload_photo_of_the_package:"ပက်ကေ့ဂျ်ဓာတ်ပုံများကို တင်ပါ။",
The_actual_data_of_the_product_must_be_all_greater_than_0:"ထုတ်ကုန်ဒေတာအစစ်အမှန်အားလုံးသည် 0 ထက် များရမည်။",
Please_enter_the_qualified_and_unqualified_quantity:"စုစုပေါင်းအရေအတွက်ကို ထည့်ပါ။",
Please_select_the_billing_attribute_for_the_product:"ထုတ်ကုန်ငွေတောင်းခံခြင်း အင်္ဂါရပ်ကို ရွေးပါ။",
Please_complete_the_selection_of_warehouse_location_number_first:"အရင်ဆုံး တည်နေရာနံပါတ်ရွေးချယ်မှုကို ပြီးမြောက်အောင် ပြုလုပ်ပါ။",
Multiple_products_please_select_multiple_SKU_types_and_location_numbers:"ထုတ်ကုန်များစွာအတွက် Multi-SKU အမျိုးအစား တည်နေရာနံပါတ်ကို ရွေးပါ။",
Is_it_confirmed_that_there_is_a_difference_in_the_dimensions_of_the_three_sides_of_the_currently_inspected_product_compared_to_the_previous_inspected_product:"လက်ရှိစစ်ဆေးနေသော ပစ္စည်း၏ သုံးဘက်အတိုင်းအတာများသည် ယခင်စစ်ဆေးခဲ့သော ပစ္စည်း၏ အတိုင်းအတာများနှင့် ကွာခြားနေပါသည်။ အတည်ပြုပါသလား?",
Is_it_confirmed_that_there_is_a_difference_between_the_actual_weight_of_the_current_quality_inspection_product_and_the_actual_weight_of_the_previous_quality_inspection:"လက်ရှိစစ်ဆေးနေသော ပစ္စည်း၏ တကယ့်အလေးချိန်သည် ယခင်စစ်ဆေးခဲ့သော ပစ္စည်း၏ တကယ့်အလေးချိန်နှင့် ကွာခြားနေပါသည်။ အတည်ပြုပါသလား?",
The_qualified_quantity_cannot_exceed_the_total_quantity:"အရည်အသွေးပြည့်မီသော ပစ္စည်းများ၏ အရေအတွက်သည် စုစုပေါင်းအရေအတွက်ထက် မကျော်လွန်နိုင်ပါ။",
The_current_storage_location_is_a_single_SKU_storage_location_which_has_been_selected_by_other_products:"လက်ရှိသိုလှောင်ထားသော နေရာသည် တစ်ခုတည်းသော SKU နေရာဖြစ်ပြီး အခြားပစ္စည်းတစ်ခုက ရွေးချယ်ထားပါသည်။",
batch_return_warehouse_relocation:"အစုလိုက် ပြန်ပို့ရန် နေရာ ပြောင်းရွှေ့ခြင်း",
automatically_print_the_inventory_transfer_list:"ပြောင်းရွှေ့စာရင်းကို အလိုအလျောက် ပုံနှိပ်ခြင်း",
print_the_inventory_transfer_list:"ပြောင်းရွှေ့စာရင်းကို ပုံနှိပ်ခြင်း",
view_SKU_transaction_history:"SKU လုပ်ငန်းဆောင်တာ မှတ်တမ်းများကို ကြည့်ရှုခြင်း",
Inventory_transfer_task_ID:"ပြောင်းရွှေ့တာဝန် ID",
print_list:"စာရင်းကို ပုံနှိပ်ခြင်း",
commodity_income:"ထုတ်ကုန် ဝင်ငွေ",
refund_fee:"ပြန်အမ်းငွေကြေး",
shippingFee:"ကုန်ပို့ဆောင်ခ ထွက်ငွေ",
shippingIncomFee:"ကုန်ပို့ဆောင်ခ ဝင်ငွေ",
discountFee:"လျှော့စျေး စုစုပေါင်း",
serviceFee:"ဝန်ဆောင်မှုကြေး",
commissionFee:"ကော်မရှင်",
taxFee:"အခွန်",
advertisingFee:"ကြော်ငြာကြေး",
paymentFee:"ငွေပေးချေမှု ဆောင်ရွက်ခ",
warehousePackingFee:"ဂိုဒေါင် ထုပ်ပိုးခ",
otherFee:"အခြား ဝင်ငွေ/ထွက်ငွေ",
orderIncomeFee:"အော်ဒါ ဝင်ငွေ",
platformName:"ပလက်ဖောင်းအမည်",
FinancialRecognition:"ဘဏ္ဍာရေး အတည်ပြုချက်",
Pending_warehouse_transfer:"ရွှေ့ပြောင်းစောင့်ဆိုင်းနေ",
To_be_received:"လက်ခံစောင့်ဆိုင်းနေ",
convertToWaitingForReception:"လက်ခံစောင့်ဆိုင်းနေသို့ ပြောင်းလဲထားသည်",
Please_enter_the_warehouse_location_number:"တည်နေရာနံပါတ် ထည့်ပါ",
Please_choose_to_add_SKU:"SKU ထည့်ပါ",
returnInventoryQuantity:"ပြန်လည်ပို့ထားသော ပစ္စည်းအရေအတွက်",
controlTime:"ထိန်းချုပ်ချိန်",
Transfer_of_warehouse_completed:"ရွှေ့ပြောင်းပြီး",
Revoked:"ဖျက်သိမ်းပြီး",
The_current_warehouse_type_is_shelf_to_return_location_Please_select_a_new_warehouse:"လက်ရှိ ဂိုဒေါင်အမျိုးအစားမှာ 'ပြန်လည်ပို့ရန် တည်နေရာစာရင်းတွင် ပါဝင်ထားသည်' ဖြစ်ပါသည်။ ဂိုဒေါင်ကို ပြန်ရွေးပါ။",
recommended_shelf_location:"အကြံပြု စာရင်းတင်ရန် တည်နေရာ",
Is_the_measurement_size_correct:"အတိုင်းအတာ မှန်ကန်မှု စစ်ဆေးပါ",
Please_add_SKU:"SKU ထည့်ပါ",
Currency_for_profit_calculation:"အမြတ်တွက်ချက်ငွေကြေး",
Order_delivery_time:"အော်ဒါ ပို့ဆောင်ချိန်",
Last_update_time:"နောက်ဆုံး အပ်ဒိတ်လုပ်သည့် အချိန်",
operatorUserId:"လည်ပတ်သူ",
total_inventory_batch:"လက်ရှိ အုပ်စု စုစုပေါင်း ပစ္စည်းအရေအတွက်",
Please_select_the_recommended_storage_location_for_listing:"အကြံပြုထားသော သိုလှောင်ရန်နေရာကို ရွေးချယ်ပါ",
Please_select_the_data_that_needs_to_be_transferred_to_the_warehouse_first:"ပထမဦးစွာ လိုအပ်သော ပြောင်းရွှေ့ဒေတာကို ရွေးချယ်ပါ",
Import_inventory_list:"ကုန်ပစ္စည်းစာရင်း တင်သွင်းခြင်း",
Return_warehouse_location_Return_pending_review:"ပြန်ပို့ရန်နေရာတွင် ပြန်လည်စစ်ဆေးရန် စောင့်ဆိုင်းနေသော ပစ္စည်းများ",
Inventory_transfer_task_removal_flow:"ပြောင်းရွှေ့တာဝန်မှ ဖယ်ရှားခြင်း လုပ်ငန်းငွေကြေးစာရင်း",
The_inventory_quantity_for_the_return_warehouse_relocation_cannot_be_0:"ပြန်ပို့ရန်နေရာမှ ပြောင်းရွှေ့မည့် ကုန်ပစ္စည်းအရေအတွက်ကို သုည မဖြစ်နိုင်ပါ",
The_current_return_order_is_marked_as_abandoned_by_the_customer_and_will_be_automatically_discarded_after_saving:"လက်ရှိ ပြန်ပို့ရန်မှာယူမှု ဖောက်သည်မှ စွန့်လွှတ်ထားသည်ဟု မှတ်သားထားပြီး သိမ်းဆည်းပြီးနောက် အလိုအလျောက် စွန့်လွှတ်သွားမည်",
Final_order_placement_time:"နောက်ဆုံး အော်ဒါ ဆွဲယူချိန်",
Last_updated_listing_time:"နောက်ဆုံး စာရင်း ပြင်ဆင်ချိန်",
Product_SKU:"ထုတ်ကုန် SKU",
sales_volumes:"ရောင်းချပမာဏ",
Platform_settlement_amount:"ပလက်ဖောင်း ငွေလက်ခံငွေပမာဏ",
Order_product_sales_revenue:"အော်ဒါ ထုတ်ကုန် ရောင်းချတန်ဖိုး",
Cost_of_goods:"ထုတ်ကုန် ကုန်ကျစရိတ်",
merchandise_procurement_cost:"ထုတ်ကုန် ဝယ်ယူစရိတ်",
First_leg_freight:"အစပိုင်း ပို့ဆောင်ခ",
Platform_shipping_fee:"ပလက်ဖောင်း ပို့ဆောင်ခ",
Actual_shipping_cost:"တကယ့် ပို့ဆောင်ခ",
The_buyer_pays_the_shipping_fee:"ဝယ်သူ ပေးဆောင်သည့် ပို့ဆောင်ခ",
Platform_freight_subsidy:"ပလက်ဖောင်း ပို့ဆောင်ခ အထောက်အပံ့ငွေ",
Revenue_from_3PL_freight_refund:"3PL ပို့ဆောင်ခ ပြန်အမ်းငွေ",
Platform_fees:"ပလက်ဖောင်း ကြေးများ",
Platform_commission:"ပလက်ဖောင်း ကော်မရှင်",
Alliance_commission:"မိတ်ဖက် ကော်မရှင်",
Transaction_fee:"ငွေလွှဲကြေး",
Platform_activity_expenses:"ပလက်ဖောင်း ပရိုမိုးရှင်းကြေး",
Additional_plan_service_fee:"အပိုအစီအစဉ် ဝန်ဆောင်ခ",
threePL_insurance_premium:"3PL အာမခံကြေး",
Seller_pays_cross_border_tax:"ရောင်းသူပေးဆောင်သည့် နယ်စပ်ကျော် အခွန်",
Freight_service_tax_SST:"ပို့ဆောင်ခပေါ် ဝန်ဆောင်ခ အခွန် (SST)",
Withholding_tax:"အခွန် ဖြတ်တောက်ငွေ",
Overseas_return_service_fee:"ပြန်ပို့ဝန်ဆောင်မှုကြေး",
Value_added_tax_VAT:"တန်ဖိုးတိုးအခွန် (VAT)",
Product_and_Service_Tax:"ကုန်ပစ္စည်း ဝန်ဆောင်ခ အခွန်",
Coupons_Discounts:"ကူပွန်များနှင့် လျှော့စျေးများ",
Seller_Coupons:"ရောင်းသူကူပွန်များ",
Shopee_discount:"Shopee လျှော့စျေးများ",
Shopee_coin_deduction:"Shopee Coins ဖြင့် ဖြည့်ဆည်းခြင်း",
Shopee_discount_return:"Shopee လျှော့စျေး ပြန်အမ်းငွေ",
refund_amount:"ပြန်အမ်းငွေပမာဏ",
Other_platform_expenses:"အခြား ပလက်ဖောင်းကြေးများ",
place_an_order_time:"အော်ဒါတင်ချိန်",
createTime:"အော်ဒါတင်ချိန်",
Refund_product_amount:"ပြန်အမ်းပေးသည့် ပစ္စည်းပမာဏ",
updateTime:"အပ်ဒိတ်လုပ်ချိန်",
Original_price_of_the_product:"ပစ္စည်း မူလစျေးနှုန်း",
merchandise_discount:"ကုန်ပစ္စည်းလျှော့စျေး",
Sellers_product_discount:"ရောင်းသူထုတ်ကုန်လျှော့စျေး",
Shopee_Coupons:"Shopee ကူပွန်များ",
Shopee_coin_exchange:"Shopee Coins ပြန်လဲအသုံးပြုခြင်း",
The_buyer_pays_the_transaction_fee:"ဝယ်သူငွေလွှဲကြေး",
The_buyer_pays_the_total_amount:"ဝယ်သူစုစုပေါင်းပေးဆောင်ငွေ",
Estimated_shipping_cost:"ခန့်မှန်းထားသော ပို့ဆောင်ခ",
The_seller_bears_the_shipping_cost:"ရောင်းသူထမ်းဆောင်သည့် ပို့ဆောင်ခ",
Platform_compensation_amount:"ပလက်ဖောင်းဆပ်ငွေ",
Service_fees_charged_for_participating_in_the_sellers_free_shipping_plan:"ရောင်းသူအခမဲ့ပို့ဆောင်ရေးအစီအစဉ်တွင် ပါဝင်ခြင်းအတွက် ဝန်ဆောင်ခ",
Order_reverse_shipping_service_tax_shipping_service_tax:"အော်ဒါ ပြန်ပို့ခြင်း ဝန်ဆောင်ခ + ပို့ဆောင်ခ ဝန်ဆောင်ခ",
SG_Goods_and_Services_Tax_MY_LVG_Goods_Ta:"SG ကုန်ပစ္စည်းနှင့် ဝန်ဆောင်မှုခွန် / MY LVG ကုန်ပစ္စည်းခွန်",
Cross_border_goods_tax_logistics_clearance_service_fees_service_tax_on_low_value_goods_imported_from_Singapore_anti_dumping_duty_on_imported_goods:"နယ်စပ်ကျော် ကုန်ပစ္စည်းခွန် + လိုဂျစ်စတစ် ပံ့ပိုးသူ အကောက်ခွန်ရှင်းလင်းခ + စင်ကာပူ တန်ဖိုးနည်း ကုန်ပစ္စည်း တင်သွင်းခွန် + တင်သွင်းကုန်ပစ္စည်း အန္တီဒမ်ပင်ခွန်",
The_amount_of_fees_charged_to_the_seller_for_failure_to_deliver_the_order:"အော်ဒါ မအောင်မြင်၍ ရောင်းသူအား ကောက်ခံသည့် ကြေး",
Return_order_return_shipping_fee:"ပြန်ပို့ထားသော အော်ဒါ ပို့ဆောင်ခ",
refundShippingSubsidyFee:"ပြန်ပို့သယ်ရေးအာမခံငွေ",
Compensation_provided_by_the_platform_for_lost_or_damaged_packages:"ပျောက်ဆုံး သို့မဟုတ် ပျက်စီးသွားသော ပက်ကေ့ဂျ်များအတွက် ပလက်ဖောင်းမှ ပေးသော အစားထိုးငွေ",
Import_of_MY_low_value_goods_subject_to_service_tax:"မလေးရှား (MY) တန်ဖိုးနည်း ကုန်ပစ္စည်းများ တင်သွင်းရာတွင် ကောက်ခံသော ဝန်ဆောင်ခအခွန်",
Profit_margin_Profit_Order_payment_for_product_amount_Financial_currency_exchange_rate:"အမြတ်အစွန်း = အမြတ် ÷ (မှာယူထားသော ကုန်ပစ္စည်းတန်ဖိုး × ငွေလဲနှုန်း)",
Charges_incurred_for_packages_requiring_signature_confirmation_services:"လက်မှတ်အတည်ပြုရန် လိုအပ်သော ပက်ကေ့ဂျ်များအတွက် ဖြစ်ပေါ်သော ကြေးများ",
Profit_Order_paid_product_amount_Actual_shipping_fee_Buyer_paid_shipping_fee_Platform_shipping_subsidy_3PL_shipping_fee_refund_income_Commission_Alliance_commission_Transaction_fee_Service_fee_Platform_activity_fee_Additional_planned_service_fee_3PL_insurance_fee_Seller_paid_cross_border_tax_Shipping_service_tax_SST_Withholding_tax_Overseas_return_service_fee_Value_added_tax_VAT_Product_service_tax_Seller_discount_coupon_Shopee_discount_Shopee_gold_coin_deduction_Shopee_discount_refund_Refund_product_amount_Return_order_return_shipping_fee_Return_shipping_insurance_income_Platform_other_fees_Order_adjustment_amount_x_Financial_currency_exchange_rate_Product_procurement_cost_First_leg_shipping_fee_Warehouse_rental_Listing_fee_Order_processing_fee:"အမြတ် = (မှာယူထားသော ကုန်ပစ္စည်းတန်ဖိုး - အမှန်တကယ် ပို့ဆောင်ခ + ဝယ်သူပေးချေသော ပို့ဆောင်ခ + ပလက်ဖောင်း ပို့ဆောင်ခ အထောက်အပံ့ + 3PL ပို့ဆောင်ခ လျှော့ဈေး ဝင်ငွေ - ကော်မရှင် - မိတ်ဖက် ကော်မရှင် - ငွေလွှဲခ - ဝန်ဆောင်ခ - ပလက်ဖောင်း ကြော်ငြာခ - အပိုအစီအစဉ် ဝန်ဆောင်ခ - 3PL အာမခံခ - ရောင်းသူပေးချေသော နယ်စပ်အခွန် - ပို့ဆောင်ခ SST - ထိန်းသိမ်းခွန် - ပြည်ပ ပြန်ပို့ ဝန်ဆောင်ခ - တန်ဖိုးတိုးအခွန် (VAT) - ထုတ်ကုန်ဝန်ဆောင်ခ အခွန် - ရောင်းသူလက်မှတ်များ - Shopee လျှော့စျေးများ - Shopee Coins ဖြုတ်ချခြင်း + Shopee လျှော့စျေး ပြန်အမ်းငွေများ - ပြန်အမ်းပေးသော ကုန်ပစ္စည်းတန်ဖိုး - ပြန်ပို့အမှာစာ ပို့ဆောင်ခ + ပြန်ပို့အာမခံ ဝင်ငွေ - အခြားပလက်ဖောင်းကြေးများ + အမှာစာ ပြင်ဆင်မှုငွေများ) × ငွေကြေး လဲလှယ်နှုန်း - (ကုန်ပစ္စည်း ဝယ်ယူစရိတ် + ထွက်ပို့ဆောင်ခ + ဂိုဒေါင်ငှားခ + စာရင်းတင်ကြေး + အမှာစာ ဆောင်ရွက်ခ)",
Profit_Order_payment_for_product_amount_Actual_Freight_Buyer_Paid_Freight_Platform_Freight_Subsidy_3PL_Freight_Return_Revenue_Commission_Alliance_Commission_Transaction_Fee_Service_Fee_Platform_Activity_Fee_Additional_Plan_Service_Fee_3PL_Insurance_Fee_Seller_Paid_Cross_border_Tax_Freight_Service_Tax_SST_Withholding_Tax_Overseas_Return_Service_Fee_Value_Added_Tax_VAT_Product_Service_Tax_Seller_Discount_Coupon_Shopee_Discount_Shopee_Gold_Coin_Deduction_Shopee_Discount_Return_Refund_Product_Amount_Return_Order_Return_Freight_Return_Freight_Insurance_Income_Platform_Other_Fees_Financial_Currency_Exchange_Rate_Product_Procurement_Cost_First_leg_Freight_Warehouse_Rent_Listing_Fee_Order_Processing_Fee:"အမြတ် = (အော်ဒါပေးငွေပမာဏ - တကယ့်ပို့ဆောင်ခ + ဝယ်သူပေးပို့ဆောင်ခ + ပလက်ဖောင်းပို့ဆောင်ခအထောက်အပံ့ + 3PL ပို့ဆောင်ခလျှော့ငွေ - ကော်မရှင် - မိတ်ဖက်ကော်မရှင် - ငွေလွှဲကြေး - ဝန်ဆောင်ခ - ပလက်ဖောင်းမြှင့်တင်ကြေး - အပိုအစီအစဉ်ဝန်ဆောင်ခ - 3PL အာမခံကြေး - ရောင်းသူပေး နယ်စပ်အခွန် - ပို့ဆောင်ဝန်ဆောင်ခအခွန် (SST) - ထိန်းသိမ်းခွန် - ပြည်ပပြန်ပို့ဝန်ဆောင်ခ - တန်ဖိုးတိုးအခွန် (VAT) - ထုတ်ကုန်ဝန်ဆောင်ခအခွန် - ရောင်းသူလက်မှတ်များ - Shopee လျှော့စျေးများ - Shopee Coin ဖြုတ်ချခြင်း + Shopee လျှော့စျေး ပြန်အမ်းငွေများ - ထုတ်ကုန် ပြန်အမ်းငွေများ - ပြန်ပို့အမှာစာ ပို့ဆောင်ခ + ပြန်ပို့အာမခံ ဝင်ငွေ - အခြားပလက်ဖောင်းကြေးများ) × ငွေကြေး လဲလှယ်နှုန်း - (ထုတ်ကုန် ဝယ်ယူစရိတ် + ထွက်ပို့ဆောင်ခ + ဂိုဒေါင်ငှားခ + စာရင်းတင်ကြေးများ + အမှာစာ ဆောင်ရွက်ခ)",
Profit_Order_payment_for_product_amount_actual_shipping_cost_buyer_paid_shipping_cost_platform_shipping_subsidy_seller_bears_shipping_cost_seller_discount_coupon_gold_coin_deduction_platform_discount_subsidy_commission_product_service_tax_platform_activity_fee_installment_payment_handling_fee_advertising_fee_payment_handling_fee_platform_compensation_amount_platform_other_fees_refunded_product_amount_return_order_return_shipping_cost_Exchange_rate_product_procurement_cost_first_leg_shipping_cost_warehouse_rental_shelving_fee_order_processing_fee:"အမြတ် = (မှာယူထားသောပစ္စည်းတန်ဖိုး - အမှန်တကယ်ပို့ဆောင်ခ + ဝယ်သူပေးပို့ဆောင်ခ + ပလက်ဖောင်းပို့ဆောင်ခအထောက်အပံ့ - ရောင်းသူပို့ဆောင်ခ - ရောင်းသူလက်မှတ်လျှော့စျေး - ကွိုင်လျှော့ချခြင်း + ပလက်ဖောင်းလျှော့စျေးအထောက်အပံ့ - ကော်မရှင် - ထုတ်ကုန်ဝန်ဆောင်ခအခွန် - ပလက်ဖောင်းပွဲကြေး - အပိုင်းပိုင်းပေးချေမှုကိုင်တွယ်ခ - ကြော်ငြာစရိတ် - ငွေပေးချေမှုကိုင်တွယ်ခ + ပလက်ဖောင်းအစားထိုးငွေပမာဏ + အခြားပလက်ဖောင်းကြေးများ - ပြန်အမ်းပေးသောပစ္စည်းတန်ဖိုး - ပြန်ပို့ဆောင်မှုပို့ဆောင်ခ) × ငွေလဲနှုန်း - (ကုန်ပစ္စည်းဝယ်ယူစရိတ် + ပထမဆုံးပို့ဆောင်ခ + ဂိုဒေါင်ငှားခ + စာရင်းတင်ကြေး + အော်ဒါစီမံခန့်ခွဲခ)",
Profit_Discounted_product_subtotal_Refund_Actual_Freight_Seller_Paid_Freight_Platform_Freight_Subsidy_Exchange_Freight_Seller_Freight_Discount_TSP_Commission_Platform_Commission_Alliance_Commission_Transaction_Fees_SFP_Service_Fees_Service_Fees_Additional_Plan_Service_Fees_Logistics_Insurance_Fees_Freight_Service_Tax_SST_Value_Added_Tax_VAT_Product_Service_Tax_Seller_Coupon_Return_Order_Freight_Other_Platform_Fees_Credit_Card_Payment_Fees_Platform_Adjustment_Amount_Ecological_Donations_Commission_Exchange_Rate_Product_Purchase_Cost_First_leg_Freight_Warehouse_Rent_Listing_Fee_Order_Processing_Fee:"အမြတ် = (လျှော့စျေးပစ္စည်း စုစုပေါင်း - ပြန်အမ်းငွေများ - တကယ်ကျသင့်သော ပို့ဆောင်ခ + ရောင်းသူပေးပို့ဆောင်ခ + ပလက်ဖောင်းပို့ဆောင်ခ အထောက်အပံ့ - လဲလှယ်ပို့ဆောင်ခ - ရောင်းသူပို့ဆောင်ခ လျှော့စျေးများ - TSP ကော်မရှင် - ပလက်ဖောင်းကော်မရှင် - မိတ်ဖက်ကော်မရှင်) - ကုန်သွယ်မှုကြေး - SFP ဝန်ဆောင်မှုကြေး - ဝန်ဆောင်မှုကြေး - ထပ်ဆောင်းအစီအစဉ်ဝန်ဆောင်မှုကြေး - လိုဂျစ်စတစ်စ်အာမခံကြေး - ပို့ဆောင်မှုဝန်ဆောင်မှုအခွန် (SST) - တန်ဖိုးတိုးအခွန် (VAT) - ထုတ်ကုန်ဝန်ဆောင်မှုအခွန် - ရောင်းသူလက်မှတ်များ - ပြန်ပို့အမှာစာပို့ဆောင်ခ - အခြားပလက်ဖောင်းကြေးများ - ခရက်ဒစ်ကတ်လုပ်ငန်းကြေး + ပလက်ဖောင်းညှိနှိုင်းငွေပမာဏ - ပတ်ဝန်းကျင်အလှူငွေ - ကိုင်တွယ်ကြေး) * လဲလှယ်နှုန်း - (ထုတ်ကုန်ဝယ်ယူစရိတ် + ပထမဆုံးပို့ဆောင်ခ + ဂိုဒေါင်ငှားခ + စာရင်းတင်ကြေး + အမှာစာဆောင်ရွက်ခ)",
storeCurrency:"ဆိုင်ငွေကြေး",
escrowCurrency:"ဘဏ္ဍာရေးငွေကြေး",
exchangeRate:"ဘဏ္ဍာရေးငွေကြေး လဲလှယ်နှုန်း",
income_expenditure_information:"ဝင်ငွေ/ထွက်ငွေ အချက်အလက်",
expense_item:"ကြေးပစ္စည်းများ",
revenue_expenditure:"ဝင်ငွေ/ထွက်ငွေ",
Take_the_actual_bill_and_the_buyer_pays_the_shipping_fee:"အမှန်တကယ် ငွေတောင်းခံလွှာ ဝယ်သူက သယ်ယူပို့ဆောင်ခ ပေးချေသည်",
percent:"ရာခိုင်နှုန်း",
Order_payment_for_product_amoun:"အမှာစာ ပေးချေမှု ထုတ်ကုန် ပမာဏ",
The_last_update_time_of_profit_and_expense_data_automatically_updated_when_platform_orders_change_or_settle:"အမြတ်/ကုန်ကျစရိတ် ဒေတာ နောက်ဆုံး အပ်ဒိတ်လုပ်သည့် အချိန်၊ ပလက်ဖောင်းအမှာစာ ပြောင်းလဲမှုများ သို့မဟုတ် ဖြေရှင်းမှုများ ဖြစ်သည့်အခါ အလိုအလျောက် အပ်ဒိတ်လုပ်သည်။",
Take_the_settlement_time_of_the_order_and_for_non_platform_orders_take_the_time_when_the_order_is_moved_to_the_Completed_status_When_the_settlement_time_is_empty_it_means_that_the_platform_has_not_ended_yet:"အော်ဒါငွေချေချိန်ယူသည်; ပလက်ဖောင်းမဟုတ်သော အော်ဒါများအတွက်၊ အော်ဒါကို [ပြီးစီး] အခြေအနေသို့ ရွှေ့ပြောင်းသည့်အချိန်ကို ငွေချေချိန်အဖြစ်ယူသည်။ ငွေချေချိန်ဗလာဖြစ်ခြင်းသည် ပလက်ဖောင်းမှ မပြီးစီးသေးကြောင်းကို ဆိုလိုသည်။",
Take_the_final_settlement_time_of_the_order_Payment_Period_and_for_non_platform_orders_take_the_time_when_the_order_is_moved_to_the_Completed_status_If_the_settlement_time_is_empty_it_means_the_platform_has_not_ended_yet:"နောက်ဆုံးအော်ဒါငွေချေချိန်ယူသည် (ငွေပေးချေကာလ); ပလက်ဖောင်းမဟုတ်သော အော်ဒါများအတွက်၊ အော်ဒါကို [ပြီးစီး] အခြေအနေသို့ ရွှေ့ပြောင်းသည့်အချိန်ကို ငွေချေချိန်အဖြစ်ယူသည်။ ငွေချေချိန်ဗလာဖြစ်ခြင်းသည် ပလက်ဖောင်းမှ မပြီးစီးသေးကြောင်းကို ဆိုလိုသည်။",
Take_the_final_settlement_date_of_the_order_Settlement_Date_and_for_non_platform_orders_take_the_time_when_the_order_is_moved_to_the_Completed_status_If_the_settlement_time_is_empty_it_means_the_platform_has_not_ended_yet:"အော်ဒါအတွက် နောက်ဆုံးငွေချေမှုနေ့ (Settlement Date)။ ပလက်ဖောင်းမဟုတ်သော အော်ဒါများအတွက် ငွေချေချိန်သည် အော်ဒါသည် [ပြီးစီး] အခြေအနေသို့ ပြောင်းလဲသည့် အချိန်ဖြစ်သည်။ ငွေချေချိန်ဗလာဖြစ်ခြင်းသည် ပလက်ဖောင်းမှ ငွေလွှဲပြောင်းမှုကို မပြီးစီးသေးကြောင်း ဆိုလိုသည်။",
The_system_calculates_the_estimated_settlement_amount_of_the_order_based_on_the_income_of_the_order_platform_fees_minus_the_expenditure_of_the_order_platform_fees_Please_compare_and_verify_it_with_the_settlement_amount_of_the_platform:"စနစ်သည် ပလက်ဖောင်းကြေး ဝင်ငွေမှ ပလက်ဖောင်းကြေး ထွက်ငွေကို ဖြုတ်၍ အော်ဒါအတွက် ခန့်မှန်းငွေချေမှုပမာဏကို တွက်ချက်သည်။ ဤကို ပလက်ဖောင်း၏ ငွေချေမှုပမာဏနှင့် နှိုင်းယှဉ်၍ အတည်ပြုပါ။",
Estimated_settlement_amount:"ခန့်မှန်းငွေချေမှုပမာဏ",
The_order_payment_completion_time_the_time_when_the_funds_have_been_transferred_is_recorded_For_non_platform_orders_the_settlement_time_is_determined_by_the_moment_the_order_is_moved_to_the_Completed_status_If_the_settlement_time_is_blank_it_indicates_that_the_platform_has_not_finalized_the_order:"အော်ဒါအတွက် ငွေပေးချေမှု ပြီးဆုံးသည့် အချိန် (ငွေပြောင်းရွှေ့ပြီးစီးသည့်အချိန်) ဖြစ်သည်။ ပလက်ဖောင်းမဟုတ်သော အော်ဒါများအတွက် ဖြေရှင်းချိန်သည် အော်ဒါကို [ပြီးစီး] အခြေအနေသို့ ပြောင်းရွှေ့သည့်အချိန်ဖြစ်သည်။ ဖြေရှင်းချိန်တွင် အချက်အလက်မပါရှိခြင်းသည် ပလက်ဖောင်းမှ အော်ဒါကို မပြီးစီးသေးကြောင်းကို ဆိုလိုသည်။",
The_time_when_the_platform_status_of_the_order_changes_to_Competed_Cancelled:"အော်ဒါ၏ ပလက်ဖောင်းအခြေအနေသည် ပြီးစီး/ဖျက်သိမ်း သို့ ပြောင်းလဲသည့် အချိန်။",
Retrieve_the_system_order_outbound_time:"စနစ်မှ အော်ဒါပို့ဆောင်သည့် အချိန်။",
Seller_bears_the_shipping_cost_actual_shipping_cost_buyer_pays_the_shipping_cost_platform_shipping_subsidy_3PL_shipping_cost_refund_income_not_included_in_order_profit_calculation_for_operational_analysis_reference_only:"ရောင်းသူ၏ ပို့ဆောင်ခ = အမှန်တကယ် ပို့ဆောင်ခ - ဝယ်သူ ပေးဆောင်ပြီးသော ပို့ဆောင်ခ - ပလက်ဖောင်း ပို့ဆောင်ခ အထောက်အပံ့ - 3PL ပို့ဆောင်ခ လျှော့စျေး ဝင်ငွေ (အော်ဒါ အမြတ်တွက်ချက်မှုတွင် မပါဝင်ပါ; လည်ပတ်မှု သုံးသပ်ချက်အတွက်သာ)",
time_filtering:"အချိန် စစ်ထုတ်စနစ်",
Exchange_rate_setting_System_settings_Currency_exchange_rate_Currency_exchange_rate_list:"ငွေလဲနှုန်း စနစ်ချိန်ညှိခြင်း: စနစ်ဆက်တင်များ → ငွေလဲနှုန်းများ → ငွေလဲနှုန်းစာရင်း;",
The_system_converts_the_original_currency_of_the_store_into_the_financial_currency_for_profit_based_on_the_exchange_rate:"စနစ်သည် ငွေလဲနှုန်းများအပေါ် အခြေခံ၍ ဆိုင်၏ မူလငွေကြေးကို အမြတ်ငွေငွေကြေးသို့ ပြောင်းလဲပေးသည်။",
When_the_currency_exchange_rate_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_the_data_will_be_synchronized_after_24_00_on_the_same_day:"ငွေလဲနှုန်းများကို မချိန်ညှိထားပါက စနစ်သည် ဒေတာများကို ညှိနှိုင်းမည်မဟုတ်ပါ။ ချိန်ညှိပြီးပါက တစ်နေ့ ၂၄:၀၀ နာရီကျော်ပြီးနောက် ဒေတာညှိနှိုင်းမှု ဖြစ်ပေါ်ပါမည်။",
deduction_currency_value_system_settings_Currency_exchange_rate_Exchange_rates_in_the_currency_exchange_rate_list_Record_the_exchange_rate_when_obtaining_the_order_revenue_and_expenditure_for_the_first_time_and_do_not_update_the_exchange_rate_value_in_the_profit_afterwards_When_the_currency_exchange_rate_is_not_set_it_defaults_to_0_When_the_exchange_rate_value_can_be_obtained_in_subsequent_automatic_updates_it_will_be_updated:"ဆိုင်ငွေကြေးမှ ငွေချေမှုငွေကြေးသို့ ပြောင်းလဲခြင်း: System Settings ➡ Currency Exchange Rates ➡ Exchange rates in the Currency Exchange Rate List တွင် ဖော်ပြထားသည့် အတိုးနှုန်းကို ယူသည်။ အမှာစာ ဝင်ငွေ/ထွက်ငွေ ဒေတာကို ပထမဆုံး ရယူသည့်အခါ အတိုးနှုန်းကို မှတ်တမ်းတင်ပြီး အမြတ်တွက်ချက်မှုများတွင် ထပ်မံ မပြောင်းလဲပါ။ ငွေကြေးအတိုးနှုန်း မသတ်မှတ်ထားပါက 0 ကို မူလတန်ဖိုးအဖြစ် သတ်မှတ်သည်။ အတိုးနှုန်းတန်ဖိုးများ ရရှိလာသည့်အခါ အလိုအလျောက် အပ်ဒိတ်ဖြစ်ပါသည်။",
Please_set_the_conversion_exchange_rate_between_the_relevant_store_currency_and_the_financial_deduction_currency_which_will_be_used_for_calculating_order_profit_report_data:"အမှာစာအမြတ်အစီရင်ခံစာတွက်ချက်မှုများတွင် အသုံးပြုရန် ဆိုင်ငွေကြေးမှ ငွေကြေးလျော့ချပေးမှုငွေကြေးသို့ ပြောင်းလဲနှုန်းများကို သတ်မှတ်ပါ။",
Not_involved_in_order_profit_calculation_for_operational_analysis_reference_only:"အမှာစာအမြတ်တွက်ချက်မှုတွင် မပါဝင်ပါ; လည်ပတ်မှုဆိုင်ရာ ခွဲခြမ်းစိတ်ဖြာရန်သာ အသုံးပြုပါ။",
The_actual_settlement_amount_on_the_platform_is_not_included_in_the_calculation_of_order_profits_and_is_only_for_operational_analysis_reference:"ပလက်ဖောင်းမှ တကယ့်ငွေပေးချေမှုပမာဏ; အမှာစာအမြတ်တွက်ချက်မှုတွင် မပါဝင်ပါ; လည်ပတ်မှုဆိုင်ရာ ခွဲခြမ်းစိတ်ဖြာရန်သာ အသုံးပြုပါ။",
The_procedures_for_sellers_to_participate_in_the_PayLater_program_and_receive_fees:"PayLater စနစ်တွင် ပါဝင်သော ရောင်းသူများအား ကောက်ခံသည့် ကြေးများ",
Freight_subsidies_and_rewards_provided_by_the_platform_Freight_subsidies_provided_by_the_platform_for_sellers_to_ship_Delivery_rewards_obtained_by_sellers_signing_a_joint_sponsorship_free_delivery_plan:"ပလက်ဖောင်းမှ ပံ့ပိုးသည့် သယ်ယူပို့ဆောင်ရေး လျှော့စျေးငွေများနှင့် အကျိုးခံစားခွင့်များ + ရောင်းသူမှ ကိုယ်တိုင်ဖြည့်ဆည်းသည့် အော်ဒါများအတွက် ပလက်ဖောင်း သယ်ယူပို့ဆောင်ရေး လျှော့စျေးငွေများ + ပူးပေါင်းထောက်ပံ့သည့် အခမဲ့ပို့ဆောင်ရေး စနစ်တွင် စာရင်းသွင်းထားသော ရောင်းသူများ ရရှိသည့် ပို့ဆောင်ရေး အကျိုးခံစားခွင့်များ",
billID:"ငွေတောင်းခံလွှာ ID",
Deduct_a_20_refund_management_fee_from_the_total_amount_of_returned_items:"ပြန်လည်ပေးအပ်သည့် ပစ္စည်းကြေးစုစုပေါင်းမှ ဖြတ်တောက်သည့် ၂၀% ပြန်အမ်းငွေ စီမံခန့်ခွဲမှုကြေး",
Service_fees_charged_for_participating_in_on_site_special_programs_service_fees_charged_for_participating_in_bonus_rebates_service_fees_charged_for_using_Tiktok_Mall_servers_charged_for_participating_in_coupon_plans_service_fees_charged_for_participating_in_limited_time_rush_purchase_service_fees_charged_for_promotional_activities_service_fees_charged_for_pre_purchase_plans:"ဆိုက်ပေါ် အထူးအစီအစဉ်များတွင် ပါဝင်ခြင်းအတွက် ဝန်ဆောင်ခ + အပို cashback အစီအစဉ်များတွင် ပါဝင်ခြင်းအတွက် ဝန်ဆောင်ခ + Douyin Mall အသုံးပြုခြင်းအတွက် ဝန်ဆောင်ခ + voucher အစီအစဉ်များတွင် ပါဝင်ခြင်းအတွက် ဝန်ဆောင်ခ + flash sale များတွင် ပါဝင်ခြင်းအတွက် ဝန်ဆောင်ခ + ကြော်ငြာလှုပ်ရှားမှုများအတွက် ဝန်ဆောင်ခ + ကြိုမှာအစီအစဉ်များအတွက် ဝန်ဆောင်ခ",
difference_amount:"ကွာဟမှုပမာဏ",
bill_type:"ငွေတောင်းခံလွှာအမျိုးအစား",
recalculateTime:"ငွေတောင်းခံလွှာ ပြန်တွက်ချိန်",
Please_fill_in_the_task_number_first:"အရင်ဆုံး တာဝန်နံပါတ် ထည့်ပါ။",
Payment_time:"ငွေချေမှုရက်စွဲ",
part_number:"ပစ္စည်းနံပါတ်",
The_commission_paid_by_the_seller_to_the_creator_alliance_advertising_commission_commission_purchased_through_partner_links_eligible_advertising_order_commission:"ရောင်းသူမှ ဖန်တီးသူအား ပေးသော ကော်မရှင် + မိတ်ဖက် ကြော်ငြာ ကော်မရှင် + မိတ်ဖက် လင့်ခ်များမှ ဝယ်ယူမှုများအတွက် ကော်မရှင် + သတ်မှတ်ထားသော ကြော်ငြာ အော်ဒါများမှ ကော်မရှင်",
Please_enter_SKU_line_break_or_comma_separated:"SKU များကို လိုင်းချိုး သို့မဟုတ် ကော်မာဖြင့် ခွဲ၍ ထည့်ပါ။",
Recalculate_warehouse_rental_fees:"ဂိုဒေါင်ငှားခ ပြန်တွက်ချက်",
Recalculate_manual_outbound_fees:"လက်ဖြင့် ထွက်ပစ္စည်း ကိုင်တွယ်ခ ပြန်တွက်ချက်",
Recalculate_manual_warehousing_fees:"လက်ဖြင့် ဝင်ပစ္စည်း ကိုင်တွယ်ခ ပြန်တွက်ချက်",
Recalculate_the_return_item_listing_fee:"ပြန်ပို့ပစ္စည်း ပြန်သိုလှောင်ခ ပြန်တွက်ချက်",
Recalculate_storage_fees:"ဝင်ပစ္စည်း ကိုင်တွယ်ခ ပြန်တွက်ချက်",
Recalculate_storage_order_operation_fees:"ဂိုဒေါင်အော်ဒါ ကိုင်တွယ်ခ ပြန်တွက်ချက်ရန်",
Please_select_the_delivery_time:"ပို့ဆောင်ချိန်ကို ရွေးချယ်ပါ",
Copy_the_expense_settings_to_the_specified_warehouse:"အခကြေးငွေ သတ်မှတ်ချက်များကို သတ်မှတ်ထားသော ဂိုဒေါင်သို့ ကူးယူရန်",
Specify_the_customer:"သတ်မှတ်ထားသော ဖောက်သည်",
Customers_who_need_to_be_copied:"ကူးယူရန်လိုအပ်သော ဖောက်သည်",
If_you_do_not_select_it_it_means_that_all_customers_are_selected:"မရွေးထားပါက ဖောက်သည်အားလုံးကို ရွေးထားမည်",
Exclude_customers:"ထည့်မထားသော ဖောက်သည်များ",
Excluded_customers:"ထည့်မထားသော ဖောက်သည်များ",
Specify_the_warehouse:"သတ်မှတ်ထားသော ဂိုဒေါင်",
The_warehouse_that_was_copied:"ကူးယူမည့် ဂိုဒေါင်",
Template_warehouse:"နမူနာ ဂိုဒေါင်",
Specify_the_warehouse_from_which_the_data_originated:"ဒေတာအရင်းအမြစ် သတ်မှတ်သည့် ဂိုဒေါင်",
If_it_is_empty_it_is_equivalent_to_the_specified_warehouse:"အကွက်ကို မဖြည့်ပါက သတ်မှတ်ထားသော ဂိုဒေါင်သို့ အလိုအလျောက် သတ်မှတ်မည်",
Template_customers:"နမူနာ ဖောက်သည်",
Generate_the_header_fee_settings_according_to_the_specified_template:"သတ်မှတ်ထားသော နမူနာအတိုင်း ပထမဆုံး ပို့ဆောင်ခ စီမံချက်များ ဖန်တီးမည်",
The_type_of_expense:"ကြေးအမျိုးအစား",
Order_Processing_Fees:"အော်ဒါ လုပ်ငန်းစဉ်ကြေး",
Warehouse_rental_fee:"ဂိုဒေါင် ငှားခ",
Labelling_fee:"တံဆိပ်တပ်ခ",
Head_fee:"ပထမဆုံး ပို့ဆောင်ခ",
Packaging_material_fee:"ထုပ်ပိုးပစ္စည်းကြေး",
Please_select_a_specified_warehouse:"သတ်မှတ်ထားသော ဂိုဒေါင်ကို ရွေးချယ်ပါ",
Configure_at_least_one_item:"အနည်းဆုံး တစ်ခု ပြင်ဆင်ထားရမည်",
Adjust_the_price_of_the_first_leg_in_batches:"အစုလိုက် ပထမဆုံး ပို့ဆောင်စျေးနှုန်း ချိန်ညှိခြင်း",
Freight_costs:"ကုန်ပို့ခ",
OverRange_shipping_rates:"အကွာအကွင်း ကျော်လွန်သော ကုန်ပို့ခ",
On_the_basis_of_the_original_treatment_the_positive_number_increases_the_price_and_the_negative_number_decreases_the_price:"မူရင်း တန်ဖိုးများအပေါ် အခြေခံ၍ လုပ်ဆောင်မည်။ အပေါင်းဂဏန်းများသည် စျေးနှုန်း တိုးမည်၊ အနုတ်ဂဏန်းများသည် စျေးနှုန်း လျော့မည်။",
Copy_additional_service_fees:"တန်ဖိုးတိုးဝန်ဆောင်မှုကြေးများ မိတ္တူကူးယူခြင်း",
Specify_the_customer_from_which_the_data_originated:"သတ်မှတ်ထားသော ဒေတာအရင်းအမြစ်များမှ ဖောက်သည်များ",
Please_select_a_module_type:"မော်ဂျူးအမျိုးအစားကို ရွေးချယ်ပါ",
copy_approval_template:"အတည်ပြုပုံစံ မိတ္တူကူးယူခြင်း",
copy_template:"ပုံစံ မိတ္တူကူးယူခြင်း",
replace_approver:"အတည်ပြုသူ အစားထိုးခြင်း",
Original_approver:"မူရင်းအတည်ပြုသူ",
Approver:"အတည်ပြုသူ",
Please_select_the_module_type_first:"ပထမဦးစွာ မော်ဂျူးအမျိုးအစားကို ရွေးချယ်ပါ",
Please_select_the_task_stage:"တာဝန်အဆင့်ကို ရွေးချယ်ပါ",
Please_select_the_valueAdded_type:"တန်ဖိုးဖြည့်စွက်မှု အမျိုးအစားကို ရွေးချယ်ပါ",
Please_select_a_template_customer:"ပုံစံ ဖောက်သည်ကို ရွေးချယ်ပါ",
Please_select_a_template_warehouse:"ပုံစံ ဂိုဒေါင်ကို ရွေးချယ်ပါ",
modify_information:"အချက်အလက် တည်းဖြတ်ခြင်း",
receiving_SMS_number:"SMS လက်ခံနံပါတ်",
early_warning_balance:"သတိပေးငွေလက်ကျန်",
whether_to_receive_SMS_messages:"SMS လက်ခံခြင်း",
Not_less_than_zero:"0 ထက် မနည်းရ",
wechat_binding_status:"WeChat ချိတ်ဆက်မှု အခြေအနေ",
get_qrcode:"QR ကုဒ် ရယူခြင်း",
untie:"ချိတ်ဆက်မှု ဖျက်ရန်",
refresh_binding_status:"ချိတ်ဆက်မှု အခြေအနေ ပြန်လည်အသစ်ပြုရန်",
bound:"ချိတ်ဆက်ထားသည်",
not_yet_bound:"ချိတ်ဆက်မထားသည်",
whether_to_untie:"ချိတ်ဆက်မှု ဖျက်မည်?",
officialAccountPushLogs:"တရားဝင်အကောင့် ပို့စ်မှတ်တမ်း စာရင်း",
The_type_of_message:"မက်ဆေ့ခ်ျ အမျိုးအစား",
Push_status:"ပို့စ်အခြေအနေ",
Push_customers:"ပို့ခဲ့သည့်နေရာ",
Push_content:"ပို့စ်အကြောင်းအရာ",
Push_time:"ပို့ချိန်",
Push_the_OpenID:"ပို့စ် OpenID",
creator:"ဖန်တီးသူ",
The_push_succeeded:"ပို့စ်အောင်မြင်သည်",
Push_failed:"ပို့စ်မအောင်မြင်သည်",
Please_enter_a_name_for_the_subAccount:"ခွဲအကောင့်အမည် ထည့်ပါ",
Please_enter_your_mobile_phone_number:"မိုဘိုင်းနံပါတ် ထည့်ပါ",
Please_select_a_role:"အခန်းကဏ္ဍကို ရွေးချယ်ပါ",
Please_select_Enable_status:"ဖွင့်လှစ်မှု အခြေအနေကို ရွေးချယ်ပါ",
role:"အခန်းကဏ္ဍ",
roleGrade:"အခန်းကဏ္ဍ အဆင့်",
Enabled_status:"ဖွင့်လှစ်မှု အခြေအနေ",
The_name_of_the_subAccount:"လက်အောက်အကောင့် အမည်",
Mobile_phone_number:"မိုဘိုင်းနံပါတ်",
mailbox:"အီးမေးလ်လိပ်စာ",
Confirm_your_password:"စကားဝှက် အတည်ပြုပါ",
The_warehouse_to_which_it_belongs:"ဆက်စပ် ဂိုဒေါင်",
Transit_warehouses:"သယ်ယူပို့ဆောင်ရေး ဂိုဒေါင်",
Select_all:"အားလုံးကို ရွေးချယ်ပါ",
operate:"လုပ်ဆောင်ချက်",
Delete:"ဖျက်ပါ",
Please_enter_your_password:"စကားဝှက် ထည့်ပါ",
Please_enter_your_password_correctly_first:"ပထမဦးစွာ စကားဝှက်ကို မှန်ကန်စွာ ထည့်ပါ",
Please_enter_your_confirmation_password:"စကားဝှက် အတည်ပြုပါ",
The_password_entered_twice_is_inconsistent:"ထည့်သွင်းသော စကားဝှက်များ မကိုက်ညီပါ",
This_is_used_to_restrict_the_account_to_only_be_able_to_select_the_next_lower_role_level_when_creating_or_modifying_employee_accounts_during_operations_based_on_the_current_account_is_role_level:"ဝန်ထမ်းအကောင့်များ ဖန်တီး/ပြင်ဆင်သည့်အခါ အကောင့် လုပ်ဆောင်ချက်များကို ကန့်သတ်ရန် အသုံးပြုပြီး လက်ရှိ အကောင့်၏ အခန်းကဏ္ဍ အဆင့်ထက် တစ်ဆင့်နိမ့်သော အခန်းကဏ္ဍများကိုသာ ရွေးချယ်ခွင့်ပြုသည်။",
Modify_the_quality_inspection_quantity:"အရည်အသွေးစစ်ဆေးမှုအရေအတွက် ပြင်ဆင်ခြင်း",
When_there_is_a_labeled_quantity_prioritize_the_fee_deduction_and_the_refund_of_the_labeling_fee_to_avoid_double_deductions:"တံဆိပ်တပ်ထားသောအရေအတွက်များရှိပါက၊ ထပ်တူကြေးများမဖြစ်စေရန် ပထမဦးစွာ လုပ်ငန်းကြေးချေမှုန်းခြင်းနှင့် တံဆိပ်ကြေးပြန်အမ်းပေးခြင်းကို ဦးစားပေးဆောင်ရွက်ပါ။",
Please_enter_your_inquiry:"မေးခွန်းအသေးစိတ်ကို ထည့်ပါ။",
Please_select_the_level_3_data_you_want_to_modify:"ပြင်ဆင်ရန် တတိယဒေတာကို ရွေးပါ။",
Select_the_data_in_the_same_task:"တစ်ခုတည်းသော တာဝန်အောက်ရှိ ဒေတာကို ရွေးပါ။",
The_number_of_quality_inspections_cannot_be_greater_than_the_number_of_appointments:"အရည်အသွေးစစ်ဆေးမှုအရေအတွက်သည် စီစဉ်ထားသောအရေအတွက်ထက် မကျော်လွန်နိုင်ပါ။",
The_number_of_labels_cannot_be_greater_than_the_qualified_quantity:"တံဆိပ်တပ်ထားသောအရေအတွက်သည် အရည်အသွေးပြည့်မီသောအရေအတွက်ထက် မကျော်ရ",
There_is_a_labeled_quantity:"လက်ရှိတံဆိပ်တပ်ထားသောအရေအတွက်",
Whether_to_continue:"ဆက်လက်လုပ်ဆောင်မလား?",
The_operation_was_canceled:"လုပ်ငန်းရပ်ဆိုင်းသွားပါသည်",
Please_check_the_secondary_data:"ဒုတိယဒေတာကို ရွေးချယ်ပါ",
Please_check_the_boxes_under_the_same_shipping_list:"တစ်ခုတည်းသောလက်ခံလွှာအောက်ရှိ ဘောက်စ်များကို ရွေးချယ်ပါ",
Please_select_the_products_in_the_same_task:"တစ်ခုတည်းသောတာဝန်အောက်ရှိ ထုတ်ကုန်များကို ရွေးချယ်ပါ",
Please_check_only_one_task:"တစ်ခုတည်းသာ ရွေးချယ်ပါ",
Please_tick_the_box:"ရွေးချယ်ပါ",
Please_check_only_one_inbound_order:"တစ်ခုတည်းသာ လက်ခံလွှာကို ရွေးချယ်ပါ",
Please_check_the_Inbound_List_or_Inbound_List_box:"လက်ခံလွှာ သို့မဟုတ် လက်ခံလွှာဘောက်စ်များကို ရွေးချယ်ပါ",
operation_cancelled:"လုပ်ငန်းရပ်ဆိုင်းသွားပါသည်",
Complete_quality_inspection_in_batches:"အစုလိုက်အရည်အသွေးစစ်ဆေးမှုပြီးစီးပါပြီ",
The_quantity_to_be_inspected:"စစ်ဆေးရန် စောင့်ဆိုင်းနေသည့် အရေအတွက်",
The_quantity_has_been_inspected:"စစ်ဆေးပြီးသော အရေအတွက်",
sku:"SKU",
inspected_quantity:"စစ်ဆေးပြီးသော အရေအတွက်",
labelled_quantity:"တံဆိပ်ကပ်ပြီးသော အရေအတွက်",
actual_length_cm:"တကယ့်အရှည် (စင်တီမီတာ)",
actual_width_cm:"တကယ့်အကျယ် (စင်တီမီတာ)",
actual_height_cm:"တကယ့်အမြင့် (စင်တီမီတာ)",
actual_weight_kg:"တကယ့်အလေးချိန် (ကီလိုဂရမ်)",
commodity_billing_attribute:"ထုတ်ကုန် ငွေတောင်းခံခြင်း အင်္ဂါရပ်များ",
Confirm_quality_inspection_information:"စစ်ဆေးမှု အသေးစိတ် အတည်ပြုပါ",
No_need_for_confirmation:"အတည်ပြုရန် မလိုအပ်ပါ",
to_be_confirmed:"အတည်ပြုရန် စောင့်ဆိုင်းနေသည်",
acknowledged:"အတည်ပြုပြီး",
Quality_inspection_information_status:"စစ်ဆေးမှု အခြေအနေ",
Confirm_the_actual_weight_length_width_height_and_whether_the_billing_attributes_of_the_goods_are_correct:"တကယ့်အလေးချိန်၊ အတိုင်းအတာများနှင့် ထုတ်ကုန် ငွေတောင်းခံခြင်း အင်္ဂါရပ်များ၏ တိကျမှုကို အတည်ပြုပါ",
Please_verify_the_actual_weight_dimensions_length_width_height_and_the_billing_attributes_of_the_goods_to_prevent_any_abnormal_deductions_of_fees:"မမှန်ကန်သော ဖြုတ်ချခြင်းများ မဖြစ်စေရန် အလေးချိန်၊ အတိုင်းအတာနှင့် ကုန်ပစ္စည်း ငွေတောင်းခံခြင်းဆိုင်ရာ အင်္ဂါရပ်များကို အတည်ပြုပါ။",
Please_input_inspection_quantity:"စစ်ဆေးမည့် အရေအတွက် ထည့်ပါ",
please_input_unqualified_quantity:"မကိုက်ညီသည့် အရေအတွက် ထည့်ပါ",
please_input_labeled_quantity:"တံဆိပ်တပ်မည့် အရေအတွက် ထည့်ပါ",
please_input_positive_number:"အပေါင်းဂဏန်း ထည့်ပါ",
please_input_qualified_quantity:"ကိုက်ညီသည့် အရေအတွက် ထည့်ပါ",
please_select_is_there_a_mark:"တံဆိပ်တပ်ခြင်း အခြေအနေ ရွေးပါ",
please_input_actual_length:"အမှန်တကယ် အရှည် ထည့်ပါ",
please_input_actual_width:"အမှန်တကယ် အကျယ် ထည့်ပါ",
please_input_actual_height:"အမှန်တကယ် အမြင့် ထည့်ပါ",
please_input_actual_weight:"အမှန်တကယ် အလေးချိန် ထည့်ပါ",
please_select_commodity_billing_attribute:"ငွေတောင်းခံခြင်းဆိုင်ရာ အင်္ဂါရပ်များ ရွေးပါ",
please_input_quantity:"အရေအတွက် ထည့်ပါ",
appointment_quantity:"အစီအစဉ်ထားသော အရေအတွက်",
whether_to_go_to_configure_warehouse_inbound_task_control_settings:"ဝင်ရောက်လာမည့် လုပ်ငန်းတာဝန် ထိန်းချုပ်မှု ဆက်တင်များအတွက် သိုလှောင်ဂိုဒေါင် ဖွဲ့စည်းမှုသို့ ဆက်လက်သွားမည်လား?",
please_check:"ကျေးဇူးပြု၍ အမှတ်ပြုပါ",
inspection_quantity_cannot_exceed_reserved_quantity:"စစ်ဆေးမည့် အရေအတွက်သည် သိုလှောင်ထားသည့် အရေအတွက်ထက် မပိုရ",
labeled_quantity_cannot_exceed_qualified_quantity:"တံဆိပ်တပ်မည့် အရေအတွက်သည် အရည်အသွေးပြည့်မည့် အရေအတွက်ထက် မပိုရ",
box_number:"ဘောက်စ်နံပါတ်",
special_commodity_confirm:"အထူးပစ္စည်း – အတည်ပြုပါ?",
box_number_error_please_reenter:"ဘောက်စ်နံပါတ် မှားနေသည် – ကျေးဇူးပြု၍ ထပ်မံ ထည့်ပါ",
please_input_box_number:"ကျေးဇူးပြု၍ ဘောက်စ်နံပါတ် ထည့်ပါ",
please_input_goods_code:"ကျေးဇူးပြု၍ ထုတ်ကုန် ဘားကုဒ် ထည့်ပါ",
current_box_number_no_goods_code:"လက်ရှိ ဘောက်စ်နံပါတ်တွင် ဤထုတ်ကုန် ဘားကုဒ် မပါဝင်ပါ",
duplicate_sku_box_number:"SKU ဘောက်စ်နံပါတ် ထပ်တူ တွေ့ရှိပါသည်",
operation_successful:"လုပ်ငန်းဆောင်ရွက်မှု အောင်မြင်ပါသည်",
product_entry_number:"ဝင်ရောက်လာမည့် ပို့ဆောင်လွှာနံပါတ်",
product:"ထုတ်ကုန်",
has_labeled_quantity_continue:"တံဆိပ်တပ်ထားသော အရေအတွက် ရှိနေပါသည်။ ဆက်လက်လုပ်ဆောင်မလား?",
please_input_real_length:"တကယ့်အရှည်ကို ထည့်ပါ။",
please_input_real_width:"တကယ့်အကျယ်ကို ထည့်ပါ။",
please_input_real_height:"တကယ့်အမြင့်ကို ထည့်ပါ။",
please_input_real_weight:"တကယ့်အလေးချိန်ကို ထည့်ပါ။",
real_length_cm:"တကယ့်အရှည် (စင်တီမီတာ)",
real_width_cm:"တကယ့်အကျယ် (စင်တီမီတာ)",
real_height_cm:"တကယ့်အမြင့် (စင်တီမီတာ)",
real_weight_kg:"တကယ့်အလေးချိန် (ကီလိုဂရမ်)",
commodity_chinese_name:"တရုတ်အမည်",
commodity_english_name:"အင်္ဂလိပ်အမည်",
labeled_quantity:"တံဆိပ်တပ်ထားသော အရေအတွက်",
this_time_labeled_quantity:"လက်ရှိ တံဆိပ်တပ်နေသော အရေအတွက်",
There_is_an_incorrect_location_number:"သိုလှောင်ရာနေရာကုဒ် မမှန်ပါ",
Please_fill_it_out:"ဖြည့်စွက်ပါ။",
shelved_quantity:"စင်ပေါ်တွင် ထားရှိပြီးသား အရေအတွက်",
recommended_storage_location_number:"အကြံပြုသိုလှောင်ရာနေရာ",
reserved_commodity_quantity:"သိမ်းဆည်းထားသော ထုတ်ကုန်အရေအတွက်",
Task_time:"တာဝန်ချိန်",
set_priority_quality_inspection:"ဦးစားပေး စစ်ဆေးမှု သတ်မှတ်",
pause_task:"တာဝန် ရပ်ဆိုင်း",
activate_task:"တာဝန် စတင်",
modify_quality_inspection_num:"စစ်ဆေးမည့် အရေအတွက် ပြင်ဆင်",
to_be_generated:"ထုတ်လုပ်ရန် စောင့်ဆိုင်းနေ",
uncompleted:"မပြီးစီးသေး",
paused:"ရပ်ဆိုင်းထား",
Rebinding_task:"တာဝန် ပြန်ခန့်",
Mandate_Holder:"တာဝန် ဆောင်ရွက်သူ",
task_id:"တာဝန် ID",
customer_id:"ဖောက်သည် ID",
task_executor:"တာဝန် ဆောင်ရွက်သူ",
task_quality_inspection_start_time:"တာဝန် စစ်ဆေးမှု စတင်ချိန်",
task_quality_inspection_end_time:"တာဝန် စစ်ဆေးမှု အဆုံးချိန်",
total_reserved_quantity:"အစီအစဉ်ထားသော စုစုပေါင်း အရေအတွက်",
total_qualified_quantity:"အောင်မြင်သော စုစုပေါင်း အရေအတွက်",
total_unqualified_quantity:"မအောင်မြင်သော စုစုပေါင်း အရေအတွက်",
is_task_paused:"တာဝန် ရပ်ဆိုင်းမလား?",
is_priority_quality_inspection:"ဦးစားပေး စစ်ဆေးမလား?",
Rebinding:"ပြန်ခန့်",
is_excess_quality_inspection_task:"စစ်ဆေးမှု ကျော်လွန်နေသော တာဝန်?",
reserved_quantity:"အစီအစဉ်ထားသော အရေအတွက်",
excess_quantity:"ပိုမိုပို့ဆောင်ထားသော အရေအတွက်",
lack_send_quantity:"လျော့နည်းစွာ ပို့ဆောင်ထားသော အရေအတွက်",
breakage_quantity:"ပျက်စီးသောအရေအတွက်",
is_wrongly_sent_sku:"မှားယွင်းပို့သော SKU",
Please_select_the_assignee:"တာဝန်ဆောင်ရွက်သူကိုရွေးချယ်ပါ",
original_qualified_quantity:"မူရင်းအောင်မြင်သောအရေအတွက်",
original_labeled_quantity:"မူရင်းတံဆိပ်တပ်ထားသောအရေအတွက်",
original_lack_send_quantity:"မူရင်းပို့ဆောင်မှုနည်းသောအရေအတွက်",
original_breakage_quantity:"မူရင်းပျက်စီးသောအရေအတွက်",
please_select:"အမှတ်ပြုပါ",
confirm_operation:"လုပ်ငန်းအတည်ပြုပါသလား?",
prompt:"မေးခွန်း",
cancel:"ဖျက်ရန်",
set_priority_shelves:"ဦးစားပေးစာရင်းသတ်မှတ်ခြင်း",
total_shelved_quantity:"စာရင်းသွင်းထားသောစုစုပေါင်းအရေအတွက်",
is_priority_shelves:"ဦးစားပေးစာရင်း",
batch_complete_shelves:"အုပ်စုပြီးစီးစာရင်း",
shelves_layer:"စင်ထပ်",
shelves_column:"စင်တန်း",
shelves_cube:"စွမ်းရည်",
Mark_the_number_of_anomalies:"မမှန်ကန်သောအရေအတွက်အမှတ်ပြုခြင်း",
Please_enter_a_valid_number:"မှန်ကန်သောနံပါတ်ထည့်ပါ",
Please_enter_an_integer_greater_than_0:"0 ထက်ကြီးသောအပြည့်အစုံနံပါတ်ထည့်ပါ",
The_current_row_data_is_abnormal_The_qualified_quantity_cannot_be_less_than_the_quantity_that_has_been_put_on_the_shelves:"လက်ရှိ အတန်းဒေတာ မမှန်ကန်မှု: အရည်အသွေးပြည့်မီသော အရေအတွက်သည် စင်ပေါ်ထားရှိသော အရေအတွက်ထက် မနည်းနိုင်ပါ။",
The_abnormal_quantity_cannot_exceed:"မမှန်ကန်သော အရေအတွက်သည် မကျော်နိုင်ပါ။",
Exchange_shipping_fee:"လဲလှယ်ပို့ဆောင်ခ",
Seller_shipping_discount:"ရောင်းသူ ပို့ဆောင်ခ လျှော့စျေး",
TSP_commission:"TSP ကော်မရှင်",
Transportation_insurance_premium:"သယ်ယူပို့ဆောင်ရေး အာမခံကြေး",
Credit_card_payment_processing_fee:"ခရက်ဒစ်ကတ် ငွေပေးချေမှု လုပ်ငန်းဆောင်တာကြေး",
SFP_service_fee:"SFP ဝန်ဆောင်မှုကြေး",
Ecological_donation:"ပတ်ဝန်းကျင်ဆိုင်ရာ လှူဒါန်းငွေ",
Transportation_Service_Tax_SST:"သယ်ယူပို့ဆောင်ရေး ဝန်ဆောင်မှု အခွန် (SST)",
Platform_adjustment_amount:"ပလက်ဖောင်း ချိန်ညှိငွေ",
TikTok_Coupons:"TikTok ကူပွန်",
TikTok_product_discounts:"TikTok ထုတ်ကုန် လျှော့စျေး",
Add_multiple_SKU:"ပိုပို့ထားသော SKU ထည့်ရန်",
Add_wrongly_sent_SKU:"မှားပို့ထားသော SKU ထည့်ရန်",
preview_file:"ဖိုင်များကို ကြိုကြည့်ရန်",
all_file_number:"စုစုပေါင်း ဖိုင်များ",
can_preview_file_number:"ကြိုကြည့်နိုင်သော ဖိုင်များ",
can_not_preview_file_number:"မကြိုကြည့်နိုင်သော ဖိုင်များ",
current_preview_file:"လက်ရှိ ကြိုကြည့်နေသော ဖိုင်",
download_all:"အားလုံး ဒေါင်းလုဒ်လုပ်ရန်",
download_file:"ဖိုင် ဒေါင်းလုဒ်လုပ်ရန်",
upload_file:"ဖိုင် တင်ရန်",
add_type_of_value_added_expense:"တန်ဖိုးတိုးကြေး အမျိုးအစား ထည့်ရန်",
type_of_value_added:"တန်ဖိုးတိုး အမျိုးအစား",
revocation_time:"ဖျက်သိမ်းချိန်",
can_preview:"ကြိုကြည့်နိုင်သည်",
can_not_preview:"မကြိုကြည့်နိုင်သည်",
task_phase:"တာဝန်အဆင့်",
customer_file:"ဖောက်သည် ဖိုင်များ",
view_file:"ဖိုင် ကြည့်ရန်",
warehouse_file:"ဂိုဒေါင် ဖိုင်များ",
a:"ပစ္စည်းများ",
freight:"ပို့ဆောင်ခ",
special_expense:"အထူးကြေးများ",
revocation_operator:"ဖျက်သိမ်းသူ",
accomplish_operator:"ပြီးစီးသူ",
confirm_audit:"ပြန်လည်သုံးသပ်မှု အတည်ပြုရန်",
return_to_be_audit:"ပြန်လည်သုံးသပ်ရန် စောင့်ဆိုင်းနေသော ဖိုင်",
filename:"ဖိုင်အမည်",
value_added_task_id:"တန်ဖိုးတိုးလုပ်ငန်းတာဝန် ID",
whether_to_submit:"တင်သွင်းပြီး",
cancelled_operation:"ဖျက်သိမ်းပြီး",
transfer_inventory_customer:"ကုန်ပစ္စည်းလွှဲပြောင်းမည့် ဖောက်သည်",
whether_to_audit:"အတည်ပြုပြီး",
whether_to_return_to_be_audit:"ပြန်လည်သုံးသပ်ရန်",
only_can_upload:"တင်သွင်းရန်သာ",
file_and_not_more_than_300_MB:"ဖိုင်များ၊ 300MB မကျော်",
add_expense_item:"ကြေးပစ္စည်း ထည့်ရန်",
add_settings_of_value_added_expense:"တန်ဖိုးတိုးကြေး ဆက်တင်များ ထည့်ရန်",
default_expense:"မူလကြေး",
valueAddedServiceTask:"တန်ဖိုးတိုးဝန်ဆောင်မှု လုပ်ငန်းတာဝန်",
operateValueAddedServiceTask:"တန်ဖိုးတိုးဝန်ဆောင်မှု လုပ်ငန်းတာဝန် ဆောင်ရွက်ရန်",
valueAddedServiceTaskDetail:"တန်ဖိုးတိုးဝန်ဆောင်မှု လုပ်ငန်းတာဝန် အသေးစိတ်",
valueAddedServiceFee:"တန်ဖိုးတိုးဝန်ဆောင်မှုကြေး",
valueAddedServiceList:"တန်ဖိုးတိုးဝန်ဆောင်မှု စာရင်း",
approverList:"အတည်ပြုသူ စာရင်း",
approvalProcesstemplate:"အတည်ပြုခြင်းလုပ်ငန်းစဉ် နမူနာ",
Import_the_approval_process_template:"အတည်ပြုခြင်းလုပ်ငန်းစဉ် နမူနာ တင်သွင်းရန်",
SKU_Inventory_Transfer:"SKU ကုန်ပစ္စည်း လွှဲပြောင်းခြင်း",
Full_Inventory:"ကုန်ပစ္စည်းအားလုံး",
Transfer_the_entire_inventory_of_the_corresponding_SKU_in_the_system_to_the_specified_customer_in_all_warehouses_After_the_task_is_completed_the_product_barcode_and_SKU_will_have_a_suffix:"စနစ်ရှိ ဂိုဒေါင်အားလုံးမှ သတ်မှတ်ထားသော SKU ၏ ပစ္စည်းစာရင်းအားလုံးကို သတ်မှတ်ထားသော ဖောက်သည်ထံ လွှဲပြောင်းပေးမည်။ တာဝန်ပြီးဆုံးပါက ထုတ်ကုန်ဘားကုဒ်များနှင့် SKU များတွင် နောက်ဆက်တွဲစာလုံး (suffix) တစ်ခု ထည့်သွင်းမည်။",
Partial_Inventory:"ပစ္စည်းစာရင်း အပိုင်းပိုင်း",
Transfer_the_specified_quantity_of_the_corresponding_SKU_in_the_system_to_the_specified_customer_Re_labeling_is_required:"စနစ်မှ သတ်မှတ်ထားသော SKU အတွက် သတ်မှတ်ထားသော ပမာဏရှိ ပစ္စည်းစာရင်းကို သတ်မှတ်ထားသော ဖောက်သည်ထံ လွှဲပြောင်းပေးမည်။ အမှတ်တံဆိပ် ပြန်တပ်ရန် လိုအပ်ပါသည်။",
Label_Removal:"အမှတ်တံဆိပ် ဖယ်ရှားခြင်း",
Common_scenarios_include_removing_the_specified_barcode_from_the_product_The_warehouse_will_re_price_this_task_based_on_the_difficulty_of_processing:"ပုံမှန်အခြေအနေ - ထုတ်ကုန်များမှ သတ်မှတ်ထားသော ဘားကုဒ်များကို ဖယ်ရှားခြင်း။ လုပ်ငန်းရှုပ်ထွေးမှုအပေါ် မူတည်၍ ဂိုဒေါင်မှ စျေးနှုန်းကို ပြန်လည်သုံးသပ်နိုင်ပါသည်။",
Replace_Product_Barcode:"ထုတ်ကုန်ဘားကုဒ် အစားထိုးခြင်း",
Replace_the_barcode_on_the_product_with_the_system_barcode_Common_scenarios_include_incorrect_barcode_content_mismatch_with_system_settings_damaged_barcode_stained_barcode_and_aged_barcode_that_cannot_be_recognized:"ထုတ်ကုန်တွင် ရှိပြီးသား ဘားကုဒ်ကို စနစ်မှ ထုတ်ပေးသော ဘားကုဒ်ဖြင့် အစားထိုးခြင်း။ ပုံမှန်ဖြစ်ပေါ်သော အခြေအနေများ - ဘားကုဒ်အကြောင်းအရာ မှားယွင်းခြင်း၊ စနစ်မှတ်တမ်းများနှင့် မကိုက်ညီခြင်း၊ ဘားကုဒ်ပျက်စီးခြင်း၊ ညစ်ပတ်ခြင်း/အမှိုက်ကျခြင်း၊ သက်တမ်းရှည်၍ ဖတ်မရခြင်း စသည်တို့။",
Replace_Other_Labels_on_Products:"ထုတ်ကုန်ပေါ်ရှိ အခြားတံဆိပ်များ အစားထိုးခြင်း",
Replace_the_labels_on_products_according_to_requirements_If_the_processing_is_complex_please_describe_it_clearly_or_provide_detailed_information_The_warehouse_will_re_price_this_task_based_on_the_difficulty_of_processing:"တောင်းဆိုသည့်အတိုင်း တံဆိပ်အစားထိုးခြင်း လုပ်ငန်းစဉ်ကို ဆောင်ရွက်ပါ။ လုပ်ငန်းစဉ် ရှုပ်ထွေးပါက၊ ကျေးဇူးပြု၍ ရှင်းလင်းသေချာသော ဖော်ပြချက် သို့မဟုတ် အသေးစိတ်စာရွက်စာတမ်းများ ပေးပါ။ ဂိုဒေါင်သည် ဤတာဝန်ကို လုပ်ငန်းစဉ် ရှုပ်ထွေးမှုအပေါ် မူတည်၍ ပြန်လည်စျေးနှုန်းသတ်မှတ်မည်။",
Processing:"ထုပ်ပိုးခြင်း",
Common_scenarios_include_processing_the_packaging_box_bubble_wrap_and_specified_products_transported_to_the_warehouse_If_it_is_complex_please_provide_a_detailed_operation_process_It_can_be_created_together_with_the_creation_of_the_inventory_receipt_or_added_as_a_value_added_service_before_the_inventory_receipt_starts_inspection:"ပုံမှန်အခြေအနေများ: သတ်မှတ်ထားသော ထုတ်ကုန်များနှင့်အတူ ဂိုဒေါင်သို့ ပို့ဆောင်ထားသော ထုပ်ပိုးသေတ္တာများနှင့် ဘတ်ဘယ်လ်ဝရက်များကို ထုပ်ပိုးခြင်း။ ရှုပ်ထွေးသော လုပ်ငန်းစဉ်များအတွက်၊ ကျေးဇူးပြု၍ အသေးစိတ်လုပ်ထုံးလုပ်နည်းညွှန်ကြားချက်များ ပေးပါ။ ဤဝန်ဆောင်မှုကို ကုန်ပစ္စည်းလက်ခံမှတ်တမ်းနှင့် တပြိုင်နက် ဖန်တီးနိုင်ပြီး၊ အရည်အသွေးစစ်ဆေးမှု စတင်မတိုင်မီ တန်ဖိုးဖြည့်ဝန်ဆောင်မှုအဖြစ် ထည့်သွင်းနိုင်သည်။",
Assembly:"တပ်ဆင်ခြင်း",
Common_scenarios_include_assembling_multiple_products_into_a_new_product_or_multiple_assemblies_of_products_and_adjusting_the_inventory_for_corresponding_shelf_up_and_shelf_down_operations_after_assembly_If_there_are_complex_assembly_operations_please_provide_detailed_explanations_and_example_files:"ပုံမှန်အခြေအနေများ။ ပစ္စည်းများစွာကို ထုတ်ကုန်အသစ်တစ်ခုအဖြစ် တပ်ဆင်ခြင်း၊ သို့မဟုတ် ပစ္စည်းအရေအတွက်များကို သင့်လျော်စွာ ချိန်ညှိကာ တပ်ဆင်ရေးအဆင့်များစွာ ဆောင်ရွက်ခြင်း။ ရှုပ်ထွေးသော တပ်ဆင်ရေးလုပ်ထုံးလုပ်နည်းများအတွက် အသေးစိတ်ရှင်းလင်းချက်များနှင့် ဥပမာပြစာရွက်စာတမ်းများ ပေးပါ။",
transfer_customer_id:"ဖောက်သည် ID ပြောင်းရွှေ့ခြင်း",
Transfer_inventory_to_use_current_label:"လက်ရှိ တံဆိပ်များဖြင့် ပစ္စည်းများ ပြောင်းရွှေ့ခြင်း",
If_selected_the_product_barcode_of_the_transferred_party_will_be_changed_to_the_current_SKU_barcode_If_not_selected_the_product_barcode_of_the_transferred_party_will_remain_unchanged:"ပြောင်းရွှေ့ပြီးနောက် ပြောင်းရွှေ့ပစ္စည်းများ၏ ဘားကုဒ်များကို လက်ရှိ SKU ၏ ဘားကုဒ်ဖြင့် အစားထိုးရန် 'ဟုတ်' ကို ရွေးပါ။ မဟုတ် (No) ကိုရွေးပါ: ကူးပြောင်းပို့သော ပစ္စည်း၏ ဘားကုဒ် မပြောင်းလဲပါ။",
file:"ဖိုင်",
select_inventory:"ပစ္စည်းစာရင်းရွေးချယ်",
Save_and_Submit:"သိမ်းပြီး တင်သွင်း",
greater_than_0_number:"0 ထက် ကြီးသော အရေအတွက်",
batch_submit:"အစုလိုက် တင်သွင်းခြင်း",
batch_return_to_be_audit:"ပြန်လည်သုံးသပ်ရန် စောင့်ဆိုင်းနေသော အစုလိုက် ပြန်ပို့ခြင်း",
batch_revoke:"အစုလိုက် ဖျက်သိမ်းခြင်း",
batch_confirm:"အစုလိုက် အတည်ပြုခြင်း",
Confirm_revoke:"ဖျက်သိမ်းခြင်းကို အတည်ပြုပါသလား?",
The_remarks_are_the_same_as_the_original:"မူရင်းနှင့် တူညီသော မှတ်ချက်များ",
task_info:"တာဝန်အချက်အလက်",
Audit_flow:"ပြန်လည်သုံးသပ်ခြင်းလုပ်ငန်းစဉ်",
Joint_approval:"ပူးတွဲအတည်ပြုခြင်း",
Single_approval:"တစ်ဦးချင်းစီ အတည်ပြုခြင်း",
Process_flow:"လုပ်ငန်းစဉ် လည်ပတ်မှု",
Module_type:"မော်ဂျူးအမျိုးအစား",
processing:"လုပ်ငန်းစဉ်",
add_flow:"လုပ်ငန်းစဉ် ထည့်သွင်း",
edit_flow:"လုပ်ငန်းစဉ် တည်းဖြတ်",
select_auditor:"ပြန်လည်သုံးသပ်သူ ရွေးချယ်",
Audit_details:"ပြန်လည်သုံးသပ်မှု အသေးစိတ်",
Approval_level:"အတည်ပြုအဆင့်",
approver_Type:"အတည်ပြုပုံစံ",
comfirm_delete:"ဖျက်သိမ်းခြင်းကို အတည်ပြုပါသလား?",
please_set_audit_flow:"ပြန်လည်သုံးသပ်ခြင်းလုပ်ငန်းစဉ်ကို ပြင်ဆင်ပါ။",
valueAddedServiceFeeDetail:"တန်ဖိုးတိုးဝန်ဆောင်မှုကြေး အသေးစိတ်",
addValueAddedServiceTask:"တန်ဖိုးတိုးဝန်ဆောင်မှုတာဝန် ဖန်တီးခြင်း",
expense_deduction_details:"ကြေးပြင်ဆင်ခြင်း အသေးစိတ်",
createValueAddedServiceTask:"တန်ဖိုးတိုးဝန်ဆောင်မှုတာဝန် ဖန်တီးခြင်း",
editValueAddedServiceTask:"တန်ဖိုးတိုးဝန်ဆောင်မှုတာဝန် တည်းဖြတ်ခြင်း",
create_Task:"တာဝန် ဖန်တီးခြင်း",
set_Audit_Flow:"ပြန်လည်သုံးသပ်ခြင်းလုပ်ငန်းစဉ် ပြင်ဆင်ခြင်း",
return_Audit_Flow:"ပြန်လည်သုံးသပ်ခြင်းလုပ်ငန်းစဉ် ဖျက်ခြင်း",
batch_confirm_audit:"အစုလိုက် ပြန်လည်သုံးသပ် အတည်ပြုခြင်း",
set_process_flow:"လုပ်ငန်းစဉ် လည်ပတ်မှု ဖွဲ့စည်းပုံ ပြင်ဆင်ခြင်း",
return_process_flow:"လုပ်ငန်းစဉ် လည်ပတ်မှု ဖျက်ခြင်း",
batch_complete_task:"အစုလိုက် တာဝန်များ ပြီးစီးစေခြင်း",
Edit_price:"စျေးနှုန်း တည်းဖြတ်ခြင်း",
Joint_audit:"အတူတကွ ပြန်လည်သုံးသပ်ခြင်း",
Single_audit:"တစ်ဦးချင်း ပြန်လည်သုံးသပ်ခြင်း",
add_approver:"ပြန်လည်သုံးသပ်သူ ထည့်ခြင်း",
print_task:"တာဝန် ပုံနှိပ်ခြင်း",
view_audit_process:"ပြန်လည်သုံးသပ်ခြင်းလုပ်ငန်းစဉ် ကြည့်ရှုခြင်း",
view_process_flow:"လုပ်ငန်းစဉ် လည်ပတ်မှု ဖွဲ့စည်းပုံ ကြည့်ရှုခြင်း",
confirm_complete_task:"တာဝန် ပြီးစီးမှု အတည်ပြုခြင်း",
billing_type:"ငွေတောင်းခံပုံ",
mark_Exception:"မမှန်ကန်ဟု အမှတ်အသားပြု",
replenishmentTaskControl:"ပြန်ဖြည့်ခြင်း လုပ်ငန်းတာဝန် ထိန်းချုပ်မှု",
replenishmentList:"ပြန်ဖြည့်ခြင်း လုပ်ငန်းတာဝန် စာရင်း",
Picking_storage_location_number:"ရွေးယူရာနေရာ ID",
Inventory_storage_location_number:"သိုလှောင်ရာနေရာ ID",
Order_quantity_awaiting_replenishment:"ပြန်ဖြည့်ရန် စောင့်ဆိုင်းနေသော အော်ဒါအရေအတွက်",
Replenishment_control_threshold_quantity:"ပြန်ဖြည့်ခြင်း ထိန်းချုပ်မှု အကန့်အသတ်အရေအတွက်",
Picking_items_below_the_threshold_based_on_the_current_inventory_quantity:"ရွေးယူရာတွင် ရှိသော ပစ္စည်းအရေအတွက် အကန့်အသတ်အောက် ကျခြင်း",
Inventory_threshold_for_picking_warehouse_locations:"ရွေးယူရာနေရာ ပစ္စည်း အကန့်အသတ်",
Number_of_task_varieties:"လုပ်ငန်းတာဝန်ရှိ ပစ္စည်းအရေအတွက်",
No_recommended_storage_location_Default_replenishment_quantity_is_not_specified:"အကြံပြုမထားသော တည်နေရာများအတွက် ပုံမှန် ပြန်ဖြည့်ပမာဏ",
Generate_replenishment_task:"ပြန်ဖြည့်လုပ်ငန်းတာဝန် ဖန်တီးခြင်း",
Create_replenishment_task_control:"ပြန်ဖြည့်လုပ်ငန်းတာဝန် ထိန်းချုပ်မှု ဖန်တီးခြင်း",
Only_video_and_image_formats_are_supported_for_preview_for_other_types_of_files_please_download_them_and_view_them:"ကြိုကြည့်ရန် ဗီဒီယိုနှင့် ပုံဖော်မက်များကိုသာ ထောက်ပံ့ပါသည်။ ကြည့်ရှုရန် အခြားဖိုင်အမျိုးအစားများကို ဒေါင်းလုဒ်လုပ်ပါ။",
returnRemark:"ပြန်လည်မှတ်ချက်များ",
The_length_of_this_note_does_not_exceed_2000_characters:"မှတ်ချက်အရှည်သည် 2000 အက္ခရာထက် မကျော်ရ",
shopeeOnlineProductDetails:"Shopee အွန်လိုင်းထုတ်ကုန် အသေးစိတ်",
lazadaOnlineProductDetails:"Lazada အွန်လိုင်းထုတ်ကုန် အသေးစိတ်",
tiktokOnlineProductDetails:"TikTok အွန်လိုင်းထုတ်ကုန် အသေးစိတ်",
lazadaHostTheOnlineProductDetails:"Lazada စီမံခန့်ခွဲသော အွန်လိုင်း ထုတ်ကုန် အသေးစိတ်",
Shop_SKU:"ဆိုင် SKU",
Inventory_SKU:"ကုန်ပစ္စည်းစာရင်း SKU",
Multi_attribute_ID:"အင်္ဂါရပ်များစွာ ID",
Pairing_Log:"ကိုက်ညီမှတ်တမ်း",
"Confirm_unpairing?":"ချိတ်ဆက်မှုဖျက်ခြင်း အတည်ပြုမလား?",
Prompt:"မေးခွန်း",
Confirm:"အတည်ပြု",
Operation_successful:"လုပ်ငန်းစဉ် အောင်မြင်ပါပြီ",
Deletion_cancelled:"ဖျက်ခြင်း ပယ်ဖျက်ပါပြီ",
Unpair:"ချိတ်ဆက်မှုဖျက်ခြင်း",
Online_SKU_Image:"အွန်လိုင်း SKU ပုံ",
Multi_attribute:"အင်္ဂါရပ်များစွာ",
Inventory_SKU_Image:"ကုန်ပစ္စည်းစာရင်း SKU ပုံ",
Chinese_Name:"တရုတ်အမည်",
English_Name:"အင်္ဂလိပ်အမည်",
Store:"ဆိုင်",
Inventory_Sync_Time:"စာရင်းညှိနှိုင်းချိန်",
Inventory_Sync_Quantity:"စာရင်းညှိနှိုင်းအရေအတွက်",
Online_SKU:"အွန်လိုင်း SKU",
Please_select_customer_first:"အရင်ဆုံး ဖောက်သည်ကို ရွေးချယ်ပါ။",
Please_check_only_one_item:"တစ်ခုတည်းသာ အမှတ်အသားပြုပါ။",
Inventory_synchronization_time:"စာရင်းညှိနှိုင်းချိန်",
Inventory_synchronization_quantity:"စာရင်းညှိနှိုင်းအရေအတွက်",
Handover_task_order_number:"လွှဲပြောင်းတာဝန် အော်ဒါနံပါတ်",
taskStatus:"တာဝန်အခြေအနေ",
delivery_door:"ပို့ဆောင်ရေးတံခါး",
trailer_number:"ထရေလာနံပါတ်",
handover_person:"လွှဲပြောင်းရေး ဝန်ထမ်းများ",
handover_start_time:"လွှဲပြောင်းခြင်း စတင်ချိန်",
handover_end_time:"လွှဲပြောင်းခြင်း အဆုံးချိန်",
handover_attachments:"လွှဲပြောင်းပူးတွဲစာရွက်များ",
Ended:"ပြီးစီး",
handoverTime:"လွှဲပြောင်းချိန်",
scan_the_flow_chart:"စကင် အဆင့်လိုက်",
upload_attachments:"ပူးတွဲစာရွက်များ တင်သွင်းခြင်း",
print_handover_form:"လွှဲပြောင်းလွှာ ပုံနှိပ်ခြင်း",
scanTime:"စကင်ချိန်",
orderDetails:"အော်ဒါအသေးစိတ်",
handover_scanning_time:"လွှဲပြောင်း စကင်ချိန်",
scan_people:"စကင်နာ",
create_handover_task:"လွှဲပြောင်းတာဝန် ဖန်တီးခြင်း",
end_handover_task:"လွှဲပြောင်းတာဝန် အဆုံးသတ်ခြင်း",
Are_you_sure_to_end_the_current_friendship_task:"လက်ရှိ လွှဲပြောင်းတာဝန် အဆုံးသတ်ခြင်းကို အတည်ပြုပါသလား?",
end_handover_task_success:"လွှဲပြောင်းတာဝန် အောင်မြင်စွာ အဆုံးသတ်ပြီးပါပြီ",
created_successfully:"ဖန်တီးမှု အောင်မြင်ပါပြီ",
Please_enter_the_task_number:"တာဝန်နံပါတ် ထည့်ပါ။",
marking_can_be_posted_for_outbound_shipment:"အပြင်ပို့ရန် တံဆိပ်တပ်ထားသော အရာများ အမှတ်ပြုခြင်း",
remove_the_label_from_the_outbound_shipment:"အပြင်ပို့ရန် တံဆိပ်တပ်ထားသော အရာများ ဖယ်ရှားခြင်း",
selected_product:"ရွေးထားသော ပစ္စည်းများ",
can_be_posted_and_shipped_from_the_warehouse:"အပြင်ပို့ရန် တံဆိပ်တပ်ထားသော ဂိုဒေါင်",
batch_posting_outbound_information:"အစုလိုက် အပြင်ပို့ရန် တံဆိပ်တပ်ထားသော အချက်အလက်များ",
scan:"စကင်",
batch_labeling_posting_and_outbound:"အစုလိုက် အပြင်ပို့ရန် တံဆိပ်တပ်ထားသော အရာများ အမှတ်ပြုခြင်း",
batch_deletion_of_tags_stickers_and_outbound_shipments:"အမှတ်တံဆိပ်ထိုးထားသော ထွက်ပစ္စည်းများအတွက် အစုလိုက် ဖျက်ခြင်း",
amount_money:"အရေအတွက်",
logisticsControlList:"ကုန်ပို့ရေး လက်လွှဲထိန်းချုပ်မှု",
Confirm_the_deletion_of_the_logistics_handover_processr:"ကုန်ပို့ရေး လက်လွှဲကို ဖျက်ရန် အတည်ပြုပါသလား?",
New_logistics_handover_added:"ကုန်ပို့ရေး လက်လွှဲ အသစ် ထည့်ရန်",
taskSchedulingList:"တာဝန်ချိန်ဇယား စာရင်း",
taskLogList:"တာဝန်မှတ်တမ်း စာရင်း",
serverList:"ဆာဗာ စာရင်း",
Task_name:"တာဝန်အမည်",
Task_type:"တာဝန်အမျိုးအစား",
Task_priority:"တာဝန် ဦးစားပေးမှု",
Distribution_rules:"ဖြန့်ဖြူးရေး စည်းမျဉ်းများ",
Port_path:"Port လမ်းကြောင်း",
Minimum_running_memory:"အနည်းဆုံး လည်ပတ်ရန် မှတ်ဉာဏ်",
Minimum_running_CPU:"အနည်းဆုံး လည်ပတ်ရန် CPU",
Whether_it_is_enabled:"ဖွင့်/ပိတ်",
Asynchronous_distribution:"အချိန်မရွေး ဖြန့်ဖြူးခြင်း",
Scheduled_execution:"ချိန်းထားသော ဆောင်ရွက်မှု",
Periodical_execution:"ကာလအလိုက် ဆောင်ရွက်ခြင်း",
Last_run_start_time:"နောက်ဆုံး ဆောင်ရွက်ချိန် စတင်ချိန်",
Please_enter_a_name_for_the_task:"တာဝန်အမည် ထည့်ပါ",
Please_enter_a_task_priority:"တာဝန် ဦးစားပေးမှု ထည့်ပါ",
Please_enter_a_distribution_rule:"ဖြန့်ဖြူးရေး စည်းမျဉ်းများ ထည့်ပါ",
Please_enter_the_port_path:"Port လမ်းကြောင်း ထည့်ပါ",
Please_enter_the_minimum_running_memory:"အနည်းဆုံး RAM ထည့်ပါ",
Please_enter_the_minimum_running_CPU:"အနည်းဆုံး CPU ထည့်ပါ",
Distribute_parameter_content:"ဖြန့်ဖြူးရေး ပါရာမီတာ အကြောင်းအရာ",
Unusual_content:"Exception အကြောင်းအရာ",
Abnormal_time:"Exception အချိန်",
Server_status:"ဆာဗာ အခြေအနေ",
Server_name:"ဆာဗာ အမည်",
Server_port:"ဆာဗာ Port",
memory:"မှတ်ဉာဏ်",
Update_the_server_information:"ဆာဗာ အချက်အလက် ပြင်ဆင်ရန်",
listWarehouseTransferTasks:"ဂိုဒေါင် ပြောင်းရွှေ့ တာဝန် စာရင်း",
Move_out_Of_Warehouse:"ဂိုဒေါင် ထွက်",
Move_into_warehouse:"ဂိုဒေါင် ဝင်",
Completion_time_warehouse_transfer:"ပြောင်းရွှေ့ပြီးချိန်",
Please_select_to_move_out_of_the_warehouse:"ထုတ်ပို့ရန် ဂိုဒေါင်ကို ရွေးချယ်ပါ",
Please_select_to_move_into_the_warehouse:"ထည့်သွင်းရန် ဂိုဒေါင်ကို ရွေးချယ်ပါ",
Moving_in_and_out_of_the_warehouse_is_not_allowed_to_be_repeated:"Duplicate ဂိုဒေါင်များကို ထည့်သွင်းရန်နှင့် ထုတ်ပို့ရန် နှစ်ခုစလုံးအတွက် ရွေးချယ်၍ မရပါ။",
Warehouse_transfer_task_number:"လွှဲပြောင်းတာဝန် ID",
Remove_warehouse_location_number:"ထုတ်ပို့မည့် တည်နေရာ ID",
Move_into_storage_location_number:"ထည့်သွင်းမည့် တည်နေရာ ID",
Create_warehouse_transfer_task:"လွှဲပြောင်းတာဝန် ဖန်တီးခြင်း",
addWarehouseTransferTaskBtn:"လွှဲပြောင်းတာဝန် ဖန်တီးခြင်း",
edit_warehouse_transfer_task:"လွှဲပြောင်းတာဝန် တည်းဖြတ်ခြင်း",
Warehouse_transfer_type:"လွှဲပြောင်းအမျိုးအစား",
Partial_warehouse_transfer:"အပိုင်းဆိုင်ရာ လွှဲပြောင်းခြင်း",
All_positions_transferred:"အပြည့်အစုံ လွှဲပြောင်းခြင်း",
Warehouse_transfer_information:"လွှဲပြောင်းခြင်း အချက်အလက်များ",
Move_out_warehouse_location:"ထုတ်ပို့မည့် တည်နေရာ ID",
Move_into_storage_location:"ထည့်သွင်းမည့် တည်နေရာ ID",
Please_select_the_type_of_warehouse_transfer:"လွှဲပြောင်းအမျိုးအစားကို ရွေးချယ်ပါ",
Please_select_the_storage_location_number_to_be_moved_into:"ပို့ဆောင်မည့် ဘေးနံပါတ်ကို ရွေးချယ်ပါ",
Select_the_goods_that_need_to_be_transferred:"ရွှေ့ပြောင်းမည့် ပစ္စည်းများကို ရွေးချယ်ပါ",
Quickly_plan_storage_locations:"အမြန် ဘေးစီမံခန့်ခွဲခြင်း",
Please_select_the_goods_that_require_rapid_planning_of_storage_locations:"အမြန် ဘေးစီမံခန့်ခွဲရန် လိုအပ်သော ပစ္စည်းများကို ရွေးချယ်ပါ",
Only_virtual_and_temporary_storage_locations_can_be_used_at_this_location_The_virtual_and_temporary_storage_locations_of_this_warehouse_are_empty_Please_create_the_corresponding_virtual_and_temporary_storage_locations_for_the_warehouse_and_then_refresh_again:"ဤနေရာတွင် virtual နှင့် temporary ဘေးများကိုသာ အသုံးပြုနိုင်ပါသည်။ ဤဂိုဒေါင်၏ virtual/temporary ဘေးများတွင် အရာမရှိပါ။ ဤဂိုဒေါင်အတွက် သက်ဆိုင်ရာ virtual/temporary ဘေးများကို ဖန်တီးပြီးနောက် ပြန်လည်အသစ်တင်၍ ထပ်မံကြိုးစားပါ။",
The_number_of_listings_cannot_exceed_the_inventory_quantity_The_current_inventory_quantity_is:"သိုလှောင်ပမာဏသည် စတော့ရှယ်ယာပမာဏထက် မကျော်လွန်ရ။ လက်ရှိ စတော့ရှယ်ယာပမာဏမှာ",
Select_a_store:"ဆိုင်ကို ရွေးချယ်ပါ",
If_the_shipping_address_in_the_store_is_backend_is_not_consistent_with_the_system_warehouse_address_it_cannot_be_selected_Please_go_to_the_store_authorization_page_to_confirm:"ဆိုင်၏ နောက်ခံ ပို့ဆောင်ရေးလိပ်စာသည် စနစ်၏ ဂိုဒေါင်လိပ်စာနှင့် မတူကွဲပြားပါက ရွေးချယ်၍ မရပါ။ ဆိုင်ခွင့်ပြု မျက်နှာပြင်တွင် အတည်ပြုပါ။",
Shop_shipping_warehouse:"ဆိုင် ပို့ဆောင်ရေး ဂိုဒေါင်",
Clear_all:"အားလုံး ဖျက်ရန်",
No_data_obtained:"ဒေတာ မရရှိသေးပါ",
Selected_store:"ဆိုင် ရွေးချယ်ထားသည်",
synchronousInventorySettingList:"ညှိနှိုင်းထားသော စတော့ရှယ်ယာ ဆက်တင်များ စာရင်း",
synchronousInventoryLogList:"ညှိနှိုင်းထားသော စတော့ရှယ်ယာ မှတ်တမ်း စာရင်း",
synchronousInventoryAnomaly:"ညှိနှိုင်းထားသော စတော့ရှယ်ယာ မမှန်ကန်မှုများ",
synchronousInventoryProductList:"အွန်လိုင်း ထုတ်ကုန် စတော့ရှယ်ယာ ညှိနှိုင်းမှု စာရင်း",
store:"ဆိုင်",
online_sku:"အွန်လိုင်း SKU များ",
multi_attribute_id:"အင်္ဂါရပ်များစွာ ID များ",
multi_attribute:"အင်္ဂါရပ်များစွာ",
inventory_sku:"ကုန်ပစ္စည်း SKU များ",
sync_time:"ညှိနှိုင်းချိန်",
online_sku_image:"အွန်လိုင်း SKU ပုံများ",
sync_inventory_quantity:"ညှိနှိုင်းထားသော ကုန်ပစ္စည်းအရေအတွက်",
rule_name:"စည်းကမ်းအမည်",
inventory_allot_policy:"ကုန်ပစ္စည်းခွဲဝေမှု မဟာဗျူဟာ",
modifier:"ပြင်ဆင်သူ",
create_time:"ဖန်တီးချိန်",
modify_time:"ပြင်ဆင်ချိန်",
create:"ဖန်တီး",
set_non_sync_online_products:"အွန်လိုင်းထုတ်ကုန်များအတွက် ထည့်သွင်းမထားသော အရာများကို စနစ်တကျ သတ်မှတ်ရန်",
The_creation_and_modification_rules_will_not_take_effect_immediately_Please_wait_patiently:"စည်းကမ်း ဖန်တီးခြင်း/ပြင်ဆင်ခြင်းသည် လုပ်ငန်းစဉ်ပြီးနောက်မှသာ အကျိုးသက်ရောက်ပါမည်။ ကျေးဇူးပြု၍ စိတ်ရှည်စွာ စောင့်ဆိုင်းပါ။",
Only_online_products_that_have_been_paired_with_inventory_SKUs_will_be_synchronized:"Inventory SKU များနှင့် တွဲထားသော အွန်လိုင်းထုတ်ကုန်များသာ ညှိနှိုင်းမည်။",
Inventory_threshold:"ကုန်ပစ္စည်း အရေအတွက် အကန့်အသတ်",
Sync_store_range:"ဆိုင် ညှိနှိုင်းမှု အကျယ်",
Sync_SKU_ranges:"SKU ညှိနှိုင်းမှု အကျယ်",
Recent_run_time:"နောက်ဆုံး ပြုလုပ်ချိန်",
Sync_specified_policy_inventory:"သတ်မှတ်ထားသော မဟာဗျူဟာအတွက် ကုန်ပစ္စည်း ညှိနှိုင်းခြင်း",
The_quantity_of_available_inventory_at_that_time:"အချိန်အလိုက် ရရှိနိုင်သော ကုန်ပစ္စည်း အရေအတွက်",
The_available_inventory_quantity_during_the_synchronization_process:"ညှိနှိုင်းမှု ပြုလုပ်သည့် အချိန်တွင် ရရှိနိုင်သော ကုန်ပစ္စည်း အရေအတွက်",
Synchronized_item_ID:"သမိုင်းဆိုင်ရာ ItemId",
synchronous_regimes:"ညှိနှိုင်းမှု အခြေအနေ",
synchronous_messages:"ညှိနှိုင်းမှု မက်ဆေ့ခ်ျ",
The_name_of_the_inventory_updateable_strategy:"ကုန်ပစ္စည်း အပ်ဒိတ်အတွက် မဟာဗျူဟာ အမည်",
Inventory_synchronization_strategy:"ကုန်ပစ္စည်း ညှိနှိုင်းမှု မဟာဗျူဟာ",
Inventory_synchronization_strategy_value:"ကုန်ပစ္စည်း ညှိနှိုင်းမှု မဟာဗျူဟာ တန်ဖိုး",
ExportOrderTraceTaskList:"ပို့ဆောင်ရေး လွှဲပြောင်းမှု အသေးစိတ်",
Are_you_sure_to_modify_the_processing_plan:"ပြင်ဆင်မှု ကိုင်တွယ်ဖြေရှင်းမှု အတည်ပြုချက်",
The_task_number_selection_is_inconsistent_please_choose_again:"တာဝန် ID ရွေးချယ်မှု မကိုက်ညီပါ။ ပြန်လည်ရွေးချယ်ပါ။",
Only_products_with_inventory_quantity_greater_than_0_and_inventory_quantity_greater_than_the_occupied_inventory_quantity_can_be_selected:"ကုန်ပစ္စည်းအရေအတွက် > 0 နှင့် သိမ်းဆည်းထားသော ပစ္စည်းအရေအတွက်ထက် ပိုများသော ပစ္စည်းများကိုသာ ရွေးချယ်ပါ။",
There_are_not_enough_suitable_storage_locations_for_the_user_please_choose_on_your_own:"သင့်တော်သော သိုလှောင်ရာနေရာ မလုံလောက်ပါ။ လက်ဖြင့် ရွေးချယ်ပါ။",
Import_warehouse_order:"ဂိုဒေါင်အော်ဒါများ ထည့်သွင်းခြင်း",
Do_you_want_to_cancel_the_selected_warehouse_transfer_task:"ရွေးထားသော ပြောင်းရွှေ့တာဝန်များကို ဖျက်သိမ်းခြင်း အတည်ပြုပါ",
Have_you_completed_the_warehouse_relocation_task:"ပြောင်းရွှေ့တာဝန်များ ပြီးစီးခြင်း အတည်ပြုပါ",
Has_the_status_of_pending_reception_confirmed:"အခြေအနေ 'လက်ခံရန် စောင့်ဆိုင်းနေ' သို့ ပြောင်းလဲခြင်း အတည်ပြုပါ",
Please_first_select_the_warehouse_transfer_task_that_needs_to_be_revoked:"ပထမဦးစွာ ဖျက်သိမ်းမည့် လွှဲပြောင်းတာဝန်ကို ရွေးချယ်ပါ",
Are_you_sure:"အတည်ပြု",
completeWarehouseRelocation:"လွှဲပြောင်းပြီးစီး",
exportTransferTask:"လွှဲပြောင်းတာဝန်များ ထုတ်ယူ",
transfer_task_list:"လွှဲပြောင်းတာဝန်စာရင်း",
AdjustTheWarehouseRelocationTaskLocation:"လွှဲပြောင်းတာဝန် သိုလှောင်ရာနေရာများ ချိန်ညှိ",
Print_the_inventory_transfer_list:"လွှဲပြောင်းစာရင်း ပုံနှိပ်",
Print_transfer_and_packing_information:"လွှဲပြောင်းထုပ်ပိုးသတင်းအချက်အလက် ပုံနှိပ်",
exportWarehouseInventoryInformation:"ဂိုဒေါင် ပစ္စည်းစာရင်း သတင်းအချက်အလက် ထုတ်ယူ",
Only_one_warehouse_transfer_task_can_be_selected:"တစ်ကြိမ်လျှင် လွှဲပြောင်းတာဝန် တစ်ခုသာ ရွေးချယ်နိုင်ပါသည်",
Export_existing_inventory:"လက်ရှိ ပစ္စည်းစာရင်း ထုတ်ယူ",
Export_all_inventory:"ပစ္စည်းစာရင်း အားလုံး ထုတ်ယူ",
Please_select_the_relocation_task:"လွှဲပြောင်းတာဝန် တစ်ခု ရွေးချယ်ပါ",
binning:"ဘောက်စ် ခွဲခြားခြင်း",
Please_download_from_the_task_center_in_five_minutes:"ငါးမိနစ်ကြာပြီးနောက် Task Centre မှ ဒေါင်းလုဒ်ဆွဲပါ",
server_storage_address:"ဆာဗာသိုလှောင်မှုလိပ်စာ",
Please_add_product_details_first:"ပထမဦးစွာ ထုတ်ကုန်အသေးစိတ်ကို ထည့်ပါ။",
Please_select_products_with_SKU_and_location_numbers_that_are_not_the_same:"SKU နှင့် တည်နေရာကုဒ် မတူညီသော ထုတ်ကုန်များကို ရွေးချယ်ပါ။",
Profit_Order_payment_for_product_amount_Refund_Actual_Freight_Seller_Paid_Freight_Platform_Freight_Subsidy_Exchange_Freight_Seller_Freight_Discount_TSP_Commission_Platform_Commission_Alliance_Commission_Transaction_Fees_SFP_Service_Fees_Service_Fees_Additional_Plan_Service_Fees_Logistics_Insurance_Fees_Freight_Service_Tax_SST_Value_Added_Tax_VAT_Product_Service_Tax_Seller_Discount_Coupons_Return_Order_Freight_Other_Platform_Fees_Credit_Card_Payment_Fees_Platform_Adjustment_Amount_Ecological_Donations_Fees_Refund_Product_Amount_Return_Order_Return_Freight_x_Exchange_Rate_Product_Procurement_Cost_Initial_Freight_Warehouse_Rent_Listing_Fee_Order_Processing_Fee:"အမြတ် = (မှာယူထားသော ထုတ်ကုန်ပမာဏ - ပြန်အမ်းငွေများ - အမှန်တကယ် ပို့ဆောင်ခ + ရောင်းသူပေးပို့ဆောင်ခ + ပလက်ဖောင်းပို့ဆောင်ခအထောက်အပံ့ - လဲလှယ်ပို့ဆောင်ခ - ရောင်းသူပို့ဆောင်ခလျှော့စျေး - TSP ကော်မရှင် - ပလက်ဖောင်းကော်မရှင် - မိတ်ဖက်ကော်မရှင် - ငွေလွှဲကြေးများ - SFP ဝန်ဆောင်ခ - ဝန်ဆောင်ခ - အပိုအစီအစဉ် ဝန်ဆောင်ခ - လိုဂျစ်စတစ်အာမခံကြေး - သယ်ယူပို့ဆောင်ခ ဝန်ဆောင်ခအခွန် (SST) - တန်ဖိုးတိုးအခွန် (VAT) - ထုတ်ကုန်ဝန်ဆောင်ခအခွန် - ရောင်းသူလျှော့စျေးကတ်များ - ပြန်ပို့အမှာပစ္စည်း သယ်ယူပို့ဆောင်ခ - အခြားပလက်ဖောင်းကြေးများ - ခရက်ဒစ်ကတ် လုပ်ငန်းဆောင်ရွက်ခ + ပလက်ဖောင်းပြင်ဆင်ငွေပမာဏ - ပတ်ဝန်းကျင်အလှူငွေ - ကိုင်တွယ်ဆောင်ရွက်ခ - ပြန်အမ်းပေးမည့် ကုန်ပစ္စည်းတန်ဖိုး - ပြန်ပို့ခ (Returned Order Return Shipping Cost) × လဲလှယ်နှုန်း - (ကုန်ပစ္စည်းဝယ်ယူစရိတ် + ထွက်ပို့ခ + ဂိုဒေါင်ငှားခ + စာရင်းတင်ခ + အော်ဒါဆောင်ရွက်ခ)",
The_value_added_tax_paid_by_the_platform_on_behalf_of_the_buyer_import_value_added_tax_value_added_tax_paid_by_the_platform_on_behalf_of_the_seller:"ဝယ်သူအတွက် ပလက်ဖောင်းမှ ပေးဆောင်ထားသော VAT + တင်သွင်း VAT + ရောင်းသူအတွက် ပလက်ဖောင်းမှ ပေးဆောင်ထားသော VAT",
Return_order_return_fee:"ပြန်ပို့ခ ကုန်ကျစရိတ်များ",
When_the_original_currency_conversion_profit_financial_currency_exchange_rate_of_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_the_data_will_be_synchronized_after_24_00_on_the_same_day:"ဆိုင်၏ အမြတ်ငွေ ငွေကြေးအတွက် မူလ ငွေလဲနှုန်း မသတ်မှတ်ထားပါက စနစ်သည် ဒေတာများကို ညှိနှိုင်းမည်မဟုတ်ပါ။ သတ်မှတ်ပြီးပါက တစ်နေ့တာ 24:00 နာရီကျော်ပြီးနောက် ဒေတာများကို ညှိနှိုင်းမည်ဖြစ်သည်။",
Gold_coin_deduction:"ရွှေငွေကြေး ဖြတ်တောက်ခြင်း",
Platform_preferential_subsidies:"ပလက်ဖောင်း ပရိုမိုးရှင်း အထောက်အပံ့ငွေများ",
Installment_payment_handling_fee:"အပိုင်းပိုင်းပေးချေမှု လုပ်ငန်းဆောင်ရွက်ခများ",
Sellers_free_shipping_promotion_fee_refund_of_shipping_fee_to_customer_shipping_subsidy_provided_by_seller_seller_pays_for_shipping_fee:"ရောင်းသူ၏ အခမဲ့ပို့ဆောင်ရေး ပရိုမိုးရှင်း ကုန်ကျစရိတ်များ + ဖောက်သည်များထံ ပြန်အမ်းပေးသည့် ပို့ဆောင်ခများ + ရောင်းသူမှ ပံ့ပိုးပေးသည့် ပို့ဆောင်ရေး အထောက်အပံ့ငွေများ + ရောင်းသူမှ ပေးချေသော ပို့ဆောင်ခများ",
The_total_amount_of_other_expenses_not_shown_such_as_FBI_project_processing_fees_buyer_review_incentives_LazFlash_additional_daily_subsidies_below_9_99_etc:"ပြသထားခြင်းမရှိသော အခြားကြေးများ စုစုပေါင်း၊ ဥပမာ။ FBI ပရောဂျက် လုပ်ငန်းစဉ်ကြေး၊ ဝယ်သူပြန်လည်သုံးသပ်ရန် လှုံ့ဆော်ငွေများ၊ $9.99 အောက်အတွက် LazFlash ထပ်ဆောင်း/နေ့စဉ် အထောက်အပံ့ငွေများ စသည်ဖြင့်။",
starting_inventory:"စတင်စာရင်း (≥)",
Terminate_inventory:"အဆုံးစာရင်း (<)",
Inventory_allocation_strategy:"စာရင်းခွဲဝေမှု မဟာဗျူဟာ",
Inventory_update_value:"စာရင်း အပ်ဒိတ်တန်ဖိုး",
Fixed_value:"တည်ငြိမ်တန်ဖိုး",
Percentage:"ရာခိုင်နှုန်း",
schema:"နည်းလမ်း",
Add_the_maximum_inventory_range:"အများဆုံး စာရင်း ကန့်သတ်ချက် ထည့်ရန်",
Shop_back_end:"ဆိုင်နောက်ခံ",
Mapping_warehouse_address:"ချိတ်ဆက်ထားသော ဂိုဒေါင်လိပ်စာ",
ship_address:"ပို့ဆောင်ရေးလိပ်စာ",
Create_a_strategy:"မဟာဗျူဟာ ဖန်တီးခြင်း",
Manually_synchronize_the_specified_strategy:"သတ်မှတ်ထားသော မဟာဗျူဟာကို လက်ဖြင့် ညှိနှိုင်းခြင်း",
Inventory_warning_threshold:"ကုန်ပစ္စည်း သတိပေး အဆင့်",
resynchronization:"ပြန်ညှိနှိုင်းခြင်း",
Latest_synchronization_time:"နောက်ဆုံးညှိနှိုင်းချိန်",
Synchronous_logs:"ညှိနှိုင်းမှတ်တမ်း",
The_shipping_address_in_the_store_is_back_end_must_be_exactly_the_same_as_the_warehouse_address_If_they_are_not_the_same_please_modify_it_in_the_store_is_back_end_and_then_click_the_Manually_Synchronize_Warehouse_button:"ဆိုင်နောက်ခံတွင် ဖော်ပြထားသော ပို့ဆောင်ရေးလိပ်စာသည် ဂိုဒေါင်လိပ်စာနှင့် တိတိကျကျ ကိုက်ညီရမည်။ မကိုက်ညီပါက ဆိုင်နောက်ခံတွင် ပြင်ဆင်ပြီး 'ဂိုဒေါင်ကို လက်ဖြင့် ညှိနှိုင်းရန်' ခလုတ်ကို နှိပ်ပါ။",
The_fixed_value_strategy_is_a_fixed_quantity_and_the_percentage_strategy_is_a_percentage_of_the_current_available_inventory:"တန်ဖိုးသတ်မှတ်ထားသော မဟာဗျူဟာတွင် တိတိကျကျ သတ်မှတ်ထားသော အရေအတွက်ကို အသုံးပြုပြီး၊ ရာခိုင်နှုန်း မဟာဗျူဟာတွင် လက်ရှိ ရရှိနိုင်သည့် ကုန်ပစ္စည်းအရေအတွက်၏ ရာခိုင်နှုန်းကို အသုံးပြုသည်။",
The_creation_modification_manual_synchronization_of_the_policy_will_be_completed_within_half_an_hour:"မူဝါဒများ ဖန်တီးခြင်း/ပြင်ဆင်ခြင်း/ဖန်တီးခြင်း/ပြင်ဆင်ခြင်း/လက်ဖြင့်ညှိနှိုင်းခြင်းကို မိနစ် ၃၀ အတွင်း ပြီးစီးပါမည်။",
Please_check_the_synchronization_status_in_the_synchronization_inventory_log_list:"ညှိနှိုင်းထားသော ပစ္စည်းစာရင်း မှတ်တမ်းစာရင်းတွင် ညှိနှိုင်းမှု အခြေအနေကို ကြည့်ရှုပါ။",
Only_the_online_products_that_have_been_matched_with_the_inventory_SKUs_will_be_synchronized:"ပစ္စည်း SKU များကို ကိုက်ညီထားသော အွန်လိုင်းထုတ်ကုန်များသာ ညှိနှိုင်းမည်။",
The_shipping_address_in_the_store_is_backend_must_be_exactly_the_same_as_the_warehouse_address_in_the_system:"ဆိုင်နောက်ခံရှိ ပို့ဆောင်ရေးလိပ်စာသည် စနစ်၏ ဂိုဒေါင်လိပ်စာနှင့် တိတိကျကျ ကိုက်ညီရမည်။",
Maximum_synchronized_inventory:"အများဆုံးညှိနှိုင်းနိုင်သည့် ပစ္စည်းအရေအတွက်",
total_inventory:"စုစုပေါင်း ပစ္စည်းအရေအတွက်",
Unshipped_inventory:"မပို့ဆောင်ရသေးသော ပစ္စည်းများ",
Warehouse_orders_include_those_that_have_been_shipped_delivered_invalidated_cancelled_and_those_that_match_the_total_quantity_of_the_corresponding_SKUs:"ပို့ဆောင်ပြီး၊ ထုတ်ပို့ပြီး၊ ဖျက်သိမ်းပြီး၊ ပယ်ဖျက်ပြီး သို့မဟုတ် ကိုက်ညီသော SKU အရေအတွက် မပါသော ဂိုဒေါင်အော်ဒါများ",
The_maximum_synchronizable_inventory_quantity_for_a_combined_SKU_is_equal_to_the_lowest_inventory_quantity_among_the_SKUs_in_the_combination:"ပေါင်းစပ် SKU များအတွက် အများဆုံး ညှိနှိုင်းနိုင်သည့် ပစ္စည်းအရေအတွက်သည် ပေါင်းစပ်ထဲရှိ အနိမ့်ဆုံး ပစ္စည်းအရေအတွက်နှင့် ညီသည်။",
Select_store:"ဆိုင်ကို ရွေးပါ",
Specified_SKUs:"SKU ကို သတ်မှတ်ပါ",
To_prevent_over_selling_when_the_synchronized_inventory_falls_below_the_warning_threshold_the_system_will_automatically_set_the_inventory_quantity_to_0:"အရောင်းလွန်ခြင်း မဖြစ်စေရန်၊ ညှိနှိုင်းနိုင်သည့် ပစ္စည်းအရေအတွက်သည် သတိပေးအဆင့်အောက်သို့ ကျဆင်းသွားပါက စနစ်သည် အလိုအလျောက် ညှိနှိုင်းနိုင်သည့် အရေအတွက်ကို 0 သတ်မှတ်သည်။",
Set_inventory_alert_threshold_100_Current_maximum_available_inventory_99_Below_the_inventory_alert_threshold_the_system_synchronizes_the_inventory_quantity_to_0:"ဥပမာ - ပစ္စည်းသိုလှောင်မှု သတိပေးအဆင့်ကို ၁၀၀ ဟု သတ်မှတ်ထားသည်။ လက်ရှိ ရနိုင်သည့် အများဆုံး ပစ္စည်းသိုလှောင်မှုမှာ ၉၉ ဖြစ်သည်။ သတိပေးအဆင့်အောက်သို့ ကျဆင်းပါက စနစ်သည် ပစ္စည်းသိုလှောင်အရေအတွက်ကို ၀ သို့ အလိုအလျောက် ညှိနှိုင်းပေးမည်။",
Input_the_synchronous_inventory_range_interval_When_the_quantity_of_synchronous_inventory_falls_within_this_range_the_system_will_synchronize_based_on_the_set_synchronization_strategy_and_the_synchronous_inventory_quantity:"ညှိနှိုင်းနိုင်သည့် ပစ္စည်းသိုလှောင် အကွာအဝေးကို ထည့်ပါ။ အရေအတွက်သည် ဤအကွာအဝေးအတွင်း ရောက်ရှိပါက စနစ်သည် သတ်မှတ်ထားသည့် မဟာဗျူဟာနှင့် အရေအတွက်အပေါ် မူတည်၍ ညှိနှိုင်းပေးမည်။",
Add_asynchronous_online_products:"ညှိနှိုင်းမထားသော အွန်လိုင်းထုတ်ကုန်များ ထည့်ရန်",
Asynchronous_online_product_logs:"ညှိနှိုင်းမထားသော အွန်လိုင်းထုတ်ကုန် မှတ်တမ်း",
This_operation_will_permanently_delete_Do_you_want_to_continue:"ဤ လုပ်ဆောင်ချက်သည် အရာဝတ္ထုကို အမြဲတမ်း ဖျက်ပစ်မည်။ ဆက်လက်မည်လား?",
contractList:"စာချုပ် စာရင်း",
contractDetail:"စာချုပ် အသေးစိတ်",
The_name_of_the_contract:"စာချုပ် အမည်",
Contract_number:"စာချုပ် နံပါတ်",
Type_of_contract:"စာချုပ် အမျိုးအစား",
Initiation_time:"စတင်သည့် ရက်စွဲ",
Signing_time:"လက်မှတ်ရေးထိုးသည့် ရက်စွဲ",
Expiration_time:"သက်တမ်းကုန်ဆုံးသည့် ရက်စွဲ",
voided_ontract:"စာချုပ် ဖျက်သိမ်းရန်",
Rejection_contract:"စာချုပ် ငြင်းပယ်ရန်",
Activate_the_contract:"စာချုပ် စတင်အသုံးပြုရန်",
contractSubject:"အဖွဲ့အစည်း စာရင်း ပြောင်းရန်",
Apply_for_switching_the_entity:"အဖွဲ့အစည်း ပြောင်းရန် တောင်းဆိုရန်",
Rejection_time:"ငြင်းပယ်သည့် ရက်စွဲ",
Those_who_rejected_it:"ငြင်းပယ်သူ",
Reason_for_Rejection:"ငြင်းပယ်သည့် အကြောင်းရင်း",
Details_of_the_Supplementary_Agreement:"ထပ်ဆောင်း သဘောတူစာချုပ် အသေးစိတ်",
downLoadContract:"စာချုပ် ဒေါင်းလုဒ်လုပ်ရန်",
Please_select_the_customer_type:"ဖောက်သည် အမျိုးအစားကို ရွေးချယ်ပါ",
E_signature_Treasure_Authorization_Status:"လက်မှတ်ရေးထိုးခွင့် အတည်ပြုမှု အခြေအနေ",
Invalid_review:"ပြန်လည်သုံးသပ် ဖျက်ခြင်း",
Review_rejected:"ပြန်လည်သုံးသပ် ငြင်းပယ်ခြင်း",
Parent_Contract_Number:"မူရင်းစာချုပ်နံပါတ်",
Is_it_the_contracting_party:"ဤသည် လက်မှတ်ရေးထိုးသူ အဖွဲ့အစည်း ဖြစ်ပါသလား?",
Without_signing_the_contract_all_functions_will_be_prohibited:"သတ်မှတ်ထားသည့် နောက်ဆုံးသက်တမ်းမတိုင်မီ လက်မှတ်မရေးထိုးပါက စာချုပ်၏ လုပ်ဆောင်ချက်များအားလုံး ပိတ်သွားမည်ဖြစ်သည်။",
protocolCode:"သဘောတူစာချုပ်ကုဒ်",
Has_the_contract_and_user_information_been_verified_to_be_correct_and_approved_for_review:"စာချုပ်နှင့် အသုံးပြုသူ အချက်အလက်များ မှန်ကန်ကြောင်း သင် အတည်ပြုပြီးပါသလား? အတည်ပြုမည်?",
Sign_expiration_date:"လက်မှတ်သက်တမ်းကုန်ဆုံးရက်",
Signing_link_expiration_date:"လက်မှတ်လင့်ခ်သက်တမ်းကုန်ဆုံးရက်",
Please_contact_your_dedicated_investment_manager_to_review_the_contract_information:"စာချုပ်အသေးစိတ်ကို ပြန်လည်စစ်ဆေးရန် သင့်အကောင့်မန်နေဂျာထံ ဆက်သွယ်ပါ။",
Whether_to_automatically_renew:"အလိုအလျောက် သက်တမ်းတိုးခြင်း",
Used_for_subsequent_billing_and_invoicing_functions_of_the_system_account:"နောက်ထပ် စနစ်အကောင့် ငွေချေမှုနှင့် ငွေတောင်းခံလွှာ ထုတ်လုပ်ခြင်း လုပ်ဆောင်ချက်များအတွက် လိုအပ်ပါသည်။",
The_phone_number_of_the_current_contract_signatory_otherwise_the_contract_cannot_be_successfully_signed:"လက်မှတ်ရေးထိုးသူ၏ နာမည်ဖြင့် မှတ်ပုံတင်ထားသော မိုဘိုင်းနံပါတ်ဖြစ်ရမည်၊ မဟုတ်ပါက စာချုပ်လက်မှတ်ရေးထိုးခြင်း မအောင်မြင်ပါ။",
Real_QQ_WeChat_contact_with_our_company_otherwise_the_contract_cannot_be_successfully_signed:"ကျွန်ုပ်တို့ကုမ္ပဏီအတွက် စစ်မှန်သော QQ/WeChat ဆက်သွယ်ရန် အသေးစိတ်များဖြစ်ရမည်၊ မဟုတ်ပါက စာချုပ်လက်မှတ်ရေးထိုးခြင်း မအောင်မြင်ပါ။",
addcompany:"ကုမ္ပဏီထည့်ရန်",
Sign_contract_documents:"စာချုပ်လက်မှတ်ရေးထိုးခြင်း အချက်အလက်",
qq_wehat__non_nickname:"QQ/WeChat (အမည်အတိုကောက်မဟုတ်)",
Company_Name:"ကုမ္ပဏီအမည်",
contracting_entity:"လက်မှတ်ရေးထိုးမည့် အဖွဲ့အစည်း",
Do_you_want_to_apply_for_switching_subjects:"အဖွဲ့အစည်းပြောင်းရန် တောင်းဆိုပါသလား?",
Please_contact_the_investment_promotion_review_to_switch_the_subject_application:"ပြောင်းရွှေ့ခွင့်အတည်ပြုရန် စီးပွားရေးဖွံ့ဖြိုးတိုးတက်ရေးဌာနနှင့် ဆက်သွယ်ပါ။",
deadline:"နောက်ဆုံးသတ်မှတ်ထားသည့်နေ့",
Is_the_selected_contract_to_be_reviewed:"အတည်ပြုမှုအခြေအနေ",
Whether_to_void_the_selected_contract:"ဖျက်သိမ်းမှုအခြေအနေ",
Note_To_ensure_the_legal_validity_of_the_contract_please_verify_the_accuracy_of_relevant_materials:"မှတ်ချက်: ဥပဒေအရ တရားဝင်မှန်ကန်မှုရှိစေရန် အချက်အလက်အားလုံးကို တိကျစွာ စစ်ဆေးပါ။",
Inventory_information:"သိုလှောင်ရေးအော်ဒါ အသေးစိတ်",
Product_Details:"ထုတ်ကုန် သတ်မှတ်ချက်များ",
suggest_types:"အကြံပြုမှုအမျိုးအစား",
stock_up_suggestions:"ပိုမိုသိုလှောင်ရန် အကြံပြုချက်",
shortage_suggestion:"ကုန်လွန်သွားသော ပစ္စည်းများအတွက် အကြံပြုချက်",
generate_a_backup_order:"ပိုမိုသိုလှောင်ရန် အော်ဒါ ဖန်တီးခြင်း",
Total_number_of_products_awaiting_review:"စစ်ဆေးရန် စုစုပေါင်း စောင့်ဆိုင်းနေသည့် အချက်များ",
Planned_stocking_inventory:"စီစဉ်ထားသော ပိုမိုသိုလှောင်မည့် ပစ္စည်းအရေအတွက်",
Sales_volume_7_14_30_60_90:"ရောင်းအား (၇/၁၄/၃၀/၆၀/၉၀ ရက်)",
Daily_average_sales_in_the_past_30_days:"ပျမ်းမျှ နေ့စဉ် ရောင်းအား (နောက်ဆုံး ၃၀ ရက်)",
Stock_quantity:"ပိုမိုသိုလှောင်မည့် ပစ္စည်းအရေအတွက်",
Minimum_reserve_price:"အနည်းဆုံး ပိုမိုသိုလှောင်မည့် စျေးနှုန်း",
Last_stocking_price:"ယခင် ပိုမိုသိုလှောင်မည့် စျေးနှုန်း",
Reserve_currency_type:"ပိုမိုသိုလှောင်မည့် ငွေကြေး",
Stock_unit_price:"ပိုမိုသိုလှောင်မည့် တစ်ယူနစ် စျေးနှုန်း",
In_stock:"လက်ရှိ ပိုမိုသိုလှောင်နေဆဲ",
Total_stocking_price:"ပိုမိုသိုလှောင်မည့် စုစုပေါင်း တန်ဖိုး",
Stock_quantity_times_Stock_unit_price:"ပိုမိုသိုလှောင်မည့် ပစ္စည်းအရေအတွက် × ပိုမိုသိုလှောင်မည့် တစ်ယူနစ် စျေးနှုန်း",
The_stage_of_inventory_management_is_equal_to_the_total_number_of_matching_SKUs_in_the_pending_review_and_inventory_process:"ပြန်လည်ဖြည့်ဆည်းရေး အော်ဒါ စီမံခန့်ခွဲမှုတွင်၊ အဆင့်အလိုက် ကိုက်ညီသည့် SKU များ၏ စုစုပေါင်းအရေအတွက်: အတည်ပြုရန် စောင့်ဆိုင်းနေ၊ ပြန်လည်ဖြည့်ဆည်းဆဲ",
Daily_sales_in_the_past_30_days_purchase_days_warning_inventory_total_inventory_in_transit_inventory_if_less_than_0_display_0:"လွန်ခဲ့သည့် ၃၀ ရက်အတွင်း နေ့စဉ်ရောင်းအား * ဝယ်ယူရေး ရက်များ + သတိပေးစာရင်းရှိ ပစ္စည်း - စုစုပေါင်း ပစ္စည်း - သယ်ယူပို့ဆောင်ဆဲ ပစ္စည်း။ ၀ ထက်နည်းပါက ၀ ပြသသည်။",
By_default_it_is_equal_to_the_currency_of_the_last_stocking_If_not_available_it_is_RMB_which_can_be_modified:"မူလငွေကြေးသည် နောက်ဆုံး ပြန်ဖြည့်ခြင်း၏ ငွေကြေးဖြစ်သည်၊ မဟုတ်ပါက RMB ဖြစ်သည်။ ပြင်ဆင်နိုင်သည်။",
By_default_it_is_equal_to_the_unit_price_of_the_last_stocking_If_not_available_it_is_the_purchase_price_of_the_product_which_can_be_modified:"မူလယူနစ်စျေးနှုန်းသည် နောက်ဆုံး ပြန်ဖြည့်ခြင်း၏ စျေးနှုန်းဖြစ်သည်၊ မဟုတ်ပါက ထုတ်ကုန်ဝယ်ယူစျေးနှုန်းဖြစ်သည်။ ပြင်ဆင်နိုင်သည်။",
Completed_the_last_completed_stocking_unit_price_for_matching_SKUs:"ပြီးစီး: ကိုက်ညီသော SKU များအတွက် နောက်ဆုံး ပြန်ဖြည့်ခဲ့သည့် ယူနစ်စျေးနှုန်း။",
Starting_time_of_stocking:"ပြန်ဖြည့်ခြင်း စတင်မည့် ရက်စွဲ",
Please_select_the_start_time_for_stocking:"ပြန်ဖြည့်ခြင်း စတင်မည့် ရက်စွဲကို ရွေးချယ်ပါ။",
Completed_matching_the_lowest_stocking_unit_price_for_SKU:"ပြီးစီးပြီး၊ SKU နှင့် ကိုက်ညီသည့် ပြန်ဖြည့်ရန် အနိမ့်ဆုံး ယူနစ်စျေးနှုန်း",
Please_select_products_from_the_same_warehouse:"တစ်ခုတည်းသော ဂိုဒေါင်အတွင်းမှ ပစ္စည်းများ ရွေးချယ်ပါ",
Stock_order_number:"ပြန်ဖြည့်ရန် အော်ဒါနံပါတ်",
Stockist:"ပြန်ဖြည့်ရန် ဝန်ထမ်း",
LeadTime:"ပြန်ဖြည့်ရန် အချိန်",
supplier:"ထောက်ပံ့သူ",
Platform_order_status:"ပလက်ဖောင်း အော်ဒါအခြေအနေ",
Subtotals_of_pre_discount_products:"လျှော့စျေးမပေးခင် ပစ္စည်းစုစုပေါင်း",
Subtotals_of_discount_products:"လျှော့စျေးပေးပြီးနောက် ပစ္စည်းစုစုပေါင်း",
Not_involved_in_order_profit_calculation_for_operational_analysis_reference_only_seller_discounts_product_discounts_flash_purchases_buy_more_save_more_vouchers_and_bundled_transactions:"အော်ဒါအမြတ်တွက်ချက်မှုတွင် မပါဝင်ပါ; လည်ပတ်မှုဆိုင်ရာ ခွဲခြမ်းစိတ်ဖြာရန်သာ အသုံးပြုပါ။ ရောင်းသူလျှော့စျေးများ (ထုတ်ကုန်လျှော့စျေးများ၊ အထူးလျှော့စျေးရောင်းပွဲများ၊ အစုလိုက်ဝယ်လျှော့စျေးများ၊ ကူပွန်များနှင့် ပက်ကေ့ချ်အရောင်းများ)",
The_data_at_this_stage_is_the_original_data_before_merging_the_stocking_list_for_reference_only:"ဤအဆင့်ရှိ ဒေတာများမှာ အော်ဒါပေါင်းစည်းခြင်းမပြုမီရှိသည့် မူလဂဏန်းများသာဖြစ်ပြီး ကိုးကားရန်အတွက်သာဖြစ်သည်။",
When_the_financial_currency_exchange_rate_for_converting_profits_from_the_original_currency_of_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_the_previous_days_data_will_be_synchronized_after_24_00_on_the_same_day_only_for_orders_that_have_been_shipped_out_Profit_data_will_continue_to_be_updated_in_the_early_morning_until_the_settlement_time_of_platform_orders_is_updated:"ဆိုင်၏ အခြေခံငွေကြေးမှ အမြတ်ငွေကို ဘဏ္ဍာရေးငွေကြေးသို့ ပြောင်းလဲရန် လဲလှယ်နှုန်း မသတ်မှတ်ထားပါက စနစ်သည် ဒေတာကို ညှိနှိုင်းမည်မဟုတ်ပါ။ တစ်ကြိမ်သတ်မှတ်ပြီးပါက ယခင်နေ့၏ ဒေတာများကို ထိုနေ့ 24:00 နောက်ပိုင်းတွင် ညှိနှိုင်းမည်ဖြစ်ပြီး ပို့ဆောင်ပြီးသော အော်ဒါများအတွက်သာ ကန့်သတ်ထားမည်ဖြစ်သည်။ အမြတ်ဂဏန်းများကို တစ်ညတာ ဆက်တိုက် အပ်ဒိတ်လုပ်သွားမည်ဖြစ်ပြီး ပလက်ဖောင်းအော်ဒါ ဆက်လက်ဆောင်ရွက်မှု (settlement) ဖြစ်သည့်အခါ အပ်ဒိတ်လုပ်ခြင်းကို ရပ်တန့်မည်ဖြစ်သည်။",
When_the_financial_currency_exchange_rate_for_converting_profits_from_the_original_currency_of_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_it_the_previous_days_data_will_be_synchronized_after_24_00_on_the_same_day_Only_orders_that_have_been_issued_and_bills_have_been_generated_will_be_synchronized_Profit_data_will_be_updated_in_the_early_morning_when_bills_are_generated_and_the_settlement_time_will_be_based_on_the_last_time_bills_are_generated:"ဆိုင်ငွေကြေးမှ အမြတ်ငွေကို ဘဏ္ဍာရေးငွေကြေးသို့ ပြောင်းလဲရန် ငွေလဲနှုန်း မသတ်မှတ်ထားပါက စနစ်သည် ဒေတာကို မညှိနှိုင်းပါ။ သတ်မှတ်ပြီးပါက ယခင်နေ့မှ ဒေတာများကို ယနေ့ ၂၄:၀၀ နာရီကျော်ပြီးနောက် ညှိနှိုင်းမည်ဖြစ်သည်။ ကုန်ပစ္စည်းပို့ဆောင်ပြီး ငွေတောင်းခံလွှာ ထုတ်ထားသော အော်ဒါများကိုသာ ညှိနှိုင်းမည်ဖြစ်သည်။ အမြတ်ဒေတာများကို ငွေတောင်းခံလွှာ ထုတ်လုပ်သည့် နံနက်စောစောအချိန်တွင် အဆက်မပြတ် အပ်ဒိတ်လုပ်မည်ဖြစ်ပြီး ငွေချေချိန်မှာ နောက်ဆုံး ငွေတောင်းခံလွှာ ထုတ်လုပ်သည့် အချိန်ဖြစ်ပါမည်။",
Exchange_rate_setting:"ငွေလဲနှုန်း ဖွဲ့စည်းခြင်း",
Total_quantity_of_stocked_goods:"ဝယ်ယူထားသော ကုန်ပစ္စည်း စုစုပေါင်း အရေအတွက်",
Total_number_of_stocked_goods:"ဝယ်ယူထားသော ကုန်ပစ္စည်း စုစုပေါင်း အမျိုးအစား",
Total_price_of_the_purchase_order:"ဝယ်ယူရေး အော်ဒါ စုစုပေါင်း တန်ဖိုး",
Total_cubic_meter_of_inventory_M_three:"ဝယ်ယူထားသော စုစုပေါင်း ကုဗစ်မီတာ (m³)",
Total_weight_of_stock_KG:"ဝယ်ယူထားသော စုစုပေါင်း အလေးချိန် (kg)",
Ending_time_of_stocking:"ဝယ်ယူရေး ပြီးဆုံးချိန်",
Real_payment_amount:"အမှန်တကယ် ပေးချေငွေ",
Stocking_remarks:"ဝယ်ယူရေး မှတ်ချက်များ",
Total_cubic_meters_of_goods_M_three:"ကုန်ပစ္စည်း စုစုပေါင်း ကုဗစ်မီတာ (m³)",
Total_weight_of_the_product_KG:"ပစ္စည်းစုစုပေါင်းအလေးချိန် (ကီလိုဂရမ်)",
Merge_backup_documents:"စတော့အော်ဒါများ ပေါင်းစပ်ခြင်း",
Are_you_sure_to_merge_the_selected_backup_orders:"ရွေးထားသော စတော့အော်ဒါများ ပေါင်းစပ်ခြင်း အတည်ပြုခြင်း",
Change_to_void_status:"အခြေအနေကို ဖျက်သိမ်းထားသည် သို့ ပြောင်းခြင်း",
Change_the_status_to_abnormal:"အခြေအနေကို မမှန်ကန်သည် သို့ ပြောင်းခြင်း",
Change_status_to_return:"အခြေအနေကို ပြန်ပို့ထားသည် သို့ ပြောင်းခြင်း",
Submit_to_stocking:"စတော့စောင့်ဆိုင်းစာရင်းသို့ တင်သွင်းခြင်း",
Have_you_submitted_it_to_the_inventory:"စတော့စောင့်ဆိုင်းစာရင်းသို့ တင်သွင်းခြင်း",
Submit_to_Completed:"ပြီးစီးသည် သို့ တင်သွင်းခြင်း",
SKUs_that_have_not_been_stocked_will_not_be_displayed_on_this_page:"စတော့ထဲ မရောက်ရှိသေးသော SKU များသည် ဤစာမျက်နှာတွင် မပေါ်ပါ",
Please_select_a_backup_order_to_print:"ပုံနှိပ်ရန် စတော့အော်ဒါ တစ်ခု ရွေးပါ",
Inventory_quantity_if_there_is_real_length_width_and_height_it_is_real_length_real_width_real_height_if_there_is_no_real_length_width_and_height_it_is_length_width_height_100000_if_less_than_0_001_it_is_equal_to_0_001:"စတော့အရေအတွက်* (အမှန်တကယ် အရှည်/အနံ/အမြင့် ရှိပါက: အမှန်တကယ် အရှည် × အမှန်တကယ် အနံ × အမှန်တကယ် အမြင့်။ မရှိပါက: အရှည် × အနံ × အမြင့်)/၁,၀၀၀,၀၀၀။ ၀.၀၀၁ ထက်နည်းပါက၊ ၀.၀၀၁ ဟုယူဆမည်။",
If_there_is_a_true_weight_the_stock_quantity_multiplied_by_the_true_weight_If_not_available_stock_quantity_weight:"အမှန်တကယ်အလေးချိန် ရရှိပါက၊ ပစ္စည်းအရေအတွက်ကို အမှန်တကယ်အလေးချိန်ဖြင့် မြှောက်မည်။ မရရှိပါက၊ ပစ္စည်းအရေအတွက်ကို အလေးချိန်ဖြင့် မြှောက်မည်။",
Append_contract:"စာချုပ်ထည့်ရန်",
AppendContract:"စာချုပ်ထည့်ရန်",
Add_supplementary_agreement:"ထပ်ဆောင်းစာချုပ်ထည့်ရန်",
Add_an_ancillary_agreement_template:"ထပ်ဆောင်းစာချုပ်ပုံစံထည့်ရန်",
Addendum_to_the_subcontract:"အောက်စာချုပ်ထည့်ရန်",
Please_select_the_addendum_contract:"ထည့်လိုသည့် စာချုပ်ကို ရွေးချယ်ပါ",
contract:"စာချုပ်",
To_be_signed:"လက်မှတ်ရေးထိုးရန် စောင့်ဆိုင်းနေသည်",
To_be_signed_contract:"လက်မှတ်ရေးထိုးရန် စောင့်ဆိုင်းနေသော စာချုပ်များ",
Go_to_sign:"လက်မှတ်ရေးထိုးရန် ဆက်လက်လုပ်ဆောင်ပါ",
You_have_contracts_to_sign:"သင့်တွင် လက်မှတ်ရေးထိုးရန် စောင့်ဆိုင်းနေသော စာချုပ်များ ရှိပါသည်။ ဆက်လက်လက်မှတ်ရေးထိုးလိုပါသလား။",
Add_contract_template:"စာချုပ်ပုံစံထည့်ရန်",
Edit_contract_template:"စာချုပ်ပုံစံ တည်းဖြတ်ရန်",
Template_chinese_name:"ပုံစံအမည် (တရုတ်)",
Template_english_name:"ပုံစံအမည် (အင်္ဂလိပ်)",
Audit_contract:"စာချုပ် ပြန်လည်သုံးသပ်ရန်",
Credit_limit:"အကြွေးကန့်သတ်",
Online_product_status:"အွန်လိုင်း ထုတ်ကုန် အခြေအနေ",
The_store_product_data_status_for_synchronizing_inventory_will_be_automatically_synchronized_at_least_once_a_day_and_other_unconfigured_items_need_to_be_manually_synchronized:"စာရင်းကိုက်ညီမှုဖြင့် စီစဉ်ထားသော ဆိုင်များအတွက် ထုတ်ကုန်ဒေတာအခြေအနေကို တစ်နေ့တစ်ကြိမ် အလိုအလျောက် ကိုက်ညီစေပါမည်။ အခြား မစီစဉ်ထားသေးသော ဒေတာများကို ကိုက်ညီစေရန် လက်ဖြင့် ထုတ်ယူရပါမည်။",
Online_product_matching:"အွန်လိုင်း ထုတ်ကုန် ကိုက်ညီခြင်း",
Batch_Online_product_matching:"အစုလိုက် အွန်လိုင်း ထုတ်ကုန် ကိုက်ညီခြင်း",
receiveWarehousePermissions:"လက်ခံဂိုဒေါင် ခွင့်ပြုချက်များ",
Choose_zones_and_shelves_for_quick_planning:"အမြန်စီမံကိန်းရေးဆွဲရန် ဇုန်များနှင့် စင်များ ရွေးချယ်ခြင်း",
If_a_partition_or_shelf_is_selected_only_unused_shelves_under_that_partition_or_shelf_will_be_recommended_If_partitioning_or_shelving_is_not_selected_it_will_be_recommended_that_the_corresponding_customer_s_receiving_warehouse_has_unused_storage_locations_near_the_inventory_shelves_If_there_is_no_inventory_it_will_not_be_recommended:"အပိုင်းများ သို့မဟုတ် စင်များ ရွေးချယ်ထားပါက၊ ထိုအပိုင်းများ သို့မဟုတ် စင်များအတွင်း မအသုံးပြုသေးသော စင်များကိုသာ အကြံပြုမည်။ အပိုင်းများ သို့မဟုတ် စင်များ မရွေးချယ်ထားပါက၊ သက်ဆိုင်ရာ ဖောက်သည်၏ လက်ခံဂိုဒေါင်ရှိ ပစ္စည်းရှိသော စင်များအနီးရှိ မအသုံးပြုသေးသော သိုလှောင်ရာနေရာများကို အကြံပြုမည်။ ပစ္စည်းမရှိပါက၊ အကြံပြုချက် မပေးပါ။",
Pair_product_images:"ထုတ်ကုန်ဓာတ်ပုံများ ကိုက်ညီစေခြင်း",
Paired_product_barcode:"ထုတ်ကုန်ဘားကုဒ်များ ကိုက်ညီစေခြင်း",
Matching_product_SKU:"ထုတ်ကုန် SKU များ ကိုက်ညီစေခြင်း",
Paired_product_Chinese_name:"ထုတ်ကုန် တရုတ်အမည်များ ကိုက်ညီစေခြင်း",
Paired_product_English_name:"ထုတ်ကုန် အင်္ဂလိပ်အမည်များ ကိုက်ညီစေခြင်း",
online_SKU:"အွန်လိုင်း SKU များ",
Actual_amount:"လက်ကျန်အရေအတွက်",
Please_select_orders_from_the_same_platform:"တစ်ခုတည်းသော ပလက်ဖောင်းမှ အော်ဒါများကို ရွေးချယ်ပါ။",
The_old_password_matches_the_new_password_please_re_enter:"ဟောင်း password နှင့် အသစ် password ကိုက်ညီပါသည်။ ထပ်မံ ထည့်ပါ။",
generate_a_contract:"စာချုပ် ဖန်တီးခြင်း",
Deposit_Bank:"ဘဏ်အမည်",
Deposit_Bank_No:"ဘဏ်အကောင့်နံပါတ်",
ID_card_address:"ID လိပ်စာ",
ID_card_name:"အမည်",
Please_enter_your_name:"အမည် ထည့်ပါ။",
Please_enter_the_name_of_the_legal_representative:"ဥပဒေအရ ကိုယ်စားလှယ်အမည် ထည့်ပါ။",
Please_enter_the_company:"ကုမ္ပဏီအမည် ထည့်ပါ။",
Please_enter_the_legal_representative_company:"ဥပဒေအရ ကိုယ်စားလှယ်၏ ကုမ္ပဏီအမည် ထည့်ပါ။",
Please_select_the_company:"ကုမ္ပဏီရွေးပါ။",
Please_enter_the_business_license_code:"စီးပွားရေးလိုင်စင်နံပါတ် ထည့်ပါ။",
contractTemplateManagemen:"စာချုပ်ပုံစံ",
Contract_Template_Id:"စာချုပ်ပုံစံ ID",
Contract_signing_expiration_date:"စာချုပ်လက်မှတ်ရေးထိုး သက်တမ်းကုန်ဆုံးရက်များ",
file_path:"ဖိုင်လမ်းကြောင်း",
Please_select_the_contract_type:"စာချုပ်အမျိုးအစားကို ရွေးချယ်ပါ",
Please_select_the_contract_template:"စာချုပ်ပုံစံကို ရွေးချယ်ပါ",
Please_upload_the_file:"ဖိုင်ကို တင်ပါ",
Signing_effective_time:"လက်မှတ်ရေးထိုး သက်တမ်း",
Validity_period_of_ID_card:"အထောက်အထားကတ် သက်တမ်း",
Please_enter_the_validity_period_of_your_ID_card:"အထောက်အထားကတ် သက်တမ်းကို ထည့်ပါ",
Validity_period_of_legal_person_s_ID_card:"ဥပဒေရေးရာ ကိုယ်စားလှယ်၏ အထောက်အထားကတ် သက်တမ်း",
Please_enter_the_validity_period_of_the_legal_person_s_ID_card:"ဥပဒေရေးရာ ကိုယ်စားလှယ်၏ အထောက်အထားကတ် သက်တမ်းကို ထည့်ပါ",
Date_of_Birth:"မွေးနေ့",
Please_enter_your_date_of_birth:"မွေးနေ့ကို ထည့်ပါ",
Business_license_address:"စီးပွားရေးလိုင်စင်လိပ်စာ",
Validity_period_of_business_license:"စီးပွားရေးလိုင်စင် သက်တမ်း",
Please_enter_the_validity_period_of_the_business_license:"စီးပွားရေးလိုင်စင် သက်တမ်းကို ထည့်ပါ။",
Please_enter_your_ID_address:"ID ကတ်လိပ်စာကို ထည့်ပါ။",
Please_enter_the_address_on_your_business_license:"စီးပွားရေးလိုင်စင်လိပ်စာကို ထည့်ပါ။",
When_uploading_the_ID_card_file_the_first_one_is_the_front_of_the_ID_card_and_the_second_one_is_the_back_of_the_ID_card:"ID ကတ်စာရွက်များကို တင်သောအခါ ပထမဓာတ်ပုံမှာ ID ကတ်ရှေ့ဘက်၊ ဒုတိယဓာတ်ပုံမှာ နောက်ဘက်ဖြစ်ပါသည်။",
Please_select_data_from_the_same_warehouse:"တစ်ခုတည်းသော ဂိုဒေါင်အောက်ရှိ ဒေတာကို ရွေးပါ။",
Batch_modify_storage_location_types_and_store_SKU_types:"Bay အမျိုးအစားကို အစုလိုက်ပြင်ဆင်ရန်၊ SKU အမျိုးအစားကို သိုလှောင်ရန်",
Single_page_signature_page:"တစ်စာမျက်နှာ လက်မှတ်ရေးထိုးရန် စာမျက်နှာ",
Please_enter_the_single_page_signature_page:"တစ်စာမျက်နှာ လက်မှတ်ရေးထိုးရန် စာမျက်နှာကို ထည့်ပါ။",
Signature_page_number_of_saddle_seal:"ထပ်တိုးလက်မှတ်ရေးထိုးရန် စာမျက်နှာနံပါတ်",
Please_enter_the_page_number_for_signing_the_saddle_seal:"တံဆိပ်ထိုးလက်မှတ် စာမျက်နှာနံပါတ်ကို ထည့်ပါ။",
Total_number_of_pages_in_the_contract:"စာချုပ် စုစုပေါင်း စာမျက်နှာများ",
If_the_total_number_of_pages_in_the_contract_is_2_fill_in_1_2_The_total_number_of_pages_in_the_contract_is_3_please_fill_in_1:"စာချုပ် စုစုပေါင်း စာမျက်နှာများမှာ ၂ ဖြစ်ပါက ၁-၂ ဟု ထည့်ပါ။ စာချုပ် စုစုပေါင်း စာမျက်နှာများမှာ ၃ ဖြစ်ပါက ၁-၃ ဟု ထည့်ပါ။",
Online_product_information:"အွန်လိုင်း ထုတ်ကုန် အချက်အလက်",
Online_variant_ID:"အွန်လိုင်း မျိုးစုံ ID",
Import_warehouse_transfer_task:"သိုလှောင်ဂိုဒေါင်မှ ထုတ်ပို့ရေး တာဝန်",
Export_warehouse_inventory_information:"ထုတ်ပို့ဂိုဒေါင်ရှိ ပစ္စည်းစာရင်း အချက်အလက်",
Adjust_the_storage_location:"သိုလှောင်ရာနေရာ ချိန်ညှိခြင်း",
The_selected_stock_quantity_cannot_be_0_please_enter_the_stock_quantity:"ရွေးချယ်ထားသော သိုလှောင်ပမာဏသည် သုည မဖြစ်နိုင်ပါ။ သိုလှောင်ပမာဏကို ထည့်ပါ။",
Order_status:"အော်ဒါအခြေအနေ",
Rule_1:"စည်းကမ်း ၁",
Rule_2:"စည်းကမ်း ၂",
Channel_number:"ချန်နယ်နံပါတ်",
Area_code:"ဇုန်ကုဒ်",
Shelf_number:"ရက်ခ်နံပါတ်",
Shelf_position:"ရက်ခ်တည်နေရာနံပါတ်",
Represent_with_1_2_letters_numbers_to_distinguish_different_functional_areas_for_example:"လုပ်ဆောင်မှုဇုန်အမျိုးမျိုးကို ခွဲခြားရန် အက္ခရာနှင့် ဂဏန်း တစ်လုံးမှ နှစ်လုံး အသုံးပြုပါ၊ ဥပမာ။",
R_Receiving_Area:"R: လက်ခံဧရိယာ",
S_Storage_Area:"S: သိုလှောင်ဧရိယာ",
P_Picking_Area:"P: ရွေးယူရာဒေသ (Picking Area)",
D_Delivery_Area:"D: ပို့ဆောင်ရာဒေသ (Delivery Area)",
Or_use_SA_to_distinguish_different_areas_of_different_functional_zones_heavy_shelves_light_shelves_ground_push:"အခြားနည်းလမ်းအနေဖြင့် လုပ်ဆောင်မှုဒေသများအတွင်းရှိ အပိုင်းခွဲဒေသများကို ခွဲခြားရန် SA ကို အသုံးပြုနိုင်သည် (ဥပမာ - အလေးပစ္စည်းတင်စင်များ၊ အလင်းပစ္စည်းတင်စင်များ၊ ကြမ်းပြင်ပြသမှု)",
Represented_by_1_2_digits_numbered_in_sequence_such_as_01_02__99_combined_with_the_area_number_such_as_S_01_for_storage_area:"နံပါတ် 1-2 ဖြင့် အစဉ်လိုက် သတ်မှတ်ထားပြီး (ဥပမာ - 01, 02…99)၊ ဒေသကုဒ်နှင့် ပေါင်းစပ်အသုံးပြုသည် (ဥပမာ - S-01 သည် သိုလှောင်ရာဒေသကို ဆိုလိုသည်)",
Represent_with_1_2_digits_numbered_in_sequence_such_as_01_02_99_combined_with_the_area_channel_number_such_as_S_01_01_representing_the_first_shelf_of_the_first_channel_in_the_storage_area:"နံပါတ် ၁-၂ လုံးကို အစဉ်လိုက် (ဥပမာ 01, 02…99) သုံးပြီး၊ ဇုန်လမ်းကြောင်းနံပါတ်များနှင့် ပေါင်းစပ်အသုံးပြုပါ (ဥပမာ S-01-01 သည် သိုလှောင်ဇုန်ရှိ ပထမဆုံးလမ်းကြောင်း၊ ပထမဆုံးစင်ကို ဆိုလိုသည်)။",
Represent_with_1_2_digits_numbered_from_bottom_to_top_such_as_01_02_03_combined_with_the_area_channel_and_shelf_number_such_as_S_01_01_01_representing_the_first_layer_of_the_first_shelf_in_the_first_channel_of_the_storage_area:"၁-၂ လုံးဂဏန်းဖြင့် သတ်မှတ်ကာ အောက်မှ အပေါ်သို့ (ဥပမာ 01, 02, 03…) ဂဏန်းစီ၍၊ ဇုန်၊ လမ်းကြောင်းနှင့် စင်နံပါတ်များနှင့် ပေါင်းစပ်ထားသည် (ဥပမာ S-01-01-01 သည် သိုလှောင်ဇုန်၏ ပထမလမ်းကြောင်းရှိ ပထမဆုံး စင်၏ ပထမဆုံး အလွှာကို ဆိုလိုသည်)။",
Represented_by_1_2_digits_the_same_layer_is_numbered_from_left_to_right_such_as_01_02_combined_with_the_area_channel_shelf_and_layer_numbers_such_as_S_01_01_01_01_representing_the_first_channel_first_shelf_first_layer_first_digit_grid_of_the_storage_area:"အလွှာအတွင်း ဘယ်မှညာ စဉ်လိုက်မှုကို ဖော်ပြသည့် ၁-၂ လုံးဂဏန်း (ဥပမာ 01, 02…), ဇုန်၊ လမ်းကြောင်း၊ စင်နှင့် အလွှာကုဒ်များနှင့် ပေါင်းစပ်အသုံးပြုသည် (ဥပမာ S-01-01-01-01 သည် သိုလှောင်ဇုန်၏ ပထမလမ်းကြောင်းရှိ ပထမစင်၏ ပထမအလွှာတွင် တည်ရှိသည့် ပထမနေရာကို ဆိုလိုသည်)။",
Complete_coding_example_S_02_05_03_04:"ကုဒ်ရေးဆွဲခြင်း ဥပမာ ပြည့်စုံ: S-02-05-03-04",
if_03_is_03_rd_floor_04_is_04_th_storage_location_S_Storage_area_02_Second_aisle_05_Fifth_shelf:"03 တတိယအဆင့် 04 စတုတ္ထသိုလှောင်ခန်း S သိုလှောင်ဇုန် 02 ဒုတိယချန်နယ် 05 ငါးမြောက်ထပ်",
Please_enter_the_area_code:"ဧရိယာကုဒ်ကို ထည့်ပါ။",
Please_enter_the_channel_number:"ချန်နယ်နံပါတ်ကို ထည့်ပါ။",
Please_enter_the_shelf_position:"စင်တည်နေရာနံပါတ်ကို ထည့်ပါ။",
Online_product_images:"အွန်လိုင်းထုတ်ကုန်ဓာတ်ပုံများ",
increase_storage_locations:"သိုလှောင်ရာနေရာ ထည့်ရန်",
articleList:"ဆောင်းပါးစာရင်း",
article_Name:"ဆောင်းပါးခေါင်းစဉ်",
whether_to_turn_it_on:"ဖွင့်/ပိတ်",
create_Article:"ဆောင်းပါးအသစ်ဖန်တီးရန်",
edit_Article:"ဆောင်းပါးတည်းဖြတ်ရန်",
article_Details:"ဆောင်းပါးအသေးစိတ်",
Open:"ဖွင့်",
Shut_down:"ပိတ်",
articleDetail:"ဆောင်းပါးအသေးစိတ်",
External_ERP_Help_Documentation:"ပြင်ပ ERP အကူအညီစာရွက်စာတမ်းများ",
help_document:"အကူအညီစာရွက်စာတမ်းများ",
help_center:"အကူအညီစင်တာ",
Please_enter_the_article_name:"ဆောင်းပါးခေါင်းစဉ်ကို ထည့်ပါ။",
Please_select_the_status:"အခြေအနေကို ရွေးပါ။",
Please_select_the_menu:"မီနူးကို ရွေးပါ။",
helpDocument:"အကူအညီစာရွက်စာတမ်းများ",
shopeeGlobalOnlineProducts:"Shopee Global အွန်လိုင်း ထုတ်ကုန်များ",
global_item_id:"ကမ္ဘာလုံးဆိုင်ရာ itemId",
global_multi_attribute_id:"ကမ္ဘာလုံးဆိုင်ရာ အင်္ဂါရပ်များစွာ ID",
global_online_sku:"ကမ္ဘာလုံးဆိုင်ရာ အွန်လိုင်း SKU",
is_mapped:"ချိတ်ဆက်မှု အခြေအနေ",
product_status:"ထုတ်ကုန် အခြေအနေ",
pull_product_task:"ထုတ်ကုန် ဆွဲယူခြင်း တာဝန်",
pull_log:"ဆွဲယူမှတ်တမ်း",
delete_shelves_by_layer:"အလွှာအလိုက် စင်များ ဖျက်ခြင်း",
The_lowest_purchase_unit_price_in_the_completed_stage_of_inventory_management:"စတော့ပြင်ဆင်ခြင်း၊ အော်ဒါစီမံခန့်ခွဲခြင်း ပြီးစီးပြီး၊ အဆင့်အလိုက် အနိမ့်ဆုံး ဝယ်ယူအော်ဒါ စျေးနှုန်း",
The_most_recent_purchase_unit_price_in_the_completed_stage_of_inventory_management:"ကုန်ပစ္စည်းပြင်ဆင်ခြင်း၊ အော်ဒါစီမံခန့်ခွဲခြင်း ပြီးစီးပြီး၊ လက်ရှိအဆင့်တွင် နောက်ဆုံးဝယ်ယူမှု၏ တစ်ယူနစ်စျေးနှုန်း",
Default_last_purchase_currency_initially_CNY:"နောက်ဆုံးဝယ်ယူမှုမှ မူလငွေကြေး၊ CNY ဖြင့် စတင်သတ်မှတ်ထားသည်။",
The_default_is_the_last_purchase_unit_price_which_is_initially_the_purchase_price_of_the_product:"နောက်ဆုံးဝယ်ယူမှုအော်ဒါမှ မူလယူနစ်စျေးနှုန်း၊ ပစ္စည်း၏ ဝယ်ယူစျေးနှုန်းဖြင့် စတင်သတ်မှတ်ထားသည်။",
Daily_sales_in_the_past_30_days_multiplied_by_purchase_days_warning_inventory_total_inventory_in_transit_inventory_and_planned_stock_quantity:"ပြီးခဲ့သည့် ၃၀ ရက်အတွင်း နေ့စဉ်ရောင်းအား * ဝယ်ယူရေးရက်များ + သတိပေးသိုလှောင်ပမာဏ - စုစုပေါင်းသိုလှောင်ပစ္စည်း - သယ်ယူပို့ဆောင်နေသောပစ္စည်း - ပြန်ဖြည့်ရန် စီစဉ်ထားသော ပမာဏ",
Do_not_display_items_less_than_or_equal_to_0:"တန်ဖိုးများ ≤ 0 ကို မပြသပါ။",
Daily_sales_in_the_past_30_days_multiplied_by_purchase_days_warning_inventory_total_inventory_in_transit_inventory_planned_stock_quantity_and_out_of_stock_quantity:"လွန်ခဲ့သော ၃၀ ရက်အတွင်း နေ့စဉ်ရောင်းအား × ဝယ်ယူရက်များ + သတိပေးစာရင်း - စုစုပေါင်းစာရင်း - သယ်ယူပို့ဆောင်နေသောစာရင်း - စီစဉ်ထားသောစာရင်းပြန်ဖြည့်ပမာဏ + စာရင်းမလုံလောက်သောပမာဏ",
Suggested_stocking_quantity_multiplied_by_purchase_unit_price:"အကြံပြုစာရင်းပြန်ဖြည့်ပမာဏ × ဝယ်ယူဈေးနှုန်း",
Completing_the_purchase_order_will_not_change_the_purchase_unit_price_of_the_goods:"ပြန်ဖြည့်အော်ဒါတစ်ခု ပြီးစီးခြင်းသည် ကုန်ပစ္စည်း၏ ဝယ်ယူစျေးနှုန်းကို မပြောင်းလဲပါ။",
The_number_of_layers_cannot_be_0:"အဆင့်အဆင့်အဆင့် (Tier level) ကို 0 ဖြစ်၍ မရပါ။",
Mandatory_deduction_of_fees:"မဖြစ်မနေ ဖြတ်ချခြင်း",
Do_you_confirm_the_mandatory_deduction_of_fees:"မဖြစ်မနေ ဖြတ်ချခြင်းကို အတည်ပြုပါ",
Unrestricted_balance_can_be_deducted_as_negative:"ကန့်သတ်ချက်မရှိ; ကျန်ငွေကို အနုတ်တန်ဖိုးအထိ ဖြတ်ချနိုင်သည်။",
Inventory_management_pending_review_sum_of_stage_quantities_in_inventory_preparation:"ပြန်ဖြည့်အော်ဒါ စီမံခန့်ခွဲမှု: အတည်ပြုရန် စောင့်နေ (Pending Approval) + ပြန်ဖြည့်ဆဲ (In Replenishment) အဆင့်များရှိ ပမာဏများ၏ စုစုပေါင်း",
The_quantity_of_inventory_pending_review_reviewed_received_in_transit_warehouse_in_transit_in_the_final_stage_of_receiving_received_in_the_final_stage_under_quality_inspection_and_not_yet_listed_in_the_quality_inspection_stage:"လက်ခံအမှာစာ: အတည်ပြုရန် စောင့်နေ၊ အတည်ပြုပြီး၊ သယ်ယူပို့ဆောင်ရေးဂိုဒေါင်တွင် လက်ခံရရှိ၊ သယ်ယူပို့ဆောင်နေ၊ နောက်ဆုံးအဆင့် လက်ခံနေ၊ နောက်ဆုံးအဆင့် လက်ခံပြီး၊ စစ်ဆေးနေ၊ စစ်ဆေးပြီး - ဤအဆင့်တွင် မထည့်သေးသော ပမာဏ",
Please_enter_1_2_characters:"စာလုံး ၁-၂ လုံး ထည့်ပါ",
Please_enter_1_2_digits:"ဂဏန်း ၁-၂ လုံး ထည့်ပါ",
Please_enter_a_number:"ဂဏန်း တစ်ခု ထည့်ပါ",
Is_it_an_available_storage_location:"ဤသည် သိုလှောင်ရန် နေရာ ရနိုင်ပါသလား?",
deduction_item:"လျော့ချမည့် ပစ္စည်းများ",
Sales_Trend_Chart:"အရောင်းလမ်းကြောင်းဇယား",
total_occupancy_quantity:"စုစုပေါင်း အသုံးပြုထားသော ပမာဏ",
Occupied_inventory_volume:"အသုံးပြုထားသော စုစုပေါင်း ပစ္စည်းစာရင်း",
Total_occupancy_quantity_order_occupancy_quantity_manual_outbound_occupancy_quantity_warehouse_transfer_occupancy_quantity:"စုစုပေါင်း အသုံးပြုထားသော ပမာဏ (အော်ဒါ အသုံးပြုထားသော ပမာဏ / လက်ဖြင့် ထွက်ပို့ထားသော အသုံးပြုထားသော ပမာဏ / လွှဲပြောင်းထားသော အသုံးပြုထားသော ပမာဏ)",
Sales_time_filtering:"အရောင်းအချိန် စစ်ထုတ်စနစ်",
Order_occupancy_quantity:"အော်ဒါ အသုံးပြုထားသော ပမာဏ",
Quantity_occupied_by_manual_outbound:"လက်ဖြင့် ထွက်ပို့ထားသော အသုံးပြုထားသော ပမာဏ",
Number_of_occupied_warehouses_for_relocation:"လွှဲပြောင်းထားသော အသုံးပြုထားသော ပမာဏ",
Please_select_the_item_that_needs_to_be_deducted:"လျော့ချရန် လိုအပ်သော အရာဝတ္ထုများကို ရွေးချယ်ပါ။",
Please_select_the_storage_type:"သိုလှောင်မှု အမျိုးအစားကို ရွေးချယ်ပါ။",
Please_select_the_type_of_storage_location:"တည်နေရာ အမျိုးအစားကို ရွေးချယ်ပါ။",
Transfer_according_to_batches_If_the_transfer_quantity_is_less_than_or_equal_to_the_available_inventory_of_a_single_batch_transfer_the_available_inventory_first_If_the_available_inventory_of_the_batch_is_less_than_the_total_inventory_of_the_batch_it_cannot_be_transferred:"အစုလိုက် ပြောင်းရွှေ့ခြင်း။ ပြောင်းရွှေ့မည့်ပမာဏသည် တစ်အစုလျှင် ရနိုင်သည့် ပစ္စည်းအရေအတွက်နှင့် ညီ/နည်းပါက ရနိုင်သည့် ပစ္စည်းများကို ပထမဦးစွာ ပြောင်းရွှေ့မည်။ တစ်အစုလျှင် ရနိုင်သည့် ပစ္စည်းအရေအတွက်သည် အစုစုစုပေါင်း ပစ္စည်းအရေအတွက်ထက် နည်းပါက ပြောင်းရွှေ့ခြင်း ဆက်လက်မလုပ်နိုင်ပါ။",
If_batch_occupancy_quantity_priority_should_be_given_to_transferring_occupied_inventory_followed_by_transferring_available_inventory:"တစ်အစုတွင် အသုံးပြုထားသည့် ပစ္စည်းအရေအတွက်နှင့် ညီ/ပိုပါက အသုံးပြုထားသည့် ပစ္စည်းများကို ပထမဦးစွာ ပြောင်းရွှေ့ပြီး ထို့နောက် ရနိုင်သည့် ပစ္စည်းများကို ပြောင်းရွှေ့မည်။",
After_transferring_a_batch_of_inventory_if_there_are_still_remaining_quantities_that_have_not_been_transferred_transfer_the_remaining_quantities_from_other_batches:"တစ်အစု၏ ပစ္စည်းများကို ပြောင်းရွှေ့ပြီးနောက် ကျန်ရှိသေးသည့် ပမာဏကို အခြားအစုများမှ ပြောင်းရွှေ့မည်။",
When_the_financial_currency_exchange_rate_for_converting_profits_from_the_original_currency_of_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_it_the_previous_day_s_data_will_be_synchronized_after_24_00_on_the_same_day_Only_orders_that_have_been_issued_and_bills_have_been_generated_will_be_synchronized_Profit_data_will_be_updated_in_the_early_morning_when_bills_are_generated_and_the_settlement_time_will_be_based_on_the_last_time_bills_are_generated_Note_The_billing_of_platform_orders_may_be_generated_at_multiple_time_points_If_some_of_the_billing_points_are_generated_before_the_currency_exchange_rate_is_set_these_bills_will_not_be_pulled_resulting_in_incomplete_order_report_fees:"ဆိုင်၏ မူလငွေကြေးမှ ဘဏ္ဍာရေးငွေကြေးသို့ အမြတ်ငွေကို ပြောင်းလဲရန် ငွေလဲနှုန်း မသတ်မှတ်ထားပါက စနစ်သည် ဒေတာကို ညှိနှိုင်းမည်မဟုတ်ပါ။ သတ်မှတ်ပြီးပါက ယခင်နေ့၏ ဒေတာများကို ထိုနေ့ 24:00 နာရီကျော်ပြီးနောက် ညှိနှိုင်းမည်ဖြစ်သည်။ ထွက်ပို့မှု ပြီးစီးပြီး ငွေတောင်းခံလွှာ ထုတ်ထားသော အော်ဒါများသာ ညှိနှိုင်းမည်ဖြစ်သည်။ အမြတ်ဒေတာများကို ငွေတောင်းခံလွှာ ထုတ်သည့်အခါ ညနေခင်းတွင် အပ်ဒိတ်လုပ်မည်ဖြစ်ပြီး ငွေရှင်းချိန်မှာ နောက်ဆုံး ထုတ်ထားသည့် ငွေတောင်းခံလွှာ၏ အချိန်ဖြစ်မည်။ မှတ်ချက်: ပလက်ဖောင်းအော်ဒါ ငွေတောင်းခံလွှာများကို အချိန်အမျိုးမျိုးတွင် ထုတ်ပေးနိုင်ပါသည်။ ငွေလဲနှုန်း သတ်မှတ်မပြုမီ ငွေတောင်းခံလွှာအချို့ကို ထုတ်ပေးခဲ့ပါက၊ ထိုငွေတောင်းခံလွှာများကို ပြန်လည်မရရှိနိုင်သဖြင့် အော်ဒါအစီရင်ခံစာကြေးများ မပြည့်စုံခြင်း ဖြစ်နိုင်ပါသည်။",
Currency_for_warehouse_fee_settlement:"ဂိုဒေါင်ကြေး ဖြေရှင်းငွေကြေး",
Original_currency_of_the_order:"အော်ဒါ မူလငွေကြေး",
BatchAddStorageLocations:"အစုလိုက် သိုလှောင်ရာနေရာများ ထည့်ခြင်း",
Please_fill_in_the_scope_in_order:"အကွာအဝေးကို အစဉ်လိုက် ဖြည့်ပါ။",
The_initial_value_cannot_be_greater_than_or_equal_to_the_end_value:"အစတန်ဖိုးသည် အဆုံးတန်ဖိုးထက် မကြီးမဖြစ်ရ",
The_initial_value_must_be_greater_than_0:"အစတန်ဖိုးသည် 0 ထက် ကြီးမဖြစ်ရ",
The_interval_between_initial_and_final_values_should_not_exceed_20:"အစနှင့်အဆုံးတန်ဖိုးများအကြားကွာဟမှုသည် 20 ထက်မပိုရ",
Position_grid_number:"တည်နေရာ ID",
Fetching:"ထုတ်ယူခြင်း",
Refresh_delivery_exception:"ပို့ဆောင်မှုဆိုင်ရာ မမှန်ကန်ချက်များကို ပြန်လည်အသစ်ပြုလုပ်ခြင်း",
Activate_Contract:"စာချုပ်ဖွင့်ခြင်း",
First_leg_order_log:"ဝင်ရောက်မှာယူမှတ်တမ်း",
Initial_billing_log:"ဝင်ရောက်ငွေတောင်းခံမှတ်တမ်း",
Create_template:"နမူနာဖန်တီးခြင်း",
Set_custom_calculation:"ကိုယ်ပိုင်တွက်ချက်မှု သတ်မှတ်ခြင်း",
Custom_calculation_log:"ကိုယ်ပိုင်တွက်ချက်မှတ်တမ်း",
Daily_sales_in_the_past_30_days:"လွန်ခဲ့သော ၃၀ ရက်အတွင်း နေ့စဉ်ရောင်းအား",
Planned_stocking_quantity:"ပြန်လည်ဖြည့်ဆည်းရန် စီစဉ်ထားသော ပမာဏ",
No_goods_found:"ထုတ်ကုန်မတွေ့ပါ",
Stock_up_suggestions_Product_information:"ပြန်လည်ဖြည့်ဆည်းရန် အကြံပြုသော ပစ္စည်းများ",
Out_of_stock_suggested_product_information:"ကုန်ကျဆုံးနေသော ပစ္စည်းများအတွက် အစားထိုးအကြံပြုချက်များ",
Address_Business_License_Address:"လိပ်စာ/စီးပွားရေးလိုင်စင်လိပ်စာ",
Customer_type:"ဖောက်သည်အမျိုးအစား",
Customer_authorization_status:"အတည်ပြုခွင့်အခြေအနေ",
Authorization_effective_time:"အတည်ပြုခွင့်စတင်သက်တမ်း",
Authorization_expiration_time:"အတည်ပြုခွင့်သက်တမ်းကုန်ဆုံး",
Go_to_authorization:"အတည်ပြုခွင့်သို့ ဆက်လက်",
logistics_information:"ပို့ဆောင်ရေးသတင်းအချက်အလက်",
Logistics_update_time:"ပို့ဆောင်ရေးအပ်ဒိတ်ချိန်",
Current_inventory_batch_quantity:"လက်ရှိစာရင်းပမာဏ",
Unqualified_quantity_shortage_damage:"မလိုက်နာသောပမာဏ (လျော့နည်း/ပျက်စီးသောပစ္စည်းများ)",
Positive_numbers_are_required_to_refund_fees_while_negative_numbers_are_required_to_deduct_customer_balances:"အပေါင်းတန်ဖိုးများသည် ပြန်အမ်းငွေများရှိကြောင်း ပြသသည်။ အနုတ်တန်ဖိုးများသည် ဖောက်သည်ငွေလက်ကျန်မှ ဖြတ်တောက်မည့်ငွေများကို ပြသသည်။",
ReturnedForGeneration:"ပြန်ပို့ရန် စောင့်ဆိုင်းနေသည့် မှတ်တမ်းများ",
Our_Information:"ကျွန်ုပ်တို့၏သတင်းအချက်အလက်",
the_other_party_s_information:"မိတ်ဖက်၏သတင်းအချက်အလက်",
Identity_witness_portrait:"ID ကတ် ပုံရိပ်ဘက်",
National_emblem_on_ID_card:"ID ကတ် အမျိုးသားအလံဘက်",
Please_enter_QQ_WeChat:"QQ/WeChat ကို ထည့်ပါ။",
generated_person:"ထုတ်လုပ်သူ",
generation_time:"ထုတ်လုပ်ချိန်",
The_automatic_addition_of_packaging_materials_will_only_be_triggered_when_it_is_submitted_for_shipment_or_when_the_waybill_number_is_obtained:"အလိုအလျောက် ထုပ်ပိုးထည့်ခြင်းသည် 'ပို့ဆောင်ရန် စောင့်ဆိုင်းနေ' သို့မဟုတ် 'Waybill နံပါတ် ရှာဖွေခြင်း' သို့ တင်သွင်းသည့်အခါမှသာ လှုပ်ရှားပါမည်။",
preview:"ကြိုကြည့်",
Packaging_material_combination:"ထုပ်ပိုးပေါင်းစပ်မှု",
Inventory_quantity_is_below:"အောက်တွင် ရှိသော ပစ္စည်းအရေအတွက်",
Sales_in_the_last_30_days_greater_than:"ယခင် ၃၀ ရက် အရောင်း အထက်",
Sales_in_the_last_30_days_greater:"ယခင် ၃၀ ရက် အရောင်း",
Please_select_the_affiliated_warehouse:"ဂိုဒေါင်ကို ရွေးချယ်ပါ",
The_calculated_suggested_stocking_quantity_will_be_sorted_in_descending_order:"တွက်ချက်ထားသော အကြံပြု စတော့အဆင့်များကို ကျဆင်းအဆင့်အလိုက် စီစဉ်မည်",
Custom_calculation_settings:"စိတ်ကြိုက် တွက်ချက်မှု ဆက်တင်များ",
Suggested_stocking_quantity:"အကြံပြု စတော့အရေအတွက်",
Calculate_based_on_custom_calculation_formula:"စိတ်ကြိုက် ဖော်မြူလာအတိုင်း တွက်ချက်ထားသည်",
Calculate_the_recommended_stocking_quantity_based_on_the_formula_in_your_custom_calculation_settings_located_in_the_top_right_corner:"ညာဘက်အပေါ်ရှိ ဖော်မြူလာအတိုင်း တွက်ချက်ထားသော အကြံပြု စတော့အရေအတွက် - စိတ်ကြိုက် တွက်ချက်မှု ဆက်တင်များ",
When_the_available_inventory_cannot_meet_your_pending_shipment_quantity_a_shortage_recommendation_will_be_triggered_recommending_as_much_as_is_needed:"လက်ကျန်ရှိသော ပစ္စည်းများဖြင့် မဖြည့်ဆည်းနိုင်သော အမှာစာများ ရှိပါက၊ ပစ္စည်းမလုံလောက်မှု သတိပေးချက်များ ထွက်ပေါ်ကာ လိုအပ်သည့် အရေအတွက်ကို တိတိကျကျ အကြံပြုပါမည်။",
The_total_quantity_of_goods_required_for_orders_in_the_pending_processing_and_review_stages_of_the_order_list:"စစ်ဆေးမှု စောင့်ဆိုင်းနေ' (Pending Processing) နှင့် 'အတည်ပြုချက် စောင့်ဆိုင်းနေ' (Pending Approval) အဆင့်များရှိ အမှာစာများအတွက် လိုအပ်သည့် ပစ္စည်းစုစုပေါင်း",
Calculate_the_recommended_stocking_quantity_based_on_a_custom_calculation_formula:"ကိုယ်ပိုင် ဖော်မြူလာအပေါ် အခြေခံ၍ အကြံပြု လက်ကျန်အရေအတွက် တွက်ချက်ခြင်း",
Inventory_in_return_processing:"ပြန်ပို့မှု ဆိုင်ရာ လက်ကျန်",
Average_daily_sales_in_the_past_30_days_multiplied_by_purchase_days_plus_warning_inventory_at_least_one_must_be_activated:"(ယခင် ၃၀ ရက်အတွင်း ပျမ်းမျှ တစ်နေ့တာ အရောင်း × ဝယ်ယူမှု ကြာမြင့်ချိန်) + ကြိုတင်သတိပေး စတော့အဆင့် (အနည်းဆုံး တစ်ခု ဖွင့်ထားရမည်)",
Total_inventory_available_inventory_Total_number_of_goods_awaiting_review_Inventory_in_return_processing_In_transit_inventory_Planned_stocking_quantity_at_least_one_must_be_activated:"(စုစုပေါင်း စတော့ / အသုံးပြုနိုင်သည့် စတော့) - ပြန်လည်သုံးသပ်ရန် စောင့်ဆိုင်းနေသည့် ကုန်ပစ္စည်း စုစုပေါင်း - ပြန်အမ်းငွေ လုပ်ငန်းစဉ်ရှိ စတော့ - သယ်ယူပို့ဆောင်ရေးလမ်းကြောင်းရှိ စတော့ - စတော့ ပြန်လည်ဖြည့်တင်းရန် စီစဉ်ထားသည့် ပမာဏ (အနည်းဆုံး တစ်ခု ဖွင့်ထားရမည်)",
warehouse_type:"ဂိုဒေါင်အမျိုးအစား",
Please_enter_the_name_of_the_person_in_charge:"တာဝန်ရှိသူ၏ အမည်ကို ထည့်ပါ။",
Only_process_orders_that_have_been_pending_review_and_entered_the_system_within_the_current_15_day_period:"လက်ရှိစနစ်အချိန်မှ နောက်ဆုံး ၁၅ ရက်အတွင်း ထည့်သွင်းထားသော စောင့်ဆိုင်းနေသည့် အော်ဒါများကိုသာ ဆောင်ရွက်ပါ",
The_order_will_be_automatically_triggered_when_it_is_submitted_for_shipment_or_when_the_waybill_number_is_obtained:"အော်ဒါများသည် 'ပို့ဆောင်ရန် စောင့်ဆိုင်းနေ' (Pending Dispatch) သို့မဟုတ် 'လိုက်လံရှာဖွေရေးနံပါတ် ရယူခြင်း' (Tracking Number Acquisition) အခြေအနေသို့ ရောက်ရှိသည့်အခါ အလိုအလျောက် လှုပ်ရှားပါ",
Return_Order:"ပြန်ပို့လာသော ကုန်ပစ္စည်းများ",
Pending_Review_Pending_Listing_In_Listing_Process_Number_of_Qualified_Items_Not_Yet_Completed_for_Listing:"စစ်ဆေးရန် စောင့်ဆိုင်းနေ၊ ပြန်သိုလှောင်ရန် စောင့်ဆိုင်းနေ၊ ပြန်သိုလှောင်နေဆဲ၊ အရည်အသွေးပြည့်မီသော်လည်း ပြန်သိုလှောင်မှု မပြီးစီးသေးသော ပမာဏများ",
canChangeSku:"အစားထိုးနိုင်သော SKU များ",
abnormalSKUPendingProcessing:"ဆောင်ရွက်ရန် စောင့်ဆိုင်းနေသည့် ပုံမှန်မဟုတ်သော SKU များ",
batch_change_sku:"အစုလိုက် SKU အစားထိုးခြင်း",
change_sku:"SKU အစားထိုးခြင်း",
please_select_the_sku_to_be_replaced:"အစားထိုးမည့် SKU ကို ရွေးချယ်ပါ",
please_select_new_sku:"အသစ်ထည့်မည့် SKU ကို ရွေးချယ်ပါ",
please_select_orders_from_the_same_warehouse:"တစ်ခုတည်းသော ဂိုဒေါင်ရှိ အော်ဒါများကို အမှတ်တံဆိပ်ထိုးပါ",
The_old_and_new_sku_cannot_be_the_same:"ဟောင်းနှင့် အသစ် SKU များသည် တူညီ၍ မရပါ။",
Mark_replaceable_SKU:"အစားထိုးနိုင်သည့် SKU များကို အမှတ်တံဆိပ်ထိုးပါ",
Month_of_cost_recalculation:"ကြေး ပြန်တွက်ချက်မည့် လ",
Order_adjustment_amount:"အော်ဒါ ပြင်ဆင်မည့် ငွေပမာဏ",
If_there_is_a_token_error_prompt_please_check_if_the_token_is_copied_correctly_or_if_the_authorized_Lazada_service_marketplace_site_corresponds_to_the_system_repository_country:"Token အမှားစာတစ်စောင် ပေါ်လာပါက၊ token ကို မှန်ကန်စွာ ကူးယူထားကြောင်း အတည်ပြုပါ သို့မဟုတ် ခွင့်ပြုထားသော Lazada Service Market ဆိုဒ်သည် စနစ်၏ ဂိုဒေါင်တည်နေရာနှင့် ကိုက်ညီမှုရှိမရှိ စစ်ဆေးပါ။",
channel_name:"ချန်နယ်အမည်",
Service_Type:"ဝန်ဆောင်မှုအမျိုးအစား",
Billing_Plan:"ငွေချေမှုအစီအစဉ်",
Delivery_countr:"ပို့ဆောင်မည့်နိုင်ငံ",
Delivery_area:"ပို့ဆောင်မည့်ဒေသ",
Logistics_provider_name:"ကုန်ပို့သူအမည်",
Quality_inspection_has_started:"အရည်အသွေးစစ်ဆေးမှု စတင်",
Completed_quality_inspection:"အရည်အသွေးစစ်ဆေးမှု ပြီးစီး",
Number_of_items_awaiting_quality_inspection:"စစ်ဆေးရန် စောင့်ဆိုင်းနေသည့် ပစ္စည်းများ",
The_number_of_quality_inspection_items_that_have_started:"စစ်ဆေးမှု စတင်ထားသည့် ပစ္စည်းများ",
Number_of_completed_quality_inspections:"စစ်ဆေးမှု ပြီးစီးထားသည့် ပစ္စည်းများ",
Product_in_transit_details:"ပို့ဆောင်နေဆဲ ပစ္စည်းအသေးစိတ်",
Quick_Region_Selection:"ဒေသရွေးချယ်မှု အမြန်",
Connection_error_please_check_if_the_video_plugin_is_open_and_try_again:"ဆက်သွယ်မှုအမှားဖြစ်နေပါသည်။ ဗီဒီယို plug-in ဖွင့်ထားကြောင်း အတည်ပြုပြီး ထပ်မံကြိုးစားပါ။",
Failed_to_save_the_currently_recorded_video:"လက်ရှိ ဗီဒီယိုမှတ်တမ်းတင်ခြင်း မအောင်မြင်ပါ။",
Please_enter_the_name_of_the_logistics_provider:"ပို့ဆောင်သူအမည် ထည့်ပါ။",
Please_enter_the_channel_name:"ချန်နယ်အမည် ထည့်ပါ။",
Please_select_the_delivery_country:"ပို့ဆောင်မည့်နိုင်ငံ ရွေးပါ။",
Import_logistics_channel_management_data:"လော့ဂျစ်စတစ်စ်ချန်နယ် စီမံခန့်ခွဲမှုဒေတာ တင်သွင်းခြင်း",
Export_Logistics_Channel_Management_Data:"လော့ဂျစ်စတစ်စ်ချန်နယ် စီမံခန့်ခွဲမှုဒေတာ ထုတ်ပို့ခြင်း",
Edit_channel:"ချန်နယ် တည်းဖြတ်ခြင်း",
Confirm_the_logistics_provider:"ပို့ဆောင်သူ အတည်ပြုခြင်း",
Recording_local_address:"ဒေသခံလိပ်စာ မှတ်တမ်းတင်ခြင်း",
Confirm_Clearing_Order_Packaging:"ကလီးယားအော်ဒါ ထုပ်ပိုးပစ္စည်းများ အတည်ပြုခြင်း",
Operation_Successful:"လုပ်ငန်းဆောင်တာ အောင်မြင်ပါပြီ",
Please_Select_The_Data:"ဒေတာ ရွေးပါ။",
Please_Select_Data_From_The_Same_Platform:"တစ်ခုတည်းသော ပလက်ဖောင်းမှ ဒေတာကို ရွေးချယ်ပါ။",
Confirm_Transfer_To_Pending:"စောင့်ဆိုင်းနေသော လုပ်ငန်းစဉ်သို့ ကူးပြောင်းရန် အတည်ပြုပါ။",
Confirm_Excluding_All_Rules:"စည်းကမ်းအားလုံးကို ထုတ်ပယ်ရန် အတည်ပြုပါ။",
Confirm_Canceling_Exclusion_Of_All_Rules:"ထုတ်ပယ်ထားသော စည်းကမ်းအားလုံးကို ဖျက်ရန် အတည်ပြုပါ။",
Confirm_Excluding_Automatic_Packaging_Rules:"အလိုအလျောက် ထုပ်ပိုးခြင်း စည်းကမ်းများကို ထုတ်ပယ်ရန် အတည်ပြုပါ။",
Confirm_Canceling_Exclusion_Of_Automatic_Packaging_Rules:"အလိုအလျောက် ထုပ်ပိုးခြင်း ထုတ်ပယ်စည်းကမ်းများကို ဖျက်ရန် အတည်ပြုပါ။",
Confirm_Excluding_Submission_Rules:"တင်သွင်းခြင်း စည်းကမ်းများကို ထုတ်ပယ်ရန် အတည်ပြုပါ။",
Confirm_Canceling_Exclusion_Of_Submission_Rules:"တင်သွင်းခြင်း ထုတ်ပယ်စည်းကမ်းများကို ဖျက်ရန် အတည်ပြုပါ။",
Yes:"ဟုတ်",
No:"မဟုတ်",
Currently_Selected_Orders_Have_No_Shipping_Exceptions_No_Action_Required:"လက်ရှိရွေးထားသော အော်ဒါများတွင် ပို့ဆောင်မှုဆိုင်ရာ ထူးခြားချက် မတွေ့ရှိရပါ၊ လုပ်ဆောင်ရန် မလိုပါ။",
Orders_Will_Be_Marked_As_Out_Of_Stock_If_Warehouse_Has_No_Inventory_After_Submission:"အဆိုပြုချက်ကို တင်သွင်းပြီးနောက် ဂိုဒေါင်တွင် ကုန်ပစ္စည်းမရှိသော အော်ဒါများကို ပစ္စည်းကုန်ဆုံး (out of stock) ဟု မှတ်သားမည်",
Out_Of_Stock_Orders:"ပစ္စည်းကုန်ဆုံး အော်ဒါများ",
Selected_Orders_Contain_Orders_Without_Tracking_Numbers_Cannot_Preview_Shipping_Labels:"ရွေးချယ်ထားသော အော်ဒါများတွင် waybill နံပါတ်များ မပါဝင်ပါ; waybill များကို ကြိုကြည့်ရှု၍ မရနိုင်ပါ",
Preview_PDF:"PDF ကြိုကြည့်ရှုခြင်း",
Sum_Of_Created_Within_Last_Seven_Days_Pending_Review_Tracking_Number_Acquisition_In_Progress_And_Shipping_Exceptions:"ပြီးခဲ့သည့် ၇ ရက်အတွင်း ပို့ဆောင်မှုဆိုင်ရာ မမှန်ကန်မှု စုစုပေါင်း: ပြန်လည်သုံးသပ်ရန် စောင့်ဆိုင်းနေ၊ waybill နံပါတ် ရယူဆဲ",
Shipping_Exceptions_In_Last_Seven_Days:"ပြီးခဲ့သည့် ၇ ရက်အတွင်း ပို့ဆောင်မှုဆိုင်ရာ မမှန်ကန်မှုများ",
Basic_Query:"အခြေခံ မေးမြန်းချက်",
Expired_Stores:"သက်တမ်းကုန်ဆုံးထားသော ဆိုင်များ",
Order_Number:"အော်ဒါနံပါတ်",
Tracking_Number:"ဝေဘီလ်နံပါတ်",
Creation_Time:"ဖန်တီးသည့်ရက်စွဲ",
Transaction_Number:"ငွေလုပ်ငန်း ID",
Platform:"ပလက်ဖောင်း",
Order_Source:"အော်ဒါရင်းမြစ်",
API_Order:"API အော်ဒါ",
Push_Order:"ပို့ထားသော အော်ဒါ",
Manual_Order:"လက်ဖြင့် ထည့်သွင်းသော အော်ဒါ",
Cargo_Query:"ကုန်ပစ္စည်းစုံစမ်းမေးမြန်းခြင်း",
Warehouse:"ဂိုဒေါင်",
Logistics_Channel:"သယ်ယူပို့ဆောင်ရေးလမ်းကြောင်း",
Country:"နိုင်ငံ",
Chinese_Product_Name:"တရုတ်ထုတ်ကုန်အမည်",
English_Product_Name:"အင်္ဂလိပ်ထုတ်ကုန်အမည်",
Order_Status_Query:"အော်ဒါအခြေအနေစုံစမ်းမေးမြန်းခြင်း",
Logistics_Status:"သယ်ယူပို့ဆောင်ရေးအခြေအနေ",
Priority_Delivery:"ဦးစားပေးပို့ဆောင်ခြင်း",
Delivery_Method:"ပို့ဆောင်နည်း",
WMS_Status:"WMS အခြေအနေ",
Platform_Status:"ပလက်ဖောင်းအခြေအနေ",
Time_Query:"အချိန်စုံစမ်းမေးမြန်းခြင်း",
Confirmation_Time:"အတည်ပြုချိန်",
Outbound_Time:"ထွက်ခွာချိန်",
Batch_Query:"အုပ်စုစုံစမ်းမေးမြန်းခြင်း",
Add_Quick_Query:"အမြန်စုံစမ်းမေးမြန်းခြင်းထည့်ရန်",
Create_Order:"အော်ဒါဖန်တီးရန်",
Transfer_To_Tracking_Number_Acquisition_In_Progress_Or_Awaiting_Shipment:"ပို့ဆောင်ရေးအမိန့်နံပါတ် ရယူခြင်း/ပို့ဆောင်ရန် စောင့်ဆိုင်းခြင်းမှ ပြောင်းရွှေ့ခြင်း",
Orders_With_Tracking_Numbers_Will_Automatically_Transfer_To_Stage_Awaiting_Shipment_Orders_Without_Tracking_Numbers_Will_Automatically_Transfer_To_Stage_Tracking_Number_Acquisition_In_Progress:"ပို့ဆောင်ရေးအမိန့်နံပါတ်ပါ အော်ဒါများကို အလိုအလျောက် ပြောင်းရွှေ့မည် - ပို့ဆောင်ရန် စောင့်ဆိုင်းခြင်း။ ပို့ဆောင်ရေးအမိန့်နံပါတ်မပါသော အော်ဒါများကို အလိုအလျောက် ပြောင်းရွှေ့မည် - ပို့ဆောင်ရေးအမိန့်နံပါတ် ရယူခြင်း။",
Transfer_To_Pending:"စတင်ဆောင်ရွက်ရန် စောင့်ဆိုင်းခြင်းသို့ ပြောင်းရွှေ့ခြင်း",
Fetch_Orders:"အော်ဒါ ပြန်လည်ရယူခြင်း",
Set_Order_Packaging:"အော်ဒါ ထုပ်ပိုးပစ္စည်းများ စနစ်တကျ ချိန်ညှိခြင်း",
Clear_Order_Packaging:"အော်ဒါ ထုပ်ပိုးပစ္စည်းများ ဖျက်ခြင်း",
Void_Orders:"အော်ဒါ ဖျက်သိမ်းခြင်း",
Delete_Orders:"အော်ဒါ ဖျက်ပစ်ခြင်း",
Only_Supports_Operating_API_Orders_Within_12_Hours_Of_Delivery_Deadline_And_Push_Orders_Created_More_Than_12_Hours_Ago:"ပို့ဆောင်ချိန် ကန့်သတ်ချက် ၁၂ နာရီအတွင်းရှိ API အော်ဒါများနှင့် ၁၂ နာရီထက်ရှေးက ဖန်တီးထားသော push အော်ဒါများကိုသာ ထောက်ပံ့ပေးသည်။",
Return_To_Pending_Review:"ပြန်လည်သုံးသပ်ရန် စောင့်ဆိုင်းနေဆဲ အဆင့်သို့ ပြန်သွားရန်",
Activate:"ဖွင့်ရန်",
Refresh_Platform_Status:"ပလက်ဖောင်း အခြေအနေ ပြန်လည်အသစ်ပြုရန်",
Online_Product_Matching:"အွန်လိုင်း ထုတ်ကုန် ကိုက်ညီမှု",
Resubmit_For_Shipping:"ပို့ဆောင်ရန် ထပ်မံတင်သွင်းရန်",
More_Operations:"အခြား လုပ်ဆောင်ချက်များ",
Import:"တင်သွင်းရန်",
Export:"ထုတ်ပို့ရန်",
Tracking_Number_Acquisition_Successful_Will_Automatically_Transfer_To_Awaiting_Shipment:"လိုက်နာရှာဖွေရေးနံပါတ် ရရှိပြီးနောက် အလိုအလျောက် Pending Dispatch အဆင့်သို့ ပြောင်းရွှေ့သွားမည်။",
Shipping_Label_Operations:"Waybill လုပ်ငန်းစဉ်များ",
Upload_Shipping_Label:"Waybill တင်ရန်",
System_Printing_Requires_Downloading_A_Print_Plugin:"စနစ်ပုံနှိပ်ရန် print plugin ကို ဒေါင်းလုဒ်လုပ်ရန် လိုအပ်ပါသည်",
Click_To_Download:"ဒေါင်းလုဒ်လုပ်ရန် နှိပ်ပါ",
Print_Shipping_Label:"ပို့ဆောင်ရေးလိပ်စာ ပုံနှိပ်ခြင်း",
Download_Shipping_Label:"ပို့ဆောင်ရေးလိပ်စာ ဒေါင်းလုဒ်လုပ်ခြင်း",
Preview_Shipping_Label:"ပို့ဆောင်ရေးလိပ်စာ ကြိုကြည့်ခြင်း",
Order_Batch_Processing:"အော်ဒါအစုလိုက် လုပ်ငန်းစဉ်",
Replace_SKU:"SKU အစားထိုးခြင်း",
Delete_SKU:"SKU ဖျက်ခြင်း",
Add_SKU:"SKU ထည့်ခြင်း",
Modify_SKU_Quantity:"SKU အရေအတွက် ပြင်ဆင်ခြင်း",
Modify_Warehouse:"ဂိုဒေါင် ပြင်ဆင်ခြင်း",
Edit_Notes:"မှတ်ချက်များ ပြင်ဆင်ခြင်း",
Rule_Processing:"စည်းကမ်းချက် လုပ်ငန်းစဉ်",
Exclude_Submission_Rules:"တင်သွင်းမှု စည်းကမ်းများ ထုတ်ပယ်ခြင်း",
Cancel_Excluding_Submission_Rules:"တင်သွင်းမှု စည်းကမ်းများ ထုတ်ပယ်ခြင်း ဖျက်ခြင်း",
Exclude_Automatic_Packaging_Rules:"အလိုအလျောက် ထုပ်ပိုးမှု စည်းကမ်းများ ထုတ်ပယ်ခြင်း",
Cancel_Excluding_Automatic_Packaging_Rules:"အလိုအလျောက် ထုပ်ပိုးမှု စည်းကမ်းများ ထုတ်ပယ်ခြင်း ဖျက်ခြင်း",
Exclude_All_Rules:"စည်းကမ်းအားလုံး ထုတ်ပယ်ခြင်း",
Cancel_Excluding_All_Rules:"စည်းကမ်းအားလုံး ထုတ်ပယ်ခြင်း ဖျက်ခြင်း",
Exception:"မမှန်ကန်မှုများ",
Order_Amount:"အော်ဒါပမာဏ",
Tracking_Number_Acquisition_In_Progress:"ပို့ဆောင်ရေးနံပါတ် ရှာဖွေနေသည်...",
Push:"တွန်း",
Manual:"လက်",
Platform_Set_Priority_Delivery:"ပလက်ဖောင်း ဦးစားပေး ပို့ဆောင်မှု ဆက်တင်များ",
Priority:"ထူးချွန်",
Manual_Set_Priority_Delivery:"ဦးစားပေးပို့ဆောင်မှုကို လက်ဖြင့် သတ်မှတ်ပါ",
Pre_Sale_Orders:"ရောင်းမတိုင်မီမှာယူမှုများ",
Pre_Sale:"မတိုင်ခင်",
Out_Of_Stock:"မလုံလောက်ခြင်း",
Split_Orders:"အမှာစာခွဲခြင်း",
Split:"ဖြုတ်ခွဲ",
Product_Category:"ထုတ်ကုန်အမျိုးအစား",
Product_Quantity:"ထုတ်ကုန်အရေအတွက်",
Operation:"လုပ်ဆောင်ချက်",
Edit:"ပြင်ဆင်",
Do_Not_Leave_Blanks_For_Line_Breaks:"အလွတ်လိုင်းခွဲခြင်းမပြု",
Warehouse_Order_List:"ဂိုဒေါင်မှာယူစာရင်း",
All:"အားလုံး",
Today:"ယနေ့",
Yesterday:"မနေ့",
Day_Before_Yesterday:"မနေ့တုန်းက",
Last_Three_Days:"ပြီးခဲ့သည့် သုံးရက်",
Last_Week:"ပြီးခဲ့သည့် တစ်ပတ်",
Last_Month:"ပြီးခဲ့သည့် လ",
Non_Out_Of_Stock_Orders:"ကုန်မကျန်သော မှာယူမှုများ",
With_Tracking_Number:"ပို့ဆောင်ရေးနံပါတ်ပါ",
Without_Tracking_Number:"ပို့ဆောင်ရေးနံပါတ်မပါ",
Notes:"မှတ်ချက်များ",
With_Notes:"မှတ်ချက်ပါ",
Without_Notes:"မှတ်ချက်မပါ",
With_Platform_Notes:"ပလက်ဖောင်းမှတ်ချက်ပါ",
Without_Platform_Notes:"ပလက်ဖောင်းမှတ်ချက်မပါ",
Platform_Notes:"ပလက်ဖောင်းမှတ်ချက်များ",
Non_Split_Orders:"ခွဲမထားသော အော်ဒါများ",
Non_Pre_Sale_Orders:"ကြိုရောင်းမဟုတ်သော အော်ဒါများ",
Paired_Orders:"ကိုက်ညီသော အော်ဒါများ",
Already_Paired_Orders:"ကိုက်ညီပြီးသား အော်ဒါများ",
Not_Paired_Orders:"မကိုက်ညီသေးသော အော်ဒါများ",
Shipping_Exceptions:"ပို့ဆောင်မှုဆိုင်ရာ ထူးခြားချက်များ",
Priority_Delivery_Orders:"ဦးစားပေး ပို့ဆောင်ရေး အော်ဒါများ",
Non_Priority_Delivery_Orders:"ဦးစားမပေးသော ပို့ဆောင်ရေး အော်ဒါများ",
With_Shipping_Exceptions:"ပို့ဆောင်မှုဆိုင်ရာ ထူးခြားချက်ပါ",
Without_Shipping_Exceptions:"ပို့ဆောင်မှုဆိုင်ရာ ထူးခြားချက်မပါ",
Task:"တာဝန်များ",
All_Tasks:"အားလုံး",
Today_Tasks:"ယနေ့တာဝန်များ",
Yesterday_Tasks:"မနေ့တာဝန်များ",
Submitted_Order_Tasks:"တင်သွင်းပြီးသော အော်ဒါတာဝန်များ",
Today_000000_180000_Submitted_Order_Tasks:"ယနေ့ 00:00:00 မှ 18:00:00 အတွင်း တင်သွင်းထားသော အော်ဒါတာဝန်များ",
Yesterday_000000_235959_Submitted_Order_Tasks:"မနေ့က 00:00:00 မှ 23:59:59 အတွင်း တင်သွင်းထားသော အော်ဒါတာဝန်များ",
Not_Excluding_Submission_Rules:"တင်သွင်းမှုစည်းမျဉ်းများ မဖယ်ရှားထား",
Excluded_Submission_Rules:"တင်သွင်းမှုစည်းမျဉ်းများ ဖယ်ရှားထား",
Not_Excluding_Automatic_Packaging_Rules:"အလိုအလျောက်ထုပ်ပိုးခြင်းစည်းမျဉ်းများ မဖယ်ရှားထား",
Excluded_Automatic_Packaging_Rules:"အလိုအလျောက်ထုပ်ပိုးခြင်းစည်းမျဉ်းများ ဖယ်ရှားထား",
Shipping_Label:"ဝေဘီလ်",
With_Shipping_Label:"ဝေဘီလ်ပါရှိ",
Without_Shipping_Label:"ဝေဘီလ်မပါ",
Online_Product_Image:"အွန်လိုင်းထုတ်ကုန်ဓာတ်ပုံများ",
No_Online_Product_Details_Available:"အွန်လိုင်းထုတ်ကုန်အသေးစိတ် မရရှိနိုင်ပါ",
Online_Product_Details:"အွန်လိုင်းထုတ်ကုန်အသေးစိတ်",
Product_Image:"ထုတ်ကုန်ဓာတ်ပုံများ",
System_Product_Details:"စနစ်ထုတ်ကုန်အသေးစိတ်",
Quantity:"အရေအတွက်",
Out_Of_Stock_Status:"ကုန်သွားသောအခြေအနေ",
Out:"ကုန်သွား",
Total_Inventory:"စုစုပေါင်းလက်ကျန်",
Total_Available_Inventory:"အသုံးပြုနိုင်သည့်စုစုပေါင်းလက်ကျန်",
Total_Occupied_Inventory:"ကတိပြုထားသည့်စုစုပေါင်းလက်ကျန်",
Total_Unavailable_Inventory:"အသုံးမပြုနိုင်သည့်စုစုပေါင်းလက်ကျန်",
Total_In_Transit_Inventory:"သယ်ယူပို့ဆောင်ဆဲစုစုပေါင်းလက်ကျန်",
This_Operation_Will_Permanently_Delete_The_Query_Condition_Proceed:"ဤလုပ်ဆောင်ချက်သည် ဤမေးမြန်းချက်စည်းကမ်းများကို အမြဲတမ်း ဖျက်ပစ်မည်။ ဆက်လက်လုပ်ဆောင်မလား?",
Currently_Only_Single_Order_Upload_Is_Supported:"လက်ရှိတွင် တစ်ခုချင်းစီ အော်ဒါတင်သွင်းခြင်းကိုသာ ထောက်ပံ့ပါသည်",
Current_Order_Cannot_Upload_Shipping_Label_Only_Orders_With_Order_Status_As_Pending_Review_Or_Awaiting_Shipment_And_WMS_Status_As_Picking_Exception_Sorting_Exception_Shipping_Exception_Or_Cancellation_Exception_Can_Upload_Shipping_Label:"လက်ရှိအော်ဒါများတွင် ပို့ဆောင်ရေးလက်မှတ်များကို တင်၍ မရပါ။ 'အတည်ပြုရန် စောင့်နေ' (Pending Approval) သို့မဟုတ် 'ပို့ရန် စောင့်နေ' (Pending Dispatch) အခြေအနေရှိသော အော်ဒါများနှင့် WMS အခြေအနေတွင် 'ရွေးယူမှု အမှား' (Picking Anomaly), 'ခွဲခြားမှု အမှား' (Sorting Anomaly), 'ပို့ဆောင်မှု အမှား' (Dispatch Anomaly), သို့မဟုတ် 'ဖျက်သိမ်းမှု အမှား' (Cancellation Anomaly) ရှိသော အော်ဒါများတွင်သာ ပို့ဆောင်ရေးလက်မှတ်များကို တင်နိုင်ပါသည်။",
Shipping_Label_Address_Is_Empty:"ပို့ဆောင်ရေးလက်မှတ်လိပ်စာ မဖြည့်ထားပါ",
Printing_In_Progress:"ပုံနှိပ်နေသည်...",
Network_Response_Failed:"ကွန်ယက် တုံ့ပြန်မှု မအောင်မြင်ပါ",
Download_Failed_Please_Try_Again_Later:"ဒေါင်းလုဒ် မအောင်မြင်ပါ၊ နောက်မှ ထပ်မံကြိုးစားပါ။",
Select_The_SKU_To_Add_And_Enter_The_Quantity_To_Add:"ထည့်လိုသော SKU များကိုရွေးပြီး အရေအတွက် ထည့်ပါ",
Product_Barcode:"ထုတ်ကုန် ဘားကုဒ်",
Only_One_Can_Be_Selected:"ရွေးချယ်နိုင်သည့် ရွေးစရာ တစ်ခုတည်းသာ ရှိသည်",
Please_Enter_The_Quantity:"အရေအတွက် ထည့်ပါ",
Please_Enter_Notes:"မှတ်ချက်များ ထည့်ပါ",
Select_The_SKU_To_Delete:"ဖျက်လိုသော SKU များကိုရွေးပါ",
Please_Select_The_SKU:"SKU များကိုရွေးပါ",
Order_Fetching_Time:"အော်ဒါ ပြန်လည်ရယူချိန်",
Please_Enter_Separated_By_Commas_Or_Line_Breaks:"ကော်မာ သို့မဟုတ် လိုင်းချိုးဖြင့် ခွဲ၍ ထည့်ပါ",
Please_Select_Store:"ဆိုင်ကိုရွေးပါ",
Transaction_Number_And_Order_Fetching_Time_Cannot_Be_Empty_Simultaneously:"Transaction ID နှင့် order retrieval time နှစ်ခုလုံးကို ဗလာမထားနိုင်ပါ။",
Fetch_Logistics_Tracking:"ကုန်ပို့ရေး လိုက်လံစစ်ဆေးမှု ရယူခြင်း",
Logistics_Tracking:"ကုန်ပို့ရေး လိုက်လံစစ်ဆေးမှု",
Latest_Update:"နောက်ဆုံး အပ်ဒိတ်",
Logistics_Information_Is_Being_Fetched:"ကုန်ပို့ရေး အချက်အလက် ဆွဲယူခြင်း",
Select_The_SKU_To_Modify_And_Enter_The_New_SKU_Quantity:"ပြင်ဆင်လိုသော SKU ကို ရွေးပြီး ပြင်ဆင်မည့် အရေအတွက်ကို ထည့်ပါ။",
Select_Product:"ထုတ်ကုန် ရွေးပါ",
Please_Select_Warehouse:"ဂိုဒေါင် ရွေးပါ",
Pair:"ကိုက်ညီမှု",
Paired_Product_Image:"ကိုက်ညီသော ထုတ်ကုန် ပုံ",
Paired_Product_Barcode:"ကိုက်ညီသော ထုတ်ကုန် ဘားကုဒ်",
Paired_Product_SKU:"ကိုက်ညီသော ထုတ်ကုန် SKU",
Paired_Product_Chinese_Name:"ကိုက်ညီသော ထုတ်ကုန် တရုတ်အမည်",
Paired_Product_English_Name:"ကိုက်ညီသော ထုတ်ကုန် အင်္ဂလိပ်အမည်",
Statistics_Time_Range:"စာရင်းအင်းအချိန်ကာလ",
Number_Of_People:"ဝန်ထမ်းအရေအတွက်",
Human_Efficiency:"ဝန်ထမ်းထိရောက်မှု",
Packing_Lead_Time:"ထုပ်ပိုးမှုအချိန်မီမှု",
Starting_Hour:"စတင်ချိန်",
Corresponding_Hour_For_Calculation_Day:"တွက်ချက်မည့်နေ့အတွက် ကိုက်ညီသည့်အချိန်",
Ending_Hour:"အဆုံးချိန်",
Corresponding_Hour_For_Calculation_Day_Plus_One_Day:"တွက်ချက်မည့်နေ့ + ၁ ရက်အတွက် ကိုက်ညီသည့်အချိန်",
Changes_Take_Effect_From_The_Next_Hour:"ပြင်ဆင်ချက်များကို နောက်အချိန်မှစ၍ အကျုံးဝင်မည်",
Add:"ထည့်ရန်",
Operation_Log:"လုပ်ငန်းမှတ်တမ်း",
Type:"အမျိုးအစား",
Calculation_Day:"တွက်ချက်မည့်နေ့",
Calculation_Day_Starting_Hour:"တွက်ချက်မည့်နေ့ စတင်ချိန်",
Next_Day_Ending_Hour:"နောက်နေ့ အဆုံးချိန်",
Calculation_Time_Field:"တွက်ချက်ချိန်ကွက်",
List_Row_Background_Color:"စာရင်းအတန်း နောက်ခံအရောင်",
Please_Enter_Starting_Hour:"စတင်ချိန် ထည့်ပါ",
Please_Enter_A_Number_Between_0_And_23:"0 မှ 23 အတွင်း ဂဏန်းတစ်ခု ထည့်ပါ။",
Starting_Hour_Cannot_Be_Greater_Than_Ending_Hour:"စတင်ချိန်သည် အဆုံးချိန်ထက် မကျော်နိုင်ပါ။",
Please_Enter_Ending_Hour:"အဆုံးချိန် ထည့်ပါ။",
Ending_Hour_Cannot_Be_Less_Than_Starting_Hour:"အဆုံးချိန်သည် စတင်ချိန်ထက် မရှေးမဖြစ်ပါ။",
Please_Enter_Type:"အမျိုးအစား ရွေးပါ။",
Type_Cannot_Be_Duplicated:"အမျိုးအစားများကို ထပ်မံ မတူညီနိုင်ပါ။",
Please_Select_Background_Color:"နောက်ခံအရောင် ရွေးပါ။",
Background_Color_Cannot_Be_Duplicated:"နောက်ခံအရောင်များကို ထပ်မံ မတူညီနိုင်ပါ။",
Please_Select_Calculation_Day:"တွက်ချက်မည့်နေ့ ရွေးပါ။",
Please_Select_Calculation_Time_Field:"တွက်ချက်ချိန်ကွက်လပ် ရွေးပါ။",
Auto_Update_Time:"အလိုအလျောက် အပ်ဒိတ်ချိန်",
Next_Auto_Update_Time:"နောက်တစ်ကြိမ် အလိုအလျောက် အပ်ဒိတ်ချိန်",
Set_Statistical_Time_Range:"စာရင်းအင်း အချိန်ကာလ သတ်မှတ်",
Orders_Not_Completed_For_Delivery_Before_Statistical_Time_Range:"စာရင်းအင်းကာလမတိုင်မီ မဖြည့်ဆည်းရသေးသော အော်ဒါများ",
Warehouse_Orders:"ဂိုဒေါင်အော်ဒါများ",
Total_Orders_Awaiting_Shipment_Picking_In_Progress_And_Shipping_In_Progress_For_The_Corresponding_Warehouse:"ဆိုင်ရာ ဂိုဒေါင်အတွက် 'ပို့ရန်ကျန်', 'ရွေးယူဆဲ', 'ပို့ဆောင်ဆဲ' အော်ဒါစုစုပေါင်း",
Total_Orders_Shipped_And_Dispatched_For_The_Corresponding_Warehouse:"ဆိုင်ရာ ဂိုဒေါင်အတွက် 'ပို့ပြီး', 'ပို့ဆောင်ပြီး' အော်ဒါစုစုပေါင်း",
Total_Orders:"အော်ဒါစုစုပေါင်း",
Total_Not_Shipped:"မပို့ရသေးသော စုစုပေါင်း",
Total_Shipped:"ပို့ပြီးသော စုစုပေါင်း",
Please_Select_Time:"အချိန်ယူနစ်ကို ရွေးပါ",
Hour:"နာရီ",
Minute:"မိနစ်",
Second:"စက္ကန့်",
Statistical_Time_Range:"စာရင်းအင်းကာလ",
Corresponding_Start_Time_Of_Execution_At_That_Time_End_Time:"လက်ရှိ ဆောင်ရွက်မှုအတွက် သက်ဆိုင်ရာ စတင်နှင့် အဆုံးချိန်များ",
Corresponding_Field_For_Statistical_Data:"စာရင်းအင်းဒေတာအတွက် သက်ဆိုင်ရာ ကွက်လပ်",
Unread_Notification:"မဖတ်သေးသော အသိပေးစာများ",
noticeList:"အသိပေးစာ စာရင်း",
Receive_customer:"လက်ခံမည့် ဖောက်သည်များ",
Receive_staff:"လက်ခံမည့် ဝန်ထမ်းများ",
Receive_warehouse:"လက်ခံမည့် ဂိုဒေါင်များ",
Receive_department:"လက်ခံမည့် ဌာနများ",
Receive_country:"လက်ခံမည့် နိုင်ငံများ",
Add_Notification:"အသိပေးစာ ထည့်ရန်",
Edit_Notification:"အသိပေးစာ တည်းဖြတ်ရန်",
Recipient:"လက်ခံသူ",
Please_enter_a_title:"ခေါင်းစဉ်ကို ထည့်ပါ",
Please_enter_content:"အကြောင်းအရာကို ထည့်ပါ",
Please_select_the_recipient:"လက်ခံသူကို ရွေးပါ",
The_title_must_be_1_to_50_characters:"ခေါင်းစဉ်မှာ အက္ခရာ ၁ မှ ၅၀ အတွင်း ဖြစ်ရမည်",
Please_choose_a_logistics_provider:"ပို့ဆောင်ရေး ဝန်ဆောင်မှုပေးသူကို ရွေးပါ",
Platform_And_Shop:"ပလက်ဖောင်း/ဆိုင်",
Export_inventory_historical_inventory_information:"ထုတ်ပို့မည့် ပစ္စည်းစာရင်း + သမိုင်းဆိုင်ရာ ပစ္စည်းစာရင်း အချက်အလက်များ",
Appointment_for_warehouse_entry_and_storage_time:"သတ်မှတ်ထားသော ဂိုဒေါင်လက်ခံချိန်",
To_be_confirmed:"အတည်ပြုရန် စောင့်ဆိုင်းနေ",
Number_of_packaging_cycles:"ထုပ်ပိုးရေးအလှည့်များ",
Please_select_the_scheduled_time_for_warehouse_entry_and_storage:"သတ်မှတ်ထားသော ဂိုဒေါင်လက်ခံချိန်ကို ရွေးချယ်ပါ",
storage_phase:"လက်ခံခြင်းအဆင့်",
quantity_in_transit:"လမ်းပေါ်ရှိ ပမာဏ",
Daily_scheduled_inbound_time:"နေ့စဉ် သတ်မှတ်ထားသော လက်ခံချိန်များ",
Select_time_range:"အချိန်ကာလကို ရွေးချယ်ပါ",
Maximum_number_of_reserved_storage_parties:"သတ်မှတ်ထားသော လက်ခံပါတီများ အများဆုံး",
Total_number_of_reserved_storage_units:"စုစုပေါင်း သတ်မှတ်ထားသော လက်ခံပါတီများ",
Available_for_appointment:"စာရင်းသွင်းနိုင်ပါသည်",
Fully_booked:"ပြည့်စုံစာရင်းသွင်းထားသည်",
The_available_appointment_dates_are_green_and_the_remaining_number_of_available_appointments_per_day_is_displayed_below_the_dates_If_the_number_of_reserved_parties_is_full_it_will_be_marked_in_red_indicating_that_the_reservation_is_full:"စာရင်းသွင်းနိုင်သည့် ရက်များသည် အစိမ်းရောင်ဖြင့် ပြထားပြီး၊ နေ့စဉ် ကျန်ရှိသေးသည့် အခွင့်အလမ်းများကို အောက်တွင် ပြထားသည်။ ပြည့်စုံစာရင်းသွင်းထားသည့် ရက်များသည် အနီရောင်ဖြင့် ပြထားပြီး ပြည့်စုံစာရင်းသွင်းထားသည် ဟု ဖော်ပြထားသည်။",
Monday:"တနင်္လာ",
Tuesday:"အင်္ဂါ",
Wednesday:"ဗုဒ္ဓဟူး",
Thursday:"ကြာသာပတေး",
Friday:"သောကြာ",
Saturday:"စနေနေ့",
Sunday:"တနင်္ဂနွေ",
Pre_order_storage_for_the_next_seven_days :"အနာဂတ် ၇ ရက်အတွင်း ဂိုဒေါင်ဝင်စာရင်းသွင်းမှုများ",

}